/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated from server at 2026-09-15T14:27:29.053Z
 * Generator: build/generate-api-types.ts
 * Server: http://localhost:8080
 *
 * This file contains:
 * - Base types (JsonFw, FizFile)
 * - Decoder/encoder helper functions
 * - Enums as TypeScript union types
 * - Bean classes with full decode/encode support
 * - Individual decode/encode functions
 */

// ============================================================================
// Base Types
// ============================================================================

type singleDecoder<A> = (prop: string) => A;
type objectDecoder<A, B> = (prop: A) => B;
type singleEncoder<A> = (prop: A) => string;
type objectEncoder<A> = (prop: A) => JsonFw | string;

export type JsonFw = { [x: string]: FizFile | FizFile[] | JsonFw | JsonFw[] };
type FizJSONObject = JsonFw;
type FizFile = File | Blob | string;

// ============================================================================
// Helper Constants & Functions
// ============================================================================

const methods = {};

const inline = function<A>(target: A, ...from: JsonFw[]): A {
  from.forEach(oneFrom => {
    Object.assign(target, oneFrom);
  });
  return target;
};

const nothingtodo = function<A>(val: A): A {
  return val;
};

const notimplementedyet = function() {
  throw new Error("Not implemented yet");
};

const nullableDecoder = function<A>(sub: singleDecoder<A>) {
  return function(value: string | null | undefined): A | null | undefined {
    if (value === undefined || value === null) {
      return null;
    }
    return sub(value);
  };
};

const nullableEncoder = function<A>(sub: singleEncoder<A>) {
  return function(value: A | null | undefined): string | null | undefined {
    if (value === undefined || value === null) {
      return null;
    }
    return sub(value);
  };
};

const decodeboolean: singleDecoder<boolean> = function(value: string) {
  return (value === "true");
};

const encodeboolean = function(value: boolean) {
  return value ? "true" : "false";
};

const decodenumber: singleDecoder<number> = function(value: string): number {
  return Number(value);
};

const decodeNumber = nullableDecoder(decodenumber);
const encodenumber = function(number: number) { return number.toString(); };
const encodeNumber = nullableEncoder(encodenumber);

const decodeString: ((s: string) => string) = nothingtodo;
const encodeString = nothingtodo;

const decodeDate = function(iso8601: string) {
  if (iso8601 === undefined || iso8601 === null) {
    return undefined;
  }
  return new Date(iso8601);
};

const encodeDate = function(date: Date | undefined | null) {
  if (date === undefined || date === null) {
    return undefined;
  }
  return date.toISOString();
};

const decodeFizJSONObject = nothingtodo;
const encodeFizJSONObject = nothingtodo;

const decodeMap = function(keyDecoder: any, valueDecoder: any) {
  if (keyDecoder === nothingtodo && valueDecoder === nothingtodo) return nothingtodo;
  return function(value: any) {
    var result: any = {}, key, val;
    if (value === null || value === undefined) {
      return value;
    }
    for (key in value) {
      val = value[key];
      result[keyDecoder(key)] = val === null ? null : valueDecoder(val);
    }
    return result;
  };
};

const encodeMap = function(keyEncoder: any, valueEncoder: any) {
  if (keyEncoder === nothingtodo && valueEncoder === nothingtodo) return nothingtodo;
  return function(value: any) {
    var result: any = {}, key, val;
    for (key in value) {
      result[keyEncoder(key)] = valueEncoder(value[key]);
    }
    return result;
  };
};

const decodeArray = function<A, B>(valueDecoder: (src: A) => B): (src: A[]) => B[] {
  if ((valueDecoder as unknown) === nothingtodo) return nothingtodo as (src: A[]) => B[];
  return function(value: A[]) {
    if (value === null || value === undefined) {
      return undefined as any;
    }
    var result: B[] = [];
    for (var i = 0; i < value.length; i++) {
      var item = value[i];
      if (item !== null) {
        result[i] = valueDecoder(item);
      }
    }
    return result;
  };
};

const encodeArray = function(valueEncoder: any) {
  return function(value: any) {
    var i, res: any = {};
    if (value === null || value === undefined) {
      return value;
    }
    if (!Array.isArray(value)) {
      console.log("bad param", value, new Error());
      return valueEncoder(value);
    }
    if (value.length === 0) {
      return "$empty";
    }
    for (i in value) {
      res[i] = valueEncoder(value[i]);
    }
    return res;
  };
};

const decodeFizFile = nothingtodo;
const encodeFizFile = nothingtodo;

const enumsValue: any = {};
const decodeEnum = function(value: any) {
  if (value === null || value === undefined) {
    return value;
  }
  var res;
  if ((res = enumsValue[value])) {
    return res;
  } else {
    return enumsValue[value] = value;
  }
};

const encodeEnum = nothingtodo;
const decodeBoolean = nullableDecoder(decodeboolean);
const encodeBoolean = nullableEncoder(encodeboolean);
const decodeMetaId = decodeString;
const encodeMetaId = encodeString;
const decodeTimeZone = decodeString;  // TimeZone → string
const encodeTimeZone = encodeString;

const decodeDynamic: objectDecoder<JsonFw, unknown> = function(json: JsonFw) {
  if (json instanceof Array) {
    return decodeArray(decodeDynamic)(json as any);
  } else if (typeof json === "object") {
    if ((json as any).FiZClassId === undefined) {
      return decodeMap(decodeString, decodeDynamic)(json);
    } else {
      var type = types[(json as any).FiZClassId as string] || ServerError;
      return new type(json);
    }
  } else {
    return json;
  }
};

const encodeDynamic = function(json: any) {
  return notimplementedyet();
};

function decodeStructure(valueDecoder: any) {
  return function rootDecode(json: any) {
    if (json.ex) {
      throw decodeDynamic(json.ex.ex);
    }
    if (json.un) {
      throw decodeDynamic(json.un.un);
    }
    if (json.r) {
      return valueDecoder(json.r.r);
    }
    return valueDecoder(json.feed);
  };
}

// ============================================================================
// Method Registration
// ============================================================================

function registerMethod(
  api: string,
  argumentsName: (string | {name?: string, encode: objectEncoder<any>})[],
  decoder: objectDecoder<JsonFw, any>,
  https = undefined
) {
  methods[api] = {
    api: api,
    argumentsName: argumentsName,
    decoder: decoder,
    https: https
  };
}

// ============================================================================
// Base Classes
// ============================================================================

export class ServerBeanPrototype {
  constructor(json: JsonFw) {}
  onDecode(json: JsonFw): void {}
  cloneWith(datas: Partial<typeof this>) {
    function EXT() {}
    (EXT as any).prototype = this;
    return Object.assign(new (EXT as any)(), datas);
  }
}

export class ServerError extends ServerBeanPrototype {
  code: string = "";
  message: string = "";
  constructor(json: JsonFw) {
    super(json);
    Object.assign(this, json);
    this.code = json.FiZClassId as string;
    this.toString = function() { return this.code + " " + this.message; };
    this.onDecode(json);
  }
}

// ============================================================================
// Enums
// ============================================================================

export type AccessTokenTypeEnum = 'Bearer' | 'mac' | 'SOMETHING_ELSE';

export type AccountIdentifierTypeEnum = 'Email' | 'Msisdn' | 'ExternalId' | 'Login' | 'AccessToken' | 'ORANGE_ISE2' | 'MOVISTAR_HUB_ID' | 'PROXIMUS_ID' | 'ORANGE_EUID' | 'SOMETHING_ELSE';

export type AccountIdentifierValidationMethodEnum = 'PINCODE' | 'TOKEN' | 'SOMETHING_ELSE';

export type ApiAccessRightRulesetEnum = 'CLIENTASUSER' | 'LEGACY' | 'WEB' | 'SUPERADMIN' | 'BROADCAST' | 'NOAUTHENT' | 'ORANGE' | 'PROVISIONING_TPY' | 'EMAIL_INBOUND_INTEGRATION' | 'SOMETHING_ELSE';

export type ApiKeyClientType = 'Confidential' | 'Public' | 'SOMETHING_ELSE';

export type ApplicationBlockedPopupActionEnum = 'URL' | 'CLOSE' | 'STORE' | 'SOMETHING_ELSE';

export type AttendeeResponseEnum = 'NOT_INVITED' | 'PENDING' | 'DECLINED' | 'ATTENDING' | 'MAYBE_ATTENDING' | 'SOMETHING_ELSE';

export type AttendeeStatusEnum = 'ATTENDEE' | 'SOMETHING_ELSE';

export type BlockingStatusEnum = 'NotBlocked' | 'BlockedShown' | 'BlockedUnshown' | 'SOMETHING_ELSE';

export type BroadcastSignalTypeEnum = 'CONNECT' | 'HELLO' | 'MESSAGE' | 'PING' | 'PONG' | 'DISCONNECT' | 'SOMETHING_ELSE';

export type BudgetMainKPIEnum = 'TOTAL_REVENUES' | 'TOTAL_EXPENSES' | 'BALANCE' | 'SOMETHING_ELSE';

export type BudgetPaidUsageEnum = 'NONE' | 'PAID' | 'UNPAID' | 'SOMETHING_ELSE';

export type BudgetTransactionType = 'EXPENSE' | 'REVENUE' | 'SOMETHING_ELSE';

export type CalendarTypeEnum = 'PUBLIC_HOLIDAYS_FOLDER' | 'SCHOOL_HOLIDAYS_FOLDER' | 'SCHOOL_HOLIDAY_ITEM' | 'FAMILIES_FOLDER' | 'FAMILIES_NOT_FOLDER' | 'PUBLIC_HOLIDAYS' | 'PUBLIC_HOLIDAYS_ONLY' | 'TASKS' | 'MEALPLANNER' | 'TIMETABLE' | 'BUDGET' | 'SPECIAL_DAYS' | 'SOMETHING_ELSE';

export type CallToActionIconEnum = 'INVITE' | 'CAKE' | 'CALENDAR' | 'LOVE' | 'LIST' | 'CLOUD' | 'SMILE' | 'CAMERA' | 'PEOPLE' | 'PREMIUM' | 'SEND' | 'SOMETHING_ELSE';

export type CallToActionTypeEnum = 'INVITE' | 'WALL_VIEW' | 'WALL_POST' | 'EVENT_VIEW' | 'BIRTHDAY_VIEW' | 'EVENT_CREATE' | 'CALENDAR' | 'PROFILE_EDIT' | 'FAMILY_COVER' | 'FAMILY_CREATE' | 'PREMIUM' | 'SEND_CARD' | 'FAMILY' | 'URL' | 'MESSAGE' | 'MAP' | 'LIST' | 'CONTACT' | 'GALLERY' | 'MEALPLANNER' | 'RECIPEBOX' | 'TIMETABLE' | 'SETTINGS' | 'LIST_CREATE' | 'TIMETABLE_CREATE' | 'RECIPE_CREATE' | 'CHECKIN_CREATE' | 'PLACE_CREATE' | 'MESSAGE_CREATE' | 'CONTACT_CREATE' | 'PHOTO_CREATE' | 'CALENDAR_SETTINGS' | 'PREMIUM_MEALPLANNER' | 'PREMIUM_TIMETABLE' | 'PREMIUM_RECURRINGTASKS' | 'PREMIUM_CALENDARSYNC' | 'PREMIUM_RECIPE' | 'PREMIUM_LOCATION' | 'EXPLORE_WELCOME' | 'EXPLORE_PINUNPIN' | 'SOMETHING_ELSE';

export type ColorSystemEnum = 'PEACOCK' | 'TOMATO' | 'BANANA' | 'FLAMINGO' | 'GRAPE' | 'BLUEBERRY' | 'SAGE' | 'LAVENDER' | 'BASIL' | 'GRAPHITE' | 'TANGERINE' | 'MOCHA' | 'HIBISCUS' | 'PALE_PURPLE' | 'GLACIER' | 'PEACH' | 'ONYX' | 'SOMETHING_ELSE';

export type CreditAutoRenewType = 'NONE' | 'AUTO' | 'SOMETHING_ELSE';

export type CreditPaymentMigratedStateEnum = 'TO_MIGRATE' | 'MIGRATED' | 'ERROR' | 'EXPIRED' | 'SOMETHING_ELSE';

export type CreditPaymentTypeEnum = 'SYSTEM' | 'TEST' | 'ORANGE' | 'ITUNES' | 'GPLAYSTORE' | 'PROMO' | 'SPRINT' | 'TMO_TOPAPPS_TRIAL' | 'SPRINT_TRIAL' | 'PROVISIONNING_API' | 'MOVISTAR_API' | 'SPRINT_PROMO_ONEYEAR' | 'TELEKOM_API' | 'VIVO_API' | 'PROMO_CAMPAIGN' | 'ITUNES_IOS7' | 'PROXIMUS_INTEGRATION' | 'TWOCHECKOUT' | 'TWOCHECKOUT_TEMP' | 'ORANGE_TEMP' | 'SOMETHING_ELSE';

export type CreditStatusDetailEnum = 'ACTIVE' | 'TRIAL' | 'CANCELLED' | 'IN_GRACE' | 'ON_HOLD' | 'PAUSED' | 'EXPIRED' | 'PENDING' | 'SOMETHING_ELSE';

export type CreditStatusEnum = 'ACTIVE' | 'INACTIVE' | 'SOMETHING_ELSE';

export type CreditTypeEnum = 'QUOTA' | 'GEOLOC_AUTOTRACK' | 'ORANGE_PREMIUM' | 'VIDEO' | 'FAMILYWALL_PREMIUM' | 'SPRINT_FRAMILYWALL_PREMIUM' | 'SPRINT_FRAMILYWALL_PREMIUM_PLUS' | 'ITEM_TRACKER' | 'MOVISTAR_GEOLOC_FREEMIUM' | 'MOVISTAR_GEOLOC_PREMIUM' | 'FAMILY_MEMBER_QUOTA' | 'TELEKOM_ALBANIA_PREMIUM' | 'VIVO_PREMIUM' | 'TELEKOM_AUSTRIA_PREMIUM' | 'PROXIMUS_PREMIUM' | 'FAMILY_NB_QUOTA' | 'SOMETHING_ELSE';

export type CreditTypeOfPeriodEnum = 'MONTHLY' | 'YEARLY' | 'SOMETHING_ELSE';

export type DeepLinkPageEnum = 'home' | 'map' | 'im' | 'calendar' | 'list' | 'budget' | 'documents' | 'specialdays' | 'settings' | 'settingsNotifications' | 'recipeSharing' | 'premium' | 'myfamily' | 'SOMETHING_ELSE';

export type DeviceModelTypeEnum = 'Android' | 'Iphone' | 'Iphone_Dev' | 'Ipad' | 'IPad_Dev' | 'Web' | 'Android_GCM' | 'WindowsPhone' | 'Iphone_familyplace' | 'Iphone_verizon' | 'Iphone_sprint' | 'Iphone_familylife' | 'Iphone_mifamily' | 'Iphone_dtelekomalbania' | 'WebFirebase' | 'Iphone_vivo' | 'Android_PersistentPush' | 'Android_PersistentPush_FCM' | 'Iphone_dtelekomaustria' | 'Iphone_proximus' | 'Android_HomeHub' | 'SOMETHING_ELSE';

export type DeviceTypeEnum = 'PHONE' | 'EMAIL' | 'MOBILE' | 'PHONE_HOME' | 'PHONE_WORK' | 'FAX_HOME' | 'FAX_WORK' | 'PAGER' | 'OTHER' | 'SOMETHING_ELSE';

export type EventTypeEnum = 'UNKNOWN' | 'BIRTHDAY' | 'BIRTHDAY_ACCOUNT' | 'EXTERNAL' | 'TASK' | 'SPECIAL_DAYS' | 'ANNIVERSARY' | 'BIRTHDAY_CUSTOM' | 'SOMETHING_ELSE';

export type ExternalImportTypeEnum = 'EVENT_BY_ICAL' | 'EVENT_BY_INBOX' | 'EVENT_BY_URL' | 'SOMETHING_ELSE';

export type FamilyAdminRightEnum = 'None' | 'Admin' | 'SuperAdmin' | 'SubAccount' | 'SOMETHING_ELSE';

export type FamilyRoleTypeEnum = 'Mom' | 'Dad' | 'Daughter' | 'Son' | 'Unknown' | 'Pet' | 'GrandFather' | 'GrandMother' | 'Custom' | 'SOMETHING_ELSE';

export type FeedbackTypeEnum = 'GENERAL' | 'BUDGET_LAUNCH' | 'FILER' | 'SPECIAL_DAYS' | 'SOMETHING_ELSE';

export type FilerDisplayModeEnum = 'LIST' | 'GRID' | 'SOMETHING_ELSE';

export type FilerSortingEnum = 'alphabetical' | 'alphabeticalReverse' | 'modificationDate' | 'modificationDateReverse' | 'SOMETHING_ELSE';

export type GenderEnum = 'MASCULINE' | 'FEMININE' | 'OTHER' | 'SOMETHING_ELSE';

export type GeolocSharingEnum = 'NEVER' | 'ALWAYS' | 'PLACES' | 'SOMETHING_ELSE';

export type GoogleTokenType = 'Web' | 'Android' | 'Iphone' | 'SOMETHING_ELSE';

export type IMMessageTypeEnum = 'Text' | 'Glympse' | 'SOMETHING_ELSE';

export type InvitationStatusEnum = 'PENDING' | 'PENDING_EMAIL_DELIVERED' | 'ERR_EMAIL_INVALID_ADDRESS' | 'ERR_EMAIL_BOUNCED' | 'ERR_EMAIL_DEFFERED' | 'ERR_SMS_INVALID_ADDRESS' | 'OPEN_URL' | 'SOMETHING_ELSE';

export type LaunchpadOpeningEnum = 'FAMILY_CREATED' | 'FAMILY_JOINED' | 'ONCE_RETURNING' | 'FIRST_OF_DAY' | 'OTHERS' | 'SOMETHING_ELSE';

export type LocationMoveTypeEnum = 'IN' | 'OUT' | 'AUTO' | 'SOMETHING_ELSE';

export type LocationStateEnum = 'OK' | 'NO_LOC' | 'NO_DEVICE' | 'REQUEST_PENDING' | 'CANNOT_CONNECT' | 'DEVICELOCATION_TURNED_OFF' | 'LOCATION_NOT_AUTHORIZED' | 'SOMETHING_ELSE';

export type LocationSubscriptionStatusEnum = 'PENDING' | 'SUBSCRIBED' | 'NOT_SUBSCRIBED' | 'SOMETHING_ELSE';

export type MailNotificationTypeEnum = 'NEVER' | 'ALWAYS' | 'WHEN_NO_DEVICE' | 'SOMETHING_ELSE';

export type MealTypeEnum = 'BREAKFAST' | 'LUNCH' | 'DINNER' | 'SNACK' | 'CUSTOM1' | 'CUSTOM2' | 'SOMETHING_ELSE';

export type MediaContentState = 'SAVING' | 'READY' | 'SOMETHING_ELSE';

export type MediaFilterTypeEnum = 'ALL' | 'BEST_MOMENT' | 'AUTHOR' | 'MOOD_STAR' | 'SOMETHING_ELSE';

export type MediaPreviewStatusEnum = 'UNSET' | 'OK' | 'KO' | 'SOMETHING_ELSE';

export type MetaIdTypeEnum = 'account' | 'wall' | 'wallComment' | 'thread' | 'message' | 'profile' | 'profileDevice' | 'profileAddress' | 'family' | 'event' | 'eventComment' | 'place' | 'placeTip' | 'contact' | 'contactDevice' | 'contactAddress' | 'contactComment' | 'task' | 'taskComment' | 'media' | 'mediaAlbum' | 'settings' | 'locationSubscription' | 'locationPublication' | 'location' | 'locationDevice' | 'credit' | 'threadUsers' | 'mediaComment' | 'invitation' | 'imThread' | 'familymember' | 'placeGeofencing' | 'profileFamily' | 'itemTracker' | 'settingsFamily' | 'locationAuthorization' | 'icalEvent' | 'extCalendar' | 'extCalendarGoogle' | 'calendar' | 'googleEvent' | 'taskList' | 'taskListComment' | 'googleCredential' | 'pushMessage' | 'calendarTask' | 'outlookCredential' | 'oulookEvent' | 'extCalendarOutlook' | 'dish' | 'recipe' | 'meal' | 'calendarMealPlanner' | 'recipeIngredient' | 'calendarFolder' | 'color' | 'category' | 'calendarTimetable' | 'taskCategory' | 'deviceConfig' | 'dashboardTile' | 'calendarFolderOtherFamilies' | 'extCalendarByUrl' | 'budgetCategory' | 'paymentMethod' | 'budget' | 'budgetTransaction' | 'folder' | 'settingsPerFamily' | 'calendarBudget' | 'calendarSpecialDays' | 'externalImport' | 'taskAsEvent' | 'dishAsEvent' | 'mealAsEvent' | 'budgetTransactionAsEvent' | 'externalRecipeProvider' | 'externalRecipe' | 'extCalendarByUrlEvent' | 'alexaCredential' | 'alexaTaskList' | 'alexaTask' | 'SOMETHING_ELSE';

export type MoodEnum = 'STAR' | 'AMY_READ' | 'SOMETHING_ELSE';

export type OrangeOptionsEnum = 'NONE' | 'BUNDLED' | 'SUBSCRIBED' | 'PURCHASED1' | 'PURCHASED2' | 'PURCHASED3' | 'SOMETHING_ELSE';

export type ParticipantStatusEnum = 'NORMAL' | 'CREATOR' | 'READONLY' | 'BLOCKED' | 'DELETED' | 'SOMETHING_ELSE';

export type PartnerTypeEnum = 'Family' | 'ORANGE' | 'orange_familyplace' | 'sprint_framilywall' | 'movistar_familylife' | 'movistar_mifamily' | 'telekom_albania' | 'vivo_familia' | 'telekom_austria' | 'proximus_family' | 'SOMETHING_ELSE';

export type PlaceTypeEnum = 'UNKNOWN' | 'SPORT' | 'SCHOOL' | 'HOME' | 'MUSIC' | 'PARK' | 'WORK' | 'SHOPPING' | 'TRAVEL' | 'DOCTOR' | 'HOSPITAL' | 'POLICE' | 'RESTAURANT' | 'UNIVERSITY' | 'BANK' | 'MARKET' | 'SOMETHING_ELSE';

export type PremiumPopupTypeEnum = 'PROMO_YEARLY_50' | 'SOMETHING_ELSE';

export type PremiumRightFlagEnum = 'OK' | 'KO_PREMIUM' | 'KO_LIMIT' | 'KO_HIDE' | 'SOMETHING_ELSE';

export type PromoPushScreenTarget = 'LAUNCHPAD' | 'URL' | 'LAUNCHPAD_SECTION' | 'SOMETHING_ELSE';

export type PushTypeEnum = 'New_Checkin' | 'New_Message' | 'New_Event' | 'Update_Event' | 'Comment_Event' | 'Comment_Checkin' | 'New_Picture' | 'Comment_Picture' | 'Event_Reminder' | 'NewLocationSubscriber' | 'Task_Reminder' | 'New_Task' | 'Update_Task' | 'Comment_Task' | 'QuotaAlmostExceeded' | 'QuotaExceeded' | 'PremiumLost' | 'FamilyInvitation' | 'LocationRequestAccepted' | 'LocationRequestRejected' | 'PartyCallConfCreated' | 'PartyCallJoined' | 'PartyCallLeft' | 'New_Status' | 'Comment_Status' | 'Member_Joined' | 'Complete_Task' | 'New_Multiple_Picture' | 'Multiple_Picture_Comment' | 'KidsAtHome' | 'GeoFencingIn' | 'GeoFencingOut' | 'GeolocAutotrackRequest' | 'GeolocAutotrackAccepted' | 'GeolocAutotrackDeclined' | 'GeolocAutotrackTemporaryStarted' | 'GeolocAutotrackTemporaryFinished' | 'AlarmPanicButton' | 'AlamPanicCleared' | 'GeolocFencingRequest' | 'GeolocFencingNewPlace' | 'GeolocPositionRefreshRequest' | 'GeolocPositionRefreshResponse' | 'GeolocPositionRefreshError' | 'GeolocPickMeUpRequest' | 'GeolocPickMeUpResponse' | 'SprintTrialMiddle' | 'SprintTrialEnd' | 'SprintPromoOneYearEnd' | 'AmyVoiceMessage' | 'AmyMissedCall' | 'ItemTrackerAdded' | 'ItemTrackerLost' | 'ItemTrackerFound' | 'CommentMarkedAsBestMoment' | 'CategoryAdded' | 'TaskListAdded' | 'TaskListCommmented' | 'PersistentPushWakeUp' | 'UnhandlePush' | 'Promo' | 'TaskListContentModified' | 'PremiumGracePeriod' | 'PremiumOnHold' | 'PremiumRecovered' | 'DailyBrief' | 'TendanceCuisinePush' | 'TimetableCreate' | 'TimetableUpdate' | 'TimetableReminder' | 'BudgetTransactionReminder' | 'BudgetAdded' | 'BudgetContentModified' | 'FilerFolderCreated' | 'FilerFileCreated' | 'AlexaConnected' | 'MealAdded' | 'MealPlannerContentModified' | 'RecipeAdded' | 'RecipeContentModified' | 'ContactAdded' | 'ContactContentModified' | 'SOMETHING_ELSE';

export type RecipeSystemCategoryEnum = 'FAVORITE' | 'KIDS_LOVE' | 'REALLY_EASY' | 'DESSERT' | 'TASTES_AMAZING' | 'VEGGIE' | 'SOMETHING_ELSE';

export type RecurrencyActionOptionEnum = 'All' | 'OnlyOne' | 'OnlyAfter' | 'AndParent' | 'SOMETHING_ELSE';

export type RecurrencyEnum = 'NONE' | 'YEARLY' | 'MONTHLY' | 'WEEKLY' | 'DAILY' | 'DAYWEEK' | 'BIWEEKLY' | 'SEMI_MONTHLY' | 'SOMETHING_ELSE';

export type RefObjectActionEnum = 'CREATED' | 'COMMENTED' | 'MOOD_STAR' | 'SOMETHING_ELSE';

export type RefObjectTypeEnum = 'PLACE_IN' | 'PLACE_OUT' | 'MESSAGE_IN' | 'MESSAGE_OUT' | 'EVENT' | 'MESSAGE_THREAD' | 'STATUS' | 'EVENT_CREATED' | 'FAMILY_CREATED' | 'INVITATION_SENT' | 'INVITATION_ACCEPTED' | 'PROFILE_CHANGED' | 'ACCOUNT_DELETED' | 'CONTACT_CREATED' | 'CONTACT_UPDATED' | 'CONTACT_DELETED' | 'CONTACTS_DELETED' | 'MEMBER_JOIN' | 'SINGLE_PICTURE' | 'EVENT_UPDATED' | 'EVENT_COMMENTED' | 'TASK_CREATED' | 'TASK_UPDATED' | 'TASK_COMMENTED' | 'TASK_ASSIGNED' | 'PREMIUM_ACQUIRED' | 'PREMIUM_LOST' | 'ORANGE_PREMIUM_ACQUIRED' | 'TASK_MARKED_COMPLETED' | 'MULTIPLE_PICTURE' | 'ORANGE_VVM_MISSED_CALL' | 'ORANGE_VVM_VOICE_MSG' | 'ORANGE_LOCATION_GENERIC' | 'PREMIUM_SPRINT_TRIAL_ACQUIRED' | 'SINGLE_PICTURE_COMMENTED' | 'MULTIPLE_PICTURE_COMMENTED' | 'ORANGE_THUNDERSTORM_ALERT' | 'TASKLIST' | 'SOMETHING_ELSE';

export type ReminderTypeEnum = 'NONE' | 'SNOOZE' | 'EMAIL' | 'SOMETHING_ELSE';

export type ReminderUnitEnum = 'DAY' | 'HOUR' | 'MINUTE' | 'SOMETHING_ELSE';

export type SectionEnum = 'LIST' | 'CALENDAR' | 'MAP' | 'GALLERY' | 'CONTACT' | 'FAMILY' | 'LAUNCHPAD' | 'SETTINGS' | 'ACTIVITY' | 'TRACKER' | 'MEALPLANNER' | 'RECIPEBOX' | 'TIMETABLE' | 'PREMIUM' | 'MY_PROXIMUS' | 'MESSAGE' | 'EXPLORE' | 'SOMETHING_FAKE' | 'BUDGET' | 'FILER' | 'SPECIAL_DAYS' | 'SOMETHING_ELSE';

export type StatusServerEnum = 'OK' | 'KO_UNKNOWN' | 'KO_DATABASE' | 'KO_CLOUDFILE' | 'SOMETHING_ELSE';

export type TaskListSortingEnum = 'modif_date' | 'custom' | 'SOMETHING_ELSE';

export type TaskListTypeEnum = 'TODOS' | 'SHOPPING_LIST' | 'OTHER' | 'SOMETHING_ELSE';

export type TaskSortingEnum = 'custom' | 'alphabetical' | 'alphabeticalReverse' | 'duedate' | 'duedateReverse' | 'creationdate' | 'creationdateReverse' | 'byrecipe' | 'byrecipeReverse' | 'SOMETHING_ELSE';

export type TokenTypeEnum = 'Invitation' | 'ForgotPassword' | 'DeepLoginLink' | 'InvitationAccepted' | 'MealPlannerAnonymousSharing' | 'RecipeSharing' | 'AccountIdentifierValidation' | 'TimetableAnonymousSharing' | 'SOMETHING_ELSE';

export type UserActionEnum = 'CREATED' | 'UPDATED' | 'MARK_COMPLETED' | 'DELETED' | 'IMPORTED' | 'SOMETHING_ELSE';

export type WeatherEnum = 'Cloud' | 'Clear' | 'Fog' | 'Thunder' | 'Drizzle' | 'Rain' | 'Snow' | 'SOMETHING_ELSE';

// ============================================================================
// Bean Classes
// ============================================================================

type AccessTokenBeanJSON = {
  access_token: string;
  accountId: string;
  expires_in: string;
  loginInfos: AccountLoginInfoJSON;
  mac_algorithm?: string;
  mac_key?: string;
  token_type: AccessTokenTypeEnum;
};

export class AccessTokenBean extends ServerBeanPrototype {
  /** @param accessToken the accessToken to set */
  access_token!: string;
  /** @param accountId the accountId of the logged account */
  accountId!: string;
  /** @param expireIn the expireIn to set (in second) */
  expires_in!: number;
  /** information about the login procedure
 @param loginInfos the loginInfos to set */
  loginInfos!: AccountLoginInfo;
  /** @param macAlgorithm the macAlgorithm to set */
  mac_algorithm?: string;
  /** @param macKey the macKey to set */
  mac_key?: string;
  /** @param tokenType the tokenType to set */
  token_type!: AccessTokenTypeEnum;

  constructor(json: AccessTokenBeanJSON) {
    super(json);
    this.access_token = decodeString(json.access_token);
    this.accountId = decodeString(json.accountId);
    this.expires_in = decodenumber(json.expires_in);
    this.loginInfos = decodeAccountLoginInfo(json.loginInfos);
    this.mac_algorithm = decodeString(json.mac_algorithm);
    this.mac_key = decodeString(json.mac_key);
    this.token_type = decodeEnum(json.token_type);
    this.onDecode(json);
  }
}

function decodeAccessTokenBean(json: AccessTokenBeanJSON | undefined): AccessTokenBean | undefined {
  return json === undefined ? undefined : new AccessTokenBean(json);
}

function encodeAccessTokenBean(obj: AccessTokenBean | null): AccessTokenBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    access_token: encodeString(obj.access_token),
    accountId: encodeString(obj.accountId),
    expires_in: encodenumber(obj.expires_in),
    loginInfos: encodeAccountLoginInfo(obj.loginInfos),
    mac_algorithm: encodeString(obj.mac_algorithm),
    mac_key: encodeString(obj.mac_key),
    token_type: encodeEnum(obj.token_type)
  } as AccessTokenBeanJSON);
}

type AccountActivityBeanJSON = {
  accountId?: string;
  displayName?: string;
  familyId?: string;
  lastModifiedEvent?: IEventJSON;
  lastStatus?: IWallMessageJSON;
  location?: ILocationJSON;
  pictureUrl?: string;
};

export class AccountActivityBean extends ServerBeanPrototype {
  accountId?: number;
  displayName?: string;
  /** @param familyId the familyId to set */
  familyId?: string;
  /** WARNING it is not anymore the lastmodifiedEvent but the last Event that happened<br>
 name is kept for compatibility
 @param lastModifiedEvent */
  lastModifiedEvent?: IEvent;
  /** @param lastShout the lastShout to set */
  lastStatus?: IWallMessage;
  location?: ILocation;
  pictureUrl?: string;

  constructor(json: AccountActivityBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.displayName = decodeString(json.displayName);
    this.familyId = decodeMetaId(json.familyId);
    this.lastModifiedEvent = decodeIEvent(json.lastModifiedEvent);
    this.lastStatus = decodeIWallMessage(json.lastStatus);
    this.location = decodeILocation(json.location);
    this.pictureUrl = decodeString(json.pictureUrl);
    this.onDecode(json);
  }
}

function decodeAccountActivityBean(json: AccountActivityBeanJSON | undefined): AccountActivityBean | undefined {
  return json === undefined ? undefined : new AccountActivityBean(json);
}

function encodeAccountActivityBean(obj: AccountActivityBean | null): AccountActivityBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    displayName: encodeString(obj.displayName),
    familyId: encodeMetaId(obj.familyId),
    lastModifiedEvent: encodeIEvent(obj.lastModifiedEvent),
    lastStatus: encodeIWallMessage(obj.lastStatus),
    location: encodeILocation(obj.location),
    pictureUrl: encodeString(obj.pictureUrl)
  } as AccountActivityBeanJSON);
}

type AccountBeanJSON = {
  accountId: string;
  creationDate?: string;
  deleted: string;
  identifiers: Array<IAccountIdentifierJSON>;
  lastLoginDate?: string;
  name: string;
  termsChecked: string;
  termsOrangeFamilyPlaceChecked: string;
  termsProximusFamilyChecked?: string;
};

export class AccountBean extends ServerBeanPrototype {
  accountId!: number;
  /** @param creationDate the creationDate to set */
  creationDate?: Date;
  /** @param deleted the deleted to set */
  deleted!: boolean;
  identifiers!: Array<IAccountIdentifier>;
  lastLoginDate?: Date;
  name!: string;
  /** @param termsChecked the termsChecked to set */
  termsChecked!: boolean;
  termsOrangeFamilyPlaceChecked!: boolean;
  /** @param termsProximusFamilyChecked the termsProximusFamilyChecked to set */
  termsProximusFamilyChecked?: boolean;

  constructor(json: AccountBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationDate = decodeDate(json.creationDate);
    this.deleted = decodeboolean(json.deleted);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.name = decodeString(json.name);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);
    this.onDecode(json);
  }
}

function decodeAccountBean(json: AccountBeanJSON | undefined): AccountBean | undefined {
  return json === undefined ? undefined : new AccountBean(json);
}

function encodeAccountBean(obj: AccountBean | null): AccountBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationDate: encodeDate(obj.creationDate),
    deleted: encodeboolean(obj.deleted),
    identifiers: encodeArray(encodeIAccountIdentifier)(obj.identifiers),
    lastLoginDate: encodeDate(obj.lastLoginDate),
    name: encodeString(obj.name),
    termsChecked: encodeboolean(obj.termsChecked),
    termsOrangeFamilyPlaceChecked: encodeboolean(obj.termsOrangeFamilyPlaceChecked),
    termsProximusFamilyChecked: encodeBoolean(obj.termsProximusFamilyChecked)
  } as AccountBeanJSON);
}

type AccountIdentifierBeanJSON = {
  id: string;
  type: AccountIdentifierTypeEnum;
  validated: string;
  value: string;
  verifiedPartner?: PartnerTypeEnum;
};

export class AccountIdentifierBean extends ServerBeanPrototype {
  id!: number;
  type!: AccountIdentifierTypeEnum;
  validated!: boolean;
  value!: string;
  verifiedPartner?: PartnerTypeEnum;

  constructor(json: AccountIdentifierBeanJSON) {
    super(json);
    this.id = decodeNumber(json.id);
    this.type = decodeEnum(json.type);
    this.validated = decodeBoolean(json.validated);
    this.value = decodeString(json.value);
    this.verifiedPartner = decodeEnum(json.verifiedPartner);
    this.onDecode(json);
  }
}

function decodeAccountIdentifierBean(json: AccountIdentifierBeanJSON | undefined): AccountIdentifierBean | undefined {
  return json === undefined ? undefined : new AccountIdentifierBean(json);
}

function encodeAccountIdentifierBean(obj: AccountIdentifierBean | null): AccountIdentifierBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    id: encodeNumber(obj.id),
    type: encodeEnum(obj.type),
    validated: encodeBoolean(obj.validated),
    value: encodeString(obj.value),
    verifiedPartner: encodeEnum(obj.verifiedPartner)
  } as AccountIdentifierBeanJSON);
}

type AccountIdentifierInfoJSON = {
  countryCode?: string;
  originalValue?: string;
  type: AccountIdentifierTypeEnum;
  value?: string;
};

export class AccountIdentifierInfo extends ServerBeanPrototype {
  countryCode?: string;
  /** @param originalValue the originalValue to set */
  originalValue?: string;
  type!: AccountIdentifierTypeEnum;
  value?: string;

  constructor(json: AccountIdentifierInfoJSON) {
    super(json);
    this.countryCode = decodeString(json.countryCode);
    this.originalValue = decodeString(json.originalValue);
    this.type = decodeEnum(json.type);
    this.value = decodeString(json.value);
    this.onDecode(json);
  }
}

function decodeAccountIdentifierInfo(json: AccountIdentifierInfoJSON | undefined): AccountIdentifierInfo | undefined {
  return json === undefined ? undefined : new AccountIdentifierInfo(json);
}

function encodeAccountIdentifierInfo(obj: AccountIdentifierInfo | null): AccountIdentifierInfoJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    countryCode: encodeString(obj.countryCode),
    originalValue: encodeString(obj.originalValue),
    type: encodeEnum(obj.type),
    value: encodeString(obj.value)
  } as AccountIdentifierInfoJSON);
}

type AccountLoginInfoJSON = {
  accountId: string;
  genericAutologinToken?: string;
  hasFamily: string;
  termsChecked: string;
  termsOrangeFamilyPlaceChecked: string;
  termsProximusFamilyChecked: string;
  tokenCsrf?: string;
  webApiUrl?: string;
};

export class AccountLoginInfo extends ServerBeanPrototype {
  accountId!: number;
  genericAutologinToken?: string;
  hasFamily!: boolean;
  termsChecked!: boolean;
  termsOrangeFamilyPlaceChecked!: boolean;
  /** @param termsProximusFamily the termsProximusFamily to set */
  termsProximusFamilyChecked!: boolean;
  tokenCsrf?: string;
  /** The url the web can use to access the server with the session, in case the cookies does not work
 @param apiUrl the apiUrl to set */
  webApiUrl?: string;

  constructor(json: AccountLoginInfoJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.genericAutologinToken = decodeString(json.genericAutologinToken);
    this.hasFamily = decodeboolean(json.hasFamily);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeboolean(json.termsProximusFamilyChecked);
    this.tokenCsrf = decodeString(json.tokenCsrf);
    this.webApiUrl = decodeString(json.webApiUrl);
    this.onDecode(json);
  }
}

function decodeAccountLoginInfo(json: AccountLoginInfoJSON | undefined): AccountLoginInfo | undefined {
  return json === undefined ? undefined : new AccountLoginInfo(json);
}

function encodeAccountLoginInfo(obj: AccountLoginInfo | null): AccountLoginInfoJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    genericAutologinToken: encodeString(obj.genericAutologinToken),
    hasFamily: encodeboolean(obj.hasFamily),
    termsChecked: encodeboolean(obj.termsChecked),
    termsOrangeFamilyPlaceChecked: encodeboolean(obj.termsOrangeFamilyPlaceChecked),
    termsProximusFamilyChecked: encodeboolean(obj.termsProximusFamilyChecked),
    tokenCsrf: encodeString(obj.tokenCsrf),
    webApiUrl: encodeString(obj.webApiUrl)
  } as AccountLoginInfoJSON);
}

type AccountSecurityBeanJSON = {
  hasPassword: string;
};

export class AccountSecurityBean extends ServerBeanPrototype {
  /** true if the password for this account is defined
 @param hasPassword the hasPassword to set */
  hasPassword!: boolean;

  constructor(json: AccountSecurityBeanJSON) {
    super(json);
    this.hasPassword = decodeboolean(json.hasPassword);
    this.onDecode(json);
  }
}

function decodeAccountSecurityBean(json: AccountSecurityBeanJSON | undefined): AccountSecurityBean | undefined {
  return json === undefined ? undefined : new AccountSecurityBean(json);
}

function encodeAccountSecurityBean(obj: AccountSecurityBean | null): AccountSecurityBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    hasPassword: encodeboolean(obj.hasPassword)
  } as AccountSecurityBeanJSON);
}

type AccountStateBeanJSON = {
  accountId: string;
  blockedPopup?: ApplicationBlockedPopupBeanJSON;
  credits?: Array<ICreditJSON>;
  deviceId?: string;
  locale?: string;
  premium: PremiumRightBeanJSON;
  premiumPopup?: PremiumPopupBeanJSON;
  programmaticAds: ProgrammaticAdsBeanJSON;
  purchaselyActivated: string;
  sourceIpType?: PartnerTypeEnum;
  timeZone?: string;
};

export class AccountStateBean extends ServerBeanPrototype {
  accountId!: string;
  /** A popup do display when the user open the app, indicating an important message and usually that the app cannot be used. However the popup may be skippable or not...
 <br>&nbsp;<br>
 If null no popup shall be displayed
 @param blockedPopup the blockedPopup to set */
  blockedPopup?: ApplicationBlockedPopupBean;
  /** @param credits the credits to set */
  credits?: Array<ICredit>;
  /** @param deviceId the deviceId to set */
  deviceId?: string;
  /** @param locale the locale to set */
  locale?: string;
  /** @param premium the premium to set */
  premium!: PremiumRightBean;
  /** Information about a popup displayed during premium usecases (or at application launch ?) that advertise a promotion.<br>
 Also contains the promotion information for the store integration
 <br>&nbsp;<br>
 If null no popup shall be displayed
 @param premiumPopupBean the popup */
  premiumPopup?: PremiumPopupBean;
  /** Information and configuration about the programmatic ads */
  programmaticAds!: ProgrammaticAdsBean;
  /** flag indicating if purchasely is activated or not. */
  purchaselyActivated!: boolean;
  /** the type of ip the client is connected to: now unused
 @param getSourceIpType the getSourceIpType to set */
  sourceIpType?: PartnerTypeEnum;
  /** @param timeZone the timeZone to set */
  timeZone?: string;

  constructor(json: AccountStateBeanJSON) {
    super(json);
    this.accountId = decodeMetaId(json.accountId);
    this.blockedPopup = decodeApplicationBlockedPopupBean(json.blockedPopup);
    this.credits = decodeArray(decodeICredit)(json.credits);
    this.deviceId = decodeString(json.deviceId);
    this.locale = decodeString(json.locale);
    this.premium = decodePremiumRightBean(json.premium);
    this.premiumPopup = decodePremiumPopupBean(json.premiumPopup);
    this.programmaticAds = decodeProgrammaticAdsBean(json.programmaticAds);
    this.purchaselyActivated = decodeboolean(json.purchaselyActivated);
    this.sourceIpType = decodeEnum(json.sourceIpType);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.onDecode(json);
  }
}

function decodeAccountStateBean(json: AccountStateBeanJSON | undefined): AccountStateBean | undefined {
  return json === undefined ? undefined : new AccountStateBean(json);
}

function encodeAccountStateBean(obj: AccountStateBean | null): AccountStateBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeMetaId(obj.accountId),
    blockedPopup: encodeApplicationBlockedPopupBean(obj.blockedPopup),
    credits: encodeArray(encodeICredit)(obj.credits),
    deviceId: encodeString(obj.deviceId),
    locale: encodeString(obj.locale),
    premium: encodePremiumRightBean(obj.premium),
    premiumPopup: encodePremiumPopupBean(obj.premiumPopup),
    programmaticAds: encodeProgrammaticAdsBean(obj.programmaticAds),
    purchaselyActivated: encodeboolean(obj.purchaselyActivated),
    sourceIpType: encodeEnum(obj.sourceIpType),
    timeZone: encodeTimeZone(obj.timeZone)
  } as AccountStateBeanJSON);
}

type AddressBeanJSON = {
  addressId?: string;
  geocodedAddress: GeocodedAddressJSON;
  metaId?: string;
  placeType?: PlaceTypeEnum;
};

export class AddressBean extends ServerBeanPrototype {
  addressId?: string;
  geocodedAddress!: GeocodedAddress;
  metaId?: string;
  placeType?: PlaceTypeEnum;

  constructor(json: AddressBeanJSON) {
    super(json);
    this.addressId = decodeMetaId(json.addressId);
    this.geocodedAddress = decodeGeocodedAddress(json.geocodedAddress);
    this.metaId = decodeMetaId(json.metaId);
    this.placeType = decodeEnum(json.placeType);
    this.onDecode(json);
  }
}

function decodeAddressBean(json: AddressBeanJSON | undefined): AddressBean | undefined {
  return json === undefined ? undefined : new AddressBean(json);
}

function encodeAddressBean(obj: AddressBean | null): AddressBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    addressId: encodeMetaId(obj.addressId),
    geocodedAddress: encodeGeocodedAddress(obj.geocodedAddress),
    metaId: encodeMetaId(obj.metaId),
    placeType: encodeEnum(obj.placeType)
  } as AddressBeanJSON);
}

type AdminRightBeanJSON = {
  administrators: Array<string>;
  others: Array<string>;
};

export class AdminRightBean extends ServerBeanPrototype {
  /** List of administrators of the family, the first is the super Admin and
 its right cannot be removed
 
 @param administrators */
  administrators!: Array<number>;
  /** Others Account
 
 @param others */
  others!: Array<number>;

  constructor(json: AdminRightBeanJSON) {
    super(json);
    this.administrators = decodeArray(decodeNumber)(json.administrators);
    this.others = decodeArray(decodeNumber)(json.others);
    this.onDecode(json);
  }
}

function decodeAdminRightBean(json: AdminRightBeanJSON | undefined): AdminRightBean | undefined {
  return json === undefined ? undefined : new AdminRightBean(json);
}

function encodeAdminRightBean(obj: AdminRightBean | null): AdminRightBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    administrators: encodeArray(encodeNumber)(obj.administrators),
    others: encodeArray(encodeNumber)(obj.others)
  } as AdminRightBeanJSON);
}

type AiInboxResponseBeanJSON = {
  alternative?: string;
  available: string;
  current?: string;
  domain: string;
};

export class AiInboxResponseBean extends ServerBeanPrototype {
  alternative?: string;
  /** return true if the desired email is available */
  available!: boolean;
  /** return the email that is or have been set
 @param current */
  current?: string;
  /** the domain of the email, either import.familywall.com or import.staging.familywall.com
 @param domain the domain for import */
  domain!: string;

  constructor(json: AiInboxResponseBeanJSON) {
    super(json);
    this.alternative = decodeString(json.alternative);
    this.available = decodeboolean(json.available);
    this.current = decodeString(json.current);
    this.domain = decodeString(json.domain);
    this.onDecode(json);
  }
}

function decodeAiInboxResponseBean(json: AiInboxResponseBeanJSON | undefined): AiInboxResponseBean | undefined {
  return json === undefined ? undefined : new AiInboxResponseBean(json);
}

function encodeAiInboxResponseBean(obj: AiInboxResponseBean | null): AiInboxResponseBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    alternative: encodeString(obj.alternative),
    available: encodeboolean(obj.available),
    current: encodeString(obj.current),
    domain: encodeString(obj.domain)
  } as AiInboxResponseBeanJSON);
}

type ApiKeyBeanJSON = {
  accessRightRuleset: ApiAccessRightRulesetEnum;
  apiKeyClientType: ApiKeyClientType;
  clientId: string;
  clientSecret: string;
  forcedPartner?: PartnerTypeEnum;
  name?: string;
  oAuth2PasswordBasedAuthorized: string;
  webAnonymousAuthorized: string;
  webRedirectUrlPrefix?: string;
};

export class ApiKeyBean extends ServerBeanPrototype {
  /** @param accessRightRuleset the accessRightRuleset to set */
  accessRightRuleset!: ApiAccessRightRulesetEnum;
  /** @param apiKeyClientType the apiKeyClientType to set */
  apiKeyClientType!: ApiKeyClientType;
  /** @param clientId the clientId to set */
  clientId!: string;
  /** @param clientSecret the clientSecret to set */
  clientSecret!: string;
  /** @param forcedPartner the forcedPartner to set */
  forcedPartner?: PartnerTypeEnum;
  /** @param name the name to set */
  name?: string;
  /** @param isOAuth2PasswordBasedAuthorized the isOAuth2PasswordBasedAuthorized to set */
  oAuth2PasswordBasedAuthorized!: boolean;
  /** @param isWebAnonymousAuthorized the isWebAnonymousAuthorized to set */
  webAnonymousAuthorized!: boolean;
  /** @param webRedirectUrlPrefix the webRedirectUrlPrefix to set */
  webRedirectUrlPrefix?: string;

  constructor(json: ApiKeyBeanJSON) {
    super(json);
    this.accessRightRuleset = decodeEnum(json.accessRightRuleset);
    this.apiKeyClientType = decodeEnum(json.apiKeyClientType);
    this.clientId = decodeString(json.clientId);
    this.clientSecret = decodeString(json.clientSecret);
    this.forcedPartner = decodeEnum(json.forcedPartner);
    this.name = decodeString(json.name);
    this.oAuth2PasswordBasedAuthorized = decodeboolean(json.oAuth2PasswordBasedAuthorized);
    this.webAnonymousAuthorized = decodeboolean(json.webAnonymousAuthorized);
    this.webRedirectUrlPrefix = decodeString(json.webRedirectUrlPrefix);
    this.onDecode(json);
  }
}

function decodeApiKeyBean(json: ApiKeyBeanJSON | undefined): ApiKeyBean | undefined {
  return json === undefined ? undefined : new ApiKeyBean(json);
}

function encodeApiKeyBean(obj: ApiKeyBean | null): ApiKeyBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accessRightRuleset: encodeEnum(obj.accessRightRuleset),
    apiKeyClientType: encodeEnum(obj.apiKeyClientType),
    clientId: encodeString(obj.clientId),
    clientSecret: encodeString(obj.clientSecret),
    forcedPartner: encodeEnum(obj.forcedPartner),
    name: encodeString(obj.name),
    oAuth2PasswordBasedAuthorized: encodeboolean(obj.oAuth2PasswordBasedAuthorized),
    webAnonymousAuthorized: encodeboolean(obj.webAnonymousAuthorized),
    webRedirectUrlPrefix: encodeString(obj.webRedirectUrlPrefix)
  } as ApiKeyBeanJSON);
}

type ApplicationBlockedPopupBeanJSON = {
  buttonAction: ApplicationBlockedPopupActionEnum;
  buttonTitle: string;
  buttonUrl?: string;
  image?: string;
  skippable: string;
  text: string;
  title?: string;
};

export class ApplicationBlockedPopupBean extends ServerBeanPrototype {
  /** Action to perform when the user clicks on the button. URL : redirect to an url in the browser which is 
 @param buttonAction the buttonAction to set */
  buttonAction!: ApplicationBlockedPopupActionEnum;
  /** Text of the button of the popup
 @param buttonTitle the buttonTitle to set */
  buttonTitle!: string;
  /** If the buttonAction is "URL" this is the url to open when the user clicks on the button, else it is null.
 @param buttonUrl the buttonUrl to set */
  buttonUrl?: string;
  /** Possible image to display in the popup (if null no image)
 @param imageUri */
  image?: string;
  /** If true, the popup have a "close" option such as "later..." or something, else the popup cannot be closed.
 @param skippable the skippable to set */
  skippable!: boolean;
  /** Text to display in the popup
 @param text the text to set */
  text!: string;
  /** Possible title to display in the popup (if null no title)
 @param title the title to set */
  title?: string;

  constructor(json: ApplicationBlockedPopupBeanJSON) {
    super(json);
    this.buttonAction = decodeEnum(json.buttonAction);
    this.buttonTitle = decodeString(json.buttonTitle);
    this.buttonUrl = decodeString(json.buttonUrl);
    this.image = decodeString(json.image);
    this.skippable = decodeboolean(json.skippable);
    this.text = decodeString(json.text);
    this.title = decodeString(json.title);
    this.onDecode(json);
  }
}

function decodeApplicationBlockedPopupBean(json: ApplicationBlockedPopupBeanJSON | undefined): ApplicationBlockedPopupBean | undefined {
  return json === undefined ? undefined : new ApplicationBlockedPopupBean(json);
}

function encodeApplicationBlockedPopupBean(obj: ApplicationBlockedPopupBean | null): ApplicationBlockedPopupBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    buttonAction: encodeEnum(obj.buttonAction),
    buttonTitle: encodeString(obj.buttonTitle),
    buttonUrl: encodeString(obj.buttonUrl),
    image: encodeString(obj.image),
    skippable: encodeboolean(obj.skippable),
    text: encodeString(obj.text),
    title: encodeString(obj.title)
  } as ApplicationBlockedPopupBeanJSON);
}

type AssigneeBeanJSON = {
  accountId: string;
};

export class AssigneeBean extends ServerBeanPrototype {
  accountId!: number;

  constructor(json: AssigneeBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.onDecode(json);
  }
}

function decodeAssigneeBean(json: AssigneeBeanJSON | undefined): AssigneeBean | undefined {
  return json === undefined ? undefined : new AssigneeBean(json);
}

function encodeAssigneeBean(obj: AssigneeBean | null): AssigneeBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId)
  } as AssigneeBeanJSON);
}

type AttendeeBeanJSON = {
  accountId: string;
  attendeeResponse?: AttendeeResponseEnum;
  attendeeStatus?: AttendeeStatusEnum;
};

export class AttendeeBean extends ServerBeanPrototype {
  accountId!: number;
  attendeeResponse?: AttendeeResponseEnum;
  attendeeStatus?: AttendeeStatusEnum;

  constructor(json: AttendeeBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.attendeeResponse = decodeEnum(json.attendeeResponse);
    this.attendeeStatus = decodeEnum(json.attendeeStatus);
    this.onDecode(json);
  }
}

function decodeAttendeeBean(json: AttendeeBeanJSON | undefined): AttendeeBean | undefined {
  return json === undefined ? undefined : new AttendeeBean(json);
}

function encodeAttendeeBean(obj: AttendeeBean | null): AttendeeBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    attendeeResponse: encodeEnum(obj.attendeeResponse),
    attendeeStatus: encodeEnum(obj.attendeeStatus)
  } as AttendeeBeanJSON);
}

type BackgroundThreadStatusBeanJSON = {
  errorMessage?: string;
  errorStackTrace?: string;
  running: string;
  status?: string;
};

export class BackgroundThreadStatusBean extends ServerBeanPrototype {
  errorMessage?: string;
  errorStackTrace?: string;
  running!: boolean;
  status?: string;

  constructor(json: BackgroundThreadStatusBeanJSON) {
    super(json);
    this.errorMessage = decodeString(json.errorMessage);
    this.errorStackTrace = decodeString(json.errorStackTrace);
    this.running = decodeboolean(json.running);
    this.status = decodeString(json.status);
    this.onDecode(json);
  }
}

function decodeBackgroundThreadStatusBean(json: BackgroundThreadStatusBeanJSON | undefined): BackgroundThreadStatusBean | undefined {
  return json === undefined ? undefined : new BackgroundThreadStatusBean(json);
}

function encodeBackgroundThreadStatusBean(obj: BackgroundThreadStatusBean | null): BackgroundThreadStatusBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    errorMessage: encodeString(obj.errorMessage),
    errorStackTrace: encodeString(obj.errorStackTrace),
    running: encodeboolean(obj.running),
    status: encodeString(obj.status)
  } as BackgroundThreadStatusBeanJSON);
}

type BroadcastSignalMessageJSON = {
  payload?: IBroadcastableJSON;
  signalStringVal?: string;
  signalType: BroadcastSignalTypeEnum;
};

export class BroadcastSignalMessage extends ServerBeanPrototype {
  /** @param payload the payload to set */
  payload?: IBroadcastable;
  /** @param signalStringVal the signalStringVal to set */
  signalStringVal?: string;
  /** @param signalType the signalType to set */
  signalType!: BroadcastSignalTypeEnum;

  constructor(json: BroadcastSignalMessageJSON) {
    super(json);
    this.payload = decodeDynamic(json.payload) as IBroadcastable;
    this.signalStringVal = decodeString(json.signalStringVal);
    this.signalType = decodeEnum(json.signalType);
    this.onDecode(json);
  }
}

function decodeBroadcastSignalMessage(json: BroadcastSignalMessageJSON | undefined): BroadcastSignalMessage | undefined {
  return json === undefined ? undefined : new BroadcastSignalMessage(json);
}

function encodeBroadcastSignalMessage(obj: BroadcastSignalMessage | null): BroadcastSignalMessageJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    payload: encodeDynamic(obj.payload),
    signalStringVal: encodeString(obj.signalStringVal),
    signalType: encodeEnum(obj.signalType)
  } as BroadcastSignalMessageJSON);
}

type BudgetBeanJSON = {
  accountId?: string;
  budgetCategoryLimits?: {[key:string]:string};
  budgetLimit?: string;
  budgetLimitActive?: string;
  budgetLimitCategoryActive?: string;
  currencyCode?: string;
  emoji?: string;
  familyId: string;
  mainKPI?: BudgetMainKPIEnum;
  metaId: string;
  name?: string;
  paidUsage?: BudgetPaidUsageEnum;
  recurrencyStartDay?: string;
  rights?: FizRightBeanJSON;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
} & RecurrencyDescriptorJSON;

export class BudgetBean extends ServerBeanPrototype {
  /** if this is not null, this is a custom category and it returns the author */
  accountId?: number;
  /** A map of category limits keyed by the category's metaId. For instance:<pre>
 budgetCategoryLimits : {
    budgetCategory/23395_202 :  101.0
 },
 </pre>
 @param budgetCategoryLimits the budgetCategoryLimits to set */
  budgetCategoryLimits?: Map<string, number>;
  /** The value of the budget limit, as a double
 @param budgetLimit the budgetLimit to set */
  budgetLimit?: number;
  /** Flag indicating if the budget limit is active (true) or disabled (false)
 @param budgetLimitActive the budgetLimitActive to set */
  budgetLimitActive?: boolean;
  /** @param budgetLimitCategoryActive the budgetLimitCategoryActive to set */
  budgetLimitCategoryActive?: boolean;
  /** Code for the currency setting of this budget. This is the three-letter-code from ISO 4217
 @param currencyCode the currencyCode to set */
  currencyCode?: string;
  /** emoji of the budget
 @param emoji the emoji to set */
  emoji?: string;
  /** @param familyId the familyId to set */
  familyId!: number;
  /** Main kpi displayed in the cover of this budget
 @param mainKPI the mainKPI to set */
  mainKPI?: BudgetMainKPIEnum;
  metaId!: string;
  /** name of the budget
 @param name the name to set */
  name?: string;
  /** tells if KPI must use all or paid/unpaid transactions
 @param paidUsage the usage */
  paidUsage?: BudgetPaidUsageEnum;
  /** the reccureency descriptor (recurrency type, interval, enddate, endnb)
 @param recurrency */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** In case the budget is recurrent, this is the day for which the budget shall start. Zero is INVALID! <br> 
 It depends on the type of recurrency to compute the real startDate by some details:<ul>
 <li>Weekly: the day of the week by java.time.DayOfWeek convention where  1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
     Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1.
 <li>Monthly: the day of the month from 1 to 31, and -1, -2, -3 is also valid to indicate the last day of the month, etc...<br>
 Note that for day from 28 to 31 you must use a special rrule expression such as: <pre>
 		BYMONTHDAY=28,29,30,31;BYSETPOS=-1
 </pre> where the BYSTEPPOS is only used in addition to another 'byday' attribute to indicate the valid one you want to pick for each period (here the last one)<br>
 See the rrule specification for BYSETPOS
 <li>Yearly: the day of the year from 1 to 365 at which the yearly period begins. Note that using a calendar you can easily compute to (and from) mm/dd format to this
 number of day, but this only work if you use a non-bissextil year to perform the computation, else everything will be shifted by one day after februrary.
 </ul> */
  recurrencyStartDay?: number;
  rights?: FizRightBean;
  /** list of members who can see this list. This list always contains the author of the budget.<br>
 Those are account ids (member). <br>
 @param sharedMemberIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this budget is shared<br>
 If null it is in case of an update to indicate it is not changed. */
  sharedToAll?: boolean;

  constructor(json: BudgetBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.budgetCategoryLimits = decodeMap(decodeMetaId,decodeNumber)(json.budgetCategoryLimits);
    this.budgetLimit = decodeNumber(json.budgetLimit);
    this.budgetLimitActive = decodeBoolean(json.budgetLimitActive);
    this.budgetLimitCategoryActive = decodeBoolean(json.budgetLimitCategoryActive);
    this.currencyCode = decodeString(json.currencyCode);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.mainKPI = decodeEnum(json.mainKPI);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.paidUsage = decodeEnum(json.paidUsage);
    this.recurrencyStartDay = decodeNumber(json.recurrencyStartDay);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeBudgetBean(json: BudgetBeanJSON | undefined): BudgetBean | undefined {
  return json === undefined ? undefined : new BudgetBean(json);
}

function encodeBudgetBean(obj: BudgetBean | null): BudgetBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    budgetCategoryLimits: encodeMap(encodeMetaId,encodeNumber)(obj.budgetCategoryLimits),
    budgetLimit: encodeNumber(obj.budgetLimit),
    budgetLimitActive: encodeBoolean(obj.budgetLimitActive),
    budgetLimitCategoryActive: encodeBoolean(obj.budgetLimitCategoryActive),
    currencyCode: encodeString(obj.currencyCode),
    emoji: encodeString(obj.emoji),
    familyId: encodeNumber(obj.familyId),
    mainKPI: encodeEnum(obj.mainKPI),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    paidUsage: encodeEnum(obj.paidUsage),
    recurrencyStartDay: encodeNumber(obj.recurrencyStartDay),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll)
  } as BudgetBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type BudgetCategoryBeanJSON = {
  accountId?: string;
  budgetTransactionType?: BudgetTransactionType;
  default?: string;
  emoji?: string;
  familyId: string;
  hidden?: string;
  locale?: string;
  metaId: string;
  name?: string;
  rights?: FizRightBeanJSON;
  sortingIndex?: string;
  systemCategoryId?: string;
};

export class BudgetCategoryBean extends ServerBeanPrototype {
  accountId?: number;
  budgetTransactionType?: BudgetTransactionType;
  default?: boolean;
  emoji?: string;
  familyId!: number;
  hidden?: boolean;
  locale?: string;
  metaId!: string;
  name?: string;
  rights?: FizRightBean;
  sortingIndex?: number;
  systemCategoryId?: number;

  constructor(json: BudgetCategoryBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.default = decodeBoolean(json.default);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.hidden = decodeBoolean(json.hidden);
    this.locale = decodeString(json.locale);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.systemCategoryId = decodeNumber(json.systemCategoryId);
    this.onDecode(json);
  }
}

function decodeBudgetCategoryBean(json: BudgetCategoryBeanJSON | undefined): BudgetCategoryBean | undefined {
  return json === undefined ? undefined : new BudgetCategoryBean(json);
}

function encodeBudgetCategoryBean(obj: BudgetCategoryBean | null): BudgetCategoryBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    budgetTransactionType: encodeEnum(obj.budgetTransactionType),
    emoji: encodeString(obj.emoji),
    familyId: encodeNumber(obj.familyId),
    hidden: encodeBoolean(obj.hidden),
    locale: encodeString(obj.locale),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    sortingIndex: encodeNumber(obj.sortingIndex)
  } as BudgetCategoryBeanJSON);
}

type BudgetCategoryInputBeanJSON = {
  budgetTransactionType?: BudgetTransactionType;
  emoji?: string;
  hidden?: string;
  metaId?: string;
  name?: string;
};

export class BudgetCategoryInputBean extends ServerBeanPrototype {
  /** the type of transaction allowed for this category
 @param budgetTransactionType the budgetTransactionType to set */
  budgetTransactionType?: BudgetTransactionType;
  /** One char , the emoji associated with this category
 @param emoji the emoji to set */
  emoji?: string;
  /** @param hidden the hidden to set */
  hidden?: boolean;
  /** the id of the category. If this is a system category, objectId is <100000 */
  metaId?: string;
  /** Name of the task catetory. If set to null,it won't be modified
 @param name the name to set */
  name?: string;

  constructor(json: BudgetCategoryInputBeanJSON) {
    super(json);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.emoji = decodeString(json.emoji);
    this.hidden = decodeBoolean(json.hidden);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeBudgetCategoryInputBean(json: BudgetCategoryInputBeanJSON | undefined): BudgetCategoryInputBean | undefined {
  return json === undefined ? undefined : new BudgetCategoryInputBean(json);
}

function encodeBudgetCategoryInputBean(obj: BudgetCategoryInputBean | null): BudgetCategoryInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    budgetTransactionType: encodeEnum(obj.budgetTransactionType),
    emoji: encodeString(obj.emoji),
    hidden: encodeBoolean(obj.hidden),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name)
  } as BudgetCategoryInputBeanJSON);
}

type BudgetCategorySyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<BudgetCategoryBeanJSON>;
};

export class BudgetCategorySyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<BudgetCategoryBean>;

  constructor(json: BudgetCategorySyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeBudgetCategoryBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeBudgetCategorySyncBean(json: BudgetCategorySyncBeanJSON | undefined): BudgetCategorySyncBean | undefined {
  return json === undefined ? undefined : new BudgetCategorySyncBean(json);
}

function encodeBudgetCategorySyncBean(obj: BudgetCategorySyncBean | null): BudgetCategorySyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeBudgetCategoryBean)(obj.updatedCreated)
  } as BudgetCategorySyncBeanJSON);
}

type BudgetInputBeanJSON = {
  budgetCategoryLimits?: {[key:string]:string};
  budgetLimit?: string;
  budgetLimitActive?: string;
  budgetLimitCategoryActive?: string;
  currencyCode?: string;
  emoji?: string;
  mainKPI?: BudgetMainKPIEnum;
  metaId?: string;
  name?: string;
  paidUsage?: BudgetPaidUsageEnum;
  recurrencyStartDay?: string;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
} & RecurrencyDescriptorJSON;

export class BudgetInputBean extends ServerBeanPrototype {
  /** A map of category limits keyed by the category's metaId. For instance:<pre>
 budgetCategoryLimits : {
    budgetCategory/23395_202 :  101.0
 },
 </pre>
 @param budgetCategoryLimits the budgetCategoryLimits to set */
  budgetCategoryLimits?: Map<string, number>;
  /** The value of the budget limit, as a double
 @param budgetLimit the budgetLimit to set */
  budgetLimit?: number;
  /** Flag indicating if the budget limit is active (true) or disabled (false)
 @param budgetLimitActive the budgetLimitActive to set */
  budgetLimitActive?: boolean;
  /** @param budgetLimitCategoryActive the budgetLimitCategoryActive to set */
  budgetLimitCategoryActive?: boolean;
  /** Code for the currency setting of this budget. This is the three-letter-code from ISO 4217
 @param currencyCode the currencyCode to set */
  currencyCode?: string;
  /** emoji of the budget
 @param emoji the emoji to set */
  emoji?: string;
  /** Main kpi displayed in the cover of this budget
 @param mainKPI the mainKPI to set */
  mainKPI?: BudgetMainKPIEnum;
  /** metaId of the budget
 @param metaId the metaId to set */
  metaId?: string;
  /** name of the budget
 @param name the name to set */
  name?: string;
  /** tells if KPI must use all or paid/unpaid transactions
 @param paidUsage the usage */
  paidUsage?: BudgetPaidUsageEnum;
  /** the reccureency descriptor (recurrency type, interval, enddate, endnb)
 @param recurrency */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** In case the budget is recurrent, this is the day for which the budget shall start. Zero is INVALID! <br> 
 It depends on the type of recurrency to compute the real startDate by some details:<ul>
 <li>Weekly: the day of the week by java.time.DayOfWeek convention where  1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
     Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1.
 <li>Monthly: the day of the month from 1 to 31, and -1, -2, -3 is also valid to indicate the last day of the month, etc...<br>
 Note that for day from 28 to 31 you must use a special rrule expression such as: <pre>
 		BYMONTHDAY=28,29,30,31;BYSETPOS=-1
 </pre> where the BYSTEPPOS is only used in addition to another 'byday' attribute to indicate the valid one you want to pick for each period (here the last one)<br>
 See the rrule specification for BYSETPOS
 <li>Yearly: the day of the year from 1 to 365 at which the yearly period begins. Note that using a calendar you can easily compute to (and from) mm/dd format to this
 number of day, but this only work if you use a non-bissextil year to perform the computation, else everything will be shifted by one day after februrary.
 </ul> */
  recurrencyStartDay?: number;
  /** list of members who can see this list. This list always contains the author of the budget.<br>
 Those are account ids (member). <br>
 @param sharedMemberIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this budget is shared<br>
 If null it is in case of an update to indicate it is not changed. */
  sharedToAll?: boolean;

  constructor(json: BudgetInputBeanJSON) {
    super(json);
    this.budgetCategoryLimits = decodeMap(decodeMetaId,decodeNumber)(json.budgetCategoryLimits);
    this.budgetLimit = decodeNumber(json.budgetLimit);
    this.budgetLimitActive = decodeBoolean(json.budgetLimitActive);
    this.budgetLimitCategoryActive = decodeBoolean(json.budgetLimitCategoryActive);
    this.currencyCode = decodeString(json.currencyCode);
    this.emoji = decodeString(json.emoji);
    this.mainKPI = decodeEnum(json.mainKPI);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.paidUsage = decodeEnum(json.paidUsage);
    this.recurrencyStartDay = decodeNumber(json.recurrencyStartDay);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeBudgetInputBean(json: BudgetInputBeanJSON | undefined): BudgetInputBean | undefined {
  return json === undefined ? undefined : new BudgetInputBean(json);
}

function encodeBudgetInputBean(obj: BudgetInputBean | null): BudgetInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    budgetCategoryLimits: encodeMap(encodeMetaId,encodeNumber)(obj.budgetCategoryLimits),
    budgetLimit: encodeNumber(obj.budgetLimit),
    budgetLimitActive: encodeBoolean(obj.budgetLimitActive),
    budgetLimitCategoryActive: encodeBoolean(obj.budgetLimitCategoryActive),
    currencyCode: encodeString(obj.currencyCode),
    emoji: encodeString(obj.emoji),
    mainKPI: encodeEnum(obj.mainKPI),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    paidUsage: encodeEnum(obj.paidUsage),
    recurrencyStartDay: encodeNumber(obj.recurrencyStartDay),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll)
  } as BudgetInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type BudgetSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<BudgetBeanJSON>;
};

export class BudgetSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<BudgetBean>;

  constructor(json: BudgetSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeBudgetBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeBudgetSyncBean(json: BudgetSyncBeanJSON | undefined): BudgetSyncBean | undefined {
  return json === undefined ? undefined : new BudgetSyncBean(json);
}

function encodeBudgetSyncBean(obj: BudgetSyncBean | null): BudgetSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeBudgetBean)(obj.updatedCreated)
  } as BudgetSyncBeanJSON);
}

type BudgetTransactionBeanJSON = {
  accountId?: string;
  amount?: string;
  budgetCategoryId?: string;
  budgetId?: string;
  budgetTransactionType?: BudgetTransactionType;
  familyId: string;
  lastAction?: UserActionEnum;
  lastActionAuthor?: string;
  lastActionDate?: string;
  medias?: Array<IMediaJSON>;
  metaId: string;
  note?: string;
  paidOccurence?: Array<string>;
  paymentMethodId?: string;
  recurrencyExceptionOfId?: string;
  relatedAccountId?: string;
  reminderList?: Array<IReminderJSON>;
  rights?: FizRightBeanJSON;
  startDate?: string;
  title?: string;
} & RecurrencyDescriptorJSON;

export class BudgetTransactionBean extends ServerBeanPrototype {
  /** if this is not null, this is a custom category and it returns the author */
  accountId?: number;
  /** value of the transaction, always a positive number
 @param amount the amount to set */
  amount?: number;
  /** refer to a budget category. normally never null, but if null or not related to an existing category (desync case?)
 client shall point to a system category (the first one, the system one ?)
 @param budgetCategoryId the budgetCategoryId to set */
  budgetCategoryId?: string;
  /** The budget owning this transaction
 @param budgetId the budgetId to set */
  budgetId?: string;
  /** @param budgetTransactionType the transactionType to set */
  budgetTransactionType?: BudgetTransactionType;
  /** warning, do not use, only for ios
 @param familyId the familyId to set */
  familyId!: number;
  /** @param lastAction the lastAction to set */
  lastAction?: UserActionEnum;
  /** @param lastActionAuthor the lastActionAuthor to set */
  lastActionAuthor?: number;
  /** @param lastActionDate the lastActionDate to set */
  lastActionDate?: Date;
  /** the media of the transaction: warning, generator is not used and media must be manually generated */
  medias?: Array<IMedia>;
  metaId!: string;
  /** @param note the note to set */
  note?: string;
  /** this is handled only when creating a transaction
 this field is ignored on update, use budgetmarkaspaid api for existing transaction / transaction occurence
 @param paidOccurence */
  paidOccurence?: Array<number>;
  /** refer to a payment method. normally never null, but if null or not related to an existing category (desync case?)
 client shall point to a system payment method (the first one, the system one we don't care?)
 @param paymentMethodId the paymentMethodId to set */
  paymentMethodId?: string;
  /** the reccureency descriptor (recurrency type, interval, enddate, endnb)
 @param recurrency */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** metaId of the budget transaction from which this one is an occurrence Exception
 @param recurrencyExceptionOfId the metaId to set */
  recurrencyExceptionOfId?: string;
  /** the accountId of the payer or the beneficiary of the transaction
 @param relatedAccountId the relatedAccountId to set */
  relatedAccountId?: number;
  /** the list of reminders attached to this budget transaction
 @param reminderList the list of reminders */
  reminderList?: Array<IReminder>;
  rights?: FizRightBean;
  /** @param startDate the startDate to set */
  startDate?: Date;
  /** name of the budget transaction
 @param title the name to set */
  title?: string;

  constructor(json: BudgetTransactionBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.amount = decodeNumber(json.amount);
    this.budgetCategoryId = decodeMetaId(json.budgetCategoryId);
    this.budgetId = decodeMetaId(json.budgetId);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.familyId = decodeNumber(json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.note = decodeString(json.note);
    this.paidOccurence = decodeArray(decodeNumber)(json.paidOccurence);
    this.paymentMethodId = decodeMetaId(json.paymentMethodId);
    this.recurrencyExceptionOfId = decodeMetaId(json.recurrencyExceptionOfId);
    this.relatedAccountId = decodeNumber(json.relatedAccountId);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.rights = decodeFizRightBean(json.rights);
    this.startDate = decodeDate(json.startDate);
    this.title = decodeString(json.title);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeBudgetTransactionBean(json: BudgetTransactionBeanJSON | undefined): BudgetTransactionBean | undefined {
  return json === undefined ? undefined : new BudgetTransactionBean(json);
}

function encodeBudgetTransactionBean(obj: BudgetTransactionBean | null): BudgetTransactionBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    amount: encodeNumber(obj.amount),
    budgetCategoryId: encodeMetaId(obj.budgetCategoryId),
    budgetId: encodeMetaId(obj.budgetId),
    budgetTransactionType: encodeEnum(obj.budgetTransactionType),
    familyId: encodeNumber(obj.familyId),
    metaId: encodeMetaId(obj.metaId),
    note: encodeString(obj.note),
    paidOccurence: encodeArray(encodeNumber)(obj.paidOccurence),
    paymentMethodId: encodeMetaId(obj.paymentMethodId),
    relatedAccountId: encodeNumber(obj.relatedAccountId),
    reminderList: encodeArray(encodeIReminder)(obj.reminderList),
    startDate: encodeDate(obj.startDate),
    title: encodeString(obj.title)
  } as BudgetTransactionBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type BudgetTransactionInputBeanJSON = {
  amount?: string;
  budgetCategoryId?: string;
  budgetId?: string;
  budgetTransactionType?: BudgetTransactionType;
  metaId?: string;
  note?: string;
  paidOccurence?: Array<string>;
  paymentMethodId?: string;
  recurrencyExceptionOfId?: string;
  relatedAccountId?: string;
  reminderList?: Array<IReminderJSON>;
  startDate?: string;
  title?: string;
} & RecurrencyDescriptorJSON;

export class BudgetTransactionInputBean extends ServerBeanPrototype {
  /** value of the transaction, always a positive number
 @param amount the amount to set */
  amount?: number;
  /** refer to a budget category. normally never null, but if null or not related to an existing category (desync case?)
 client shall point to a system category (the first one, the system one ?)
 @param budgetCategoryId the budgetCategoryId to set */
  budgetCategoryId?: string;
  /** The budget owning this transaction
 @param budgetId the budgetId to set */
  budgetId?: string;
  /** @param budgetTransactionType the transactionType to set */
  budgetTransactionType?: BudgetTransactionType;
  /** metaId of the budget transaction
 @param metaId the metaId to set */
  metaId?: string;
  /** @param note the note to set */
  note?: string;
  /** this is handled only when creating a transaction
 this field is ignored on update, use budgetmarkaspaid api for existing transaction / transaction occurence
 @param paidOccurence */
  paidOccurence?: Array<number>;
  /** refer to a payment method. normally never null, but if null or not related to an existing category (desync case?)
 client shall point to a system payment method (the first one, the system one we don't care?)
 @param paymentMethodId the paymentMethodId to set */
  paymentMethodId?: string;
  /** the reccureency descriptor (recurrency type, interval, enddate, endnb)
 @param recurrency */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** metaId of the budget transaction from which this one is an occurrence Exception
 @param recurrencyExceptionOfId the metaId to set */
  recurrencyExceptionOfId?: string;
  /** the accountId of the payer or the beneficiary of the transaction
 @param relatedAccountId the relatedAccountId to set */
  relatedAccountId?: number;
  /** the list of reminders attached to this budget transaction
 @param reminderList the list of reminders */
  reminderList?: Array<IReminder>;
  /** @param startDate the startDate to set */
  startDate?: Date;
  /** name of the budget transaction
 @param title the name to set */
  title?: string;

  constructor(json: BudgetTransactionInputBeanJSON) {
    super(json);
    this.amount = decodeNumber(json.amount);
    this.budgetCategoryId = decodeMetaId(json.budgetCategoryId);
    this.budgetId = decodeMetaId(json.budgetId);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.metaId = decodeMetaId(json.metaId);
    this.note = decodeString(json.note);
    this.paidOccurence = decodeArray(decodeNumber)(json.paidOccurence);
    this.paymentMethodId = decodeMetaId(json.paymentMethodId);
    this.recurrencyExceptionOfId = decodeMetaId(json.recurrencyExceptionOfId);
    this.relatedAccountId = decodeNumber(json.relatedAccountId);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.title = decodeString(json.title);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeBudgetTransactionInputBean(json: BudgetTransactionInputBeanJSON | undefined): BudgetTransactionInputBean | undefined {
  return json === undefined ? undefined : new BudgetTransactionInputBean(json);
}

function encodeBudgetTransactionInputBean(obj: BudgetTransactionInputBean | null): BudgetTransactionInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    amount: encodeNumber(obj.amount),
    budgetCategoryId: encodeMetaId(obj.budgetCategoryId),
    budgetId: encodeMetaId(obj.budgetId),
    budgetTransactionType: encodeEnum(obj.budgetTransactionType),
    metaId: encodeMetaId(obj.metaId),
    note: encodeString(obj.note),
    paidOccurence: encodeArray(encodeNumber)(obj.paidOccurence),
    paymentMethodId: encodeMetaId(obj.paymentMethodId),
    relatedAccountId: encodeNumber(obj.relatedAccountId),
    reminderList: encodeArray(encodeIReminder)(obj.reminderList),
    startDate: encodeDate(obj.startDate),
    title: encodeString(obj.title)
  } as BudgetTransactionInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type BudgetTransactionSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<BudgetTransactionBeanJSON>;
};

export class BudgetTransactionSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<BudgetTransactionBean>;

  constructor(json: BudgetTransactionSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeBudgetTransactionBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeBudgetTransactionSyncBean(json: BudgetTransactionSyncBeanJSON | undefined): BudgetTransactionSyncBean | undefined {
  return json === undefined ? undefined : new BudgetTransactionSyncBean(json);
}

function encodeBudgetTransactionSyncBean(obj: BudgetTransactionSyncBean | null): BudgetTransactionSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeBudgetTransactionBean)(obj.updatedCreated)
  } as BudgetTransactionSyncBeanJSON);
}

type CCareUserBeanJSON = {
  roles: Array<CCareRoleEnum>;
  username: string;
};

export class CCareUserBean extends ServerBeanPrototype {
  /** @param roles the roles to set (will be stored as unmodifiable) */
  roles!: Array<CCareRoleEnum>;
  /** @param username the username to set */
  username!: string;

  constructor(json: CCareUserBeanJSON) {
    super(json);
    this.roles = decodeArray(decodeEnum)(json.roles);
    this.username = decodeString(json.username);
    this.onDecode(json);
  }
}

function decodeCCareUserBean(json: CCareUserBeanJSON | undefined): CCareUserBean | undefined {
  return json === undefined ? undefined : new CCareUserBean(json);
}

function encodeCCareUserBean(obj: CCareUserBean | null): CCareUserBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    roles: encodeArray(encodeEnum)(obj.roles),
    username: encodeString(obj.username)
  } as CCareUserBeanJSON);
}

type CacheInvalidatedMessageBeanJSON = {
  classname: string;
  ownerId: string;
};

export class CacheInvalidatedMessageBean extends ServerBeanPrototype {
  /** @param classname the classname to set */
  classname!: string;
  /** @param ownerId the ownerId to set */
  ownerId!: number;

  constructor(json: CacheInvalidatedMessageBeanJSON) {
    super(json);
    this.classname = decodeString(json.classname);
    this.ownerId = decodeNumber(json.ownerId);
    this.onDecode(json);
  }
}

function decodeCacheInvalidatedMessageBean(json: CacheInvalidatedMessageBeanJSON | undefined): CacheInvalidatedMessageBean | undefined {
  return json === undefined ? undefined : new CacheInvalidatedMessageBean(json);
}

function encodeCacheInvalidatedMessageBean(obj: CacheInvalidatedMessageBean | null): CacheInvalidatedMessageBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    classname: encodeString(obj.classname),
    ownerId: encodeNumber(obj.ownerId)
  } as CacheInvalidatedMessageBeanJSON);
}

type CalendarBeanJSON = {
  activated: string;
  calendars?: Array<CalendarBeanJSON>;
  color?: string;
  countryCode?: string;
  countryLang?: string;
  errorCode?: string;
  errorMessage?: string;
  familyId?: string;
  icalAble?: string;
  location?: string;
  metaId: string;
  mine?: string;
  name?: string;
  nameEditable?: string;
  referenceId?: string;
  reminderActivated?: string;
  rights?: FizRightBeanJSON;
  sharedByAccountId?: string;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
  subtitle?: string;
  type?: CalendarTypeEnum;
  url?: string;
  useEventColor?: string;
  useEventColorEditable: string;
};

export class CalendarBean extends ServerBeanPrototype {
  /** if the use want to see those events */
  activated!: boolean;
  /** When calendar type = folder, this contains the folder's content.  
 @param calendars */
  calendars?: Array<CalendarBean>;
  /** color code used by default for events in this calendar
 nullable only when used as input => means do not change the color */
  color?: string;
  /** The country code of this suggestion (ISO 3166 alpha-2 country code)
 @param countryCode country Code */
  countryCode?: string;
  /** The _optional_ language, if this country supports different variant language, as ISO 639 alpha-2 or alpha-3 language code
 @param countryLang iso-639 language code */
  countryLang?: string;
  errorCode?: string;
  errorMessage?: string;
  /** Id of the family active for this calendar. Note: this is an helper method for iOS to manage calendar list,
 The only calendar that have real family relationship is the familywall native calendar, other external calendar are
 common to all families of an account.
 isNullabel only when used as an input Bean
 @param familyId the familyId to set */
  familyId?: string;
  /** if true an ical url might be generated for this
 if false or null it is not
 We do not want to generate ical for static ical/google/oulook calendar (even if it works)
 @param icalAble */
  icalAble?: boolean;
  /** Description item: When calendar correspond to an optional location (such as holiday), area of the world it apply to (ie france) */
  location?: string;
  /** id of the calendar, metaId.type corresponds to the type of calendar (calendar,extCalendar,extGoogleCalendar) */
  metaId!: string;
  /** is it the calendar of the current user?
 null only for Bean used as Input
 @param mine */
  mine?: boolean;
  /** name of the calendar for the UI (title)
 nullable only if bean used as input */
  name?: string;
  /** If true name is allowed to be editable
 @param nameEditable */
  nameEditable?: boolean;
  /** id of the object reference (if it is a calendarBudget it will be the id of the budget) */
  referenceId?: string;
  /** Flag indicating that the reminder is activated for this external calendar. Relevent only for external calendar: ical urls, google or outlook
 @param reminderActivated the reminderActivated to set */
  reminderActivated?: boolean;
  /** rights of update/delete for this calendar, depends on the loggued account and the author */
  rights?: FizRightBean;
  /** the accountId of the account who shared this calendar (only if shared by somebody else, if not it is null)
 @param sharedByAccountId */
  sharedByAccountId?: number;
  sharedMemberIds?: Array<number>;
  sharedToAll?: boolean;
  /** subtitle of the calendar for the UI */
  subtitle?: string;
  /** if it is a folder it describe what kind of display can be done between calendars inside */
  type?: CalendarTypeEnum;
  /** the url of the calendar
 used only for externalCalendarByUrl
 @param nameEditable */
  url?: string;
  /** if false or null => when displaying all events of all calendar events from this calendar must use the color of the calendar and not theirs
 if true => it should use the event color (and calendar color if the color of the event is null) */
  useEventColor?: boolean;
  /** indicate that the ui for (de)activating useEventColor might be displayed or not
 @param useEventColorEditable */
  useEventColorEditable!: boolean;

  constructor(json: CalendarBeanJSON) {
    super(json);
    this.activated = decodeboolean(json.activated);
    this.calendars = decodeArray(decodeCalendarBean)(json.calendars);
    this.color = decodeString(json.color);
    this.countryCode = decodeString(json.countryCode);
    this.countryLang = decodeString(json.countryLang);
    this.errorCode = decodeString(json.errorCode);
    this.errorMessage = decodeString(json.errorMessage);
    this.familyId = decodeMetaId(json.familyId);
    this.icalAble = decodeBoolean(json.icalAble);
    this.location = decodeString(json.location);
    this.metaId = decodeMetaId(json.metaId);
    this.mine = decodeBoolean(json.mine);
    this.name = decodeString(json.name);
    this.nameEditable = decodeBoolean(json.nameEditable);
    this.referenceId = decodeMetaId(json.referenceId);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedByAccountId = decodeNumber(json.sharedByAccountId);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.subtitle = decodeString(json.subtitle);
    this.type = decodeEnum(json.type);
    this.url = decodeString(json.url);
    this.useEventColor = decodeBoolean(json.useEventColor);
    this.useEventColorEditable = decodeboolean(json.useEventColorEditable);
    this.onDecode(json);
  }
}

function decodeCalendarBean(json: CalendarBeanJSON | undefined): CalendarBean | undefined {
  return json === undefined ? undefined : new CalendarBean(json);
}

function encodeCalendarBean(obj: CalendarBean | null): CalendarBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    activated: encodeboolean(obj.activated),
    color: encodeString(obj.color),
    errorCode: encodeString(obj.errorCode),
    errorMessage: encodeString(obj.errorMessage),
    familyId: encodeMetaId(obj.familyId),
    location: encodeString(obj.location),
    metaId: encodeMetaId(obj.metaId),
    mine: encodeBoolean(obj.mine),
    name: encodeString(obj.name),
    referenceId: encodeMetaId(obj.referenceId),
    reminderActivated: encodeBoolean(obj.reminderActivated),
    rights: encodeFizRightBean(obj.rights),
    sharedByAccountId: encodeNumber(obj.sharedByAccountId),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll),
    subtitle: encodeString(obj.subtitle),
    useEventColor: encodeBoolean(obj.useEventColor)
  } as CalendarBeanJSON);
}

type CalendarGroupBeanJSON = {
  budgets: Array<CalendarBeanJSON>;
  external: Array<CalendarBeanJSON>;
  families: Array<CalendarBeanJSON>;
  google?: CalendarBeanJSON;
  googles: Array<GoogleCredentialBeanJSON>;
  mine: Array<CalendarBeanJSON>;
  outlook?: CalendarBeanJSON;
  outlooks: Array<OutlookCredentialBeanJSON>;
  suggestions: Array<CalendarSuggestionBeanJSON>;
  timetables: Array<CalendarTimetableBeanJSON>;
};

export class CalendarGroupBean extends ServerBeanPrototype {
  /** The list of budget for this family */
  budgets!: Array<CalendarBean>;
  /** the external ical subscriptions calendar, for this account only
 @param external */
  external!: Array<CalendarBean>;
  /** Calendars shared by other family members, ie this is not your calendars
 @param families */
  families!: Array<CalendarBean>;
  /** One google CalendarBean (also in the list of credential)
 @param google */
  google?: CalendarBean;
  /** The list of google's credentials, each credential bean containing in itself a credential and a list of linked CalendarBean.
 @return */
  googles!: Array<GoogleCredentialBean>;
  /** Mine calendars, IE calendar that shall be displayed in _MY_ calendar menu, composed of the <ul>
 <li>familywall calendar,</li> 
 <li>synthetic calendars (tasklist calendar and meal planner calendar),</li>
 <li>other circle's calendars</li>
 <li>All automatically-added calendars from icals, and calendar associated with this account in PCalendarAssociation .</li>
 </ul>
 @param mine */
  mine!: Array<CalendarBean>;
  /** for only one outlook calendar, it is also in the Collection<OutlookCredentialBean>
 @param outlook */
  outlook?: CalendarBean;
  /** The list of outlook's credentials, each credential bean containing in itself a credential and a list of linked CalendarBean.
 @param outlook */
  outlooks!: Array<OutlookCredentialBean>;
  /** The suggested calendar for each supported countries, and optionally language
 @param suggestions the list of suggestions */
  suggestions!: Array<CalendarSuggestionBean>;
  /** The list of timetables for this family */
  timetables!: Array<CalendarTimetableBean>;

  constructor(json: CalendarGroupBeanJSON) {
    super(json);
    this.budgets = decodeArray(decodeCalendarBean)(json.budgets);
    this.external = decodeArray(decodeCalendarBean)(json.external);
    this.families = decodeArray(decodeCalendarBean)(json.families);
    this.google = decodeCalendarBean(json.google);
    this.googles = decodeArray(decodeGoogleCredentialBean)(json.googles);
    this.mine = decodeArray(decodeCalendarBean)(json.mine);
    this.outlook = decodeCalendarBean(json.outlook);
    this.outlooks = decodeArray(decodeOutlookCredentialBean)(json.outlooks);
    this.suggestions = decodeArray(decodeCalendarSuggestionBean)(json.suggestions);
    this.timetables = decodeArray(decodeCalendarTimetableBean)(json.timetables);
    this.onDecode(json);
  }
}

function decodeCalendarGroupBean(json: CalendarGroupBeanJSON | undefined): CalendarGroupBean | undefined {
  return json === undefined ? undefined : new CalendarGroupBean(json);
}

function encodeCalendarGroupBean(obj: CalendarGroupBean | null): CalendarGroupBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    budgets: encodeArray(encodeCalendarBean)(obj.budgets),
    external: encodeArray(encodeCalendarBean)(obj.external),
    families: encodeArray(encodeCalendarBean)(obj.families),
    google: encodeCalendarBean(obj.google),
    googles: encodeArray(encodeGoogleCredentialBean)(obj.googles),
    mine: encodeArray(encodeCalendarBean)(obj.mine),
    outlook: encodeCalendarBean(obj.outlook),
    outlooks: encodeArray(encodeOutlookCredentialBean)(obj.outlooks),
    suggestions: encodeArray(encodeCalendarSuggestionBean)(obj.suggestions),
    timetables: encodeArray(encodeCalendarTimetableBean)(obj.timetables)
  } as CalendarGroupBeanJSON);
}

type CalendarSharedBeanJSON = {
  calendar: CalendarBeanJSON;
  syncBean: EventSyncBeanJSON;
};

export class CalendarSharedBean extends ServerBeanPrototype {
  calendar!: CalendarBean;
  syncBean!: EventSyncBean;

  constructor(json: CalendarSharedBeanJSON) {
    super(json);
    this.calendar = decodeDynamic(json.calendar) as CalendarBean;
    this.syncBean = decodeEventSyncBean(json.syncBean);
    this.onDecode(json);
  }
}

function decodeCalendarSharedBean(json: CalendarSharedBeanJSON | undefined): CalendarSharedBean | undefined {
  return json === undefined ? undefined : new CalendarSharedBean(json);
}

function encodeCalendarSharedBean(obj: CalendarSharedBean | null): CalendarSharedBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    calendar: encodeDynamic(obj.calendar),
    syncBean: encodeEventSyncBean(obj.syncBean)
  } as CalendarSharedBeanJSON);
}

type CalendarSubscriptionResponseBeanJSON = {
  createdMetaId: Array<string>;
};

export class CalendarSubscriptionResponseBean extends ServerBeanPrototype {
  createdMetaId!: Array<string>;

  constructor(json: CalendarSubscriptionResponseBeanJSON) {
    super(json);
    this.createdMetaId = decodeArray(decodeMetaId)(json.createdMetaId);
    this.onDecode(json);
  }
}

function decodeCalendarSubscriptionResponseBean(json: CalendarSubscriptionResponseBeanJSON | undefined): CalendarSubscriptionResponseBean | undefined {
  return json === undefined ? undefined : new CalendarSubscriptionResponseBean(json);
}

function encodeCalendarSubscriptionResponseBean(obj: CalendarSubscriptionResponseBean | null): CalendarSubscriptionResponseBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    createdMetaId: encodeArray(encodeMetaId)(obj.createdMetaId)
  } as CalendarSubscriptionResponseBeanJSON);
}

type CalendarSuggestionBeanJSON = {
  calendarIds: Array<string>;
  countryCode: string;
  countryLang?: string;
};

export class CalendarSuggestionBean extends ServerBeanPrototype {
  /** The metaIds of suggested calenday for this country / language
 @param calendarIds the list of metaId */
  calendarIds!: Array<string>;
  /** The country code of this suggestion (ISO 3166 alpha-2 country code)
 @param countryCode country Code */
  countryCode!: string;
  /** The _optional_ language, if this country supports different variant language, as ISO 639 alpha-2 or alpha-3 language code
 @param countryLang iso-639 language code */
  countryLang?: string;

  constructor(json: CalendarSuggestionBeanJSON) {
    super(json);
    this.calendarIds = decodeArray(decodeMetaId)(json.calendarIds);
    this.countryCode = decodeString(json.countryCode);
    this.countryLang = decodeString(json.countryLang);
    this.onDecode(json);
  }
}

function decodeCalendarSuggestionBean(json: CalendarSuggestionBeanJSON | undefined): CalendarSuggestionBean | undefined {
  return json === undefined ? undefined : new CalendarSuggestionBean(json);
}

function encodeCalendarSuggestionBean(obj: CalendarSuggestionBean | null): CalendarSuggestionBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    calendarIds: encodeArray(encodeMetaId)(obj.calendarIds),
    countryCode: encodeString(obj.countryCode),
    countryLang: encodeString(obj.countryLang)
  } as CalendarSuggestionBeanJSON);
}

type CalendarTimetableBeanJSON = {
  activated: string;
  calendars?: Array<CalendarBeanJSON>;
  color?: string;
  countryCode?: string;
  countryLang?: string;
  errorCode?: string;
  errorMessage?: string;
  familyId?: string;
  icalAble?: string;
  location?: string;
  metaId: string;
  mine?: string;
  name?: string;
  nameEditable?: string;
  referenceId?: string;
  reminderActivated?: string;
  rights?: FizRightBeanJSON;
  sharedByAccountId?: string;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
  subtitle?: string;
  timetable: TimetableBeanJSON;
  type?: CalendarTypeEnum;
  url?: string;
  useEventColor?: string;
  useEventColorEditable: string;
};

export class CalendarTimetableBean extends ServerBeanPrototype {
  /** if the use want to see those events */
  activated!: boolean;
  /** When calendar type = folder, this contains the folder's content.  
 @param calendars */
  calendars?: Array<CalendarBean>;
  /** color code used by default for events in this calendar
 nullable only when used as input => means do not change the color */
  color?: string;
  /** The country code of this suggestion (ISO 3166 alpha-2 country code)
 @param countryCode country Code */
  countryCode?: string;
  /** The _optional_ language, if this country supports different variant language, as ISO 639 alpha-2 or alpha-3 language code
 @param countryLang iso-639 language code */
  countryLang?: string;
  errorCode?: string;
  errorMessage?: string;
  /** Id of the family active for this calendar. Note: this is an helper method for iOS to manage calendar list,
 The only calendar that have real family relationship is the familywall native calendar, other external calendar are
 common to all families of an account.
 isNullabel only when used as an input Bean
 @param familyId the familyId to set */
  familyId?: string;
  /** if true an ical url might be generated for this
 if false or null it is not
 We do not want to generate ical for static ical/google/oulook calendar (even if it works)
 @param icalAble */
  icalAble?: boolean;
  /** Description item: When calendar correspond to an optional location (such as holiday), area of the world it apply to (ie france) */
  location?: string;
  /** id of the calendar, metaId.type corresponds to the type of calendar (calendar,extCalendar,extGoogleCalendar) */
  metaId!: string;
  /** is it the calendar of the current user?
 null only for Bean used as Input
 @param mine */
  mine?: boolean;
  /** name of the calendar for the UI (title)
 nullable only if bean used as input */
  name?: string;
  /** If true name is allowed to be editable
 @param nameEditable */
  nameEditable?: boolean;
  /** id of the object reference (if it is a calendarBudget it will be the id of the budget) */
  referenceId?: string;
  /** Flag indicating that the reminder is activated for this external calendar. Relevent only for external calendar: ical urls, google or outlook
 @param reminderActivated the reminderActivated to set */
  reminderActivated?: boolean;
  /** rights of update/delete for this calendar, depends on the loggued account and the author */
  rights?: FizRightBean;
  /** the accountId of the account who shared this calendar (only if shared by somebody else, if not it is null)
 @param sharedByAccountId */
  sharedByAccountId?: number;
  sharedMemberIds?: Array<number>;
  sharedToAll?: boolean;
  /** subtitle of the calendar for the UI */
  subtitle?: string;
  /** @param timetable the timetable to set */
  timetable!: TimetableBean;
  /** if it is a folder it describe what kind of display can be done between calendars inside */
  type?: CalendarTypeEnum;
  /** the url of the calendar
 used only for externalCalendarByUrl
 @param nameEditable */
  url?: string;
  /** if false or null => when displaying all events of all calendar events from this calendar must use the color of the calendar and not theirs
 if true => it should use the event color (and calendar color if the color of the event is null) */
  useEventColor?: boolean;
  /** indicate that the ui for (de)activating useEventColor might be displayed or not
 @param useEventColorEditable */
  useEventColorEditable!: boolean;

  constructor(json: CalendarTimetableBeanJSON) {
    super(json);
    this.activated = decodeboolean(json.activated);
    this.calendars = decodeArray(decodeCalendarBean)(json.calendars);
    this.color = decodeString(json.color);
    this.countryCode = decodeString(json.countryCode);
    this.countryLang = decodeString(json.countryLang);
    this.errorCode = decodeString(json.errorCode);
    this.errorMessage = decodeString(json.errorMessage);
    this.familyId = decodeMetaId(json.familyId);
    this.icalAble = decodeBoolean(json.icalAble);
    this.location = decodeString(json.location);
    this.metaId = decodeMetaId(json.metaId);
    this.mine = decodeBoolean(json.mine);
    this.name = decodeString(json.name);
    this.nameEditable = decodeBoolean(json.nameEditable);
    this.referenceId = decodeMetaId(json.referenceId);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedByAccountId = decodeNumber(json.sharedByAccountId);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.subtitle = decodeString(json.subtitle);
    this.timetable = decodeTimetableBean(json.timetable);
    this.type = decodeEnum(json.type);
    this.url = decodeString(json.url);
    this.useEventColor = decodeBoolean(json.useEventColor);
    this.useEventColorEditable = decodeboolean(json.useEventColorEditable);
    this.onDecode(json);
  }
}

function decodeCalendarTimetableBean(json: CalendarTimetableBeanJSON | undefined): CalendarTimetableBean | undefined {
  return json === undefined ? undefined : new CalendarTimetableBean(json);
}

function encodeCalendarTimetableBean(obj: CalendarTimetableBean | null): CalendarTimetableBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    activated: encodeboolean(obj.activated),
    color: encodeString(obj.color),
    errorCode: encodeString(obj.errorCode),
    errorMessage: encodeString(obj.errorMessage),
    familyId: encodeMetaId(obj.familyId),
    location: encodeString(obj.location),
    metaId: encodeMetaId(obj.metaId),
    mine: encodeBoolean(obj.mine),
    name: encodeString(obj.name),
    referenceId: encodeMetaId(obj.referenceId),
    reminderActivated: encodeBoolean(obj.reminderActivated),
    rights: encodeFizRightBean(obj.rights),
    sharedByAccountId: encodeNumber(obj.sharedByAccountId),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll),
    subtitle: encodeString(obj.subtitle),
    timetable: encodeTimetableBean(obj.timetable),
    useEventColor: encodeBoolean(obj.useEventColor)
  } as CalendarTimetableBeanJSON);
}

type CategoryBeanJSON = {
  accountId?: string;
  categorySystem?: RecipeSystemCategoryEnum;
  emoji?: string;
  familyId: string;
  listed: string;
  metaId: string;
  name?: string;
  rights?: FizRightBeanJSON;
  sortingIndex: string;
};

export class CategoryBean extends ServerBeanPrototype {
  accountId?: number;
  categorySystem?: RecipeSystemCategoryEnum;
  emoji?: string;
  familyId!: number;
  listed!: boolean;
  metaId!: string;
  name?: string;
  rights?: FizRightBean;
  sortingIndex!: number;

  constructor(json: CategoryBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.categorySystem = decodeEnum(json.categorySystem);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.listed = decodeboolean(json.listed);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.onDecode(json);
  }
}

function decodeCategoryBean(json: CategoryBeanJSON | undefined): CategoryBean | undefined {
  return json === undefined ? undefined : new CategoryBean(json);
}

function encodeCategoryBean(obj: CategoryBean | null): CategoryBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    categorySystem: encodeEnum(obj.categorySystem),
    emoji: encodeString(obj.emoji),
    familyId: encodeNumber(obj.familyId),
    listed: encodeboolean(obj.listed),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    sortingIndex: encodeNumber(obj.sortingIndex)
  } as CategoryBeanJSON);
}

type CategoryDescriptorJSON = {
};

export class CategoryDescriptor extends ServerBeanPrototype {

  constructor(json: CategoryDescriptorJSON) {
    super(json);
    this.onDecode(json);
  }
}

function decodeCategoryDescriptor(json: CategoryDescriptorJSON | undefined): CategoryDescriptor | undefined {
  return json === undefined ? undefined : new CategoryDescriptor(json);
}

function encodeCategoryDescriptor(obj: CategoryDescriptor | null): CategoryDescriptorJSON | undefined {
  if (obj == null) return undefined;
  return inline({} as CategoryDescriptorJSON);
}

type CategoryInputBeanJSON = {
  emoji?: string;
  metaId?: string;
  name?: string;
};

export class CategoryInputBean extends ServerBeanPrototype {
  /** @param icon the icon to set */
  emoji?: string;
  /** the id of the category. If this is a system category, accountId is <1000 and objectId is null. */
  metaId?: string;
  /** Name of the custom color. If null it is a system palette color or it won't be modified
 @param name the name to set */
  name?: string;

  constructor(json: CategoryInputBeanJSON) {
    super(json);
    this.emoji = decodeString(json.emoji);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeCategoryInputBean(json: CategoryInputBeanJSON | undefined): CategoryInputBean | undefined {
  return json === undefined ? undefined : new CategoryInputBean(json);
}

function encodeCategoryInputBean(obj: CategoryInputBean | null): CategoryInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    emoji: encodeString(obj.emoji),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name)
  } as CategoryInputBeanJSON);
}

type CleanResultBeanJSON = {
  dbDeleteCount: string;
  deletedCount: string;
  memoryFree: string;
};

export class CleanResultBean extends ServerBeanPrototype {
  dbDeleteCount!: number;
  deletedCount!: number;
  memoryFree!: number;

  constructor(json: CleanResultBeanJSON) {
    super(json);
    this.dbDeleteCount = decodenumber(json.dbDeleteCount);
    this.deletedCount = decodenumber(json.deletedCount);
    this.memoryFree = decodenumber(json.memoryFree);
    this.onDecode(json);
  }
}

function decodeCleanResultBean(json: CleanResultBeanJSON | undefined): CleanResultBean | undefined {
  return json === undefined ? undefined : new CleanResultBean(json);
}

function encodeCleanResultBean(obj: CleanResultBean | null): CleanResultBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    dbDeleteCount: encodenumber(obj.dbDeleteCount),
    deletedCount: encodenumber(obj.deletedCount),
    memoryFree: encodenumber(obj.memoryFree)
  } as CleanResultBeanJSON);
}

type ClusterNodeStatusJSON = {
  clusterMember: string;
  connected: string;
  databaseStatus?: DatabaseHealthStatusBeanJSON;
  lastMessageReceived?: string;
  lastMessageSent?: string;
  localLeader?: string;
  me?: string;
  serverId: string;
  serverNb: string;
};

export class ClusterNodeStatus extends ServerBeanPrototype {
  /** true if the leader can connect to this node (ie a cluster member)
 @param clusterMember */
  clusterMember!: boolean;
  /** connection flag (true = connected to the cluster), not relevent for this host's node
 @param connected */
  connected!: boolean;
  /** database status bean
 @param databaseStatus database status */
  databaseStatus?: DatabaseHealthStatusBean;
  lastMessageReceived?: Date;
  lastMessageSent?: Date;
  /** true if this node has won the election computed on the said node (local)
 @param localLeader */
  localLeader?: boolean;
  /** flag for the node of this host
 @param me */
  me?: boolean;
  /** node identifier string
 @param serverId */
  serverId!: string;
  /** node number
 @param serverNb */
  serverNb!: number;

  constructor(json: ClusterNodeStatusJSON) {
    super(json);
    this.clusterMember = decodeboolean(json.clusterMember);
    this.connected = decodeboolean(json.connected);
    this.databaseStatus = decodeDatabaseHealthStatusBean(json.databaseStatus);
    this.lastMessageReceived = decodeDate(json.lastMessageReceived);
    this.lastMessageSent = decodeDate(json.lastMessageSent);
    this.localLeader = decodeBoolean(json.localLeader);
    this.me = decodeBoolean(json.me);
    this.serverId = decodeString(json.serverId);
    this.serverNb = decodenumber(json.serverNb);
    this.onDecode(json);
  }
}

function decodeClusterNodeStatus(json: ClusterNodeStatusJSON | undefined): ClusterNodeStatus | undefined {
  return json === undefined ? undefined : new ClusterNodeStatus(json);
}

function encodeClusterNodeStatus(obj: ClusterNodeStatus | null): ClusterNodeStatusJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    clusterMember: encodeboolean(obj.clusterMember),
    connected: encodeboolean(obj.connected),
    databaseStatus: encodeDatabaseHealthStatusBean(obj.databaseStatus),
    lastMessageReceived: encodeDate(obj.lastMessageReceived),
    lastMessageSent: encodeDate(obj.lastMessageSent),
    localLeader: encodeBoolean(obj.localLeader),
    me: encodeBoolean(obj.me),
    serverId: encodeString(obj.serverId),
    serverNb: encodenumber(obj.serverNb)
  } as ClusterNodeStatusJSON);
}

type ClusterStatusJSON = {
  clusterConnected: string;
  clusterEnabled: string;
  connectionDebugMsg: string;
  databaseStatus?: DatabaseHealthStatusBeanJSON;
  lastDbSwitchDebugMsg: string;
  lastEffectivelyClusterConnectedChange: string;
  lastTimedClusterConnectedChange: string;
  localElectedLeader?: string;
  nodeList: Array<ClusterNodeStatusJSON>;
  serverId?: string;
};

export class ClusterStatus extends ServerBeanPrototype {
  /** true if this host is connected to the cluser, ie all nodes designated by the leader as belonging to the cluster
 @param clusterConnected */
  clusterConnected!: boolean;
  clusterEnabled!: boolean;
  /** cluster connection debug message
 @param connectionDebugMsg */
  connectionDebugMsg!: string;
  /** database status bean
 @param databaseStatus database status */
  databaseStatus?: DatabaseHealthStatusBean;
  /** database stand-by/primary switch debug message
 @param lastDbSwitchDebugMsg */
  lastDbSwitchDebugMsg!: string;
  /** last time the flag clusterConnected changed, but with effect on the app, because of timer this was delayed.
 @param lastEffectivelyClusterConnectedChange */
  lastEffectivelyClusterConnectedChange!: Date;
  /** last time the flag clusterConnected changed, but no effect on the app.
 @param lastTimedClusterConnectedChange */
  lastTimedClusterConnectedChange!: Date;
  /** result of the local election
 @param localElectedLeader */
  localElectedLeader?: string;
  /** node status list
 @param nodeList */
  nodeList!: Array<ClusterNodeStatus>;
  /** node id of this host
 @param serverId */
  serverId?: string;

  constructor(json: ClusterStatusJSON) {
    super(json);
    this.clusterConnected = decodeboolean(json.clusterConnected);
    this.clusterEnabled = decodeboolean(json.clusterEnabled);
    this.connectionDebugMsg = decodeString(json.connectionDebugMsg);
    this.databaseStatus = decodeDatabaseHealthStatusBean(json.databaseStatus);
    this.lastDbSwitchDebugMsg = decodeString(json.lastDbSwitchDebugMsg);
    this.lastEffectivelyClusterConnectedChange = decodeDate(json.lastEffectivelyClusterConnectedChange);
    this.lastTimedClusterConnectedChange = decodeDate(json.lastTimedClusterConnectedChange);
    this.localElectedLeader = decodeString(json.localElectedLeader);
    this.nodeList = decodeArray(decodeClusterNodeStatus)(json.nodeList);
    this.serverId = decodeString(json.serverId);
    this.onDecode(json);
  }
}

function decodeClusterStatus(json: ClusterStatusJSON | undefined): ClusterStatus | undefined {
  return json === undefined ? undefined : new ClusterStatus(json);
}

function encodeClusterStatus(obj: ClusterStatus | null): ClusterStatusJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    clusterConnected: encodeboolean(obj.clusterConnected),
    clusterEnabled: encodeboolean(obj.clusterEnabled),
    connectionDebugMsg: encodeString(obj.connectionDebugMsg),
    databaseStatus: encodeDatabaseHealthStatusBean(obj.databaseStatus),
    lastDbSwitchDebugMsg: encodeString(obj.lastDbSwitchDebugMsg),
    lastEffectivelyClusterConnectedChange: encodeDate(obj.lastEffectivelyClusterConnectedChange),
    lastTimedClusterConnectedChange: encodeDate(obj.lastTimedClusterConnectedChange),
    localElectedLeader: encodeString(obj.localElectedLeader),
    nodeList: encodeArray(encodeClusterNodeStatus)(obj.nodeList),
    serverId: encodeString(obj.serverId)
  } as ClusterStatusJSON);
}

type ColorBeanJSON = {
  accountId?: string;
  cc: string;
  colorSystem?: ColorSystemEnum;
  metaId?: string;
  name?: string;
  rights?: FizRightBeanJSON;
  sortingIndex: string;
};

export class ColorBean extends ServerBeanPrototype {
  accountId?: number;
  cc!: string;
  colorSystem?: ColorSystemEnum;
  metaId?: string;
  name?: string;
  rights?: FizRightBean;
  sortingIndex!: number;

  constructor(json: ColorBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.cc = decodeString(json.cc);
    this.colorSystem = decodeEnum(json.colorSystem);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodenumber(json.sortingIndex);
    this.onDecode(json);
  }
}

function decodeColorBean(json: ColorBeanJSON | undefined): ColorBean | undefined {
  return json === undefined ? undefined : new ColorBean(json);
}

function encodeColorBean(obj: ColorBean | null): ColorBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    cc: encodeString(obj.cc),
    colorSystem: encodeEnum(obj.colorSystem),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    sortingIndex: encodenumber(obj.sortingIndex)
  } as ColorBeanJSON);
}

type ColorInputBeanJSON = {
  cc?: string;
  metaId?: string;
  name?: string;
};

export class ColorInputBean extends ServerBeanPrototype {
  /** Color code format #RRGGBB
 @param cc the cc to set */
  cc?: string;
  /** the id of the color. If this is a system palette color, accountId is negative and objectId is null. */
  metaId?: string;
  /** Name of the custom color. If null it is a system palette color or it won't be modified
 @param name the name to set */
  name?: string;

  constructor(json: ColorInputBeanJSON) {
    super(json);
    this.cc = decodeString(json.cc);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeColorInputBean(json: ColorInputBeanJSON | undefined): ColorInputBean | undefined {
  return json === undefined ? undefined : new ColorInputBean(json);
}

function encodeColorInputBean(obj: ColorInputBean | null): ColorInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    cc: encodeString(obj.cc),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name)
  } as ColorInputBeanJSON);
}

type CommentBeanJSON = {
  accountId: string;
  bestMoment?: string;
  commentId: string;
  creationDate: string;
  metaId?: string;
  mood?: MoodEnum;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  rights?: FizRightBeanJSON;
  text: string;
  updatedDate?: string;
};

export class CommentBean extends ServerBeanPrototype {
  accountId!: number;
  bestMoment?: boolean;
  commentId!: string;
  creationDate!: Date;
  metaId?: string;
  mood?: MoodEnum;
  moodMap?: Map<number, Array<MoodEnum>>;
  moodStarShortcut?: boolean;
  rights?: FizRightBean;
  text!: string;
  updatedDate?: Date;

  constructor(json: CommentBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.commentId = decodeMetaId(json.commentId);
    this.creationDate = decodeDate(json.creationDate);
    this.metaId = decodeMetaId(json.metaId);
    this.mood = decodeEnum(json.mood);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.rights = decodeFizRightBean(json.rights);
    this.text = decodeString(json.text);
    this.updatedDate = decodeDate(json.updatedDate);
    this.onDecode(json);
  }
}

function decodeCommentBean(json: CommentBeanJSON | undefined): CommentBean | undefined {
  return json === undefined ? undefined : new CommentBean(json);
}

function encodeCommentBean(obj: CommentBean | null): CommentBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    commentId: encodeMetaId(obj.commentId),
    creationDate: encodeDate(obj.creationDate),
    metaId: encodeMetaId(obj.metaId),
    mood: encodeEnum(obj.mood),
    rights: encodeFizRightBean(obj.rights),
    text: encodeString(obj.text),
    updatedDate: encodeDate(obj.updatedDate)
  } as CommentBeanJSON);
}

type CommentResultBeanJSON<IWallMessageJSON> = {
  comment: ICommentJSON;
  object: IHasMetaIdJSON;
};

export class CommentResultBean<IWallMessage> extends ServerBeanPrototype {
  /** The comment
 @param comment The comment */
  comment!: IComment;
  /** The commented object
 @param object The commented object */
  object!: IHasMetaId;

  constructor(json: CommentResultBeanJSON<any>, decodeIWallMessage: objectDecoder<any, IWallMessage>) {
    super(json);
    this.comment = decodeIComment(json.comment);
    this.object = decodeDynamic(json.object) as IHasMetaId;
    this.onDecode(json);
  }
}

function decodeCommentResultBean<IWallMessage>(decodeIWallMessage: objectDecoder<any, IWallMessage>) {
  return function(json: CommentResultBeanJSON<any> | undefined): CommentResultBean<IWallMessage> | undefined {
    return json === undefined ? undefined : new CommentResultBean<IWallMessage>(json, decodeIWallMessage);
  };
}

function encodeCommentResultBean<IWallMessage>(encodeIWallMessage: objectEncoder<IWallMessage>) {
  return function(obj: CommentResultBean<IWallMessage> | null): CommentResultBeanJSON<any> | undefined {
    if (obj == null) return undefined;
  return inline({
    comment: encodeIComment(obj.comment),
    object: encodeDynamic(obj.object)
  } as CommentResultBeanJSON<IWallMessageJSON>);
  };
}

type ContactBeanJSON = {
  accountId?: string;
  addresses?: Array<IAddressJSON>;
  birthDate?: string;
  birthDateNoYear?: string;
  comments?: Array<ICommentJSON>;
  devices?: Array<IDeviceJSON>;
  editable?: string;
  familyId?: string;
  firstName?: string;
  function?: string;
  gender?: GenderEnum;
  lastName?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  note?: string;
  pictureDefault?: string;
};

export class ContactBean extends ServerBeanPrototype {
  accountId?: number;
  addresses?: Array<IAddress>;
  birthDate?: Date;
  birthDateNoYear?: boolean;
  comments?: Array<IComment>;
  devices?: Array<IDevice>;
  editable?: boolean;
  /** @param familyId the familyId to set */
  familyId?: string;
  firstName?: string;
  function?: string;
  gender?: GenderEnum;
  lastName?: string;
  medias?: Array<IMedia>;
  metaId?: string;
  note?: string;
  pictureDefault?: boolean;

  constructor(json: ContactBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.firstName = decodeString(json.firstName);
    this.function = decodeString(json.function);
    this.gender = decodeEnum(json.gender);
    this.lastName = decodeString(json.lastName);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.note = decodeString(json.note);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.onDecode(json);
  }
}

function decodeContactBean(json: ContactBeanJSON | undefined): ContactBean | undefined {
  return json === undefined ? undefined : new ContactBean(json);
}

function encodeContactBean(obj: ContactBean | null): ContactBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    addresses: encodeArray(encodeIAddress)(obj.addresses),
    birthDate: encodeDate(obj.birthDate),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    devices: encodeArray(encodeIDevice)(obj.devices),
    firstName: encodeString(obj.firstName),
    function: encodeString(obj.function),
    gender: encodeEnum(obj.gender),
    lastName: encodeString(obj.lastName),
    metaId: encodeMetaId(obj.metaId),
    note: encodeString(obj.note)
  } as ContactBeanJSON);
}

type ContactSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<IContactJSON>;
};

export class ContactSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<IContact>;

  constructor(json: ContactSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeIContact)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeContactSyncBean(json: ContactSyncBeanJSON | undefined): ContactSyncBean | undefined {
  return json === undefined ? undefined : new ContactSyncBean(json);
}

function encodeContactSyncBean(obj: ContactSyncBean | null): ContactSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeIContact)(obj.updatedCreated)
  } as ContactSyncBeanJSON);
}

type CoverUriConfigurableBeanJSON = {
  darkMode: string;
  lightMode: string;
};

export class CoverUriConfigurableBean extends ServerBeanPrototype {
  /** The uri of the cover in dark mode
 @param darkMode the url */
  darkMode!: string;
  /** The uri of the cover in light mode
 @param lightMode the url */
  lightMode!: string;

  constructor(json: CoverUriConfigurableBeanJSON) {
    super(json);
    this.darkMode = decodeString(json.darkMode);
    this.lightMode = decodeString(json.lightMode);
    this.onDecode(json);
  }
}

function decodeCoverUriConfigurableBean(json: CoverUriConfigurableBeanJSON | undefined): CoverUriConfigurableBean | undefined {
  return json === undefined ? undefined : new CoverUriConfigurableBean(json);
}

function encodeCoverUriConfigurableBean(obj: CoverUriConfigurableBean | null): CoverUriConfigurableBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    darkMode: encodeString(obj.darkMode),
    lightMode: encodeString(obj.lightMode)
  } as CoverUriConfigurableBeanJSON);
}

type CoverUriPhoneAndTabletBeanJSON = {
  phone: CoverUriConfigurableBeanJSON;
  tablet: CoverUriConfigurableBeanJSON;
};

export class CoverUriPhoneAndTabletBean extends ServerBeanPrototype {
  /** the config for phone
 @param phone phone */
  phone!: CoverUriConfigurableBean;
  /** the config for tablet
 @param tablet tablet */
  tablet!: CoverUriConfigurableBean;

  constructor(json: CoverUriPhoneAndTabletBeanJSON) {
    super(json);
    this.phone = decodeCoverUriConfigurableBean(json.phone);
    this.tablet = decodeCoverUriConfigurableBean(json.tablet);
    this.onDecode(json);
  }
}

function decodeCoverUriPhoneAndTabletBean(json: CoverUriPhoneAndTabletBeanJSON | undefined): CoverUriPhoneAndTabletBean | undefined {
  return json === undefined ? undefined : new CoverUriPhoneAndTabletBean(json);
}

function encodeCoverUriPhoneAndTabletBean(obj: CoverUriPhoneAndTabletBean | null): CoverUriPhoneAndTabletBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    phone: encodeCoverUriConfigurableBean(obj.phone),
    tablet: encodeCoverUriConfigurableBean(obj.tablet)
  } as CoverUriPhoneAndTabletBeanJSON);
}

type CreditBeanJSON = {
  accountId?: string;
  autoRenewType?: CreditAutoRenewType;
  creationDate?: string;
  creditStatus?: CreditStatusEnum;
  creditStatusDetail?: CreditStatusDetailEnum;
  creditType?: CreditTypeEnum;
  endDate?: string;
  familyIds?: Array<string>;
  metaId?: string;
  paymentCancelDate?: string;
  paymentCancelReason?: string;
  paymentCancelReasonSurvey?: string;
  paymentCancelReasonSurveyCustom?: string;
  paymentDate?: string;
  paymentKey?: string;
  paymentOriginalStatus?: string;
  paymentReceipt?: string;
  paymentSKU?: string;
  paymentStatus?: string;
  paymentStatusActiveDate?: string;
  paymentSubSKU?: string;
  paymentType?: CreditPaymentTypeEnum;
  paymentValue?: string;
  periodType?: CreditTypeOfPeriodEnum;
  startDate?: string;
  text?: string;
  value?: string;
};

export class CreditBean extends ServerBeanPrototype {
  /** @param ownerId the ownerId to set */
  accountId?: number;
  /** @param autoRenewType the autoRenewType to set */
  autoRenewType?: CreditAutoRenewType;
  /** @param creationDate the creationDate to set */
  creationDate?: Date;
  /** @param creditStatus the creditStatus to set */
  creditStatus?: CreditStatusEnum;
  creditStatusDetail?: CreditStatusDetailEnum;
  /** @param creditType the creditType to set */
  creditType?: CreditTypeEnum;
  /** @param endDate the endDate to set */
  endDate?: Date;
  /** @param familyIds the familyIds to set */
  familyIds?: Array<number>;
  metaId?: string;
  paymentCancelDate?: Date;
  paymentCancelReason?: number;
  paymentCancelReasonSurvey?: number;
  paymentCancelReasonSurveyCustom?: string;
  /** @param paymentDate the paymentDate to set */
  paymentDate?: Date;
  /** @param paymentKey the paymentKey to set */
  paymentKey?: string;
  /** @param paymentOriginalStatus the paymentOriginalStatus to set */
  paymentOriginalStatus?: number;
  /** @param paymentReceipt the paymentReceipt to set */
  paymentReceipt?: string;
  paymentSKU?: string;
  /** @param paymentStatus the paymentStatus to set */
  paymentStatus?: number;
  paymentStatusActiveDate?: Date;
  paymentSubSKU?: string;
  /** @param paymentType the paymentType to set */
  paymentType?: CreditPaymentTypeEnum;
  /** @param paymentValue the paymentValue to set */
  paymentValue?: string;
  /** @param periodType the periodType to set */
  periodType?: CreditTypeOfPeriodEnum;
  /** @param startDate the startDate to set */
  startDate?: Date;
  /** @param text the text to set */
  text?: string;
  /** @param value the value to set */
  value?: number;

  constructor(json: CreditBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.autoRenewType = decodeEnum(json.autoRenewType);
    this.creationDate = decodeDate(json.creationDate);
    this.creditStatus = decodeEnum(json.creditStatus);
    this.creditStatusDetail = decodeEnum(json.creditStatusDetail);
    this.creditType = decodeEnum(json.creditType);
    this.endDate = decodeDate(json.endDate);
    this.familyIds = decodeArray(decodeNumber)(json.familyIds);
    this.metaId = decodeMetaId(json.metaId);
    this.paymentCancelDate = decodeDate(json.paymentCancelDate);
    this.paymentCancelReason = decodeNumber(json.paymentCancelReason);
    this.paymentCancelReasonSurvey = decodeNumber(json.paymentCancelReasonSurvey);
    this.paymentCancelReasonSurveyCustom = decodeString(json.paymentCancelReasonSurveyCustom);
    this.paymentDate = decodeDate(json.paymentDate);
    this.paymentKey = decodeString(json.paymentKey);
    this.paymentOriginalStatus = decodeNumber(json.paymentOriginalStatus);
    this.paymentReceipt = decodeString(json.paymentReceipt);
    this.paymentSKU = decodeString(json.paymentSKU);
    this.paymentStatus = decodeNumber(json.paymentStatus);
    this.paymentStatusActiveDate = decodeDate(json.paymentStatusActiveDate);
    this.paymentSubSKU = decodeString(json.paymentSubSKU);
    this.paymentType = decodeEnum(json.paymentType);
    this.paymentValue = decodeString(json.paymentValue);
    this.periodType = decodeEnum(json.periodType);
    this.startDate = decodeDate(json.startDate);
    this.text = decodeString(json.text);
    this.value = decodeNumber(json.value);
    this.onDecode(json);
  }
}

function decodeCreditBean(json: CreditBeanJSON | undefined): CreditBean | undefined {
  return json === undefined ? undefined : new CreditBean(json);
}

function encodeCreditBean(obj: CreditBean | null): CreditBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    autoRenewType: encodeEnum(obj.autoRenewType),
    creationDate: encodeDate(obj.creationDate),
    creditStatus: encodeEnum(obj.creditStatus),
    creditStatusDetail: encodeEnum(obj.creditStatusDetail),
    creditType: encodeEnum(obj.creditType),
    endDate: encodeDate(obj.endDate),
    familyIds: encodeArray(encodeNumber)(obj.familyIds),
    metaId: encodeMetaId(obj.metaId),
    paymentCancelDate: encodeDate(obj.paymentCancelDate),
    paymentCancelReason: encodeNumber(obj.paymentCancelReason),
    paymentCancelReasonSurvey: encodeNumber(obj.paymentCancelReasonSurvey),
    paymentCancelReasonSurveyCustom: encodeString(obj.paymentCancelReasonSurveyCustom),
    paymentDate: encodeDate(obj.paymentDate),
    paymentKey: encodeString(obj.paymentKey),
    paymentOriginalStatus: encodeNumber(obj.paymentOriginalStatus),
    paymentReceipt: encodeString(obj.paymentReceipt),
    paymentSKU: encodeString(obj.paymentSKU),
    paymentStatus: encodeNumber(obj.paymentStatus),
    paymentStatusActiveDate: encodeDate(obj.paymentStatusActiveDate),
    paymentSubSKU: encodeString(obj.paymentSubSKU),
    paymentType: encodeEnum(obj.paymentType),
    paymentValue: encodeString(obj.paymentValue),
    periodType: encodeEnum(obj.periodType),
    startDate: encodeDate(obj.startDate),
    text: encodeString(obj.text),
    value: encodeNumber(obj.value)
  } as CreditBeanJSON);
}

type DashboardTileBeanJSON = {
  active?: string;
  metaId: string;
  premium: string;
  readonly: string;
  sortingExploreIndex: string;
  sortingIndex: string;
  type: SectionEnum;
};

export class DashboardTileBean extends ServerBeanPrototype {
  /** flag to indicate if the tile is displayed (if true) in the dashboard "tile" view
 @param active the active to set */
  active?: boolean;
  metaId!: string;
  /** flag to indicate if the tile is a premium feature
 @param premium the premium to set */
  premium!: boolean;
  /** flag to indicate if the tile is displayed (if false) in the dashboard "explore" view and the tiles can be activated/desactivated from the edit mode in the dashboard.
 if true the tiles is not displayed in explore and is cannot be activated or desactivated in the dashboard.
 Note that if readonly=true and active=false, the tiles is not displayed anywhere... 
 @param readonly the readonly to set */
  readonly!: boolean;
  /** For the explore order (and not dashboard drag&drop order), index to indicate the order of the tile, 
 cannot be changed by user.
 @param sortingExploreIndex the sortingExploreIndex to set */
  sortingExploreIndex!: number;
  /** For the dashboard order (and not the one in explore screen), index to indicate the order of the tile, 
 can be changed by the move api. ascending order.
 @param sortingIndex the sortingIndex to set */
  sortingIndex!: number;
  /** type of the tile, WARNING: if the client do not understand the type, it shall ignore the tile entirely but NOT CRASH...
 @param type the type to set */
  type!: SectionEnum;

  constructor(json: DashboardTileBeanJSON) {
    super(json);
    this.active = decodeBoolean(json.active);
    this.metaId = decodeMetaId(json.metaId);
    this.premium = decodeboolean(json.premium);
    this.readonly = decodeboolean(json.readonly);
    this.sortingExploreIndex = decodenumber(json.sortingExploreIndex);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeDashboardTileBean(json: DashboardTileBeanJSON | undefined): DashboardTileBean | undefined {
  return json === undefined ? undefined : new DashboardTileBean(json);
}

function encodeDashboardTileBean(obj: DashboardTileBean | null): DashboardTileBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    active: encodeBoolean(obj.active),
    metaId: encodeMetaId(obj.metaId),
    premium: encodeboolean(obj.premium),
    readonly: encodeboolean(obj.readonly),
    sortingExploreIndex: encodenumber(obj.sortingExploreIndex),
    sortingIndex: encodeNumber(obj.sortingIndex),
    type: encodeEnum(obj.type)
  } as DashboardTileBeanJSON);
}

type DashboardTileInputBeanJSON = {
  active?: string;
  metaId: string;
};

export class DashboardTileInputBean extends ServerBeanPrototype {
  /** flag to indicate if the tile is displayed (if true) in the dashboard "tile" view
 @param active the active to set */
  active?: boolean;
  /** @param metaId the metaId to set */
  metaId!: string;

  constructor(json: DashboardTileInputBeanJSON) {
    super(json);
    this.active = decodeBoolean(json.active);
    this.metaId = decodeMetaId(json.metaId);
    this.onDecode(json);
  }
}

function decodeDashboardTileInputBean(json: DashboardTileInputBeanJSON | undefined): DashboardTileInputBean | undefined {
  return json === undefined ? undefined : new DashboardTileInputBean(json);
}

function encodeDashboardTileInputBean(obj: DashboardTileInputBean | null): DashboardTileInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    active: encodeBoolean(obj.active),
    metaId: encodeMetaId(obj.metaId)
  } as DashboardTileInputBeanJSON);
}

type DatabaseHealthStatusBeanJSON = {
  databases: {[key:string]:DatabaseHealthStatusValueJSON};
};

export class DatabaseHealthStatusBean extends ServerBeanPrototype {
  /** the database (datasource) list by their id (persistentUnitName)
 @param databases map */
  databases!: Map<string, DatabaseHealthStatusValue>;

  constructor(json: DatabaseHealthStatusBeanJSON) {
    super(json);
    this.databases = decodeMap(decodeString,decodeDatabaseHealthStatusValue)(json.databases);
    this.onDecode(json);
  }
}

function decodeDatabaseHealthStatusBean(json: DatabaseHealthStatusBeanJSON | undefined): DatabaseHealthStatusBean | undefined {
  return json === undefined ? undefined : new DatabaseHealthStatusBean(json);
}

function encodeDatabaseHealthStatusBean(obj: DatabaseHealthStatusBean | null): DatabaseHealthStatusBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    databases: encodeMap(encodeString,encodeDatabaseHealthStatusValue)(obj.databases)
  } as DatabaseHealthStatusBeanJSON);
}

type DatabaseHealthStatusValueJSON = {
  standBy: string;
};

export class DatabaseHealthStatusValue extends ServerBeanPrototype {
  /** The standby database flag used to perform the database leader election of the node sending this ping, ie to which database
 the node sending this ping is connected to perform the database leader election.
 @param standByDatabase */
  standBy!: boolean;

  constructor(json: DatabaseHealthStatusValueJSON) {
    super(json);
    this.standBy = decodeboolean(json.standBy);
    this.onDecode(json);
  }
}

function decodeDatabaseHealthStatusValue(json: DatabaseHealthStatusValueJSON | undefined): DatabaseHealthStatusValue | undefined {
  return json === undefined ? undefined : new DatabaseHealthStatusValue(json);
}

function encodeDatabaseHealthStatusValue(obj: DatabaseHealthStatusValue | null): DatabaseHealthStatusValueJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    standBy: encodeboolean(obj.standBy)
  } as DatabaseHealthStatusValueJSON);
}

type DeviceBeanJSON = {
  deviceId?: string;
  deviceType: DeviceTypeEnum;
  value: string;
};

export class DeviceBean extends ServerBeanPrototype {
  deviceId?: string;
  deviceType!: DeviceTypeEnum;
  value!: string;

  constructor(json: DeviceBeanJSON) {
    super(json);
    this.deviceId = decodeMetaId(json.deviceId);
    this.deviceType = decodeEnum(json.deviceType);
    this.value = decodeString(json.value);
    this.onDecode(json);
  }
}

function decodeDeviceBean(json: DeviceBeanJSON | undefined): DeviceBean | undefined {
  return json === undefined ? undefined : new DeviceBean(json);
}

function encodeDeviceBean(obj: DeviceBean | null): DeviceBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deviceId: encodeMetaId(obj.deviceId),
    deviceType: encodeEnum(obj.deviceType),
    value: encodeString(obj.value)
  } as DeviceBeanJSON);
}

type DeviceConfigBeanJSON = {
  MCC?: string;
  MNC?: string;
  applicationVersion?: string;
  buildTimestamp?: string;
  deviceId: string;
  languageSystem?: string;
  metaId?: string;
  modelType?: DeviceModelTypeEnum;
  nativeAppId?: string;
  notificationTokenId?: string;
  partnerType?: PartnerTypeEnum;
  systemName?: string;
  systemVersion?: string;
};

export class DeviceConfigBean extends ServerBeanPrototype {
  MCC?: string;
  MNC?: string;
  applicationVersion?: string;
  /** @param buildTimestamp the buildTimestamp to set */
  buildTimestamp?: number;
  deviceId!: string;
  languageSystem?: string;
  /** @param metaId the metaId to set */
  metaId?: string;
  modelType?: DeviceModelTypeEnum;
  /** @param nativeAppId the nativeAppId to set */
  nativeAppId?: string;
  notificationTokenId?: string;
  /** @param partnerType the partnerType to set */
  partnerType?: PartnerTypeEnum;
  systemName?: string;
  systemVersion?: string;

  constructor(json: DeviceConfigBeanJSON) {
    super(json);
    this.MCC = decodeString(json.MCC);
    this.MNC = decodeString(json.MNC);
    this.applicationVersion = decodeString(json.applicationVersion);
    this.buildTimestamp = decodeNumber(json.buildTimestamp);
    this.deviceId = decodeString(json.deviceId);
    this.languageSystem = decodeString(json.languageSystem);
    this.metaId = decodeMetaId(json.metaId);
    this.modelType = decodeEnum(json.modelType);
    this.nativeAppId = decodeString(json.nativeAppId);
    this.notificationTokenId = decodeString(json.notificationTokenId);
    this.partnerType = decodeEnum(json.partnerType);
    this.systemName = decodeString(json.systemName);
    this.systemVersion = decodeString(json.systemVersion);
    this.onDecode(json);
  }
}

function decodeDeviceConfigBean(json: DeviceConfigBeanJSON | undefined): DeviceConfigBean | undefined {
  return json === undefined ? undefined : new DeviceConfigBean(json);
}

function encodeDeviceConfigBean(obj: DeviceConfigBean | null): DeviceConfigBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    MCC: encodeString(obj.MCC),
    MNC: encodeString(obj.MNC),
    applicationVersion: encodeString(obj.applicationVersion),
    buildTimestamp: encodeNumber(obj.buildTimestamp),
    deviceId: encodeString(obj.deviceId),
    languageSystem: encodeString(obj.languageSystem),
    metaId: encodeMetaId(obj.metaId),
    modelType: encodeEnum(obj.modelType),
    nativeAppId: encodeString(obj.nativeAppId),
    notificationTokenId: encodeString(obj.notificationTokenId),
    partnerType: encodeEnum(obj.partnerType),
    systemName: encodeString(obj.systemName),
    systemVersion: encodeString(obj.systemVersion)
  } as DeviceConfigBeanJSON);
}

type DishBeanJSON = {
  accountId: string;
  date: string;
  familyId?: string;
  metaId: string;
  name?: string;
  recipeId?: string;
  rights?: FizRightBeanJSON;
  sortingIndex: string;
  type: MealTypeEnum;
};

export class DishBean extends ServerBeanPrototype {
  /** @param accountId creator of the dish */
  accountId!: number;
  date!: string;
  familyId?: string;
  metaId!: string;
  name?: string;
  recipeId?: string;
  rights?: FizRightBean;
  sortingIndex!: number;
  type!: MealTypeEnum;

  constructor(json: DishBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.date = decodeString(json.date);
    this.familyId = decodeMetaId(json.familyId);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.recipeId = decodeMetaId(json.recipeId);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodenumber(json.sortingIndex);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeDishBean(json: DishBeanJSON | undefined): DishBean | undefined {
  return json === undefined ? undefined : new DishBean(json);
}

function encodeDishBean(obj: DishBean | null): DishBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    date: encodeString(obj.date),
    familyId: encodeMetaId(obj.familyId),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    recipeId: encodeMetaId(obj.recipeId),
    sortingIndex: encodenumber(obj.sortingIndex),
    type: encodeEnum(obj.type)
  } as DishBeanJSON);
}

type DishRangeBeanJSON = {
  from: string;
  list: Array<DishBeanJSON>;
  mealList: Array<MealBeanJSON>;
  recipeList: Array<RecipeBeanJSON>;
  to: string;
};

export class DishRangeBean extends ServerBeanPrototype {
  from!: string;
  list!: Array<DishBean>;
  mealList!: Array<MealBean>;
  recipeList!: Array<RecipeBean>;
  to!: string;

  constructor(json: DishRangeBeanJSON) {
    super(json);
    this.from = decodeString(json.from);
    this.list = decodeArray(decodeDishBean)(json.list);
    this.mealList = decodeArray(decodeMealBean)(json.mealList);
    this.recipeList = decodeArray(decodeRecipeBean)(json.recipeList);
    this.to = decodeString(json.to);
    this.onDecode(json);
  }
}

function decodeDishRangeBean(json: DishRangeBeanJSON | undefined): DishRangeBean | undefined {
  return json === undefined ? undefined : new DishRangeBean(json);
}

function encodeDishRangeBean(obj: DishRangeBean | null): DishRangeBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    from: encodeString(obj.from),
    list: encodeArray(encodeDishBean)(obj.list),
    mealList: encodeArray(encodeMealBean)(obj.mealList),
    recipeList: encodeArray(encodeRecipeBean)(obj.recipeList),
    to: encodeString(obj.to)
  } as DishRangeBeanJSON);
}

type DishSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<DishBeanJSON>;
};

export class DishSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<DishBean>;

  constructor(json: DishSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeDishBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeDishSyncBean(json: DishSyncBeanJSON | undefined): DishSyncBean | undefined {
  return json === undefined ? undefined : new DishSyncBean(json);
}

function encodeDishSyncBean(obj: DishSyncBean | null): DishSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeDishBean)(obj.updatedCreated)
  } as DishSyncBeanJSON);
}

type EventBeanJSON = {
  accountId: string;
  allDay: string;
  attendeeIds: Array<string>;
  bestMoment?: string;
  birthDateNoYear?: string;
  calendarId: string;
  color?: string;
  colorInfo?: ColorBeanJSON;
  comments?: Array<ICommentJSON>;
  description?: string;
  editable?: string;
  emoji?: string;
  endDate?: string;
  eventId: string;
  eventMasterId: string;
  eventType?: EventTypeEnum;
  externalImportId?: string;
  familyId: string;
  lastAction?: UserActionEnum;
  lastActionAuthor?: string;
  lastActionDate?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  modifDate: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  occurenceIndex?: string;
  placeId?: string;
  private: string;
  recurrencyExceptionOfId?: string;
  refPersonId?: string;
  refPersonName?: string;
  reminder?: IReminderJSON;
  reminderList: Array<IReminderJSON>;
  startDate: string;
  taskListId?: string;
  text?: string;
  timeZone?: string;
  toAll: string;
  where?: string;
} & RecurrencyDescriptorJSON;

export class EventBean extends ServerBeanPrototype {
  accountId!: number;
  allDay!: boolean;
  attendeeIds!: Array<number>;
  bestMoment?: boolean;
  birthDateNoYear?: boolean;
  calendarId!: string;
  color?: string;
  /** @param colorBean the colorBean to set */
  colorInfo?: ColorBean;
  comments?: Array<IComment>;
  description?: string;
  editable?: boolean;
  emoji?: string;
  endDate?: Date;
  eventId!: string;
  eventMasterId!: string;
  eventType?: EventTypeEnum;
  externalImportId?: string;
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param lastAction the lastAction to set */
  lastAction?: UserActionEnum;
  /** @param lastActionAuthor the lastActionAuthor to set */
  lastActionAuthor?: number;
  /** @param lastActionDate the lastActionDate to set */
  lastActionDate?: Date;
  medias?: Array<IMedia>;
  metaId?: string;
  modifDate!: Date;
  moodMap?: Map<number, Array<MoodEnum>>;
  /** @param moodStarShortcut the moodStarShortcut to set */
  moodStarShortcut?: boolean;
  occurenceIndex?: number;
  placeId?: string;
  private!: boolean;
  /** @param recurrency recurrency to set */
  recurrencyDescriptor!: RecurrencyDescriptor;
  recurrencyExceptionOfId?: string;
  refPersonId?: string;
  refPersonName?: string;
  reminder?: IReminder;
  reminderList!: Array<IReminder>;
  startDate!: Date;
  taskListId?: string;
  text?: string;
  timeZone?: string;
  toAll!: boolean;
  where?: string;

  constructor(json: EventBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.allDay = decodeBoolean(json.allDay);
    this.attendeeIds = decodeArray(decodeNumber)(json.attendeeIds);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.calendarId = decodeMetaId(json.calendarId);
    this.color = decodeString(json.color);
    this.colorInfo = decodeColorBean(json.colorInfo);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.description = decodeString(json.description);
    this.editable = decodeBoolean(json.editable);
    this.emoji = decodeString(json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.eventId = decodeMetaId(json.eventId);
    this.eventMasterId = decodeMetaId(json.eventMasterId);
    this.eventType = decodeEnum(json.eventType);
    this.externalImportId = decodeMetaId(json.externalImportId);
    this.familyId = decodeMetaId(json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.occurenceIndex = decodeNumber(json.occurenceIndex);
    this.placeId = decodeMetaId(json.placeId);
    this.private = decodeboolean(json.private);
    this.recurrencyExceptionOfId = decodeMetaId(json.recurrencyExceptionOfId);
    this.refPersonId = decodeMetaId(json.refPersonId);
    this.refPersonName = decodeString(json.refPersonName);
    this.reminder = decodeIReminder(json.reminder);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.taskListId = decodeMetaId(json.taskListId);
    this.text = decodeString(json.text);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.toAll = decodeboolean(json.toAll);
    this.where = decodeString(json.where);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeEventBean(json: EventBeanJSON | undefined): EventBean | undefined {
  return json === undefined ? undefined : new EventBean(json);
}

function encodeEventBean(obj: EventBean | null): EventBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    allDay: encodeBoolean(obj.allDay),
    attendeeIds: encodeArray(encodeNumber)(obj.attendeeIds),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    calendarId: encodeMetaId(obj.calendarId),
    color: encodeString(obj.color),
    colorInfo: encodeColorBean(obj.colorInfo),
    description: encodeString(obj.description),
    editable: encodeBoolean(obj.editable),
    emoji: encodeString(obj.emoji),
    endDate: encodeDate(obj.endDate),
    eventId: encodeMetaId(obj.eventId),
    eventMasterId: encodeMetaId(obj.eventMasterId),
    eventType: encodeEnum(obj.eventType),
    externalImportId: encodeMetaId(obj.externalImportId),
    familyId: encodeMetaId(obj.familyId),
    metaId: encodeMetaId(obj.metaId),
    modifDate: encodeDate(obj.modifDate),
    occurenceIndex: encodeNumber(obj.occurenceIndex),
    placeId: encodeMetaId(obj.placeId),
    private: encodeboolean(obj.private),
    refPersonId: encodeMetaId(obj.refPersonId),
    refPersonName: encodeString(obj.refPersonName),
    reminder: encodeIReminder(obj.reminder),
    reminderList: encodeArray(encodeIReminder)(obj.reminderList),
    startDate: encodeDate(obj.startDate),
    taskListId: encodeMetaId(obj.taskListId),
    text: encodeString(obj.text),
    timeZone: encodeTimeZone(obj.timeZone),
    toAll: encodeboolean(obj.toAll),
    where: encodeString(obj.where)
  } as EventBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type EventInputBeanJSON = {
  allDay?: string;
  attendee?: Array<IAttendeeJSON>;
  birthDateNoYear?: string;
  calendarId?: string;
  color?: string;
  colorId?: string;
  description?: string;
  emoji?: string;
  endDate?: string;
  isToAll?: string;
  metaId?: string;
  picture?: Array<FizFile>;
  placeId?: string;
  private?: string;
  reminder?: IReminderJSON;
  reminderList?: Array<IReminderJSON>;
  startDate?: string;
  taskListId?: string;
  text?: string;
  timeZone?: string;
  type?: EventTypeEnum;
  where?: string;
} & RecurrencyDescriptorJSON;

export class EventInputBean extends ServerBeanPrototype {
  /** if true this is an allday event and startdate is at 00h00m00s UTC and enddate 23h59m59s UTC */
  allDay?: boolean;
  /** this list of attendees for this event (account id and their statuses) */
  attendee?: Array<IAttendee>;
  /** if true, the year in the date shall be disregarded as it has been set to 1900 arbitrarily
 @param birthDateNoYear the no year flag */
  birthDateNoYear?: boolean;
  calendarId?: string;
  /** color of the event in the form of #rrggbb for instance #f6bf26 */
  color?: string;
  /** @param colorId the colorId to set */
  colorId?: string;
  /** the description (long text field) of this event */
  description?: string;
  /** a single char string containing the emoji to display as an icon for this list

 @param emoji the emoji */
  emoji?: string;
  /** enddate of this event. if null consider that the event is an allday event at the date of startdate.
 remember that for allday this shall be 23h59m59s UTC */
  endDate?: Date;
  /** if true, the whole family will be attendee to this event (when a new memeber will join the family, it will automatically added to this event)<br>
 For update, if not null, will change the isToAll flag of this event<br> 
 If isToAll is null and attendee is not null, will be based on attendee list to compute this flag -> ie if oyu put all family members in the attendee list, this flag will be set to TRUE. */
  isToAll?: boolean;
  /** the id of the event to update (null if create) */
  metaId?: string;
  /** the media associated with this event (may be only one picture depending on the ui) */
  picture?: Array<FizFile>;
  /** place related to this event.  Normally either this or where is not null (see where field). */
  placeId?: string;
  /** a private event is only visible to the attendee and the author, else it is visible to everybody.
 if null by default it is false, not private. */
  private?: boolean;
  /** the reccureency descriptor (recurrency type, interval, enddate, endnb) */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** the first reminder of this event (to be compatible with single-reminder events).
 new clients shall use reminderList */
  reminder?: IReminder;
  /** the list of reminders attached to this event (supercede reminder) */
  reminderList?: Array<IReminder>;
  /** startdate of this event (mandatory for create). Remember that for allday event startDate shall be 00h00m00s UTC */
  startDate?: Date;
  /** set the task list if one is associated with this event */
  taskListId?: string;
  /** the title (short text field) of the event */
  text?: string;
  /** timezone of the event, if null the event has no specific timezone and is edited always in the local timezone.<br>
 If the event has a timezone, it is edited in its timezone, not the local timezone. For display, it is
 displayed on the local timezone, and in the event's timezone if possible (ie in the detail)<br>
 It is null for all-day events.
 @param timezone the timezone or null */
  timeZone?: string;
  /** the type of event (normal/birthday/?) */
  type?: EventTypeEnum;
  /** where string related to this event. Normally either this or placeId is not null.
 if where is set it will create a temporary place with this address and set placeId */
  where?: string;

  constructor(json: EventInputBeanJSON) {
    super(json);
    this.allDay = decodeBoolean(json.allDay);
    this.attendee = decodeArray(decodeIAttendee)(json.attendee);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.calendarId = decodeMetaId(json.calendarId);
    this.color = decodeString(json.color);
    this.colorId = decodeMetaId(json.colorId);
    this.description = decodeString(json.description);
    this.emoji = decodeString(json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.isToAll = decodeBoolean(json.isToAll);
    this.metaId = decodeMetaId(json.metaId);
    this.picture = decodeArray(decodeFizFile)(json.picture);
    this.placeId = decodeMetaId(json.placeId);
    this.private = decodeBoolean(json.private);
    this.reminder = decodeIReminder(json.reminder);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.taskListId = decodeMetaId(json.taskListId);
    this.text = decodeString(json.text);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.type = decodeEnum(json.type);
    this.where = decodeString(json.where);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeEventInputBean(json: EventInputBeanJSON | undefined): EventInputBean | undefined {
  return json === undefined ? undefined : new EventInputBean(json);
}

function encodeEventInputBean(obj: EventInputBean | null): EventInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    allDay: encodeBoolean(obj.allDay),
    attendee: encodeArray(encodeIAttendee)(obj.attendee),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    calendarId: encodeMetaId(obj.calendarId),
    color: encodeString(obj.color),
    colorId: encodeMetaId(obj.colorId),
    description: encodeString(obj.description),
    emoji: encodeString(obj.emoji),
    endDate: encodeDate(obj.endDate),
    isToAll: encodeBoolean(obj.isToAll),
    metaId: encodeMetaId(obj.metaId),
    picture: encodeArray(encodeFizFile)(obj.picture),
    placeId: encodeMetaId(obj.placeId),
    private: encodeBoolean(obj.private),
    reminder: encodeIReminder(obj.reminder),
    reminderList: encodeArray(encodeIReminder)(obj.reminderList),
    startDate: encodeDate(obj.startDate),
    taskListId: encodeMetaId(obj.taskListId),
    text: encodeString(obj.text),
    timeZone: encodeTimeZone(obj.timeZone),
    type: encodeEnum(obj.type),
    where: encodeString(obj.where)
  } as EventInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type EventListAndCalendarJSON = {
  events: Array<IEventJSON>;
  selectedCalendars: {[key:string]:CalendarBeanJSON};
};

export class EventListAndCalendar extends ServerBeanPrototype {
  events!: Array<IEvent>;
  selectedCalendars!: Map<string, CalendarBean>;

  constructor(json: EventListAndCalendarJSON) {
    super(json);
    this.events = decodeArray(decodeIEvent)(json.events);
    this.selectedCalendars = decodeDynamic(json.selectedCalendars) as Map<string, CalendarBean>;
    this.onDecode(json);
  }
}

function decodeEventListAndCalendar(json: EventListAndCalendarJSON | undefined): EventListAndCalendar | undefined {
  return json === undefined ? undefined : new EventListAndCalendar(json);
}

function encodeEventListAndCalendar(obj: EventListAndCalendar | null): EventListAndCalendarJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    events: encodeArray(encodeIEvent)(obj.events),
    selectedCalendars: encodeDynamic(obj.selectedCalendars)
  } as EventListAndCalendarJSON);
}

type EventSyncBeanJSON = {
  calendarId?: string;
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<IEventJSON>;
};

export class EventSyncBean extends ServerBeanPrototype {
  calendarId?: string;
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<IEvent>;

  constructor(json: EventSyncBeanJSON) {
    super(json);
    this.calendarId = decodeMetaId(json.calendarId);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeIEvent)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeEventSyncBean(json: EventSyncBeanJSON | undefined): EventSyncBean | undefined {
  return json === undefined ? undefined : new EventSyncBean(json);
}

function encodeEventSyncBean(obj: EventSyncBean | null): EventSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    calendarId: encodeMetaId(obj.calendarId),
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeIEvent)(obj.updatedCreated)
  } as EventSyncBeanJSON);
}

type ExploreBeanJSON = {
  covers: Array<LaunchpadActivityBeanJSON>;
  exploreSectionNew: string;
  familyId: string;
  tiles: Array<DashboardTileBeanJSON>;
  token?: string;
};

export class ExploreBean extends ServerBeanPrototype {
  /** @param covers the covers to set */
  covers!: Array<LaunchpadActivityBean>;
  /** @param exploreSectionNew the exploreSectionNew to set */
  exploreSectionNew!: boolean;
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param tiles the tiles to set */
  tiles!: Array<DashboardTileBean>;
  token?: string;

  constructor(json: ExploreBeanJSON) {
    super(json);
    this.covers = decodeArray(decodeLaunchpadActivityBean)(json.covers);
    this.exploreSectionNew = decodeboolean(json.exploreSectionNew);
    this.familyId = decodeMetaId(json.familyId);
    this.tiles = decodeArray(decodeDashboardTileBean)(json.tiles);
    this.token = decodeString(json.token);
    this.onDecode(json);
  }
}

function decodeExploreBean(json: ExploreBeanJSON | undefined): ExploreBean | undefined {
  return json === undefined ? undefined : new ExploreBean(json);
}

function encodeExploreBean(obj: ExploreBean | null): ExploreBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    covers: encodeArray(encodeLaunchpadActivityBean)(obj.covers),
    exploreSectionNew: encodeboolean(obj.exploreSectionNew),
    familyId: encodeMetaId(obj.familyId),
    tiles: encodeArray(encodeDashboardTileBean)(obj.tiles),
    token: encodeString(obj.token)
  } as ExploreBeanJSON);
}

type ExtendedFamilyMemberBeanJSON = {
  account?: IAccountJSON;
  accountId?: string;
  addresses?: Array<IAddressJSON>;
  birthDate?: string;
  birthDateNoYear?: string;
  color?: string;
  creationDate?: string;
  customRole?: string;
  deleted: string;
  devices?: Array<IDeviceJSON>;
  fWPremiumMemberSubscriber?: string;
  familyId: string;
  firstName?: string;
  gender?: GenderEnum;
  identifiers: Array<IAccountIdentifierJSON>;
  isAccountDeleted?: string;
  isFirstFamily?: string;
  isloggedaccount: string;
  joinDate?: string;
  lastLoginDate?: string;
  lastName?: string;
  locale?: string;
  location?: ILocationJSON;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  name: string;
  panicButtonActivated?: string;
  pictureDefault?: string;
  profileFamilyId?: string;
  right: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;
  termsChecked: string;
  termsOrangeFamilyPlaceChecked: string;
  termsProximusFamilyChecked?: string;
  timeZone?: string;
};

export class ExtendedFamilyMemberBean extends ServerBeanPrototype {
  account?: IAccount;
  accountId?: number;
  addresses?: Array<IAddress>;
  birthDate?: Date;
  birthDateNoYear?: boolean;
  /** @param color the color to set */
  color?: string;
  creationDate?: Date;
  /** @param customFamilyRole the customFamilyRole to set */
  customRole?: string;
  /** @param deleted the deleted to set */
  deleted!: boolean;
  devices?: Array<IDevice>;
  /** @param fWPremiumMemberSubscriber the fWPremiumMemberSubscriber to set */
  fWPremiumMemberSubscriber?: boolean;
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param firstName the firstName to set */
  firstName?: string;
  gender?: GenderEnum;
  identifiers!: Array<IAccountIdentifier>;
  isAccountDeleted?: boolean;
  /** @param isFirstFamily the isFirstFamily to set */
  isFirstFamily?: boolean;
  /** @param isLoggedAccount the isLoggedAccount to set */
  isloggedaccount!: boolean;
  /** @param joinDate the joinDate to set */
  joinDate?: Date;
  lastLoginDate?: Date;
  /** @param lastName the lastName to set */
  lastName?: string;
  locale?: string;
  location?: ILocation;
  medias?: Array<IMedia>;
  /** @param metaId the metaId to set */
  metaId?: string;
  name!: string;
  /** @param panicButtonActivated the panicButtonActivated to set */
  panicButtonActivated?: boolean;
  pictureDefault?: boolean;
  /** @param profileFamilyId the profileFamilyId to set */
  profileFamilyId?: number;
  right!: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;
  /** @param termsChecked the termsChecked to set */
  termsChecked!: boolean;
  termsOrangeFamilyPlaceChecked!: boolean;
  /** @param termsProximusFamilyChecked the termsProximusFamilyChecked to set */
  termsProximusFamilyChecked?: boolean;
  timeZone?: string;

  constructor(json: ExtendedFamilyMemberBeanJSON) {
    super(json);
    this.account = decodeIAccount(json.account);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = decodeString(json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.customRole = decodeString(json.customRole);
    this.deleted = decodeboolean(json.deleted);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.fWPremiumMemberSubscriber = decodeBoolean(json.fWPremiumMemberSubscriber);
    this.familyId = decodeMetaId(json.familyId);
    this.firstName = decodeString(json.firstName);
    this.gender = decodeEnum(json.gender);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.isloggedaccount = decodeBoolean(json.isloggedaccount);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.lastName = decodeString(json.lastName);
    this.locale = decodeString(json.locale);
    this.location = decodeILocation(json.location);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.panicButtonActivated = decodeBoolean(json.panicButtonActivated);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.onDecode(json);
  }
}

function decodeExtendedFamilyMemberBean(json: ExtendedFamilyMemberBeanJSON | undefined): ExtendedFamilyMemberBean | undefined {
  return json === undefined ? undefined : new ExtendedFamilyMemberBean(json);
}

function encodeExtendedFamilyMemberBean(obj: ExtendedFamilyMemberBean | null): ExtendedFamilyMemberBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    account: encodeIAccount(obj.account),
    accountId: encodeNumber(obj.accountId),
    addresses: encodeArray(encodeIAddress)(obj.addresses),
    birthDate: encodeDate(obj.birthDate),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    color: encodeString(obj.color),
    creationDate: encodeDate(obj.creationDate),
    customRole: encodeString(obj.customRole),
    deleted: encodeboolean(obj.deleted),
    devices: encodeArray(encodeIDevice)(obj.devices),
    fWPremiumMemberSubscriber: encodeBoolean(obj.fWPremiumMemberSubscriber),
    familyId: encodeMetaId(obj.familyId),
    firstName: encodeString(obj.firstName),
    gender: encodeEnum(obj.gender),
    identifiers: encodeArray(encodeIAccountIdentifier)(obj.identifiers),
    isAccountDeleted: encodeBoolean(obj.isAccountDeleted),
    isFirstFamily: encodeBoolean(obj.isFirstFamily),
    isloggedaccount: encodeBoolean(obj.isloggedaccount),
    joinDate: encodeDate(obj.joinDate),
    lastLoginDate: encodeDate(obj.lastLoginDate),
    lastName: encodeString(obj.lastName),
    locale: encodeString(obj.locale),
    location: encodeILocation(obj.location),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    panicButtonActivated: encodeBoolean(obj.panicButtonActivated),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    profileFamilyId: encodeNumber(obj.profileFamilyId),
    right: encodeEnum(obj.right),
    role: encodeEnum(obj.role),
    termsChecked: encodeboolean(obj.termsChecked),
    termsOrangeFamilyPlaceChecked: encodeboolean(obj.termsOrangeFamilyPlaceChecked),
    termsProximusFamilyChecked: encodeBoolean(obj.termsProximusFamilyChecked),
    timeZone: encodeTimeZone(obj.timeZone)
  } as ExtendedFamilyMemberBeanJSON);
}

type ExternalImportBeanJSON = {
  accountId?: string;
  created?: string;
  creationDate?: string;
  importType: ExternalImportTypeEnum;
  info?: string;
  metaId: string;
  rights?: FizRightBeanJSON;
  updated?: string;
};

export class ExternalImportBean extends ServerBeanPrototype {
  accountId?: number;
  created?: number;
  creationDate?: Date;
  importType!: ExternalImportTypeEnum;
  info?: string;
  metaId!: string;
  rights?: FizRightBean;
  updated?: number;

  constructor(json: ExternalImportBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.created = decodeNumber(json.created);
    this.creationDate = decodeDate(json.creationDate);
    this.importType = decodeEnum(json.importType);
    this.info = decodeString(json.info);
    this.metaId = decodeMetaId(json.metaId);
    this.rights = decodeFizRightBean(json.rights);
    this.updated = decodeNumber(json.updated);
    this.onDecode(json);
  }
}

function decodeExternalImportBean(json: ExternalImportBeanJSON | undefined): ExternalImportBean | undefined {
  return json === undefined ? undefined : new ExternalImportBean(json);
}

function encodeExternalImportBean(obj: ExternalImportBean | null): ExternalImportBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    created: encodeNumber(obj.created),
    creationDate: encodeDate(obj.creationDate),
    importType: encodeEnum(obj.importType),
    info: encodeString(obj.info),
    metaId: encodeMetaId(obj.metaId),
    rights: encodeFizRightBean(obj.rights),
    updated: encodeNumber(obj.updated)
  } as ExternalImportBeanJSON);
}

type ExternalImportSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<ExternalImportBeanJSON>;
};

export class ExternalImportSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<ExternalImportBean>;

  constructor(json: ExternalImportSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeExternalImportBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeExternalImportSyncBean(json: ExternalImportSyncBeanJSON | undefined): ExternalImportSyncBean | undefined {
  return json === undefined ? undefined : new ExternalImportSyncBean(json);
}

function encodeExternalImportSyncBean(obj: ExternalImportSyncBean | null): ExternalImportSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeExternalImportBean)(obj.updatedCreated)
  } as ExternalImportSyncBeanJSON);
}

type FamilyBeanJSON = {
  coverDefault?: string;
  coverMedias?: Array<IMediaJSON>;
  coverUri?: string;
  family_id: string;
  medias?: Array<IMediaJSON>;
  members: Array<IFamilyMemberJSON>;
  metaId?: string;
  name: string;
  pictureDefault?: string;
  pictureUri?: string;
};

export class FamilyBean extends ServerBeanPrototype {
  /** @param coverDefault the coverDefault to set */
  coverDefault?: boolean;
  coverMedias?: Array<IMedia>;
  coverUri?: string;
  family_id!: number;
  medias?: Array<IMedia>;
  members!: Array<IFamilyMember>;
  metaId?: string;
  name!: string;
  /** @param pictureDefault the pictureDefault to set */
  pictureDefault?: boolean;
  pictureUri?: string;

  constructor(json: FamilyBeanJSON) {
    super(json);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverUri = decodeString(json.coverUri);
    this.family_id = decodeNumber(json.family_id);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.members = decodeArray(decodeIFamilyMember)(json.members);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureUri = decodeString(json.pictureUri);
    this.onDecode(json);
  }
}

function decodeFamilyBean(json: FamilyBeanJSON | undefined): FamilyBean | undefined {
  return json === undefined ? undefined : new FamilyBean(json);
}

function encodeFamilyBean(obj: FamilyBean | null): FamilyBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    coverDefault: encodeBoolean(obj.coverDefault),
    coverMedias: encodeArray(encodeIMedia)(obj.coverMedias),
    coverUri: encodeString(obj.coverUri),
    family_id: encodeNumber(obj.family_id),
    members: encodeArray(encodeIFamilyMember)(obj.members),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    pictureUri: encodeString(obj.pictureUri)
  } as FamilyBeanJSON);
}

type FamilyMemberBeanJSON = {
  account: IAccountJSON;
  customRole?: string;
  familyId: string;
  isFirstFamily?: string;
  joinDate?: string;
  lastLoginDate?: string;
  metaId?: string;
  right: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;
};

export class FamilyMemberBean extends ServerBeanPrototype {
  account!: IAccount;
  /** @param customFamilyRole the customFamilyRole to set */
  customRole?: string;
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param isFirstFamily the isFirstFamily to set */
  isFirstFamily?: boolean;
  /** @param joinDate the joinDate to set */
  joinDate?: Date;
  /** @param lastLoginDate the lastLoginDate to set */
  lastLoginDate?: Date;
  metaId?: string;
  right!: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;

  constructor(json: FamilyMemberBeanJSON) {
    super(json);
    this.account = decodeIAccount(json.account);
    this.customRole = decodeString(json.customRole);
    this.familyId = decodeMetaId(json.familyId);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.metaId = decodeMetaId(json.metaId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.onDecode(json);
  }
}

function decodeFamilyMemberBean(json: FamilyMemberBeanJSON | undefined): FamilyMemberBean | undefined {
  return json === undefined ? undefined : new FamilyMemberBean(json);
}

function encodeFamilyMemberBean(obj: FamilyMemberBean | null): FamilyMemberBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    account: encodeIAccount(obj.account),
    customRole: encodeString(obj.customRole),
    familyId: encodeMetaId(obj.familyId),
    isFirstFamily: encodeBoolean(obj.isFirstFamily),
    joinDate: encodeDate(obj.joinDate),
    lastLoginDate: encodeDate(obj.lastLoginDate),
    metaId: encodeMetaId(obj.metaId),
    right: encodeEnum(obj.right),
    role: encodeEnum(obj.role)
  } as FamilyMemberBeanJSON);
}

type FileSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<IMediaJSON>;
};

export class FileSyncBean extends ServerBeanPrototype {
  /** list of deleted ids
 @param deletedIds list of deleted ids */
  deletedIds!: Array<string>;
  /** sync flag
 @param isSync true if it is a sync result, if it is false client should
         invalidate all its contact cache and replace it by all contacts
         in the updatedCreatedContact */
  isSync!: boolean;
  /** the sync token
 @param syncToken the sync token */
  syncToken!: string;
  /** list of updated / modified contacts
 @param updatedCreated list of updated / modified contacts */
  updatedCreated!: Array<IMedia>;

  constructor(json: FileSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeIMedia)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeFileSyncBean(json: FileSyncBeanJSON | undefined): FileSyncBean | undefined {
  return json === undefined ? undefined : new FileSyncBean(json);
}

function encodeFileSyncBean(obj: FileSyncBean | null): FileSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeIMedia)(obj.updatedCreated)
  } as FileSyncBeanJSON);
}

type FilerInputBeanJSON = {
  color?: string;
  metaId?: string;
  name?: string;
  parentFolderId?: string;
};

export class FilerInputBean extends ServerBeanPrototype {
  color?: string;
  metaId?: string;
  name?: string;
  parentFolderId?: string;

  constructor(json: FilerInputBeanJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.parentFolderId = decodeMetaId(json.parentFolderId);
    this.onDecode(json);
  }
}

function decodeFilerInputBean(json: FilerInputBeanJSON | undefined): FilerInputBean | undefined {
  return json === undefined ? undefined : new FilerInputBean(json);
}

function encodeFilerInputBean(obj: FilerInputBean | null): FilerInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    parentFolderId: encodeMetaId(obj.parentFolderId)
  } as FilerInputBeanJSON);
}

type FizApiClientSideOperationAlreadyPerformedJSON = {
  message?: string;
};

export class FizApiClientSideOperationAlreadyPerformed extends ServerBeanPrototype {
  /** @param debugMessage the debugMessage to set */
  message?: string;

  constructor(json: FizApiClientSideOperationAlreadyPerformedJSON) {
    super(json);
    this.message = decodeString(json.message);
    this.onDecode(json);
  }
}

function decodeFizApiClientSideOperationAlreadyPerformed(json: FizApiClientSideOperationAlreadyPerformedJSON | undefined): FizApiClientSideOperationAlreadyPerformed | undefined {
  return json === undefined ? undefined : new FizApiClientSideOperationAlreadyPerformed(json);
}

function encodeFizApiClientSideOperationAlreadyPerformed(obj: FizApiClientSideOperationAlreadyPerformed | null): FizApiClientSideOperationAlreadyPerformedJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    message: encodeString(obj.message)
  } as FizApiClientSideOperationAlreadyPerformedJSON);
}

type FizRightBeanJSON = {
  canDelete?: string;
  canUpdate?: string;
};

export class FizRightBean extends ServerBeanPrototype {
  /** true if can delete, null means false , false is therefore never actually transmitted over
 @param delete null means false */
  canDelete?: boolean;
  /** true if can update, null means false
 @param update null means false */
  canUpdate?: boolean;

  constructor(json: FizRightBeanJSON) {
    super(json);
    this.canDelete = decodeBoolean(json.canDelete);
    this.canUpdate = decodeBoolean(json.canUpdate);
    this.onDecode(json);
  }
}

function decodeFizRightBean(json: FizRightBeanJSON | undefined): FizRightBean | undefined {
  return json === undefined ? undefined : new FizRightBean(json);
}

function encodeFizRightBean(obj: FizRightBean | null): FizRightBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    canDelete: encodeBoolean(obj.canDelete),
    canUpdate: encodeBoolean(obj.canUpdate)
  } as FizRightBeanJSON);
}

type FolderBeanJSON = {
  accountId?: string;
  color?: string;
  emoji?: string;
  familyId: string;
  filerDisplayMode?: FilerDisplayModeEnum;
  filerModifDate: string;
  filerSorting?: FilerSortingEnum;
  metaId: string;
  name?: string;
  parentFolderId?: string;
  rights: FizRightBeanJSON;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
};

export class FolderBean extends ServerBeanPrototype {
  /** if this is not null, this is a custom folder, and it returns the author, else it is a system folder
 @param accountId creator of the folder, may be null. */
  accountId?: number;
  /** the color of the folder, as #rrggbb format
 @param color color as #rrggbb format */
  color?: string;
  /** emoji of the folder
 @param emoji the emoji to set */
  emoji?: string;
  /** @param familyId the familyId to set */
  familyId!: number;
  /** The display mode in the filer section
 @param filerDisplayModeEnum filer display mode enum */
  filerDisplayMode?: FilerDisplayModeEnum;
  /** The modification date of the folder used to sort the items in a folder, don't take into account
 some changes, such as sharing changes.
 @param filerModifDate the filer modification date */
  filerModifDate!: Date;
  /** The sorting mode in the filer section
 @param filerSortingEnum filer sorting enum */
  filerSorting?: FilerSortingEnum;
  metaId!: string;
  /** the name of the folder
 @param name folder name */
  name?: string;
  /** if this folder is not the root folder of the family, this is the id of the folder containing this folder.
 @param parentFolderId the parent folder meta id or null */
  parentFolderId?: string;
  rights!: FizRightBean;
  /** list of members who can see this folder. This list always contains the author of the folder.<br>
 Those are account ids (member). <br>
 @param sharedMemberIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this folder is shared<br>
 If null it is in case of an update to indicate it is not changed. */
  sharedToAll?: boolean;

  constructor(json: FolderBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.color = decodeString(json.color);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.filerDisplayMode = decodeEnum(json.filerDisplayMode);
    this.filerModifDate = decodeDate(json.filerModifDate);
    this.filerSorting = decodeEnum(json.filerSorting);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.parentFolderId = decodeMetaId(json.parentFolderId);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.onDecode(json);
  }
}

function decodeFolderBean(json: FolderBeanJSON | undefined): FolderBean | undefined {
  return json === undefined ? undefined : new FolderBean(json);
}

function encodeFolderBean(obj: FolderBean | null): FolderBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    color: encodeString(obj.color),
    emoji: encodeString(obj.emoji),
    familyId: encodeNumber(obj.familyId),
    filerDisplayMode: encodeEnum(obj.filerDisplayMode),
    filerSorting: encodeEnum(obj.filerSorting),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    parentFolderId: encodeMetaId(obj.parentFolderId),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll)
  } as FolderBeanJSON);
}

type FolderInputBeanJSON = {
  color?: string;
  emoji?: string;
  filerDisplayMode?: FilerDisplayModeEnum;
  filerSorting?: FilerSortingEnum;
  metaId?: string;
  name?: string;
  parentFolderId?: string;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
};

export class FolderInputBean extends ServerBeanPrototype {
  /** the color of the folder, as #rrggbb format
 @param color color as #rrggbb format */
  color?: string;
  /** emoji of the folder
 @param emoji the emoji to set */
  emoji?: string;
  /** The display mode in the filer section
 @param filerDisplayModeEnum filer display mode enum */
  filerDisplayMode?: FilerDisplayModeEnum;
  /** The sorting mode in the filer section
 @param filerSortingEnum filer sorting enum */
  filerSorting?: FilerSortingEnum;
  /** metaId of the folder
 @param metaId the metaId to set */
  metaId?: string;
  /** the name of the folder
 @param name folder name */
  name?: string;
  /** if this folder is not the root folder of the family, this is the id of the folder containing this folder.
 @param parentFolderId the parent folder meta id or null */
  parentFolderId?: string;
  /** list of members who can see this folder. This list always contains the author of the folder.<br>
 Those are account ids (member). <br>
 @param sharedMemberIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this folder is shared<br>
 If null it is in case of an update to indicate it is not changed. */
  sharedToAll?: boolean;

  constructor(json: FolderInputBeanJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.emoji = decodeString(json.emoji);
    this.filerDisplayMode = decodeEnum(json.filerDisplayMode);
    this.filerSorting = decodeEnum(json.filerSorting);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.parentFolderId = decodeMetaId(json.parentFolderId);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.onDecode(json);
  }
}

function decodeFolderInputBean(json: FolderInputBeanJSON | undefined): FolderInputBean | undefined {
  return json === undefined ? undefined : new FolderInputBean(json);
}

function encodeFolderInputBean(obj: FolderInputBean | null): FolderInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    emoji: encodeString(obj.emoji),
    filerDisplayMode: encodeEnum(obj.filerDisplayMode),
    filerSorting: encodeEnum(obj.filerSorting),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    parentFolderId: encodeMetaId(obj.parentFolderId),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll)
  } as FolderInputBeanJSON);
}

type FolderSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<FolderBeanJSON>;
};

export class FolderSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<FolderBean>;

  constructor(json: FolderSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeFolderBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeFolderSyncBean(json: FolderSyncBeanJSON | undefined): FolderSyncBean | undefined {
  return json === undefined ? undefined : new FolderSyncBean(json);
}

function encodeFolderSyncBean(obj: FolderSyncBean | null): FolderSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeFolderBean)(obj.updatedCreated)
  } as FolderSyncBeanJSON);
}

type ForgotPasswordResponseBeanJSON = {
  infoSentTo?: IProfileJSON;
  requestedIdentifier: string;
};

export class ForgotPasswordResponseBean extends ServerBeanPrototype {
  infoSentTo?: IProfile;
  requestedIdentifier!: string;

  constructor(json: ForgotPasswordResponseBeanJSON) {
    super(json);
    this.infoSentTo = decodeIProfile(json.infoSentTo);
    this.requestedIdentifier = decodeString(json.requestedIdentifier);
    this.onDecode(json);
  }
}

function decodeForgotPasswordResponseBean(json: ForgotPasswordResponseBeanJSON | undefined): ForgotPasswordResponseBean | undefined {
  return json === undefined ? undefined : new ForgotPasswordResponseBean(json);
}

function encodeForgotPasswordResponseBean(obj: ForgotPasswordResponseBean | null): ForgotPasswordResponseBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    infoSentTo: encodeIProfile(obj.infoSentTo),
    requestedIdentifier: encodeString(obj.requestedIdentifier)
  } as ForgotPasswordResponseBeanJSON);
}

type GeocodedAddressJSON = {
  accuracy?: string;
  attribute0Country?: string;
  attribute1State?: string;
  attribute2Town?: string;
  attribute3ZipCode?: string;
  attribute4Line?: string;
  formattedAddress?: string;
  latitudeE6?: string;
  longitudeE6?: string;
  radius?: string;
};

export class GeocodedAddress extends ServerBeanPrototype {
  /** accuracy of the address (0 if a country, 5 if a precise address with
 street number)

 @param accuraccy */
  accuracy?: number;
  /** country where the address is

 @param attributeCountry */
  attribute0Country?: string;
  /** state of the address

 @param attributeState */
  attribute1State?: string;
  /** town of the address

 @param attributeTown */
  attribute2Town?: string;
  /** zipCode of the address

 @param attributeZipCode */
  attribute3ZipCode?: string;
  /** line of the address (ex : 3 st-james street)

 @param attributeLine */
  attribute4Line?: string;
  /** the well formatted address

 @param formattedAddress */
  formattedAddress?: string;
  /** latitude as an int (* 1 000 000)

 @param latitudeE6
            latitude of the address */
  latitudeE6?: number;
  /** longitude as an int (* 1 000 000)

 @param longitudeE6
            longitude of the address */
  longitudeE6?: number;
  /** the radius of the place in meter

 @param radius */
  radius?: number;

  constructor(json: GeocodedAddressJSON) {
    super(json);
    this.accuracy = decodeNumber(json.accuracy);
    this.attribute0Country = decodeString(json.attribute0Country);
    this.attribute1State = decodeString(json.attribute1State);
    this.attribute2Town = decodeString(json.attribute2Town);
    this.attribute3ZipCode = decodeString(json.attribute3ZipCode);
    this.attribute4Line = decodeString(json.attribute4Line);
    this.formattedAddress = decodeString(json.formattedAddress);
    this.latitudeE6 = decodeNumber(json.latitudeE6);
    this.longitudeE6 = decodeNumber(json.longitudeE6);
    this.radius = decodeNumber(json.radius);
    this.onDecode(json);
  }
}

function decodeGeocodedAddress(json: GeocodedAddressJSON | undefined): GeocodedAddress | undefined {
  return json === undefined ? undefined : new GeocodedAddress(json);
}

function encodeGeocodedAddress(obj: GeocodedAddress | null): GeocodedAddressJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accuracy: encodeNumber(obj.accuracy),
    attribute0Country: encodeString(obj.attribute0Country),
    attribute1State: encodeString(obj.attribute1State),
    attribute2Town: encodeString(obj.attribute2Town),
    attribute3ZipCode: encodeString(obj.attribute3ZipCode),
    attribute4Line: encodeString(obj.attribute4Line),
    formattedAddress: encodeString(obj.formattedAddress),
    latitudeE6: encodeNumber(obj.latitudeE6),
    longitudeE6: encodeNumber(obj.longitudeE6),
    radius: encodeNumber(obj.radius)
  } as GeocodedAddressJSON);
}

type GoogleCredentialBeanJSON = {
  credentialId: string;
  errorCode?: string;
  errorMessage?: string;
  linkable?: Array<GoogleLinkableCalendarBeanJSON>;
  linked: Array<CalendarBeanJSON>;
  name?: string;
};

export class GoogleCredentialBean extends ServerBeanPrototype {
  /** our internal id
 
 @param credentialId */
  credentialId!: string;
  errorCode?: string;
  errorMessage?: string;
  /** calendar from google than might be linked to our system
 Use this to pick calendars from google account
 @param linkable */
  linkable?: Array<GoogleLinkableCalendarBean>;
  /** calendar from google that are already linked to our system
 Use this in the UI for connected calendars
 @param linked */
  linked!: Array<CalendarBean>;
  name?: string;

  constructor(json: GoogleCredentialBeanJSON) {
    super(json);
    this.credentialId = decodeMetaId(json.credentialId);
    this.errorCode = decodeString(json.errorCode);
    this.errorMessage = decodeString(json.errorMessage);
    this.linkable = decodeArray(decodeGoogleLinkableCalendarBean)(json.linkable);
    this.linked = decodeArray(decodeCalendarBean)(json.linked);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeGoogleCredentialBean(json: GoogleCredentialBeanJSON | undefined): GoogleCredentialBean | undefined {
  return json === undefined ? undefined : new GoogleCredentialBean(json);
}

function encodeGoogleCredentialBean(obj: GoogleCredentialBean | null): GoogleCredentialBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    credentialId: encodeMetaId(obj.credentialId),
    errorCode: encodeString(obj.errorCode),
    errorMessage: encodeString(obj.errorMessage),
    linkable: encodeArray(encodeGoogleLinkableCalendarBean)(obj.linkable),
    linked: encodeArray(encodeCalendarBean)(obj.linked),
    name: encodeString(obj.name)
  } as GoogleCredentialBeanJSON);
}

type GoogleLinkableCalendarBeanJSON = {
  color: string;
  googleId: string;
  linked: string;
  name: string;
};

export class GoogleLinkableCalendarBean extends ServerBeanPrototype {
  color!: string;
  googleId!: string;
  linked!: boolean;
  name!: string;

  constructor(json: GoogleLinkableCalendarBeanJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.googleId = decodeString(json.googleId);
    this.linked = decodeboolean(json.linked);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeGoogleLinkableCalendarBean(json: GoogleLinkableCalendarBeanJSON | undefined): GoogleLinkableCalendarBean | undefined {
  return json === undefined ? undefined : new GoogleLinkableCalendarBean(json);
}

function encodeGoogleLinkableCalendarBean(obj: GoogleLinkableCalendarBean | null): GoogleLinkableCalendarBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    googleId: encodeString(obj.googleId),
    linked: encodeboolean(obj.linked),
    name: encodeString(obj.name)
  } as GoogleLinkableCalendarBeanJSON);
}

type HomeHubValidationBeanJSON = {
  checkoutUrl?: string;
  valid: string;
};

export class HomeHubValidationBean extends ServerBeanPrototype {
  checkoutUrl?: string;
  valid!: boolean;

  constructor(json: HomeHubValidationBeanJSON) {
    super(json);
    this.checkoutUrl = decodeString(json.checkoutUrl);
    this.valid = decodeboolean(json.valid);
    this.onDecode(json);
  }
}

function decodeHomeHubValidationBean(json: HomeHubValidationBeanJSON | undefined): HomeHubValidationBean | undefined {
  return json === undefined ? undefined : new HomeHubValidationBean(json);
}

function encodeHomeHubValidationBean(obj: HomeHubValidationBean | null): HomeHubValidationBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    checkoutUrl: encodeString(obj.checkoutUrl),
    valid: encodeboolean(obj.valid)
  } as HomeHubValidationBeanJSON);
}

type IAGenerateRecipeParametersJSON = {
  cuisineType: string;
  directions: string;
  proteinType: string;
  units: string;
};

export class IAGenerateRecipeParameters extends ServerBeanPrototype {
  cuisineType!: string;
  directions!: string;
  proteinType!: string;
  units!: string;

  constructor(json: IAGenerateRecipeParametersJSON) {
    super(json);
    this.cuisineType = decodeString(json.cuisineType);
    this.directions = decodeString(json.directions);
    this.proteinType = decodeString(json.proteinType);
    this.units = decodeString(json.units);
    this.onDecode(json);
  }
}

function decodeIAGenerateRecipeParameters(json: IAGenerateRecipeParametersJSON | undefined): IAGenerateRecipeParameters | undefined {
  return json === undefined ? undefined : new IAGenerateRecipeParameters(json);
}

function encodeIAGenerateRecipeParameters(obj: IAGenerateRecipeParameters | null): IAGenerateRecipeParametersJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    cuisineType: encodeString(obj.cuisineType),
    directions: encodeString(obj.directions),
    proteinType: encodeString(obj.proteinType),
    units: encodeString(obj.units)
  } as IAGenerateRecipeParametersJSON);
}

type IAccountJSON = {
  accountId: string;
  creationDate?: string;
  deleted: string;
  identifiers: Array<IAccountIdentifierJSON>;
  lastLoginDate?: string;
  name: string;
  termsChecked: string;
  termsOrangeFamilyPlaceChecked: string;
  termsProximusFamilyChecked?: string;
};

export class IAccount extends ServerBeanPrototype {
  /** @param id the id to set */
  accountId!: number;
  creationDate?: Date;
  /** @param deleted the deleted to set */
  deleted!: boolean;
  identifiers!: Array<IAccountIdentifier>;
  lastLoginDate?: Date;
  /** the name of the account
 @param name the name to set */
  name!: string;
  termsChecked!: boolean;
  termsOrangeFamilyPlaceChecked!: boolean;
  /** warning: may be null for old db row, therefore test carefully
 @param termsProximusFamilyChecked */
  termsProximusFamilyChecked?: boolean;

  constructor(json: IAccountJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationDate = decodeDate(json.creationDate);
    this.deleted = decodeboolean(json.deleted);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.name = decodeString(json.name);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);
    this.onDecode(json);
  }
}

function decodeIAccount(json: IAccountJSON | undefined): IAccount | undefined {
  return json === undefined ? undefined : new IAccount(json);
}

function encodeIAccount(obj: IAccount | null): IAccountJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationDate: encodeDate(obj.creationDate),
    deleted: encodeboolean(obj.deleted),
    identifiers: encodeArray(encodeIAccountIdentifier)(obj.identifiers),
    lastLoginDate: encodeDate(obj.lastLoginDate),
    name: encodeString(obj.name),
    termsChecked: encodeboolean(obj.termsChecked),
    termsOrangeFamilyPlaceChecked: encodeboolean(obj.termsOrangeFamilyPlaceChecked),
    termsProximusFamilyChecked: encodeBoolean(obj.termsProximusFamilyChecked)
  } as IAccountJSON);
}

type IAccountIdentifierJSON = {
  id: string;
  type: AccountIdentifierTypeEnum;
  validated: string;
  value: string;
  verifiedPartner?: PartnerTypeEnum;
};

export class IAccountIdentifier extends ServerBeanPrototype {
  /** @param id the id to set */
  id!: number;
  type!: AccountIdentifierTypeEnum;
  /** indicate that this identifier has been proved to really be for this user (for instance a verification email has been sent)
 @param validated */
  validated!: boolean;
  /** the value of the email/msisdn/etc
 @param value */
  value!: string;
  /** return the partner that verified this identifier, ie this partner actually validated that this id correspond to the user and is approved by the partner.
 Used for sprint to tag sprint validated msisdn for billing 
 @param value */
  verifiedPartner?: PartnerTypeEnum;

  constructor(json: IAccountIdentifierJSON) {
    super(json);
    this.id = decodeNumber(json.id);
    this.type = decodeEnum(json.type);
    this.validated = decodeBoolean(json.validated);
    this.value = decodeString(json.value);
    this.verifiedPartner = decodeEnum(json.verifiedPartner);
    this.onDecode(json);
  }
}

function decodeIAccountIdentifier(json: IAccountIdentifierJSON | undefined): IAccountIdentifier | undefined {
  return json === undefined ? undefined : new IAccountIdentifier(json);
}

function encodeIAccountIdentifier(obj: IAccountIdentifier | null): IAccountIdentifierJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    id: encodeNumber(obj.id),
    type: encodeEnum(obj.type),
    validated: encodeBoolean(obj.validated),
    value: encodeString(obj.value),
    verifiedPartner: encodeEnum(obj.verifiedPartner)
  } as IAccountIdentifierJSON);
}

type IAddressJSON = {
  addressId?: string;
  geocodedAddress: GeocodedAddressJSON;
  metaId?: string;
  placeType?: PlaceTypeEnum;
};

export class IAddress extends ServerBeanPrototype {
  addressId?: string;
  geocodedAddress!: GeocodedAddress;
  metaId?: string;
  /** type of place

 @param placeType */
  placeType?: PlaceTypeEnum;

  constructor(json: IAddressJSON) {
    super(json);
    this.addressId = decodeMetaId(json.addressId);
    this.geocodedAddress = decodeGeocodedAddress(json.geocodedAddress);
    this.metaId = decodeMetaId(json.metaId);
    this.placeType = decodeEnum(json.placeType);
    this.onDecode(json);
  }
}

function decodeIAddress(json: IAddressJSON | undefined): IAddress | undefined {
  return json === undefined ? undefined : new IAddress(json);
}

function encodeIAddress(obj: IAddress | null): IAddressJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    addressId: encodeMetaId(obj.addressId),
    geocodedAddress: encodeGeocodedAddress(obj.geocodedAddress),
    metaId: encodeMetaId(obj.metaId),
    placeType: encodeEnum(obj.placeType)
  } as IAddressJSON);
}

type IApiKeyJSON = {
  accessRightRuleset: ApiAccessRightRulesetEnum;
  apiKeyClientType: ApiKeyClientType;
  clientId: string;
  clientSecret: string;
  forcedPartner?: PartnerTypeEnum;
  name?: string;
  oAuth2PasswordBasedAuthorized: string;
  webAnonymousAuthorized: string;
  webRedirectUrlPrefix?: string;
};

export class IApiKey extends ServerBeanPrototype {
  /** @param accessRightConfigType the accessRightConfigType to set */
  accessRightRuleset!: ApiAccessRightRulesetEnum;
  /** @param apiKeyClientType the apiKeyClientType to set */
  apiKeyClientType!: ApiKeyClientType;
  /** @param clientId the clientId to set */
  clientId!: string;
  /** @param clientSecret the clientSecret to set */
  clientSecret!: string;
  /** the partner that this key must use, may be null in this case the partner may use any key by specifying it in any requests
 @param forcedPartner */
  forcedPartner?: PartnerTypeEnum;
  /** @param name the name to set */
  name?: string;
  /** @param isOAuth2PasswordBasedAuthorized the isOAuth2PasswordBasedAuthorized to set */
  oAuth2PasswordBasedAuthorized!: boolean;
  /** @param isWebAnonymousAuthorized the isWebAnonymousAuthorized to set */
  webAnonymousAuthorized!: boolean;
  /** @param webRedirectUrlPrefix the webRedirectUrlPrefix to set */
  webRedirectUrlPrefix?: string;

  constructor(json: IApiKeyJSON) {
    super(json);
    this.accessRightRuleset = decodeEnum(json.accessRightRuleset);
    this.apiKeyClientType = decodeEnum(json.apiKeyClientType);
    this.clientId = decodeString(json.clientId);
    this.clientSecret = decodeString(json.clientSecret);
    this.forcedPartner = decodeEnum(json.forcedPartner);
    this.name = decodeString(json.name);
    this.oAuth2PasswordBasedAuthorized = decodeboolean(json.oAuth2PasswordBasedAuthorized);
    this.webAnonymousAuthorized = decodeboolean(json.webAnonymousAuthorized);
    this.webRedirectUrlPrefix = decodeString(json.webRedirectUrlPrefix);
    this.onDecode(json);
  }
}

function decodeIApiKey(json: IApiKeyJSON | undefined): IApiKey | undefined {
  return json === undefined ? undefined : new IApiKey(json);
}

function encodeIApiKey(obj: IApiKey | null): IApiKeyJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accessRightRuleset: encodeEnum(obj.accessRightRuleset),
    apiKeyClientType: encodeEnum(obj.apiKeyClientType),
    clientId: encodeString(obj.clientId),
    clientSecret: encodeString(obj.clientSecret),
    forcedPartner: encodeEnum(obj.forcedPartner),
    name: encodeString(obj.name),
    oAuth2PasswordBasedAuthorized: encodeboolean(obj.oAuth2PasswordBasedAuthorized),
    webAnonymousAuthorized: encodeboolean(obj.webAnonymousAuthorized),
    webRedirectUrlPrefix: encodeString(obj.webRedirectUrlPrefix)
  } as IApiKeyJSON);
}

type IAttendeeJSON = {
  accountId: string;
  attendeeResponse?: AttendeeResponseEnum;
  attendeeStatus?: AttendeeStatusEnum;
};

export class IAttendee extends ServerBeanPrototype {
  /** accountid in the family attending to this event
 @param accountId */
  accountId!: number;
  /** status of the response of a attendee, not used for the moment
 @param attendeeResponse */
  attendeeResponse?: AttendeeResponseEnum;
  /** status of an attendee, not used for the moment, always equals to ATTENDEE
 @param attendeeStatus */
  attendeeStatus?: AttendeeStatusEnum;

  constructor(json: IAttendeeJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.attendeeResponse = decodeEnum(json.attendeeResponse);
    this.attendeeStatus = decodeEnum(json.attendeeStatus);
    this.onDecode(json);
  }
}

function decodeIAttendee(json: IAttendeeJSON | undefined): IAttendee | undefined {
  return json === undefined ? undefined : new IAttendee(json);
}

function encodeIAttendee(obj: IAttendee | null): IAttendeeJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    attendeeResponse: encodeEnum(obj.attendeeResponse),
    attendeeStatus: encodeEnum(obj.attendeeStatus)
  } as IAttendeeJSON);
}

type IBroadcastableJSON = {
};

export class IBroadcastable extends ServerBeanPrototype {

  constructor(json: IBroadcastableJSON) {
    super(json);
    this.onDecode(json);
  }
}

function decodeIBroadcastable(json: IBroadcastableJSON | undefined): IBroadcastable | undefined {
  return json === undefined ? undefined : new IBroadcastable(json);
}

function encodeIBroadcastable(obj: IBroadcastable | null): IBroadcastableJSON | undefined {
  if (obj == null) return undefined;
  return inline({} as IBroadcastableJSON);
}

type ICommentJSON = {
  accountId: string;
  bestMoment?: string;
  commentId: string;
  creationDate: string;
  mood?: MoodEnum;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  rights?: FizRightBeanJSON;
  text: string;
  updatedDate?: string;
};

export class IComment extends ServerBeanPrototype {
  accountId!: number;
  /** set if bestMoment, please NEVER USE, the moodableManager handle this
 @param bestMoment */
  bestMoment?: boolean;
  commentId!: string;
  creationDate!: Date;
  mood?: MoodEnum;
  /** set the moodMap<br>
 please NEVER USE to modify the map, use moodableManager for this
 @param moodMap */
  moodMap?: Map<number, Array<MoodEnum>>;
  /** set if the currentAccount has set the mood "star"
 Please NEVER_USE, the moodableManager handle this. */
  moodStarShortcut?: boolean;
  rights?: FizRightBean;
  text!: string;
  /** date of last update of the comment, if null has never been updated
 @param updatedDate */
  updatedDate?: Date;

  constructor(json: ICommentJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.commentId = decodeMetaId(json.commentId);
    this.creationDate = decodeDate(json.creationDate);
    this.mood = decodeEnum(json.mood);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.rights = decodeFizRightBean(json.rights);
    this.text = decodeString(json.text);
    this.updatedDate = decodeDate(json.updatedDate);
    this.onDecode(json);
  }
}

function decodeIComment(json: ICommentJSON | undefined): IComment | undefined {
  return json === undefined ? undefined : new IComment(json);
}

function encodeIComment(obj: IComment | null): ICommentJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    commentId: encodeMetaId(obj.commentId),
    creationDate: encodeDate(obj.creationDate),
    mood: encodeEnum(obj.mood),
    rights: encodeFizRightBean(obj.rights),
    text: encodeString(obj.text),
    updatedDate: encodeDate(obj.updatedDate)
  } as ICommentJSON);
}

type IContactJSON = {
  accountId?: string;
  addresses?: Array<IAddressJSON>;
  birthDate?: string;
  birthDateNoYear?: string;
  comments?: Array<ICommentJSON>;
  devices?: Array<IDeviceJSON>;
  editable?: string;
  familyId?: string;
  firstName?: string;
  function?: string;
  gender?: GenderEnum;
  lastName?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  note?: string;
  pictureDefault?: string;
};

export class IContact extends ServerBeanPrototype {
  accountId?: number;
  addresses?: Array<IAddress>;
  birthDate?: Date;
  birthDateNoYear?: boolean;
  comments?: Array<IComment>;
  devices?: Array<IDevice>;
  editable?: boolean;
  familyId?: string;
  firstName?: string;
  function?: string;
  gender?: GenderEnum;
  lastName?: string;
  medias?: Array<IMedia>;
  metaId?: string;
  note?: string;
  pictureDefault?: boolean;

  constructor(json: IContactJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.firstName = decodeString(json.firstName);
    this.function = decodeString(json.function);
    this.gender = decodeEnum(json.gender);
    this.lastName = decodeString(json.lastName);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.note = decodeString(json.note);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.onDecode(json);
  }
}

function decodeIContact(json: IContactJSON | undefined): IContact | undefined {
  return json === undefined ? undefined : new IContact(json);
}

function encodeIContact(obj: IContact | null): IContactJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    addresses: encodeArray(encodeIAddress)(obj.addresses),
    birthDate: encodeDate(obj.birthDate),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    devices: encodeArray(encodeIDevice)(obj.devices),
    firstName: encodeString(obj.firstName),
    function: encodeString(obj.function),
    gender: encodeEnum(obj.gender),
    lastName: encodeString(obj.lastName),
    metaId: encodeMetaId(obj.metaId),
    note: encodeString(obj.note)
  } as IContactJSON);
}

type ICreditJSON = {
  accountId?: string;
  autoRenewType?: CreditAutoRenewType;
  creationDate?: string;
  creditStatus?: CreditStatusEnum;
  creditStatusDetail?: CreditStatusDetailEnum;
  creditType?: CreditTypeEnum;
  endDate?: string;
  familyIds?: Array<string>;
  metaId?: string;
  paymentCancelDate?: string;
  paymentCancelReason?: string;
  paymentCancelReasonSurvey?: string;
  paymentCancelReasonSurveyCustom?: string;
  paymentDate?: string;
  paymentKey?: string;
  paymentOriginalStatus?: string;
  paymentReceipt?: string;
  paymentSKU?: string;
  paymentStatus?: string;
  paymentStatusActiveDate?: string;
  paymentSubSKU?: string;
  paymentType?: CreditPaymentTypeEnum;
  paymentValue?: string;
  periodType?: CreditTypeOfPeriodEnum;
  startDate?: string;
  text?: string;
  value?: string;
};

export class ICredit extends ServerBeanPrototype {
  accountId?: number;
  autoRenewType?: CreditAutoRenewType;
  creationDate?: Date;
  creditStatus?: CreditStatusEnum;
  creditStatusDetail?: CreditStatusDetailEnum;
  creditType?: CreditTypeEnum;
  endDate?: Date;
  familyIds?: Array<number>;
  metaId?: string;
  paymentCancelDate?: Date;
  paymentCancelReason?: number;
  paymentCancelReasonSurvey?: number;
  paymentCancelReasonSurveyCustom?: string;
  paymentDate?: Date;
  paymentKey?: string;
  paymentOriginalStatus?: number;
  paymentReceipt?: string;
  paymentSKU?: string;
  paymentStatus?: number;
  paymentStatusActiveDate?: Date;
  paymentSubSKU?: string;
  paymentType?: CreditPaymentTypeEnum;
  paymentValue?: string;
  periodType?: CreditTypeOfPeriodEnum;
  startDate?: Date;
  text?: string;
  value?: number;

  constructor(json: ICreditJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.autoRenewType = decodeEnum(json.autoRenewType);
    this.creationDate = decodeDate(json.creationDate);
    this.creditStatus = decodeEnum(json.creditStatus);
    this.creditStatusDetail = decodeEnum(json.creditStatusDetail);
    this.creditType = decodeEnum(json.creditType);
    this.endDate = decodeDate(json.endDate);
    this.familyIds = decodeArray(decodeNumber)(json.familyIds);
    this.metaId = decodeMetaId(json.metaId);
    this.paymentCancelDate = decodeDate(json.paymentCancelDate);
    this.paymentCancelReason = decodeNumber(json.paymentCancelReason);
    this.paymentCancelReasonSurvey = decodeNumber(json.paymentCancelReasonSurvey);
    this.paymentCancelReasonSurveyCustom = decodeString(json.paymentCancelReasonSurveyCustom);
    this.paymentDate = decodeDate(json.paymentDate);
    this.paymentKey = decodeString(json.paymentKey);
    this.paymentOriginalStatus = decodeNumber(json.paymentOriginalStatus);
    this.paymentReceipt = decodeString(json.paymentReceipt);
    this.paymentSKU = decodeString(json.paymentSKU);
    this.paymentStatus = decodeNumber(json.paymentStatus);
    this.paymentStatusActiveDate = decodeDate(json.paymentStatusActiveDate);
    this.paymentSubSKU = decodeString(json.paymentSubSKU);
    this.paymentType = decodeEnum(json.paymentType);
    this.paymentValue = decodeString(json.paymentValue);
    this.periodType = decodeEnum(json.periodType);
    this.startDate = decodeDate(json.startDate);
    this.text = decodeString(json.text);
    this.value = decodeNumber(json.value);
    this.onDecode(json);
  }
}

function decodeICredit(json: ICreditJSON | undefined): ICredit | undefined {
  return json === undefined ? undefined : new ICredit(json);
}

function encodeICredit(obj: ICredit | null): ICreditJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    autoRenewType: encodeEnum(obj.autoRenewType),
    creationDate: encodeDate(obj.creationDate),
    creditStatus: encodeEnum(obj.creditStatus),
    creditStatusDetail: encodeEnum(obj.creditStatusDetail),
    creditType: encodeEnum(obj.creditType),
    endDate: encodeDate(obj.endDate),
    familyIds: encodeArray(encodeNumber)(obj.familyIds),
    metaId: encodeMetaId(obj.metaId),
    paymentCancelDate: encodeDate(obj.paymentCancelDate),
    paymentCancelReason: encodeNumber(obj.paymentCancelReason),
    paymentCancelReasonSurvey: encodeNumber(obj.paymentCancelReasonSurvey),
    paymentCancelReasonSurveyCustom: encodeString(obj.paymentCancelReasonSurveyCustom),
    paymentDate: encodeDate(obj.paymentDate),
    paymentKey: encodeString(obj.paymentKey),
    paymentOriginalStatus: encodeNumber(obj.paymentOriginalStatus),
    paymentReceipt: encodeString(obj.paymentReceipt),
    paymentSKU: encodeString(obj.paymentSKU),
    paymentStatus: encodeNumber(obj.paymentStatus),
    paymentStatusActiveDate: encodeDate(obj.paymentStatusActiveDate),
    paymentSubSKU: encodeString(obj.paymentSubSKU),
    paymentType: encodeEnum(obj.paymentType),
    paymentValue: encodeString(obj.paymentValue),
    periodType: encodeEnum(obj.periodType),
    startDate: encodeDate(obj.startDate),
    text: encodeString(obj.text),
    value: encodeNumber(obj.value)
  } as ICreditJSON);
}

type IDeviceJSON = {
  deviceId?: string;
  deviceType: DeviceTypeEnum;
  value: string;
};

export class IDevice extends ServerBeanPrototype {
  deviceId?: string;
  deviceType!: DeviceTypeEnum;
  value!: string;

  constructor(json: IDeviceJSON) {
    super(json);
    this.deviceId = decodeMetaId(json.deviceId);
    this.deviceType = decodeEnum(json.deviceType);
    this.value = decodeString(json.value);
    this.onDecode(json);
  }
}

function decodeIDevice(json: IDeviceJSON | undefined): IDevice | undefined {
  return json === undefined ? undefined : new IDevice(json);
}

function encodeIDevice(obj: IDevice | null): IDeviceJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deviceId: encodeMetaId(obj.deviceId),
    deviceType: encodeEnum(obj.deviceType),
    value: encodeString(obj.value)
  } as IDeviceJSON);
}

type IDeviceConfigJSON = {
  MCC?: string;
  MNC?: string;
  applicationVersion?: string;
  buildTimestamp?: string;
  deviceId: string;
  languageSystem?: string;
  metaId?: string;
  modelType?: DeviceModelTypeEnum;
  nativeAppId?: string;
  notificationTokenId?: string;
  partnerType?: PartnerTypeEnum;
  systemName?: string;
  systemVersion?: string;
};

export class IDeviceConfig extends ServerBeanPrototype {
  /** the mcc (mobile country code) of the sim card of the device, if avail. */
  MCC?: string;
  /** the mnc (mobile network code) of the sim card of the device, if avail. */
  MNC?: string;
  /** the version of the application family installed on the device. The build number for android (2015746851)
 and the application version for ios (11.2.4) */
  applicationVersion?: string;
  /** the build timestamp for this device as defined for accgetstate api (ie the timestamp of the build in seconds after 1jan1970:0h0m0sUTC)<br>
 However, for ios, since bitrise is unable to get a timestanp while building, it is incremented starting from around 1592920000 at each build, hence it is
 not a timestamp anymore. */
  buildTimestamp?: number;
  /** unique identification of the device, may be a string, generated by the client on the device.
 It is an opaque ID, and certainly not guaranteed to be the imei
 @param deviceId device id */
  deviceId!: string;
  /** the system language of the device, in java format (ie fr_FR, or en_GB). Note that this corresponds to the devicesetconfig
 api. The api that update the profile is accgetstate (which is preferred)
 @param languageSystem */
  languageSystem?: string;
  metaId?: string;
  /** the kind of device, for the purpose of the server application. It does not differenciate precisely the
 device type but only give the family that change the push protocol. Either iphone or android.
 @param modelType */
  modelType?: DeviceModelTypeEnum;
  /** Optional value for the app native package or bundle identifier on the device. For instance, it is the bundleId on ios and the packageName on android<br>
 If the device sends it, it is stored here. It must match the config for the same partner. Useful to manage 2 different bundleIds on ios.
 @param id */
  nativeAppId?: string;
  /** the push notification token that given to the push server (either android or iphone) along with the
 device id
 @param notificationTokenId */
  notificationTokenId?: string;
  /** The partnertype of this device, may be different from account's partnertype in case of several devices (or client changed) */
  partnerType?: PartnerTypeEnum;
  /** The system name of the device. exact syntax is left free for the device but it must be unique across all device type
 (ie device with different characteristics)
 For instance it may be a codename such as bliss, rythme, iphone4s32go, etc...
 @param systemName */
  systemName?: string;
  /** The version of the os. For iphone the ios version, and for android the android api level. */
  systemVersion?: string;

  constructor(json: IDeviceConfigJSON) {
    super(json);
    this.MCC = decodeString(json.MCC);
    this.MNC = decodeString(json.MNC);
    this.applicationVersion = decodeString(json.applicationVersion);
    this.buildTimestamp = decodeNumber(json.buildTimestamp);
    this.deviceId = decodeString(json.deviceId);
    this.languageSystem = decodeString(json.languageSystem);
    this.metaId = decodeMetaId(json.metaId);
    this.modelType = decodeEnum(json.modelType);
    this.nativeAppId = decodeString(json.nativeAppId);
    this.notificationTokenId = decodeString(json.notificationTokenId);
    this.partnerType = decodeEnum(json.partnerType);
    this.systemName = decodeString(json.systemName);
    this.systemVersion = decodeString(json.systemVersion);
    this.onDecode(json);
  }
}

function decodeIDeviceConfig(json: IDeviceConfigJSON | undefined): IDeviceConfig | undefined {
  return json === undefined ? undefined : new IDeviceConfig(json);
}

function encodeIDeviceConfig(obj: IDeviceConfig | null): IDeviceConfigJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    MCC: encodeString(obj.MCC),
    MNC: encodeString(obj.MNC),
    applicationVersion: encodeString(obj.applicationVersion),
    buildTimestamp: encodeNumber(obj.buildTimestamp),
    deviceId: encodeString(obj.deviceId),
    languageSystem: encodeString(obj.languageSystem),
    metaId: encodeMetaId(obj.metaId),
    modelType: encodeEnum(obj.modelType),
    nativeAppId: encodeString(obj.nativeAppId),
    notificationTokenId: encodeString(obj.notificationTokenId),
    partnerType: encodeEnum(obj.partnerType),
    systemName: encodeString(obj.systemName),
    systemVersion: encodeString(obj.systemVersion)
  } as IDeviceConfigJSON);
}

type IEventJSON = {
  accountId: string;
  allDay: string;
  attendeeIds: Array<string>;
  bestMoment?: string;
  birthDateNoYear?: string;
  calendarId: string;
  color?: string;
  colorInfo?: ColorBeanJSON;
  comments?: Array<ICommentJSON>;
  description?: string;
  editable?: string;
  emoji?: string;
  endDate?: string;
  eventId: string;
  eventMasterId: string;
  eventType?: EventTypeEnum;
  externalImportId?: string;
  familyId: string;
  lastAction?: UserActionEnum;
  lastActionAuthor?: string;
  lastActionDate?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  modifDate: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  occurenceIndex?: string;
  placeId?: string;
  private: string;
  recurrencyExceptionOfId?: string;
  refPersonId?: string;
  refPersonName?: string;
  reminder?: IReminderJSON;
  reminderList: Array<IReminderJSON>;
  startDate: string;
  taskListId?: string;
  text?: string;
  timeZone?: string;
  toAll: string;
  where?: string;
} & RecurrencyDescriptorJSON;

export class IEvent extends ServerBeanPrototype {
  accountId!: number;
  allDay!: boolean;
  attendeeIds!: Array<number>;
  bestMoment?: boolean;
  birthDateNoYear?: boolean;
  calendarId!: string;
  color?: string;
  colorInfo?: ColorBean;
  comments?: Array<IComment>;
  description?: string;
  editable?: boolean;
  emoji?: string;
  endDate?: Date;
  eventId!: string;
  eventMasterId!: string;
  eventType?: EventTypeEnum;
  externalImportId?: string;
  familyId!: string;
  lastAction?: UserActionEnum;
  lastActionAuthor?: number;
  lastActionDate?: Date;
  medias?: Array<IMedia>;
  metaId?: string;
  modifDate!: Date;
  moodMap?: Map<number, Array<MoodEnum>>;
  moodStarShortcut?: boolean;
  occurenceIndex?: number;
  placeId?: string;
  private!: boolean;
  recurrencyDescriptor!: RecurrencyDescriptor;
  recurrencyExceptionOfId?: string;
  refPersonId?: string;
  refPersonName?: string;
  reminder?: IReminder;
  reminderList!: Array<IReminder>;
  startDate!: Date;
  taskListId?: string;
  text?: string;
  timeZone?: string;
  toAll!: boolean;
  where?: string;

  constructor(json: IEventJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.allDay = decodeBoolean(json.allDay);
    this.attendeeIds = decodeArray(decodeNumber)(json.attendeeIds);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.calendarId = decodeMetaId(json.calendarId);
    this.color = decodeString(json.color);
    this.colorInfo = decodeColorBean(json.colorInfo);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.description = decodeString(json.description);
    this.editable = decodeBoolean(json.editable);
    this.emoji = decodeString(json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.eventId = decodeMetaId(json.eventId);
    this.eventMasterId = decodeMetaId(json.eventMasterId);
    this.eventType = decodeEnum(json.eventType);
    this.externalImportId = decodeMetaId(json.externalImportId);
    this.familyId = decodeMetaId(json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.occurenceIndex = decodeNumber(json.occurenceIndex);
    this.placeId = decodeMetaId(json.placeId);
    this.private = decodeboolean(json.private);
    this.recurrencyExceptionOfId = decodeMetaId(json.recurrencyExceptionOfId);
    this.refPersonId = decodeMetaId(json.refPersonId);
    this.refPersonName = decodeString(json.refPersonName);
    this.reminder = decodeIReminder(json.reminder);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.taskListId = decodeMetaId(json.taskListId);
    this.text = decodeString(json.text);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.toAll = decodeboolean(json.toAll);
    this.where = decodeString(json.where);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeIEvent(json: IEventJSON | undefined): IEvent | undefined {
  return json === undefined ? undefined : new IEvent(json);
}

function encodeIEvent(obj: IEvent | null): IEventJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    allDay: encodeBoolean(obj.allDay),
    attendeeIds: encodeArray(encodeNumber)(obj.attendeeIds),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    calendarId: encodeMetaId(obj.calendarId),
    color: encodeString(obj.color),
    colorInfo: encodeColorBean(obj.colorInfo),
    description: encodeString(obj.description),
    editable: encodeBoolean(obj.editable),
    emoji: encodeString(obj.emoji),
    endDate: encodeDate(obj.endDate),
    eventId: encodeMetaId(obj.eventId),
    eventMasterId: encodeMetaId(obj.eventMasterId),
    eventType: encodeEnum(obj.eventType),
    externalImportId: encodeMetaId(obj.externalImportId),
    familyId: encodeMetaId(obj.familyId),
    metaId: encodeMetaId(obj.metaId),
    modifDate: encodeDate(obj.modifDate),
    occurenceIndex: encodeNumber(obj.occurenceIndex),
    placeId: encodeMetaId(obj.placeId),
    private: encodeboolean(obj.private),
    refPersonId: encodeMetaId(obj.refPersonId),
    refPersonName: encodeString(obj.refPersonName),
    reminder: encodeIReminder(obj.reminder),
    reminderList: encodeArray(encodeIReminder)(obj.reminderList),
    startDate: encodeDate(obj.startDate),
    taskListId: encodeMetaId(obj.taskListId),
    text: encodeString(obj.text),
    timeZone: encodeTimeZone(obj.timeZone),
    toAll: encodeboolean(obj.toAll),
    where: encodeString(obj.where)
  } as IEventJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type IExtendedFamilyJSON = {
  coverDefault?: string;
  coverMedias?: Array<IMediaJSON>;
  coverUri?: string;
  deletedProfiles: {[key:string]:IProfileJSON};
  family_id: string;
  invitations: Array<IInvitationJSON>;
  isFirstFamily?: string;
  medias?: Array<IMediaJSON>;
  members: Array<IExtendedFamilyMemberJSON>;
  metaId?: string;
  name: string;
  pictureDefault?: string;
  pictureUri?: string;
  state?: AccountStateBeanJSON;
  wallCounter?: string;
};

export class IExtendedFamily extends ServerBeanPrototype {
  coverDefault?: boolean;
  coverMedias?: Array<IMedia>;
  coverUri?: string;
  deletedProfiles!: Map<number, IProfile>;
  family_id!: number;
  invitations!: Array<IInvitation>;
  isFirstFamily?: boolean;
  medias?: Array<IMedia>;
  members!: Array<IExtendedFamilyMember>;
  metaId?: string;
  name!: string;
  pictureDefault?: boolean;
  pictureUri?: string;
  state?: AccountStateBean;
  wallCounter?: number;

  constructor(json: IExtendedFamilyJSON) {
    super(json);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverUri = decodeString(json.coverUri);
    this.deletedProfiles = decodeMap(decodeNumber,decodeIProfile)(json.deletedProfiles);
    this.family_id = decodeNumber(json.family_id);
    this.invitations = decodeArray(decodeIInvitation)(json.invitations);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.members = decodeArray(decodeIExtendedFamilyMember)(json.members);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureUri = decodeString(json.pictureUri);
    this.state = decodeAccountStateBean(json.state);
    this.wallCounter = decodeNumber(json.wallCounter);
    this.onDecode(json);
  }
}

function decodeIExtendedFamily(json: IExtendedFamilyJSON | undefined): IExtendedFamily | undefined {
  return json === undefined ? undefined : new IExtendedFamily(json);
}

function encodeIExtendedFamily(obj: IExtendedFamily | null): IExtendedFamilyJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    coverDefault: encodeBoolean(obj.coverDefault),
    coverMedias: encodeArray(encodeIMedia)(obj.coverMedias),
    coverUri: encodeString(obj.coverUri),
    deletedProfiles: encodeMap(encodeNumber,encodeIProfile)(obj.deletedProfiles),
    family_id: encodeNumber(obj.family_id),
    invitations: encodeArray(encodeIInvitation)(obj.invitations),
    isFirstFamily: encodeBoolean(obj.isFirstFamily),
    members: encodeArray(encodeIExtendedFamilyMember)(obj.members),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    pictureUri: encodeString(obj.pictureUri),
    state: encodeAccountStateBean(obj.state),
    wallCounter: encodeNumber(obj.wallCounter)
  } as IExtendedFamilyJSON);
}

type IExtendedFamilyMemberJSON = {
  account?: IAccountJSON;
  accountId?: string;
  addresses?: Array<IAddressJSON>;
  birthDate?: string;
  birthDateNoYear?: string;
  color?: string;
  creationDate?: string;
  customRole?: string;
  deleted: string;
  devices?: Array<IDeviceJSON>;
  fWPremiumMemberSubscriber?: string;
  familyId: string;
  firstName?: string;
  gender?: GenderEnum;
  identifiers: Array<IAccountIdentifierJSON>;
  isAccountDeleted?: string;
  isFirstFamily?: string;
  isloggedaccount: string;
  joinDate?: string;
  lastLoginDate?: string;
  lastName?: string;
  locale?: string;
  location?: ILocationJSON;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  name: string;
  panicButtonActivated?: string;
  pictureDefault?: string;
  profileFamilyId?: string;
  right: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;
  termsChecked: string;
  termsOrangeFamilyPlaceChecked: string;
  termsProximusFamilyChecked?: string;
  timeZone?: string;
};

export class IExtendedFamilyMember extends ServerBeanPrototype {
  account?: IAccount;
  /** the accountId of this profile
 @param accountId the accountId of this profile */
  accountId?: number;
  /** @param addresses
            addresses of the contact */
  addresses?: Array<IAddress>;
  /** birthDate of the contact (allow to handle them in events)

 @param birthDate */
  birthDate?: Date;
  /** if true, the year in the date shall be disregarded as it has been set to 1900 arbitrarily (null is false)
 @param birthDateNoYear the no year flag (null is false) */
  birthDateNoYear?: boolean;
  /** the color associated with this profile, encoded as HTML #RRGGBB (or something like that) */
  color?: string;
  creationDate?: Date;
  customRole?: string;
  /** @param deleted the deleted to set */
  deleted!: boolean;
  /** @param devices
            email and phone numbers of the contact */
  devices?: Array<IDevice>;
  /** a flag indicating whether this member has a premium (any kind of premium package such as FAMILYWALL_PREMIUM, SPRINT_FRAMILYWALL_PREMIUM, SPRINT_FRAMILYWALL_PREMIUM_PLUS or ORANGE)
 but not individual features such as QUOTA or VIDEO or GEOLOC_AUTOTRACK. This premium shall be active on the corresponding family too (some premium are only active
 to a given set of familyIds)
 @param FWPremiumMemberSubscriber */
  fWPremiumMemberSubscriber?: boolean;
  familyId!: string;
  /** The first name of the person
 @param firstName
            the firstName of the contact */
  firstName?: string;
  /** gender of the contact

 @param gender */
  gender?: GenderEnum;
  identifiers!: Array<IAccountIdentifier>;
  /** true if this account has been deleted (or removed from the family) and the presented profile is actually a ghost profile. A ghost profile is read-only
 This is "encodable and isNullable" because it shall be null when a profile is updated.
 @param bool */
  isAccountDeleted?: boolean;
  isFirstFamily?: boolean;
  isloggedaccount!: boolean;
  joinDate?: Date;
  lastLoginDate?: Date;
  /** @param name
            the lastName */
  lastName?: string;
  /** the locale of the account
 @param locale */
  locale?: string;
  location?: ILocation;
  medias?: Array<IMedia>;
  /** metaid but not encodable, so not IHasMetaId
 @param id */
  metaId?: string;
  /** the name of the account
 @param name the name to set */
  name!: string;
  /** a flag indicating whether this member is in panic !
 @param panicButtonActivated */
  panicButtonActivated?: boolean;
  /** true if the profile picture is a default picture */
  pictureDefault?: boolean;
  profileFamilyId?: number;
  right!: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;
  termsChecked!: boolean;
  termsOrangeFamilyPlaceChecked!: boolean;
  /** warning: may be null for old db row, therefore test carefully
 @param termsProximusFamilyChecked */
  termsProximusFamilyChecked?: boolean;
  /** timezone of the account
 @param timeZone */
  timeZone?: string;

  constructor(json: IExtendedFamilyMemberJSON) {
    super(json);
    this.account = decodeIAccount(json.account);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = decodeString(json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.customRole = decodeString(json.customRole);
    this.deleted = decodeboolean(json.deleted);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.fWPremiumMemberSubscriber = decodeBoolean(json.fWPremiumMemberSubscriber);
    this.familyId = decodeMetaId(json.familyId);
    this.firstName = decodeString(json.firstName);
    this.gender = decodeEnum(json.gender);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.isloggedaccount = decodeBoolean(json.isloggedaccount);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.lastName = decodeString(json.lastName);
    this.locale = decodeString(json.locale);
    this.location = decodeILocation(json.location);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.panicButtonActivated = decodeBoolean(json.panicButtonActivated);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.onDecode(json);
  }
}

function decodeIExtendedFamilyMember(json: IExtendedFamilyMemberJSON | undefined): IExtendedFamilyMember | undefined {
  return json === undefined ? undefined : new IExtendedFamilyMember(json);
}

function encodeIExtendedFamilyMember(obj: IExtendedFamilyMember | null): IExtendedFamilyMemberJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    account: encodeIAccount(obj.account),
    accountId: encodeNumber(obj.accountId),
    addresses: encodeArray(encodeIAddress)(obj.addresses),
    birthDate: encodeDate(obj.birthDate),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    color: encodeString(obj.color),
    creationDate: encodeDate(obj.creationDate),
    customRole: encodeString(obj.customRole),
    deleted: encodeboolean(obj.deleted),
    devices: encodeArray(encodeIDevice)(obj.devices),
    fWPremiumMemberSubscriber: encodeBoolean(obj.fWPremiumMemberSubscriber),
    familyId: encodeMetaId(obj.familyId),
    firstName: encodeString(obj.firstName),
    gender: encodeEnum(obj.gender),
    identifiers: encodeArray(encodeIAccountIdentifier)(obj.identifiers),
    isAccountDeleted: encodeBoolean(obj.isAccountDeleted),
    isFirstFamily: encodeBoolean(obj.isFirstFamily),
    isloggedaccount: encodeBoolean(obj.isloggedaccount),
    joinDate: encodeDate(obj.joinDate),
    lastLoginDate: encodeDate(obj.lastLoginDate),
    lastName: encodeString(obj.lastName),
    locale: encodeString(obj.locale),
    location: encodeILocation(obj.location),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    panicButtonActivated: encodeBoolean(obj.panicButtonActivated),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    profileFamilyId: encodeNumber(obj.profileFamilyId),
    right: encodeEnum(obj.right),
    role: encodeEnum(obj.role),
    termsChecked: encodeboolean(obj.termsChecked),
    termsOrangeFamilyPlaceChecked: encodeboolean(obj.termsOrangeFamilyPlaceChecked),
    termsProximusFamilyChecked: encodeBoolean(obj.termsProximusFamilyChecked),
    timeZone: encodeTimeZone(obj.timeZone)
  } as IExtendedFamilyMemberJSON);
}

type IFamilyJSON = {
  coverDefault?: string;
  coverMedias?: Array<IMediaJSON>;
  coverUri?: string;
  family_id: string;
  medias?: Array<IMediaJSON>;
  members: Array<IFamilyMemberJSON>;
  metaId?: string;
  name: string;
  pictureDefault?: string;
  pictureUri?: string;
};

export class IFamily extends ServerBeanPrototype {
  coverDefault?: boolean;
  coverMedias?: Array<IMedia>;
  coverUri?: string;
  family_id!: number;
  medias?: Array<IMedia>;
  members!: Array<IFamilyMember>;
  metaId?: string;
  /** Name of the family, user-defined
 @param name name */
  name!: string;
  pictureDefault?: boolean;
  pictureUri?: string;

  constructor(json: IFamilyJSON) {
    super(json);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverUri = decodeString(json.coverUri);
    this.family_id = decodeNumber(json.family_id);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.members = decodeArray(decodeIFamilyMember)(json.members);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureUri = decodeString(json.pictureUri);
    this.onDecode(json);
  }
}

function decodeIFamily(json: IFamilyJSON | undefined): IFamily | undefined {
  return json === undefined ? undefined : new IFamily(json);
}

function encodeIFamily(obj: IFamily | null): IFamilyJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    coverDefault: encodeBoolean(obj.coverDefault),
    coverMedias: encodeArray(encodeIMedia)(obj.coverMedias),
    coverUri: encodeString(obj.coverUri),
    family_id: encodeNumber(obj.family_id),
    members: encodeArray(encodeIFamilyMember)(obj.members),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    pictureUri: encodeString(obj.pictureUri)
  } as IFamilyJSON);
}

type IFamilyMemberJSON = {
  account: IAccountJSON;
  customRole?: string;
  familyId: string;
  isFirstFamily?: string;
  joinDate?: string;
  lastLoginDate?: string;
  metaId?: string;
  right: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;
};

export class IFamilyMember extends ServerBeanPrototype {
  account!: IAccount;
  customRole?: string;
  familyId!: string;
  isFirstFamily?: boolean;
  joinDate?: Date;
  lastLoginDate?: Date;
  metaId?: string;
  right!: FamilyAdminRightEnum;
  role?: FamilyRoleTypeEnum;

  constructor(json: IFamilyMemberJSON) {
    super(json);
    this.account = decodeIAccount(json.account);
    this.customRole = decodeString(json.customRole);
    this.familyId = decodeMetaId(json.familyId);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.metaId = decodeMetaId(json.metaId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.onDecode(json);
  }
}

function decodeIFamilyMember(json: IFamilyMemberJSON | undefined): IFamilyMember | undefined {
  return json === undefined ? undefined : new IFamilyMember(json);
}

function encodeIFamilyMember(obj: IFamilyMember | null): IFamilyMemberJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    account: encodeIAccount(obj.account),
    customRole: encodeString(obj.customRole),
    familyId: encodeMetaId(obj.familyId),
    isFirstFamily: encodeBoolean(obj.isFirstFamily),
    joinDate: encodeDate(obj.joinDate),
    lastLoginDate: encodeDate(obj.lastLoginDate),
    metaId: encodeMetaId(obj.metaId),
    right: encodeEnum(obj.right),
    role: encodeEnum(obj.role)
  } as IFamilyMemberJSON);
}

type IFilerInputBeanJSON = {
  color?: string;
  metaId?: string;
  name?: string;
  parentFolderId?: string;
};

export class IFilerInputBean extends ServerBeanPrototype {
  /** the color of the folder, as #rrggbb format
 @param color color as #rrggbb format */
  color?: string;
  /** id of the file to update, or null if it is a creation
 @param metaId media id */
  metaId?: string;
  /** the name of the folder
 @param name folder name */
  name?: string;
  /** If this element is stored inside a folder, this is the id of this folder.<br>
 This may be null, in case the element is a "floating" element, such as the root folder or a media in the wall but not stored in a folder
 @param folderId the folder meta id or null */
  parentFolderId?: string;

  constructor(json: IFilerInputBeanJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.parentFolderId = decodeMetaId(json.parentFolderId);
    this.onDecode(json);
  }
}

function decodeIFilerInputBean(json: IFilerInputBeanJSON | undefined): IFilerInputBean | undefined {
  return json === undefined ? undefined : new IFilerInputBean(json);
}

function encodeIFilerInputBean(obj: IFilerInputBean | null): IFilerInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    parentFolderId: encodeMetaId(obj.parentFolderId)
  } as IFilerInputBeanJSON);
}

type IHasMetaIdJSON = {
  metaId?: string;
};

export class IHasMetaId extends ServerBeanPrototype {
  metaId?: string;

  constructor(json: IHasMetaIdJSON) {
    super(json);
    this.metaId = decodeMetaId(json.metaId);
    this.onDecode(json);
  }
}

function decodeIHasMetaId(json: IHasMetaIdJSON | undefined): IHasMetaId | undefined {
  return json === undefined ? undefined : new IHasMetaId(json);
}

function encodeIHasMetaId(obj: IHasMetaId | null): IHasMetaIdJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    metaId: encodeMetaId(obj.metaId)
  } as IHasMetaIdJSON);
}

type IIMMessageJSON = {
  creationDate: string;
  externalId?: string;
  fromId: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  text: string;
  threadId: string;
  type: IMMessageTypeEnum;
};

export class IIMMessage extends ServerBeanPrototype {
  creationDate!: Date;
  externalId?: string;
  fromId!: number;
  medias?: Array<IMedia>;
  metaId?: string;
  text!: string;
  threadId!: string;
  type!: IMMessageTypeEnum;

  constructor(json: IIMMessageJSON) {
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.externalId = decodeString(json.externalId);
    this.fromId = decodeNumber(json.fromId);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.text = decodeString(json.text);
    this.threadId = decodeMetaId(json.threadId);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeIIMMessage(json: IIMMessageJSON | undefined): IIMMessage | undefined {
  return json === undefined ? undefined : new IIMMessage(json);
}

function encodeIIMMessage(obj: IIMMessage | null): IIMMessageJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    creationDate: encodeDate(obj.creationDate),
    externalId: encodeString(obj.externalId),
    fromId: encodeNumber(obj.fromId),
    metaId: encodeMetaId(obj.metaId),
    text: encodeString(obj.text),
    threadId: encodeMetaId(obj.threadId),
    type: encodeEnum(obj.type)
  } as IIMMessageJSON);
}

type IIMParticipantJSON = {
  accountFirstname: string;
  accountId: string;
  accountMedias?: Array<IMediaJSON>;
  accountPictureDefault?: string;
  color?: string;
  isInFamily: string;
  isLogguedAccount?: string;
  lastReadMessageDate?: string;
  lastReceivedMessageDate?: string;
  lastSentMessageDate?: string;
  participantStatus: ParticipantStatusEnum;
};

export class IIMParticipant extends ServerBeanPrototype {
  /** The firstname of the account corresponding to this participant, from the his profile of the most matching family 
 @param accountFirstname the accountFirstname to set */
  accountFirstname!: string;
  /** account id of the participant */
  accountId!: number;
  /** The media list of the account corresponding to this participant (ie icon, avatar, etc), from the his profile of the most matching family
 @param accountMedias the accountMedias to set */
  accountMedias?: Array<IMedia>;
  /** true if the profile picture is a default picture */
  accountPictureDefault?: boolean;
  /** the color associated with this profile, encoded as HTML #RRGGBB (or something like that)
 @param color */
  color?: string;
  /** true if the account is in your current family, can be used to assert security, read-only, or viewable policies, to be defined...
 @param isInFamily */
  isInFamily!: boolean;
  /** true if it is loggued account, if not it might be null or false
 @return */
  isLogguedAccount?: boolean;
  /** date of the last read message, used to compute "read by..."
 @param lastReadMessageDate */
  lastReadMessageDate?: Date;
  /** date of the last received message, used to compute "received by..."
 @param lastReceivedMessageDate */
  lastReceivedMessageDate?: Date;
  /** date of the last message sent by this participant
 @param lastSentMessageDate */
  lastSentMessageDate?: Date;
  /** status (type) of the participant
 @param status */
  participantStatus!: ParticipantStatusEnum;

  constructor(json: IIMParticipantJSON) {
    super(json);
    this.accountFirstname = decodeString(json.accountFirstname);
    this.accountId = decodeNumber(json.accountId);
    this.accountMedias = decodeArray(decodeIMedia)(json.accountMedias);
    this.accountPictureDefault = decodeBoolean(json.accountPictureDefault);
    this.color = decodeString(json.color);
    this.isInFamily = decodeboolean(json.isInFamily);
    this.isLogguedAccount = decodeBoolean(json.isLogguedAccount);
    this.lastReadMessageDate = decodeDate(json.lastReadMessageDate);
    this.lastReceivedMessageDate = decodeDate(json.lastReceivedMessageDate);
    this.lastSentMessageDate = decodeDate(json.lastSentMessageDate);
    this.participantStatus = decodeEnum(json.participantStatus);
    this.onDecode(json);
  }
}

function decodeIIMParticipant(json: IIMParticipantJSON | undefined): IIMParticipant | undefined {
  return json === undefined ? undefined : new IIMParticipant(json);
}

function encodeIIMParticipant(obj: IIMParticipant | null): IIMParticipantJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountFirstname: encodeString(obj.accountFirstname),
    accountId: encodeNumber(obj.accountId),
    accountMedias: encodeArray(encodeIMedia)(obj.accountMedias),
    accountPictureDefault: encodeBoolean(obj.accountPictureDefault),
    color: encodeString(obj.color),
    isInFamily: encodeboolean(obj.isInFamily),
    isLogguedAccount: encodeBoolean(obj.isLogguedAccount),
    lastReadMessageDate: encodeDate(obj.lastReadMessageDate),
    lastReceivedMessageDate: encodeDate(obj.lastReceivedMessageDate),
    lastSentMessageDate: encodeDate(obj.lastSentMessageDate),
    participantStatus: encodeEnum(obj.participantStatus)
  } as IIMParticipantJSON);
}

type IIMThreadJSON = {
  isMultiFamily: string;
  messageCount: string;
  messageListModifDate: string;
  metaId?: string;
  participants: Array<IIMParticipantJSON>;
  sortingDate: string;
  unreadCount: string;
};

export class IIMThread extends ServerBeanPrototype {
  isMultiFamily!: boolean;
  /** Number of message in the thread (for current user)
 @return */
  messageCount!: number;
  messageListModifDate!: Date;
  metaId?: string;
  participants!: Array<IIMParticipant>;
  sortingDate!: Date;
  /** The number of unread messages already processed by the server (for the current user)
 @param unreadCount */
  unreadCount!: number;

  constructor(json: IIMThreadJSON) {
    super(json);
    this.isMultiFamily = decodeboolean(json.isMultiFamily);
    this.messageCount = decodenumber(json.messageCount);
    this.messageListModifDate = decodeDate(json.messageListModifDate);
    this.metaId = decodeMetaId(json.metaId);
    this.participants = decodeArray(decodeIIMParticipant)(json.participants);
    this.sortingDate = decodeDate(json.sortingDate);
    this.unreadCount = decodenumber(json.unreadCount);
    this.onDecode(json);
  }
}

function decodeIIMThread(json: IIMThreadJSON | undefined): IIMThread | undefined {
  return json === undefined ? undefined : new IIMThread(json);
}

function encodeIIMThread(obj: IIMThread | null): IIMThreadJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    isMultiFamily: encodeboolean(obj.isMultiFamily),
    messageCount: encodenumber(obj.messageCount),
    messageListModifDate: encodeDate(obj.messageListModifDate),
    metaId: encodeMetaId(obj.metaId),
    participants: encodeArray(encodeIIMParticipant)(obj.participants),
    sortingDate: encodeDate(obj.sortingDate),
    unreadCount: encodenumber(obj.unreadCount)
  } as IIMThreadJSON);
}

type IInvitationJSON = {
  accountId: string;
  creationdate: string;
  customRole?: string;
  editable?: string;
  familyId: string;
  firstname?: string;
  invitationStatus: InvitationStatusEnum;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  originalSms?: string;
  ownerId: string;
  pictureDefault?: string;
  pictureURIs?: Array<string>;
  reminderSet: string;
  right: FamilyAdminRightEnum;
  role: FamilyRoleTypeEnum;
  token?: ITokenJSON;
  tokenId: string;
};

export class IInvitation extends ServerBeanPrototype {
  accountId!: number;
  creationdate!: Date;
  customRole?: string;
  editable?: boolean;
  familyId!: string;
  firstname?: string;
  invitationStatus!: InvitationStatusEnum;
  medias?: Array<IMedia>;
  metaId?: string;
  originalSms?: string;
  ownerId!: number;
  pictureDefault?: boolean;
  pictureURIs?: Array<string>;
  reminderSet!: boolean;
  right!: FamilyAdminRightEnum;
  role!: FamilyRoleTypeEnum;
  token?: IToken;
  tokenId!: number;

  constructor(json: IInvitationJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationdate = decodeDate(json.creationdate);
    this.customRole = decodeString(json.customRole);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.firstname = decodeString(json.firstname);
    this.invitationStatus = decodeEnum(json.invitationStatus);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.originalSms = decodeString(json.originalSms);
    this.ownerId = decodeNumber(json.ownerId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureURIs = decodeArray(decodeString)(json.pictureURIs);
    this.reminderSet = decodeboolean(json.reminderSet);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.token = decodeIToken(json.token);
    this.tokenId = decodeNumber(json.tokenId);
    this.onDecode(json);
  }
}

function decodeIInvitation(json: IInvitationJSON | undefined): IInvitation | undefined {
  return json === undefined ? undefined : new IInvitation(json);
}

function encodeIInvitation(obj: IInvitation | null): IInvitationJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationdate: encodeDate(obj.creationdate),
    customRole: encodeString(obj.customRole),
    editable: encodeBoolean(obj.editable),
    familyId: encodeMetaId(obj.familyId),
    firstname: encodeString(obj.firstname),
    invitationStatus: encodeEnum(obj.invitationStatus),
    metaId: encodeMetaId(obj.metaId),
    originalSms: encodeString(obj.originalSms),
    ownerId: encodeNumber(obj.ownerId),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    pictureURIs: encodeArray(encodeString)(obj.pictureURIs),
    reminderSet: encodeboolean(obj.reminderSet),
    right: encodeEnum(obj.right),
    role: encodeEnum(obj.role),
    token: encodeIToken(obj.token),
    tokenId: encodeNumber(obj.tokenId)
  } as IInvitationJSON);
}

type ILocationJSON = {
  accountId: string;
  address?: GeocodedAddressJSON;
  authRequestPending: GeolocSharingEnum;
  authorized: GeolocSharingEnum;
  authorizedEndDate?: string;
  deviceFlag?: LocationDeviceFlagsJSON;
  familyId: string;
  geolocSharing?: GeolocSharingEnum;
  geolocSharingEndDate?: string;
  lastLocationDeviceId?: string;
  lastPositionUpdateDate?: string;
  lastRefreshRequestSentDate?: string;
  locationState?: LocationStateEnum;
  mapURI?: string;
  modifDate: string;
  moveType: LocationMoveTypeEnum;
  placeId?: string;
  wallMessage?: IWallMessageJSON;
  wallMessageId?: string;
};

export class ILocation extends ServerBeanPrototype {
  accountId!: number;
  address?: GeocodedAddress;
  authRequestPending!: GeolocSharingEnum;
  authorized!: GeolocSharingEnum;
  authorizedEndDate?: Date;
  deviceFlag?: LocationDeviceFlags;
  familyId!: string;
  geolocSharing?: GeolocSharingEnum;
  geolocSharingEndDate?: Date;
  lastLocationDeviceId?: string;
  lastPositionUpdateDate?: Date;
  lastRefreshRequestSentDate?: Date;
  locationState?: LocationStateEnum;
  mapURI?: string;
  modifDate!: Date;
  moveType!: LocationMoveTypeEnum;
  placeId?: string;
  wallMessage?: IWallMessage;
  wallMessageId?: string;

  constructor(json: ILocationJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.authRequestPending = decodeEnum(json.authRequestPending);
    this.authorized = decodeEnum(json.authorized);
    this.authorizedEndDate = decodeDate(json.authorizedEndDate);
    this.deviceFlag = decodeLocationDeviceFlags(json.deviceFlag);
    this.familyId = decodeMetaId(json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.geolocSharingEndDate = decodeDate(json.geolocSharingEndDate);
    this.lastLocationDeviceId = decodeString(json.lastLocationDeviceId);
    this.lastPositionUpdateDate = decodeDate(json.lastPositionUpdateDate);
    this.lastRefreshRequestSentDate = decodeDate(json.lastRefreshRequestSentDate);
    this.locationState = decodeEnum(json.locationState);
    this.mapURI = decodeString(json.mapURI);
    this.modifDate = decodeDate(json.modifDate);
    this.moveType = decodeEnum(json.moveType);
    this.placeId = decodeMetaId(json.placeId);
    this.wallMessage = decodeIWallMessage(json.wallMessage);
    this.wallMessageId = decodeMetaId(json.wallMessageId);
    this.onDecode(json);
  }
}

function decodeILocation(json: ILocationJSON | undefined): ILocation | undefined {
  return json === undefined ? undefined : new ILocation(json);
}

function encodeILocation(obj: ILocation | null): ILocationJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    address: encodeGeocodedAddress(obj.address),
    authRequestPending: encodeEnum(obj.authRequestPending),
    authorized: encodeEnum(obj.authorized),
    authorizedEndDate: encodeDate(obj.authorizedEndDate),
    deviceFlag: encodeLocationDeviceFlags(obj.deviceFlag),
    familyId: encodeMetaId(obj.familyId),
    geolocSharing: encodeEnum(obj.geolocSharing),
    geolocSharingEndDate: encodeDate(obj.geolocSharingEndDate),
    lastLocationDeviceId: encodeString(obj.lastLocationDeviceId),
    lastPositionUpdateDate: encodeDate(obj.lastPositionUpdateDate),
    lastRefreshRequestSentDate: encodeDate(obj.lastRefreshRequestSentDate),
    locationState: encodeEnum(obj.locationState),
    mapURI: encodeString(obj.mapURI),
    modifDate: encodeDate(obj.modifDate),
    moveType: encodeEnum(obj.moveType),
    placeId: encodeMetaId(obj.placeId),
    wallMessage: encodeIWallMessage(obj.wallMessage),
    wallMessageId: encodeMetaId(obj.wallMessageId)
  } as ILocationJSON);
}

type IMediaJSON = {
  accountId?: string;
  bestMoment: string;
  color?: string;
  creationDate?: string;
  datasize?: string;
  durationMs?: string;
  familyId?: string;
  filerModifDate?: string;
  mediaId?: string;
  mediaPreviewStatus?: MediaPreviewStatusEnum;
  metaId?: string;
  mimeType?: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  name?: string;
  parentFolderId?: string;
  pictureUrl: string;
  pointedBy?: string;
  pointedByWhat?: MetaIdTypeEnum;
  readystate?: MediaContentState;
  resolutionX?: string;
  resolutionY?: string;
  rights: FizRightBeanJSON;
};

export class IMedia extends ServerBeanPrototype {
  accountId?: number;
  bestMoment!: boolean;
  color?: string;
  creationDate?: Date;
  datasize?: number;
  durationMs?: number;
  familyId?: string;
  filerModifDate?: Date;
  mediaId?: string;
  mediaPreviewStatus?: MediaPreviewStatusEnum;
  metaId?: string;
  mimeType?: string;
  moodMap?: Map<number, Array<MoodEnum>>;
  name?: string;
  parentFolderId?: string;
  pictureUrl!: string;
  pointedBy?: string;
  pointedByWhat?: MetaIdTypeEnum;
  readystate?: MediaContentState;
  resolutionX?: number;
  resolutionY?: number;
  rights!: FizRightBean;

  constructor(json: IMediaJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeboolean(json.bestMoment);
    this.color = decodeString(json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.datasize = decodeNumber(json.datasize);
    this.durationMs = decodeNumber(json.durationMs);
    this.familyId = decodeMetaId(json.familyId);
    this.filerModifDate = decodeDate(json.filerModifDate);
    this.mediaId = decodeMetaId(json.mediaId);
    this.mediaPreviewStatus = decodeEnum(json.mediaPreviewStatus);
    this.metaId = decodeMetaId(json.metaId);
    this.mimeType = decodeString(json.mimeType);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.name = decodeString(json.name);
    this.parentFolderId = decodeMetaId(json.parentFolderId);
    this.pictureUrl = decodeString(json.pictureUrl);
    this.pointedBy = decodeMetaId(json.pointedBy);
    this.pointedByWhat = decodeEnum(json.pointedByWhat);
    this.readystate = decodeEnum(json.readystate);
    this.resolutionX = decodeNumber(json.resolutionX);
    this.resolutionY = decodeNumber(json.resolutionY);
    this.rights = decodeFizRightBean(json.rights);
    this.onDecode(json);
  }
}

function decodeIMedia(json: IMediaJSON | undefined): IMedia | undefined {
  return json === undefined ? undefined : new IMedia(json);
}

function encodeIMedia(obj: IMedia | null): IMediaJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    bestMoment: encodeboolean(obj.bestMoment),
    color: encodeString(obj.color),
    creationDate: encodeDate(obj.creationDate),
    datasize: encodeNumber(obj.datasize),
    durationMs: encodeNumber(obj.durationMs),
    familyId: encodeMetaId(obj.familyId),
    mediaId: encodeMetaId(obj.mediaId),
    metaId: encodeMetaId(obj.metaId),
    mimeType: encodeString(obj.mimeType),
    moodMap: encodeMap(encodeNumber,encodeArray(encodeEnum))(obj.moodMap),
    name: encodeString(obj.name),
    parentFolderId: encodeMetaId(obj.parentFolderId),
    pictureUrl: encodeString(obj.pictureUrl),
    pointedBy: encodeMetaId(obj.pointedBy),
    pointedByWhat: encodeEnum(obj.pointedByWhat),
    readystate: encodeEnum(obj.readystate),
    resolutionX: encodeNumber(obj.resolutionX),
    resolutionY: encodeNumber(obj.resolutionY)
  } as IMediaJSON);
}

type IPlaceJSON = {
  accountId: string;
  address?: GeocodedAddressJSON;
  contactId?: string;
  editable?: string;
  fWGeofencingIn?: string;
  fWGeofencingOut?: string;
  familyId: string;
  geofencingActive?: string;
  isTemporary: string;
  mapURI?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  name: string;
  placeId: string;
  placeType?: PlaceTypeEnum;
  text?: string;
  wifiMAC?: string;
  wifiSSID?: string;
};

export class IPlace extends ServerBeanPrototype {
  accountId!: number;
  address?: GeocodedAddress;
  contactId?: string;
  editable?: boolean;
  fWGeofencingIn?: boolean;
  fWGeofencingOut?: boolean;
  familyId!: string;
  geofencingActive?: boolean;
  isTemporary!: boolean;
  mapURI?: string;
  medias?: Array<IMedia>;
  metaId?: string;
  name!: string;
  placeId!: string;
  placeType?: PlaceTypeEnum;
  text?: string;
  wifiMAC?: string;
  wifiSSID?: string;

  constructor(json: IPlaceJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.contactId = decodeMetaId(json.contactId);
    this.editable = decodeBoolean(json.editable);
    this.fWGeofencingIn = decodeBoolean(json.fWGeofencingIn);
    this.fWGeofencingOut = decodeBoolean(json.fWGeofencingOut);
    this.familyId = decodeMetaId(json.familyId);
    this.geofencingActive = decodeBoolean(json.geofencingActive);
    this.isTemporary = decodeboolean(json.isTemporary);
    this.mapURI = decodeString(json.mapURI);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.placeId = decodeMetaId(json.placeId);
    this.placeType = decodeEnum(json.placeType);
    this.text = decodeString(json.text);
    this.wifiMAC = decodeString(json.wifiMAC);
    this.wifiSSID = decodeString(json.wifiSSID);
    this.onDecode(json);
  }
}

function decodeIPlace(json: IPlaceJSON | undefined): IPlace | undefined {
  return json === undefined ? undefined : new IPlace(json);
}

function encodeIPlace(obj: IPlace | null): IPlaceJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    address: encodeGeocodedAddress(obj.address),
    contactId: encodeMetaId(obj.contactId),
    editable: encodeBoolean(obj.editable),
    fWGeofencingIn: encodeBoolean(obj.fWGeofencingIn),
    fWGeofencingOut: encodeBoolean(obj.fWGeofencingOut),
    familyId: encodeMetaId(obj.familyId),
    geofencingActive: encodeBoolean(obj.geofencingActive),
    isTemporary: encodeboolean(obj.isTemporary),
    mapURI: encodeString(obj.mapURI),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    placeId: encodeMetaId(obj.placeId),
    placeType: encodeEnum(obj.placeType),
    text: encodeString(obj.text),
    wifiMAC: encodeString(obj.wifiMAC),
    wifiSSID: encodeString(obj.wifiSSID)
  } as IPlaceJSON);
}

type IPlaceGeofencingJSON = {
  familyId: string;
  geolocSharing?: GeolocSharingEnum;
  in: string;
  metaId?: string;
  out: string;
  place?: IPlaceJSON;
  placeId: string;
  publisherId: string;
  rightFlag: PremiumRightFlagEnum;
  subscriberId: string;
};

export class IPlaceGeofencing extends ServerBeanPrototype {
  familyId!: string;
  geolocSharing?: GeolocSharingEnum;
  in!: boolean;
  metaId?: string;
  out!: boolean;
  place?: IPlace;
  placeId!: string;
  publisherId!: number;
  rightFlag!: PremiumRightFlagEnum;
  subscriberId!: number;

  constructor(json: IPlaceGeofencingJSON) {
    super(json);
    this.familyId = decodeMetaId(json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.in = decodeboolean(json.in);
    this.metaId = decodeMetaId(json.metaId);
    this.out = decodeboolean(json.out);
    this.place = decodeIPlace(json.place);
    this.placeId = decodeMetaId(json.placeId);
    this.publisherId = decodeNumber(json.publisherId);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.subscriberId = decodeNumber(json.subscriberId);
    this.onDecode(json);
  }
}

function decodeIPlaceGeofencing(json: IPlaceGeofencingJSON | undefined): IPlaceGeofencing | undefined {
  return json === undefined ? undefined : new IPlaceGeofencing(json);
}

function encodeIPlaceGeofencing(obj: IPlaceGeofencing | null): IPlaceGeofencingJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    familyId: encodeMetaId(obj.familyId),
    geolocSharing: encodeEnum(obj.geolocSharing),
    in: encodeboolean(obj.in),
    metaId: encodeMetaId(obj.metaId),
    out: encodeboolean(obj.out),
    place: encodeIPlace(obj.place),
    placeId: encodeMetaId(obj.placeId),
    publisherId: encodeNumber(obj.publisherId),
    rightFlag: encodeEnum(obj.rightFlag),
    subscriberId: encodeNumber(obj.subscriberId)
  } as IPlaceGeofencingJSON);
}

type IProfileJSON = {
  accountId?: string;
  addresses?: Array<IAddressJSON>;
  birthDate?: string;
  birthDateNoYear?: string;
  color?: string;
  devices?: Array<IDeviceJSON>;
  firstName?: string;
  gender?: GenderEnum;
  isAccountDeleted?: string;
  lastName?: string;
  locale?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  pictureDefault?: string;
  profileFamilyId?: string;
  timeZone?: string;
};

export class IProfile extends ServerBeanPrototype {
  /** the accountId of this profile
 @param accountId the accountId of this profile */
  accountId?: number;
  /** @param addresses
            addresses of the contact */
  addresses?: Array<IAddress>;
  /** birthDate of the contact (allow to handle them in events)

 @param birthDate */
  birthDate?: Date;
  /** if true, the year in the date shall be disregarded as it has been set to 1900 arbitrarily (null is false)
 @param birthDateNoYear the no year flag (null is false) */
  birthDateNoYear?: boolean;
  /** the color associated with this profile, encoded as HTML #RRGGBB (or something like that) */
  color?: string;
  /** @param devices
            email and phone numbers of the contact */
  devices?: Array<IDevice>;
  /** The first name of the person
 @param firstName
            the firstName of the contact */
  firstName?: string;
  /** gender of the contact

 @param gender */
  gender?: GenderEnum;
  /** true if this account has been deleted (or removed from the family) and the presented profile is actually a ghost profile. A ghost profile is read-only
 This is "encodable and isNullable" because it shall be null when a profile is updated.
 @param bool */
  isAccountDeleted?: boolean;
  /** @param name
            the lastName */
  lastName?: string;
  /** the locale of the account
 @param locale */
  locale?: string;
  medias?: Array<IMedia>;
  metaId?: string;
  /** true if the profile picture is a default picture */
  pictureDefault?: boolean;
  profileFamilyId?: number;
  /** timezone of the account
 @param timeZone */
  timeZone?: string;

  constructor(json: IProfileJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = decodeString(json.color);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.firstName = decodeString(json.firstName);
    this.gender = decodeEnum(json.gender);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.lastName = decodeString(json.lastName);
    this.locale = decodeString(json.locale);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.onDecode(json);
  }
}

function decodeIProfile(json: IProfileJSON | undefined): IProfile | undefined {
  return json === undefined ? undefined : new IProfile(json);
}

function encodeIProfile(obj: IProfile | null): IProfileJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    addresses: encodeArray(encodeIAddress)(obj.addresses),
    birthDate: encodeDate(obj.birthDate),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    color: encodeString(obj.color),
    devices: encodeArray(encodeIDevice)(obj.devices),
    firstName: encodeString(obj.firstName),
    gender: encodeEnum(obj.gender),
    isAccountDeleted: encodeBoolean(obj.isAccountDeleted),
    lastName: encodeString(obj.lastName),
    locale: encodeString(obj.locale),
    metaId: encodeMetaId(obj.metaId),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    profileFamilyId: encodeNumber(obj.profileFamilyId),
    timeZone: encodeTimeZone(obj.timeZone)
  } as IProfileJSON);
}

type IPromoCodeJSON = {
  creationDate: string;
  expirationDate: string;
  lastUsageDate?: string;
  maxUsageNumber: string;
  promoCodeCampaign: IPromoCodeCampaignJSON;
  usageNumber: string;
  value: string;
};

export class IPromoCode extends ServerBeanPrototype {
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** The date when this code expires. Cannot be null (safety!)
 @param expirationDate the expirationDate to set */
  expirationDate!: Date;
  /** Date when the code has been lastly used, may be null if not yet used.
 @param lastUsageDate the lastUsageDate to set */
  lastUsageDate?: Date;
  /** Max number of time this code can be used. If -1 this is infinite, if zero this is desactivated.
 @param maxUsageNumber the maxUsageNumber to set */
  maxUsageNumber!: number;
  /** the campaign associated to this promo code
 @param promoCodeCampaign */
  promoCodeCampaign!: IPromoCodeCampaign;
  /** The number of time this code already has been used. Initialized to zero.
 @param usageNumber the usageNumber to set */
  usageNumber!: number;
  /** the actual code, ie the secret string to use to action this code. unique and indexed.
 @param value the value to set */
  value!: string;

  constructor(json: IPromoCodeJSON) {
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.expirationDate = decodeDate(json.expirationDate);
    this.lastUsageDate = decodeDate(json.lastUsageDate);
    this.maxUsageNumber = decodenumber(json.maxUsageNumber);
    this.promoCodeCampaign = decodeIPromoCodeCampaign(json.promoCodeCampaign);
    this.usageNumber = decodenumber(json.usageNumber);
    this.value = decodeString(json.value);
    this.onDecode(json);
  }
}

function decodeIPromoCode(json: IPromoCodeJSON | undefined): IPromoCode | undefined {
  return json === undefined ? undefined : new IPromoCode(json);
}

function encodeIPromoCode(obj: IPromoCode | null): IPromoCodeJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    expirationDate: encodeDate(obj.expirationDate),
    maxUsageNumber: encodenumber(obj.maxUsageNumber),
    promoCodeCampaign: encodeIPromoCodeCampaign(obj.promoCodeCampaign),
    value: encodeString(obj.value)
  } as IPromoCodeJSON);
}

type IPromoCodeCampaignJSON = {
  creationDate: string;
  creditDurationInDays?: string;
  creditType?: CreditTypeEnum;
  name: string;
};

export class IPromoCodeCampaign extends ServerBeanPrototype {
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** If not null, the number of days the credit is rewarded (ie used to compute the endDate of the credit)
 @param creditDurationInDays the creditDurationInDays to set */
  creditDurationInDays?: number;
  /** If not null, the type of credit that this campaign rewards to the user, else the campaign by default has no reward.
 @param creditType the creditType to set */
  creditType?: CreditTypeEnum;
  /** name of the campaign
 @param name the name to set */
  name!: string;

  constructor(json: IPromoCodeCampaignJSON) {
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.creditDurationInDays = decodeNumber(json.creditDurationInDays);
    this.creditType = decodeEnum(json.creditType);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeIPromoCodeCampaign(json: IPromoCodeCampaignJSON | undefined): IPromoCodeCampaign | undefined {
  return json === undefined ? undefined : new IPromoCodeCampaign(json);
}

function encodeIPromoCodeCampaign(obj: IPromoCodeCampaign | null): IPromoCodeCampaignJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    creditDurationInDays: encodeNumber(obj.creditDurationInDays),
    creditType: encodeEnum(obj.creditType),
    name: encodeString(obj.name)
  } as IPromoCodeCampaignJSON);
}

type IPromoPushCampaignJSON = {
  active?: string;
  android?: string;
  creationDate: string;
  deeplinkClassId?: string;
  deeplinkClickMaxCount?: string;
  deeplinkPartnerType?: PartnerTypeEnum;
  deeplinkRecycle?: string;
  deeplinkValidationTimeHour?: string;
  deeplinkWebUrl?: string;
  iOS?: string;
  launchpadSection?: SectionEnum;
  name: string;
  promoPartnerType?: PartnerTypeEnum;
  pushJson?: FizJSONObject;
  pushPremiumFeatureHighlight?: string;
  pushScreenTarget?: PromoPushScreenTarget;
  trackingName?: string;
  url?: string;
};

export class IPromoPushCampaign extends ServerBeanPrototype {
  /** true if the campaign is active, ie if the engine is actively pushing those users
 @param active */
  active?: boolean;
  /** if true, will be sent to android devices
 @return */
  android?: boolean;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** Class identifier of the deeplink, may be null if no deeplink
 @param deeplinkClassId the deeplinkClassId to set */
  deeplinkClassId?: string;
  /** The number of time the deeplink will be usable. If null this means an infinite number of time.
 @param deeplinkClickMaxCount the deeplinkClickMaxCount to set */
  deeplinkClickMaxCount?: number;
  /** partner type associated with this campaign, if some partner specific code must be executed when generating the push, as a deeplink.
 default to familywall.
 @param partnerType */
  deeplinkPartnerType?: PartnerTypeEnum;
  /** flag indicating if the deeplink shall be recycled, or if a new deeplink must be generated each time
 @param deeplinkRecycle the deeplinkRecycle to set */
  deeplinkRecycle?: boolean;
  /** The number of hours the generated deeplink will be active.
 @param deeplinkValidationTimeHour the deeplinkValidationTimeHour to set */
  deeplinkValidationTimeHour?: number;
  /** @param deeplinkWebUrl for deeplink that points exclusively to the web */
  deeplinkWebUrl?: string;
  /** if true, will be sent to IOS devices
 @return */
  iOS?: boolean;
  /** The launchpad section target if the screen target is LAUNCHPAD_SECTION */
  launchpadSection?: SectionEnum;
  /** name of the campaign
 @param name the name to set */
  name!: string;
  /** Partner type associated with this campaign, to filter the push and sending of the message only to those partners.
 This filter against the DeviceConfig's partnertype to send only the push to those deviceconfig 
 @param partnerType */
  promoPartnerType?: PartnerTypeEnum;
  pushJson?: JsonFw;
  /** If the screen target is a premium screen, the feature to highlight
 @param premiumHighlight */
  pushPremiumFeatureHighlight?: string;
  /** The target of the push, when you click on the push notification.
 @param screenTarget */
  pushScreenTarget?: PromoPushScreenTarget;
  /** Name appearing in google analytics tracking events.
 If null, google analytics is disabled.
 @param trackingName */
  trackingName?: string;
  /** The url of the campaign, if pushScreenTarget = URL
 @param url */
  url?: string;

  constructor(json: IPromoPushCampaignJSON) {
    super(json);
    this.active = decodeBoolean(json.active);
    this.android = decodeBoolean(json.android);
    this.creationDate = decodeDate(json.creationDate);
    this.deeplinkClassId = decodeString(json.deeplinkClassId);
    this.deeplinkClickMaxCount = decodeNumber(json.deeplinkClickMaxCount);
    this.deeplinkPartnerType = decodeEnum(json.deeplinkPartnerType);
    this.deeplinkRecycle = decodeBoolean(json.deeplinkRecycle);
    this.deeplinkValidationTimeHour = decodeNumber(json.deeplinkValidationTimeHour);
    this.deeplinkWebUrl = decodeString(json.deeplinkWebUrl);
    this.iOS = decodeBoolean(json.iOS);
    this.launchpadSection = decodeEnum(json.launchpadSection);
    this.name = decodeString(json.name);
    this.promoPartnerType = decodeEnum(json.promoPartnerType);
    this.pushJson = decodeFizJSONObject(json.pushJson);
    this.pushPremiumFeatureHighlight = decodeString(json.pushPremiumFeatureHighlight);
    this.pushScreenTarget = decodeEnum(json.pushScreenTarget);
    this.trackingName = decodeString(json.trackingName);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodeIPromoPushCampaign(json: IPromoPushCampaignJSON | undefined): IPromoPushCampaign | undefined {
  return json === undefined ? undefined : new IPromoPushCampaign(json);
}

function encodeIPromoPushCampaign(obj: IPromoPushCampaign | null): IPromoPushCampaignJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    active: encodeBoolean(obj.active),
    android: encodeBoolean(obj.android),
    deeplinkClassId: encodeString(obj.deeplinkClassId),
    deeplinkClickMaxCount: encodeNumber(obj.deeplinkClickMaxCount),
    deeplinkPartnerType: encodeEnum(obj.deeplinkPartnerType),
    deeplinkRecycle: encodeBoolean(obj.deeplinkRecycle),
    deeplinkValidationTimeHour: encodeNumber(obj.deeplinkValidationTimeHour),
    deeplinkWebUrl: encodeString(obj.deeplinkWebUrl),
    iOS: encodeBoolean(obj.iOS),
    launchpadSection: encodeEnum(obj.launchpadSection),
    name: encodeString(obj.name),
    promoPartnerType: encodeEnum(obj.promoPartnerType),
    pushJson: encodeFizJSONObject(obj.pushJson),
    pushPremiumFeatureHighlight: encodeString(obj.pushPremiumFeatureHighlight),
    pushScreenTarget: encodeEnum(obj.pushScreenTarget),
    trackingName: encodeString(obj.trackingName),
    url: encodeString(obj.url)
  } as IPromoPushCampaignJSON);
}

type IReminderJSON = {
  localId?: string;
  reminderType?: ReminderTypeEnum;
  reminderUnit?: ReminderUnitEnum;
  reminderValue?: string;
};

export class IReminder extends ServerBeanPrototype {
  localId?: number;
  reminderType?: ReminderTypeEnum;
  reminderUnit?: ReminderUnitEnum;
  reminderValue?: number;

  constructor(json: IReminderJSON) {
    super(json);
    this.localId = decodeNumber(json.localId);
    this.reminderType = decodeEnum(json.reminderType);
    this.reminderUnit = decodeEnum(json.reminderUnit);
    this.reminderValue = decodeNumber(json.reminderValue);
    this.onDecode(json);
  }
}

function decodeIReminder(json: IReminderJSON | undefined): IReminder | undefined {
  return json === undefined ? undefined : new IReminder(json);
}

function encodeIReminder(obj: IReminder | null): IReminderJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    localId: encodeNumber(obj.localId),
    reminderType: encodeEnum(obj.reminderType),
    reminderUnit: encodeEnum(obj.reminderUnit),
    reminderValue: encodeNumber(obj.reminderValue)
  } as IReminderJSON);
}

type ISettingsPerFamilyJSON = {
  accountId?: string;
  calendarFirstDayOfWeek?: string;
  calendarWeekNb?: string;
  dailyBriefHourOfDelivery?: string;
  dailyBriefNothingPlannedActivated?: string;
  dailyBriefPushActivated?: string;
  defaultReminderType?: ReminderTypeEnum;
  defaultReminderUnit?: ReminderUnitEnum;
  defaultReminderValue?: string;
  editable?: string;
  familyId?: string;
  geolocSharing?: GeolocSharingEnum;
  mealplannerFirstDayOfWeek?: string;
  showDidYouKnow?: string;
  showDishes?: string;
  showSmartCard?: string;
  specialdaysColorAnniversary?: string;
  specialdaysColorBirthday?: string;
  specialdaysColorCelebration?: string;
  specialdaysFullname?: string;
};

export class ISettingsPerFamily extends ServerBeanPrototype {
  /** the user id of this setting
 @param accountId the value */
  accountId?: number;
  /** the nb of the first day of the week to be taken into account in the calendar display. 1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
 Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1. Default value depends on the locale of the user.
 @param calendarFirstDayOfWeek the calendarFirstDayOfWeek to set */
  calendarFirstDayOfWeek?: number;
  /** If true, week number shall be displayed in the calendar
 @param caledarWeekNb the caledarWeekNb to set */
  calendarWeekNb?: boolean;
  /** The hour of delivery of the daily brief relative to midnight for the current day. IE to send a daily brief for day X , we will send it at 9am in the morning if this equals to 9
 and it will send it at 6pm the day before if this equals to -6
 @param dailyBriefHourOfDelivery the dailyBriefHourOfDelivery to set */
  dailyBriefHourOfDelivery?: number;
  /** flag indicating, when the daily brief is activated, if we send daily brief even if the daily briefs are empty
 @param dailyBriefNothingPlannedActivated the dailyBriefNothingPlannedActivated to set */
  dailyBriefNothingPlannedActivated?: boolean;
  /** flag indicating if the daily brief is active for this account
 @param dailyBriefPushActivated the dailyBriefPushActivated to set */
  dailyBriefPushActivated?: boolean;
  /** default reminder type for events (reminders have type,unit and value), not used in UI but actually used in the event manager to initialize events
 @param defaultReminderType the value */
  defaultReminderType?: ReminderTypeEnum;
  /** default reminder unit for events (reminders have type,unit and value), not used in UI but actually used in the event manager to initialize events
 @param defaultReminderUnit the value */
  defaultReminderUnit?: ReminderUnitEnum;
  /** default reminder value for events (reminders have type,unit and value), not used in UI but actually used in the event manager to initialize events
 @param defaultReminderValue the value */
  defaultReminderValue?: number;
  /** true if the settings is yours
 @param editable the value */
  editable?: boolean;
  /** the family of this setting
 @param familyId the value */
  familyId?: string;
  /** the geolocalization sharing status. PLACE_ONLY is for compat. purposes only, NEVER mean that geoloc is disabled altogether, always means that the PLocationAuthorization contains the real authorization values.
 @param value the value */
  geolocSharing?: GeolocSharingEnum;
  /** the nb of the first day of the week to be taken into account in the meal planner display. 1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
 Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1. Default value depends on the locale of the user.
 @param mealplannerFirstDayOfWeek the mealplannerFirstDayOfWeek to set */
  mealplannerFirstDayOfWeek?: number;
  /** flag indicating, when the smartcard is displayed, if the did you know are included in the smartcard
 @param showDidYouKnow the value */
  showDidYouKnow?: boolean;
  /** If true, the dishes (ie meal recipe where isRecipe==false) are shown
 @param showDishes the showDishes to set */
  showDishes?: boolean;
  /** flag indicating if the smartcard is displayed on the dashboard for this family and this account
 @param showSmartCard the value */
  showSmartCard?: boolean;
  /** the color used for anniversaries in the special days, as a MetaId of type color
 @param value the value */
  specialdaysColorAnniversary?: string;
  /** the color used for birthdays in the special days, as a MetaId of type color
 @param value the value */
  specialdaysColorBirthday?: string;
  /** the color used for celebrations in the special days, as a MetaId of type color
 @param value the value */
  specialdaysColorCelebration?: string;
  /** flag indicating if the full name is displayed for special days
 @param value the value */
  specialdaysFullname?: boolean;

  constructor(json: ISettingsPerFamilyJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.calendarWeekNb = decodeBoolean(json.calendarWeekNb);
    this.dailyBriefHourOfDelivery = decodeNumber(json.dailyBriefHourOfDelivery);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.mealplannerFirstDayOfWeek = decodeNumber(json.mealplannerFirstDayOfWeek);
    this.showDidYouKnow = decodeBoolean(json.showDidYouKnow);
    this.showDishes = decodeBoolean(json.showDishes);
    this.showSmartCard = decodeBoolean(json.showSmartCard);
    this.specialdaysColorAnniversary = decodeMetaId(json.specialdaysColorAnniversary);
    this.specialdaysColorBirthday = decodeMetaId(json.specialdaysColorBirthday);
    this.specialdaysColorCelebration = decodeMetaId(json.specialdaysColorCelebration);
    this.specialdaysFullname = decodeBoolean(json.specialdaysFullname);
    this.onDecode(json);
  }
}

function decodeISettingsPerFamily(json: ISettingsPerFamilyJSON | undefined): ISettingsPerFamily | undefined {
  return json === undefined ? undefined : new ISettingsPerFamily(json);
}

function encodeISettingsPerFamily(obj: ISettingsPerFamily | null): ISettingsPerFamilyJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    calendarFirstDayOfWeek: encodeNumber(obj.calendarFirstDayOfWeek),
    calendarWeekNb: encodeBoolean(obj.calendarWeekNb),
    dailyBriefHourOfDelivery: encodeNumber(obj.dailyBriefHourOfDelivery),
    dailyBriefNothingPlannedActivated: encodeBoolean(obj.dailyBriefNothingPlannedActivated),
    dailyBriefPushActivated: encodeBoolean(obj.dailyBriefPushActivated),
    defaultReminderType: encodeEnum(obj.defaultReminderType),
    defaultReminderUnit: encodeEnum(obj.defaultReminderUnit),
    defaultReminderValue: encodeNumber(obj.defaultReminderValue),
    editable: encodeBoolean(obj.editable),
    familyId: encodeMetaId(obj.familyId),
    geolocSharing: encodeEnum(obj.geolocSharing),
    mealplannerFirstDayOfWeek: encodeNumber(obj.mealplannerFirstDayOfWeek),
    showDidYouKnow: encodeBoolean(obj.showDidYouKnow),
    showDishes: encodeBoolean(obj.showDishes),
    showSmartCard: encodeBoolean(obj.showSmartCard),
    specialdaysColorAnniversary: encodeMetaId(obj.specialdaysColorAnniversary),
    specialdaysColorBirthday: encodeMetaId(obj.specialdaysColorBirthday),
    specialdaysColorCelebration: encodeMetaId(obj.specialdaysColorCelebration),
    specialdaysFullname: encodeBoolean(obj.specialdaysFullname)
  } as ISettingsPerFamilyJSON);
}

type ISyncBeanJSON<IHasMetaIdJSON> = {
};

export class ISyncBean<IHasMetaId> extends ServerBeanPrototype {

  constructor(json: ISyncBeanJSON<any>, decodeIHasMetaId: objectDecoder<any, IHasMetaId>) {
    super(json);
    this.onDecode(json);
  }
}

function decodeISyncBean<IHasMetaId>(decodeIHasMetaId: objectDecoder<any, IHasMetaId>) {
  return function(json: ISyncBeanJSON<any> | undefined): ISyncBean<IHasMetaId> | undefined {
    return json === undefined ? undefined : new ISyncBean<IHasMetaId>(json, decodeIHasMetaId);
  };
}

function encodeISyncBean<IHasMetaId>(encodeIHasMetaId: objectEncoder<IHasMetaId>) {
  return function(obj: ISyncBean<IHasMetaId> | null): ISyncBeanJSON<any> | undefined {
    if (obj == null) return undefined;
  return inline({} as ISyncBeanJSON<IHasMetaIdJSON>);
  };
}

type ITaskListJSON = {
  accountId?: string;
  bestMoment?: string;
  color?: string;
  comments?: Array<ICommentJSON>;
  completedHidden?: string;
  creationDate?: string;
  description?: string;
  emoji?: string;
  familyId?: string;
  inputFile?: Array<FizFile>;
  lastAction?: UserActionEnum;
  lastActionAuthor?: string;
  lastActionDate?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  name?: string;
  pinSortingIndex?: string;
  remainingTaskNumber?: string;
  rights?: FizRightBeanJSON;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
  sortingIndex?: string;
  suggestedId?: string;
  systemId?: string;
  taskCategoriesHidden?: string;
  taskListType?: TaskListTypeEnum;
  taskSorting?: TaskSortingEnum;
  totalTaskNumber?: string;
};

export class ITaskList extends ServerBeanPrototype {
  /** the author of the task list

 @param accountId */
  accountId?: number;
  /** set if bestMoment, please NEVER USE, the moodableManager handle this
 @param bestMoment */
  bestMoment?: boolean;
  /** Color of the task list as rrggbb

 @param color */
  color?: string;
  comments?: Array<IComment>;
  /** Flag indicating if the completed items shall be displayed or not in this list

 @param flagCompletedHidden true if the completed items in this list are hidden */
  completedHidden?: boolean;
  /** the creation date of the list */
  creationDate?: Date;
  /** an additional description for the list, however it is not used yet

 @param description */
  description?: string;
  /** a single char string containing the emoji to display as an icon for this list

 @param emoji */
  emoji?: string;
  /** @param familyId the familyId to set */
  familyId?: string;
  /** this is the input value for file in tasklist, but shall be only in the signature of the method instead<br>
 TO REMOVE
 @param inputFile */
  inputFile?: Array<FizFile>;
  /** the last action create or update
 @return */
  lastAction?: UserActionEnum;
  /** the accountId of the author of the corresponding last action (create,update)
 @param lastActionAuthor */
  lastActionAuthor?: number;
  /** the date at which the last action has been performed
 @param lastActionDate */
  lastActionDate?: Date;
  medias?: Array<IMedia>;
  metaId?: string;
  /** set the moodMap<br>
 please NEVER USE to modify the map, use moodableManager for this
 @param moodMap */
  moodMap?: Map<number, Array<MoodEnum>>;
  /** set if the currentAccount has set the mood "star"
 Please NEVER_USE, the moodableManager handle this. */
  moodStarShortcut?: boolean;
  /** the name of the task list (UI text). If null it indicate it shall not be updated in the udpate api.

 @param name */
  name?: string;
  /** if null it is not pinned, pin sorting index of this tasklist<br>
 This is per-user defined. See pinlist api.
 {@link ITaskApi#pinList(MetaId, boolean)} */
  pinSortingIndex?: number;
  /** number of task in this category not completed

 @param nb */
  remainingTaskNumber?: number;
  /** access right for this list (editable or deletable). If null indicate no right or no update */
  rights?: FizRightBean;
  /** list of members who can see this list. This list always contains the author of the list.<br>
 this list always contains only the author of the list if shared=false.<br>
 Those are account ids (member). <br>
 @param familyIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this list is shared (if false it is private to the author only)<br>
 If null it is in case of an update to indicate it is not changed.
 @param publicList */
  sharedToAll?: boolean;
  /** sorting index of this tasks */
  sortingIndex?: number;
  /** the id of the suggested list corresponding

 @param suggestedId */
  suggestedId?: number;
  /** if this is a system category, this is the id of the system category

 @param isSystem */
  systemId?: number;
  /** Flag indicating if the task categories shall be displayed or not in this list (per user)

 @param taskCategoriesHidden true if the task categories in this list are hidden */
  taskCategoriesHidden?: boolean;
  /** If the list has a specific type (ie shopping , todo , not a vanilla list). If null a vanilla list.

 @param listtype */
  taskListType?: TaskListTypeEnum;
  /** sorting of the task in this tasklist, defined per member. null is the default (custom) order implemented via sortingIndex.

 @param taskSortingEnum */
  taskSorting?: TaskSortingEnum;
  /** number of task in this category (completed and not completed)

 @param nb */
  totalTaskNumber?: number;

  constructor(json: ITaskListJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.color = decodeString(json.color);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.completedHidden = decodeBoolean(json.completedHidden);
    this.creationDate = decodeDate(json.creationDate);
    this.description = decodeString(json.description);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeMetaId(json.familyId);
    this.inputFile = decodeArray(decodeFizFile)(json.inputFile);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.name = decodeString(json.name);
    this.pinSortingIndex = decodeNumber(json.pinSortingIndex);
    this.remainingTaskNumber = decodeNumber(json.remainingTaskNumber);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.suggestedId = decodeNumber(json.suggestedId);
    this.systemId = decodeNumber(json.systemId);
    this.taskCategoriesHidden = decodeBoolean(json.taskCategoriesHidden);
    this.taskListType = decodeEnum(json.taskListType);
    this.taskSorting = decodeEnum(json.taskSorting);
    this.totalTaskNumber = decodeNumber(json.totalTaskNumber);
    this.onDecode(json);
  }
}

function decodeITaskList(json: ITaskListJSON | undefined): ITaskList | undefined {
  return json === undefined ? undefined : new ITaskList(json);
}

function encodeITaskList(obj: ITaskList | null): ITaskListJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    completedHidden: encodeBoolean(obj.completedHidden),
    description: encodeString(obj.description),
    emoji: encodeString(obj.emoji),
    inputFile: encodeArray(encodeFizFile)(obj.inputFile),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    pinSortingIndex: encodeNumber(obj.pinSortingIndex),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll),
    sortingIndex: encodeNumber(obj.sortingIndex),
    systemId: encodeNumber(obj.systemId),
    taskCategoriesHidden: encodeBoolean(obj.taskCategoriesHidden),
    taskListType: encodeEnum(obj.taskListType),
    taskSorting: encodeEnum(obj.taskSorting)
  } as ITaskListJSON);
}

type ITokenJSON = {
  accountId?: string;
  accountIdentifierId?: string;
  clickMaxCount?: string;
  clickcount: string;
  clientPartnerType?: PartnerTypeEnum;
  creationDate: string;
  email?: string;
  expirationDate?: string;
  familyId?: string;
  persistentNameRef?: string;
  sms?: string;
  smsInternational?: string;
  tokenId: string;
  tokenRefMetaId?: string;
  type: TokenTypeEnum;
};

export class IToken extends ServerBeanPrototype {
  /** In case the token is able to authenticate a specific account identifier, this represents the account id that can be authenticated.
 If the user logs-in, we will be able to see all token corresponding to his account with that (and subsequently all invitation for instance)
 @param accountId */
  accountId?: number;
  /** @param accountIdentifierId the account identifier that can be authenticated by this token */
  accountIdentifierId?: number;
  /** @param clickMaxCount the clickMaxCount to set */
  clickMaxCount?: number;
  /** @param clickcount the clickcount to set */
  clickcount!: number;
  /** the partner type
 @param clientPartnerType the clientPartnerType to set */
  clientPartnerType?: PartnerTypeEnum;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** @param email the email to set */
  email?: string;
  /** @param expirationDate the expirationDate to set */
  expirationDate?: Date;
  /** @param familyId the familyId to set */
  familyId?: number;
  /** @param persistentNameRef the persistentNameRef to set */
  persistentNameRef?: string;
  /** @param sms the sms to set */
  sms?: string;
  /** @param sms flag indicating if the phone number is in international format and valid format, MAY BE NULL in this case consider international format */
  smsInternational?: boolean;
  /** @param tokenId the tokenId to set */
  tokenId!: number;
  /** the tokenrefId as a metaId
 @param id */
  tokenRefMetaId?: string;
  /** @param type the type to set */
  type!: TokenTypeEnum;

  constructor(json: ITokenJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.accountIdentifierId = decodeNumber(json.accountIdentifierId);
    this.clickMaxCount = decodeNumber(json.clickMaxCount);
    this.clickcount = decodenumber(json.clickcount);
    this.clientPartnerType = decodeEnum(json.clientPartnerType);
    this.creationDate = decodeDate(json.creationDate);
    this.email = decodeString(json.email);
    this.expirationDate = decodeDate(json.expirationDate);
    this.familyId = decodeNumber(json.familyId);
    this.persistentNameRef = decodeString(json.persistentNameRef);
    this.sms = decodeString(json.sms);
    this.smsInternational = decodeBoolean(json.smsInternational);
    this.tokenId = decodenumber(json.tokenId);
    this.tokenRefMetaId = decodeMetaId(json.tokenRefMetaId);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeIToken(json: ITokenJSON | undefined): IToken | undefined {
  return json === undefined ? undefined : new IToken(json);
}

function encodeIToken(obj: IToken | null): ITokenJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    accountIdentifierId: encodeNumber(obj.accountIdentifierId),
    clickMaxCount: encodeNumber(obj.clickMaxCount),
    clickcount: encodenumber(obj.clickcount),
    clientPartnerType: encodeEnum(obj.clientPartnerType),
    creationDate: encodeDate(obj.creationDate),
    email: encodeString(obj.email),
    expirationDate: encodeDate(obj.expirationDate),
    familyId: encodeNumber(obj.familyId),
    persistentNameRef: encodeString(obj.persistentNameRef),
    sms: encodeString(obj.sms),
    smsInternational: encodeBoolean(obj.smsInternational),
    tokenId: encodenumber(obj.tokenId),
    tokenRefMetaId: encodeMetaId(obj.tokenRefMetaId),
    type: encodeEnum(obj.type)
  } as ITokenJSON);
}

type IWallMessageJSON = {
  accountId: string;
  bestMoment?: string;
  comments?: Array<ICommentJSON>;
  creationDate: string;
  editable?: string;
  event?: IEventJSON;
  extra?: FizJSONObject;
  familyId: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  modifDate: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  nested?: IHasMetaIdJSON;
  place?: IPlaceJSON;
  postAccountId: string;
  refAction?: RefObjectActionEnum;
  refId?: string;
  refType?: RefObjectTypeEnum;
  rights?: FizRightBeanJSON;
  sortingDate: string;
  text?: string;
  wallMessageId: string;
};

export class IWallMessage extends ServerBeanPrototype {
  /** the author/creator of the nested/embeeded item in this wallmessage
 @param accountId */
  accountId!: number;
  /** set if bestMoment, please NEVER USE, the moodableManager handle this
 @param bestMoment */
  bestMoment?: boolean;
  comments?: Array<IComment>;
  /** creation date of the wall message (not the referenced object)
 @param modifDate */
  creationDate!: Date;
  editable?: boolean;
  /** the nested event if the ref object is of type "event", null of other care of type.
 @param event */
  event?: IEvent;
  /** extra piece of data in form of a free-form JSON object that can different depending on the type of the refobject
 @param references */
  extra?: JsonFw;
  familyId!: string;
  /** list of medias attached to this wall message, equals to the refid or in addition to the refid */
  medias?: Array<IMedia>;
  metaId?: string;
  /** modifDate of the wall message (not the item, for instance the add of a comment modify this date)
 @param modifDate the wallmessage modifDate */
  modifDate!: Date;
  /** set the moodMap<br>
 please NEVER USE to modify the map, use moodableManager for this
 @param moodMap */
  moodMap?: Map<number, Array<MoodEnum>>;
  /** set if the currentAccount has set the mood "star"
 Please NEVER_USE, the moodableManager handle this. */
  moodStarShortcut?: boolean;
  /** nested object identified by the refid
 @param nested */
  nested?: IHasMetaId;
  /** the nested place if the ref object is of type "place", null of other care of type.
 @param place */
  place?: IPlace;
  /** The author/creator of the wall message (not necessary the author of the nested item in this wallmessage).
 PostAccountId is equals to accountId for creation-type wallmessage (ie when RefObjectAction=CREATED).
 PostAccountId is the account who performed the action when RefObjectAction!=CREATED.
 @param accountId */
  postAccountId!: number;
  /** the action done on this object. Kind of sub-type for the wall message.
 @param refObjectAction the RefObjectActionEnum */
  refAction?: RefObjectActionEnum;
  /** the id of Object referenced by the message (for tagline none)
 @param refObjectId metaid of the ref object */
  refId?: string;
  /** the type of Object referenced by the message
 @param refObjectType */
  refType?: RefObjectTypeEnum;
  rights?: FizRightBean;
  /** the date used to sort the wall message from the most recent to the least recent, usually equivalent to the creation_date
 @param sortingDate */
  sortingDate!: Date;
  /** the main text of the message
 @param text */
  text?: string;
  /** the id of the message as a metaid
 @param wallMessageId */
  wallMessageId!: string;

  constructor(json: IWallMessageJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.creationDate = decodeDate(json.creationDate);
    this.editable = decodeBoolean(json.editable);
    this.event = decodeIEvent(json.event);
    this.extra = decodeFizJSONObject(json.extra);
    this.familyId = decodeMetaId(json.familyId);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.nested = decodeDynamic(json.nested) as IHasMetaId;
    this.place = decodeIPlace(json.place);
    this.postAccountId = decodeNumber(json.postAccountId);
    this.refAction = decodeEnum(json.refAction);
    this.refId = decodeMetaId(json.refId);
    this.refType = decodeEnum(json.refType);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingDate = decodeDate(json.sortingDate);
    this.text = decodeString(json.text);
    this.wallMessageId = decodeMetaId(json.wallMessageId);
    this.onDecode(json);
  }
}

function decodeIWallMessage(json: IWallMessageJSON | undefined): IWallMessage | undefined {
  return json === undefined ? undefined : new IWallMessage(json);
}

function encodeIWallMessage(obj: IWallMessage | null): IWallMessageJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationDate: encodeDate(obj.creationDate),
    editable: encodeBoolean(obj.editable),
    event: encodeIEvent(obj.event),
    extra: encodeFizJSONObject(obj.extra),
    familyId: encodeMetaId(obj.familyId),
    medias: encodeArray(encodeIMedia)(obj.medias),
    metaId: encodeMetaId(obj.metaId),
    modifDate: encodeDate(obj.modifDate),
    nested: encodeDynamic(obj.nested),
    place: encodeIPlace(obj.place),
    postAccountId: encodeNumber(obj.postAccountId),
    refAction: encodeEnum(obj.refAction),
    refId: encodeMetaId(obj.refId),
    refType: encodeEnum(obj.refType),
    rights: encodeFizRightBean(obj.rights),
    sortingDate: encodeDate(obj.sortingDate),
    text: encodeString(obj.text),
    wallMessageId: encodeMetaId(obj.wallMessageId)
  } as IWallMessageJSON);
}

type IcalImportPreviewBeanJSON = {
  content: Array<EventInputBeanJSON>;
  count: string;
  created: string;
  error: string;
  ignored: string;
  limit?: string;
  rightFlag: PremiumRightFlagEnum;
  updated: string;
};

export class IcalImportPreviewBean extends ServerBeanPrototype {
  /** filled only in preview mode, event with a metaId will be updated, the others added */
  content!: Array<EventInputBean>;
  /** number of event in the ical file */
  count!: number;
  /** number of event not already present in the server, and actually new in the ical file, therefore created on the server */
  created!: number;
  /** number of event in error */
  error!: number;
  /** number of event not checked in the indexes in input */
  ignored!: number;
  /** for non-premium that blows the limit, we indicate the limit */
  limit?: number;
  /** if it is KO_LIMIT, nothing has been done, was more to do than the given limit
 @param rightFlag right flag if error of limit, else OK */
  rightFlag!: PremiumRightFlagEnum;
  /** number of event already in the server and that therefore have been updated (identified by generateIcalKindOfKey) */
  updated!: number;

  constructor(json: IcalImportPreviewBeanJSON) {
    super(json);
    this.content = decodeArray(decodeEventInputBean)(json.content);
    this.count = decodenumber(json.count);
    this.created = decodenumber(json.created);
    this.error = decodenumber(json.error);
    this.ignored = decodenumber(json.ignored);
    this.limit = decodeNumber(json.limit);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.updated = decodenumber(json.updated);
    this.onDecode(json);
  }
}

function decodeIcalImportPreviewBean(json: IcalImportPreviewBeanJSON | undefined): IcalImportPreviewBean | undefined {
  return json === undefined ? undefined : new IcalImportPreviewBean(json);
}

function encodeIcalImportPreviewBean(obj: IcalImportPreviewBean | null): IcalImportPreviewBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    content: encodeArray(encodeEventInputBean)(obj.content),
    count: encodenumber(obj.count),
    created: encodenumber(obj.created),
    error: encodenumber(obj.error),
    ignored: encodenumber(obj.ignored),
    limit: encodeNumber(obj.limit),
    rightFlag: encodeEnum(obj.rightFlag),
    updated: encodenumber(obj.updated)
  } as IcalImportPreviewBeanJSON);
}

type IcalImportResultBeanJSON = {
  count: string;
  created: string;
  error: string;
  ignored: string;
  updated: string;
};

export class IcalImportResultBean extends ServerBeanPrototype {
  /** number of event in the ical file */
  count!: number;
  /** number of event not already present in the server, and actually new in the ical file, therefore created on the server */
  created!: number;
  /** number of event in error */
  error!: number;
  /** number of event not checked in the indexes in input */
  ignored!: number;
  /** number of event already in the server and that therefore have been updated (identified by generateIcalKindOfKey) */
  updated!: number;

  constructor(json: IcalImportResultBeanJSON) {
    super(json);
    this.count = decodenumber(json.count);
    this.created = decodenumber(json.created);
    this.error = decodenumber(json.error);
    this.ignored = decodenumber(json.ignored);
    this.updated = decodenumber(json.updated);
    this.onDecode(json);
  }
}

function decodeIcalImportResultBean(json: IcalImportResultBeanJSON | undefined): IcalImportResultBean | undefined {
  return json === undefined ? undefined : new IcalImportResultBean(json);
}

function encodeIcalImportResultBean(obj: IcalImportResultBean | null): IcalImportResultBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    count: encodenumber(obj.count),
    created: encodenumber(obj.created),
    error: encodenumber(obj.error),
    ignored: encodenumber(obj.ignored),
    updated: encodenumber(obj.updated)
  } as IcalImportResultBeanJSON);
}

type InboundEmailPreferenceJSON = {
  accountId: string;
  familyId: string;
  timezone: string;
};

export class InboundEmailPreference extends ServerBeanPrototype {
  accountId!: number;
  familyId!: number;
  timezone!: string;

  constructor(json: InboundEmailPreferenceJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.familyId = decodeNumber(json.familyId);
    this.timezone = decodeString(json.timezone);
    this.onDecode(json);
  }
}

function decodeInboundEmailPreference(json: InboundEmailPreferenceJSON | undefined): InboundEmailPreference | undefined {
  return json === undefined ? undefined : new InboundEmailPreference(json);
}

function encodeInboundEmailPreference(obj: InboundEmailPreference | null): InboundEmailPreferenceJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    familyId: encodeNumber(obj.familyId),
    timezone: encodeString(obj.timezone)
  } as InboundEmailPreferenceJSON);
}

type InvitationBeanJSON = {
  accountId: string;
  creationdate: string;
  customRole?: string;
  editable?: string;
  familyId: string;
  firstname?: string;
  invitationStatus: InvitationStatusEnum;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  originalSms?: string;
  ownerId: string;
  pictureDefault?: string;
  pictureURIs?: Array<string>;
  reminderSet: string;
  right: FamilyAdminRightEnum;
  role: FamilyRoleTypeEnum;
  token?: ITokenJSON;
  tokenId: string;
};

export class InvitationBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId!: number;
  /** @param creationdate the creationdate to set */
  creationdate!: Date;
  /** @param customFamilyRole the customFamilyRole to set */
  customRole?: string;
  /** @param editable the editable to set */
  editable?: boolean;
  familyId!: string;
  /** @param firstname the firstname to set */
  firstname?: string;
  invitationStatus!: InvitationStatusEnum;
  medias?: Array<IMedia>;
  metaId?: string;
  originalSms?: string;
  /** @param ownerId the ownerId to set */
  ownerId!: number;
  pictureDefault?: boolean;
  pictureURIs?: Array<string>;
  /** @param reminderSet the reminderSet to set */
  reminderSet!: boolean;
  /** @param adminRights the adminRights to set */
  right!: FamilyAdminRightEnum;
  /** @param familyRole the familyRole to set */
  role!: FamilyRoleTypeEnum;
  /** @param token the token to set */
  token?: IToken;
  /** @param tokenId the tokenId to set */
  tokenId!: number;

  constructor(json: InvitationBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationdate = decodeDate(json.creationdate);
    this.customRole = decodeString(json.customRole);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.firstname = decodeString(json.firstname);
    this.invitationStatus = decodeEnum(json.invitationStatus);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.originalSms = decodeString(json.originalSms);
    this.ownerId = decodeNumber(json.ownerId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureURIs = decodeArray(decodeString)(json.pictureURIs);
    this.reminderSet = decodeboolean(json.reminderSet);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.token = decodeIToken(json.token);
    this.tokenId = decodeNumber(json.tokenId);
    this.onDecode(json);
  }
}

function decodeInvitationBean(json: InvitationBeanJSON | undefined): InvitationBean | undefined {
  return json === undefined ? undefined : new InvitationBean(json);
}

function encodeInvitationBean(obj: InvitationBean | null): InvitationBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationdate: encodeDate(obj.creationdate),
    customRole: encodeString(obj.customRole),
    editable: encodeBoolean(obj.editable),
    familyId: encodeMetaId(obj.familyId),
    firstname: encodeString(obj.firstname),
    invitationStatus: encodeEnum(obj.invitationStatus),
    metaId: encodeMetaId(obj.metaId),
    originalSms: encodeString(obj.originalSms),
    ownerId: encodeNumber(obj.ownerId),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    pictureURIs: encodeArray(encodeString)(obj.pictureURIs),
    reminderSet: encodeboolean(obj.reminderSet),
    right: encodeEnum(obj.right),
    role: encodeEnum(obj.role),
    token: encodeIToken(obj.token),
    tokenId: encodeNumber(obj.tokenId)
  } as InvitationBeanJSON);
}

type InvitationReceivedBeanJSON = {
  blockingStatus: BlockingStatusEnum;
  coverDefault?: string;
  coverMedias?: Array<IMediaJSON>;
  coverURI: string;
  familyName: string;
  invitation: IInvitationJSON;
  inviterName: string;
  medias?: Array<IMediaJSON>;
  pictureDefault?: string;
};

export class InvitationReceivedBean extends ServerBeanPrototype {
  /** @param blockingStatus the blockingStatus to set */
  blockingStatus!: BlockingStatusEnum;
  /** @param coverDefault the coverDefault to set */
  coverDefault?: boolean;
  coverMedias?: Array<IMedia>;
  coverURI!: string;
  /** @param familyName the familyName to set */
  familyName!: string;
  /** @param invitation the invitation to set */
  invitation!: IInvitation;
  /** @param inviterName the inviterName to set */
  inviterName!: string;
  medias?: Array<IMedia>;
  /** true if the profile picture is a default picture */
  pictureDefault?: boolean;

  constructor(json: InvitationReceivedBeanJSON) {
    super(json);
    this.blockingStatus = decodeEnum(json.blockingStatus);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverURI = decodeString(json.coverURI);
    this.familyName = decodeString(json.familyName);
    this.invitation = decodeIInvitation(json.invitation);
    this.inviterName = decodeString(json.inviterName);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.onDecode(json);
  }
}

function decodeInvitationReceivedBean(json: InvitationReceivedBeanJSON | undefined): InvitationReceivedBean | undefined {
  return json === undefined ? undefined : new InvitationReceivedBean(json);
}

function encodeInvitationReceivedBean(obj: InvitationReceivedBean | null): InvitationReceivedBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    blockingStatus: encodeEnum(obj.blockingStatus),
    coverDefault: encodeBoolean(obj.coverDefault),
    coverMedias: encodeArray(encodeIMedia)(obj.coverMedias),
    coverURI: encodeString(obj.coverURI),
    familyName: encodeString(obj.familyName),
    invitation: encodeIInvitation(obj.invitation),
    inviterName: encodeString(obj.inviterName),
    pictureDefault: encodeBoolean(obj.pictureDefault)
  } as InvitationReceivedBeanJSON);
}

type InvitationSendingBeanJSON = {
  invitation?: IInvitationJSON;
  invitationLink?: string;
};

export class InvitationSendingBean extends ServerBeanPrototype {
  /** @param invitation the invitation to set */
  invitation?: IInvitation;
  /** @param invitationLink the invitationLink to set */
  invitationLink?: string;

  constructor(json: InvitationSendingBeanJSON) {
    super(json);
    this.invitation = decodeIInvitation(json.invitation);
    this.invitationLink = decodeString(json.invitationLink);
    this.onDecode(json);
  }
}

function decodeInvitationSendingBean(json: InvitationSendingBeanJSON | undefined): InvitationSendingBean | undefined {
  return json === undefined ? undefined : new InvitationSendingBean(json);
}

function encodeInvitationSendingBean(obj: InvitationSendingBean | null): InvitationSendingBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    invitation: encodeIInvitation(obj.invitation),
    invitationLink: encodeString(obj.invitationLink)
  } as InvitationSendingBeanJSON);
}

type ItunesReceiptStatusBeanJSON = {
  trialDurations: {[key:string]:string};
  trialPossible: string;
};

export class ItunesReceiptStatusBean extends ServerBeanPrototype {
  /** Return the trial duration in days for each productId. if the duration is zero, this specific
 productId is not allowing trial at all (even if the flag trialPossible, for the account, is true)
 @param trialDurations duration for each productIds */
  trialDurations!: Map<string, number>;
  /** flag indicating if the account of the receipt has access to a trial, for productId that allow a trial
 @param isTrialPossible the isTrialPossible to set */
  trialPossible!: boolean;

  constructor(json: ItunesReceiptStatusBeanJSON) {
    super(json);
    this.trialDurations = decodeMap(decodeString,decodeNumber)(json.trialDurations);
    this.trialPossible = decodeboolean(json.trialPossible);
    this.onDecode(json);
  }
}

function decodeItunesReceiptStatusBean(json: ItunesReceiptStatusBeanJSON | undefined): ItunesReceiptStatusBean | undefined {
  return json === undefined ? undefined : new ItunesReceiptStatusBean(json);
}

function encodeItunesReceiptStatusBean(obj: ItunesReceiptStatusBean | null): ItunesReceiptStatusBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    trialDurations: encodeMap(encodeString,encodeNumber)(obj.trialDurations),
    trialPossible: encodeboolean(obj.trialPossible)
  } as ItunesReceiptStatusBeanJSON);
}

type LaunchpadActivityBeanJSON = {
  action: CallToActionTypeEnum;
  actionBackgroundColor?: string;
  actionIcon?: CallToActionIconEnum;
  actionMetaId?: string;
  actionText?: string;
  color: string;
  cover: string;
  coverDarkMode?: string;
  darkenCover: string;
  items?: Array<LaunchpadActivityItemBeanJSON>;
  screenSeenKeyEnum?: string;
  taggingKey?: string;
  text: string;
  title?: string;
  url?: string;
};

export class LaunchpadActivityBean extends ServerBeanPrototype {
  /** action to execute
 @param action */
  action!: CallToActionTypeEnum;
  /** background color of the action button
 color formatted like #rrggbbaa or #rrggbb
 @param actionBackgroundColor */
  actionBackgroundColor?: string;
  /** icon in the action link
 @param actionIcon */
  actionIcon?: CallToActionIconEnum;
  /** id of the object concerned by the action
 @param actionMetaId */
  actionMetaId?: string;
  /** WARNING nullable only for V3!!
 text to display in the action button
 @param actionText */
  actionText?: string;
  /** color for writing the main activity text
 @param color */
  color!: string;
  /** background image to display<br/>
 you should darken it if darkenCover is true
 @param cover */
  cover!: string;
  /** dark mode version of the cover. May be null, in this case there is no dark mode version and you shall use the normal cover instead
 @param coverDarkMode the coverDarkMode to set */
  coverDarkMode?: string;
  /** does the background image to have a dark veil in order to write in white on the image in a readable way
 @param darkenCover */
  darkenCover!: boolean;
  /** used for sendind info about upcoming events today
 @param items */
  items?: Array<LaunchpadActivityItemBean>;
  /** The corresponding value of this view to be sent to the server (by api launchpadhasseen) when this view is displayed.
 @param screenSeenKeyEnum */
  screenSeenKeyEnum?: string;
  /** Key used to tag the card in analytics or other tracking system
 @param taggingKey the taggingKey to set */
  taggingKey?: string;
  /** main activity text (might contains line break)
 @param text */
  text!: string;
  /** Title (ie text displayed in slightly bigger font)
 @param title */
  title?: string;
  /** URI when callToAction==URL
 @param url */
  url?: string;

  constructor(json: LaunchpadActivityBeanJSON) {
    super(json);
    this.action = decodeEnum(json.action);
    this.actionBackgroundColor = decodeString(json.actionBackgroundColor);
    this.actionIcon = decodeEnum(json.actionIcon);
    this.actionMetaId = decodeMetaId(json.actionMetaId);
    this.actionText = decodeString(json.actionText);
    this.color = decodeString(json.color);
    this.cover = decodeString(json.cover);
    this.coverDarkMode = decodeString(json.coverDarkMode);
    this.darkenCover = decodeboolean(json.darkenCover);
    this.items = decodeArray(decodeLaunchpadActivityItemBean)(json.items);
    this.screenSeenKeyEnum = decodeString(json.screenSeenKeyEnum);
    this.taggingKey = decodeString(json.taggingKey);
    this.text = decodeString(json.text);
    this.title = decodeString(json.title);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodeLaunchpadActivityBean(json: LaunchpadActivityBeanJSON | undefined): LaunchpadActivityBean | undefined {
  return json === undefined ? undefined : new LaunchpadActivityBean(json);
}

function encodeLaunchpadActivityBean(obj: LaunchpadActivityBean | null): LaunchpadActivityBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    action: encodeEnum(obj.action),
    actionBackgroundColor: encodeString(obj.actionBackgroundColor),
    actionIcon: encodeEnum(obj.actionIcon),
    actionMetaId: encodeMetaId(obj.actionMetaId),
    actionText: encodeString(obj.actionText),
    color: encodeString(obj.color),
    cover: encodeString(obj.cover),
    coverDarkMode: encodeString(obj.coverDarkMode),
    darkenCover: encodeboolean(obj.darkenCover),
    items: encodeArray(encodeLaunchpadActivityItemBean)(obj.items),
    screenSeenKeyEnum: encodeString(obj.screenSeenKeyEnum),
    taggingKey: encodeString(obj.taggingKey),
    text: encodeString(obj.text),
    title: encodeString(obj.title),
    url: encodeString(obj.url)
  } as LaunchpadActivityBeanJSON);
}

type LaunchpadActivityItemBeanJSON = {
  color?: string;
  text?: string;
  title?: string;
};

export class LaunchpadActivityItemBean extends ServerBeanPrototype {
  color?: string;
  text?: string;
  title?: string;

  constructor(json: LaunchpadActivityItemBeanJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.text = decodeString(json.text);
    this.title = decodeString(json.title);
    this.onDecode(json);
  }
}

function decodeLaunchpadActivityItemBean(json: LaunchpadActivityItemBeanJSON | undefined): LaunchpadActivityItemBean | undefined {
  return json === undefined ? undefined : new LaunchpadActivityItemBean(json);
}

function encodeLaunchpadActivityItemBean(obj: LaunchpadActivityItemBean | null): LaunchpadActivityItemBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    text: encodeString(obj.text),
    title: encodeString(obj.title)
  } as LaunchpadActivityItemBeanJSON);
}

type LaunchpadBeanJSON = {
  activities?: Array<LaunchpadActivityBeanJSON>;
  contactCount: string;
  contactSectionNew: string;
  eventDayCount: string;
  eventMonthCount: string;
  eventSectionNew: string;
  eventWeekCount: string;
  exploreSectionNew: string;
  familyId: string;
  familyMemberCount: string;
  familyPendingInvitationCount: string;
  familySectionNew: string;
  fileCount: string;
  filerSectionNew: string;
  folderCount: string;
  gallerySectionNew: string;
  listCount: string;
  listItemCount: string;
  listPendingItemCount: string;
  listSectionNew: string;
  mapSectionNew: string;
  mealDayCount: string;
  mealSectionNew: string;
  mealWeekCount: string;
  messageUnreadCount: string;
  pictureCount: string;
  placeCount: string;
  recipeCount: string;
  recipeSectionNew: string;
  specialDaysEventTotal: string;
  specialDaysEventUpcoming: string;
  specialDaysEventUpcoming3Days: string;
  specialDaysSectionNew: string;
  specialDaysUpcomingEventName?: string;
  tiles: Array<DashboardTileBeanJSON>;
  timetableCount: string;
  timetableSectionNew: string;
  timetableUpcomingEventDate?: string;
  timetableUpcomingEventName?: string;
  token?: string;
  videoCount: string;
  weather?: WeatherBeanJSON;
};

export class LaunchpadBean extends ServerBeanPrototype {
  /** The smartcard list of cards, that is the main activity screens ordered by display wanted order
 @param activities the list of launchpad activity beans */
  activities?: Array<LaunchpadActivityBean>;
  /** number of contact
 @param contactCount number of contact */
  contactCount!: number;
  /** is there something new here since last time user has done an launchpadclick(CONTACT)
 @param contactSectionNew flag if contact section is new */
  contactSectionNew!: boolean;
  /** number of event today
 @param eventDayCount  number of event this day */
  eventDayCount!: number;
  /** number of event this month
 @param eventMonthCount nb event this month */
  eventMonthCount!: number;
  /** is there something new here since last time user has done an launchpadclick(CALENDAR)
 @param eventSectionNew flag if event section is new */
  eventSectionNew!: boolean;
  /** number of event this week
 @param eventWeekCount  event nb this week */
  eventWeekCount!: number;
  /** @param exploreSectionNew the exploreSectionNew to set */
  exploreSectionNew!: boolean;
  /** the familyid */
  familyId!: string;
  /** number of member in the family
 @param familyMemberCount nb of members */
  familyMemberCount!: number;
  /** number of pending invitation in current family
 @param familyPendingInvitationCount nb of pending invitation */
  familyPendingInvitationCount!: number;
  /** true if there is something new in the family section since last call of launchpadclick(FAMILY)
 @param familySectionNew flag if family section is new */
  familySectionNew!: boolean;
  /** number of file in the filer section in total
 @param fileCount nb of file */
  fileCount!: number;
  /** true if there is something new since the last call of launchpadclick(FILER)
 @param filerSectionNew flag the filerSectionNew */
  filerSectionNew!: boolean;
  /** number of folder in the filer section in total
 @param folderCount nb of folder */
  folderCount!: number;
  /** is there something new here since last time user has done an launchpadclick(GALLERY)
 @param gallerySectionNew flag if gallery section is new */
  gallerySectionNew!: boolean;
  /** count of List in the family
 @param listCount number of lists */
  listCount!: number;
  /** count of item in list (tasks)
 @param listItemCount  nb of items (tasks) */
  listItemCount!: number;
  /** count of items in list no marked as done
 @param listPendingItemCount nb of unchecked items in list */
  listPendingItemCount!: number;
  /** is there something new here since last time user has done an launchpadclick(LIST)
 @param listSectionNew  flag if task section is new */
  listSectionNew!: boolean;
  /** is there something new here since last time user has done an launchpadclick(MAP)
 @param mapSectionNew flag if map section is new */
  mapSectionNew!: boolean;
  /** number of meal (not dish) setted tpday, if 0 use the week field
 @param mealDayCount number of meal (not dish) setted tpday, if 0 use the week field */
  mealDayCount!: number;
  /** true if there is something new in the meal planner (exce since last call of launchpadclick(RECIPE_BOX)
 @param mealSectionNew flag meal section new */
  mealSectionNew!: boolean;
  /** number of meal (not dish) set in this current week
 @param mealWeekCount number of meal (not dish) set in this current week */
  mealWeekCount!: number;
  /** @param messageUnreadCount the messageUnreadCount to set */
  messageUnreadCount!: number;
  /** number of picture in the family
 @param pictureCount number of picture */
  pictureCount!: number;
  /** number of place of the family
 @param placeCount nb places */
  placeCount!: number;
  /** number of recipe in the family
 @param recipeCount number of recipe */
  recipeCount!: number;
  /** true if there is something new in the recipeBox since last call of launchpadclick(RECIPE_BOX)
 @param recipeSectionNew */
  recipeSectionNew!: boolean;
  /** total (past and future) number of event in the special days section */
  specialDaysEventTotal!: number;
  /** number of distinct upcoming special days events */
  specialDaysEventUpcoming!: number;
  /** number of distinct upcoming special days events in THREE DAYS and no further in the future */
  specialDaysEventUpcoming3Days!: number;
  /** flag, true if an event in the special days have a modif date greater than the LastSectionAccessSpecialDays date , updated by launchpadclick */
  specialDaysSectionNew!: boolean;
  /** name of the next upcoming special days, if the event is under 3 days away */
  specialDaysUpcomingEventName?: string;
  /** tiles set composing the dashboard
 @param tiles the tiles to set */
  tiles!: Array<DashboardTileBean>;
  /** the number of existing timetables
 @param timetableCount the timetableCount to set */
  timetableCount!: number;
  /** true if there is something new since the last call of launchpadclick(TIMETABLE)
 @param timetableSectionNew the timetableSectionNew to set */
  timetableSectionNew!: boolean;
  /** Date of the next upcoming timetable event, for all timetables of the family
 @param timetableUpcomingEventDate the timetableUpcomingEventDate to set */
  timetableUpcomingEventDate?: Date;
  /** Name of the next upcoming timetable event, for all timetables of the family
 @param timetableUpcomingEventName the timetableUpcomingEventName to set */
  timetableUpcomingEventName?: string;
  token?: string;
  /** number of video in the family
 @return number of video */
  videoCount!: number;
  weather?: WeatherBean;

  constructor(json: LaunchpadBeanJSON) {
    super(json);
    this.activities = decodeArray(decodeLaunchpadActivityBean)(json.activities);
    this.contactCount = decodenumber(json.contactCount);
    this.contactSectionNew = decodeboolean(json.contactSectionNew);
    this.eventDayCount = decodenumber(json.eventDayCount);
    this.eventMonthCount = decodenumber(json.eventMonthCount);
    this.eventSectionNew = decodeboolean(json.eventSectionNew);
    this.eventWeekCount = decodenumber(json.eventWeekCount);
    this.exploreSectionNew = decodeboolean(json.exploreSectionNew);
    this.familyId = decodeMetaId(json.familyId);
    this.familyMemberCount = decodenumber(json.familyMemberCount);
    this.familyPendingInvitationCount = decodenumber(json.familyPendingInvitationCount);
    this.familySectionNew = decodeboolean(json.familySectionNew);
    this.fileCount = decodenumber(json.fileCount);
    this.filerSectionNew = decodeboolean(json.filerSectionNew);
    this.folderCount = decodenumber(json.folderCount);
    this.gallerySectionNew = decodeboolean(json.gallerySectionNew);
    this.listCount = decodenumber(json.listCount);
    this.listItemCount = decodenumber(json.listItemCount);
    this.listPendingItemCount = decodenumber(json.listPendingItemCount);
    this.listSectionNew = decodeboolean(json.listSectionNew);
    this.mapSectionNew = decodeboolean(json.mapSectionNew);
    this.mealDayCount = decodenumber(json.mealDayCount);
    this.mealSectionNew = decodeboolean(json.mealSectionNew);
    this.mealWeekCount = decodenumber(json.mealWeekCount);
    this.messageUnreadCount = decodenumber(json.messageUnreadCount);
    this.pictureCount = decodenumber(json.pictureCount);
    this.placeCount = decodenumber(json.placeCount);
    this.recipeCount = decodenumber(json.recipeCount);
    this.recipeSectionNew = decodeboolean(json.recipeSectionNew);
    this.specialDaysEventTotal = decodenumber(json.specialDaysEventTotal);
    this.specialDaysEventUpcoming = decodenumber(json.specialDaysEventUpcoming);
    this.specialDaysEventUpcoming3Days = decodenumber(json.specialDaysEventUpcoming3Days);
    this.specialDaysSectionNew = decodeboolean(json.specialDaysSectionNew);
    this.specialDaysUpcomingEventName = decodeString(json.specialDaysUpcomingEventName);
    this.tiles = decodeArray(decodeDashboardTileBean)(json.tiles);
    this.timetableCount = decodenumber(json.timetableCount);
    this.timetableSectionNew = decodeboolean(json.timetableSectionNew);
    this.timetableUpcomingEventDate = decodeDate(json.timetableUpcomingEventDate);
    this.timetableUpcomingEventName = decodeString(json.timetableUpcomingEventName);
    this.token = decodeString(json.token);
    this.videoCount = decodenumber(json.videoCount);
    this.weather = decodeWeatherBean(json.weather);
    this.onDecode(json);
  }
}

function decodeLaunchpadBean(json: LaunchpadBeanJSON | undefined): LaunchpadBean | undefined {
  return json === undefined ? undefined : new LaunchpadBean(json);
}

function encodeLaunchpadBean(obj: LaunchpadBean | null): LaunchpadBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    activities: encodeArray(encodeLaunchpadActivityBean)(obj.activities),
    contactCount: encodenumber(obj.contactCount),
    contactSectionNew: encodeboolean(obj.contactSectionNew),
    eventDayCount: encodenumber(obj.eventDayCount),
    eventMonthCount: encodenumber(obj.eventMonthCount),
    eventSectionNew: encodeboolean(obj.eventSectionNew),
    eventWeekCount: encodenumber(obj.eventWeekCount),
    exploreSectionNew: encodeboolean(obj.exploreSectionNew),
    familyId: encodeMetaId(obj.familyId),
    familyMemberCount: encodenumber(obj.familyMemberCount),
    familyPendingInvitationCount: encodenumber(obj.familyPendingInvitationCount),
    familySectionNew: encodeboolean(obj.familySectionNew),
    fileCount: encodenumber(obj.fileCount),
    filerSectionNew: encodeboolean(obj.filerSectionNew),
    folderCount: encodenumber(obj.folderCount),
    gallerySectionNew: encodeboolean(obj.gallerySectionNew),
    listCount: encodenumber(obj.listCount),
    listItemCount: encodenumber(obj.listItemCount),
    listPendingItemCount: encodenumber(obj.listPendingItemCount),
    listSectionNew: encodeboolean(obj.listSectionNew),
    mapSectionNew: encodeboolean(obj.mapSectionNew),
    mealDayCount: encodenumber(obj.mealDayCount),
    mealSectionNew: encodeboolean(obj.mealSectionNew),
    mealWeekCount: encodenumber(obj.mealWeekCount),
    messageUnreadCount: encodenumber(obj.messageUnreadCount),
    pictureCount: encodenumber(obj.pictureCount),
    placeCount: encodenumber(obj.placeCount),
    recipeCount: encodenumber(obj.recipeCount),
    recipeSectionNew: encodeboolean(obj.recipeSectionNew),
    specialDaysEventTotal: encodenumber(obj.specialDaysEventTotal),
    specialDaysEventUpcoming: encodenumber(obj.specialDaysEventUpcoming),
    specialDaysEventUpcoming3Days: encodenumber(obj.specialDaysEventUpcoming3Days),
    specialDaysSectionNew: encodeboolean(obj.specialDaysSectionNew),
    specialDaysUpcomingEventName: encodeString(obj.specialDaysUpcomingEventName),
    tiles: encodeArray(encodeDashboardTileBean)(obj.tiles),
    timetableCount: encodenumber(obj.timetableCount),
    timetableSectionNew: encodeboolean(obj.timetableSectionNew),
    timetableUpcomingEventDate: encodeDate(obj.timetableUpcomingEventDate),
    timetableUpcomingEventName: encodeString(obj.timetableUpcomingEventName),
    token: encodeString(obj.token),
    videoCount: encodenumber(obj.videoCount),
    weather: encodeWeatherBean(obj.weather)
  } as LaunchpadBeanJSON);
}

type LaunchpadConditionBeanJSON = {
  activityCover?: string;
  activitySeenRecently?: string;
  activitySeenToday?: string;
  circleCount: string;
  circleCreatedRecently: string;
  customAvatar: string;
  customFamilyCover: string;
  diduknowCoverShowable?: string;
  diduknowCreateCircleShowable?: string;
  diduknowGreetingsShowable?: string;
  diduknowPremiumShowable?: string;
  diduknowProfileShowable?: string;
  eventDayCount: string;
  eventMonthCount: string;
  eventWeekCount: string;
  hasActivity?: string;
  modifiedActivity: string;
  modifiedActivityThisMonth: string;
  modifiedActivityThisWeek: string;
  modifiedActivityToday: string;
  nbInvite: string;
  nbMember: string;
  newLikesInActivity: string;
  openingMode: LaunchpadOpeningEnum;
  premium?: string;
  showDidYouKnow: string;
  storageUsage: string;
  todayEvents?: Array<LaunchpadEventJSON>;
  upcomingBirthdays?: Array<LaunchpadEventJSON>;
  upcomingEvents?: Array<LaunchpadEventJSON>;
  upcomingTimetablesEvents?: Array<LaunchpadEventJSON>;
};

export class LaunchpadConditionBean extends ServerBeanPrototype {
  /** the last pictures publoshed on the wall, whatever this is : any type of wall messages and any medias 
 @param activityCover */
  activityCover?: string;
  /** true if activity has been seen in the last 10 minutes or so 
 @param activitySeenRecently */
  activitySeenRecently?: boolean;
  /** true if activity has been seen after today midnight 
 @param activitySeenToday */
  activitySeenToday?: boolean;
  /** nb of family for the logged account 
 @param circleCount */
  circleCount!: number;
  /** circle has been created recently, ie since 30 days or so 
 @param circleCreatedRecently the circleCreatedRecently to set */
  circleCreatedRecently!: boolean;
  /** true if the avatar is custom 
 @param customAvatar */
  customAvatar!: boolean;
  /** true if the cover has been modified 
 @param customFamilyCover */
  customFamilyCover!: boolean;
  diduknowCoverShowable?: boolean;
  diduknowCreateCircleShowable?: boolean;
  diduknowGreetingsShowable?: boolean;
  diduknowPremiumShowable?: boolean;
  diduknowProfileShowable?: boolean;
  /** number of events this day (even if already passed) 
 @param eventDayCount */
  eventDayCount!: number;
  /** number of events this month (even if already passed) 
 @param eventMonthCount */
  eventMonthCount!: number;
  /** number of events this week (even if already passed) 
 @param eventWeekCount */
  eventWeekCount!: number;
  /** true if there is something I haven't done myself on the wall 
 @param hasActivity */
  hasActivity?: boolean;
  /** true if the activity has been modified except for new likes (since last activity section open date) 
 @param modifiedActivity the modifiedActivity to set */
  modifiedActivity!: boolean;
  /** true if the activity has been modified this month 
 @param modifiedActivityThisMonth */
  modifiedActivityThisMonth!: boolean;
  /** true if the activity has been modified this week 
 @param modifiedActivityThisWeek */
  modifiedActivityThisWeek!: boolean;
  /** true if the activity has been modified today 
 @param modifiedActivityToday */
  modifiedActivityToday!: boolean;
  /** nb of invite (pending members) in the family 
 @param nbInvite the nbInvite to set */
  nbInvite!: number;
  /** Nb of member (not pending) in the family 
 @param nbMember the nbMember to set */
  nbMember!: number;
  /** true if the activity had new likes (since last activity section open date) 
 @param newLikesInActivity the newLikesInActivity to set */
  newLikesInActivity!: boolean;
  /** the way the launchpad has been opened (lines in the excel specs). 
 @param openingMode the openingMode to set */
  openingMode!: LaunchpadOpeningEnum;
  /** if current circle is premium 
 @param premium */
  premium?: boolean;
  /** flag indicating, when the smartcard is displayed, if the did you know are included in the smartcard
 @param showDidYouKnow the value */
  showDidYouKnow!: boolean;
  /** a float indicating how storage is full (between 0 and 1, it might be a little upper than 1)
 @param storageUsage */
  storageUsage!: number;
  /** list of events Today (even if already in the past) 
 @param todayEvents the todayEvents to set */
  todayEvents?: Array<LaunchpadEvent>;
  /** list of today's birthdays 
 @param upcomingBirthdays the upcomingBirthdays to set */
  upcomingBirthdays?: Array<LaunchpadEvent>;
  /** list of events that starts Today after now 
 @param upcomingEvents the upcomingEvents to set */
  upcomingEvents?: Array<LaunchpadEvent>;
  /** list of upcoming timetablesevents, from "now" till in one week 
 @param upcomingTimetables the upcomingTimetables to set */
  upcomingTimetablesEvents?: Array<LaunchpadEvent>;

  constructor(json: LaunchpadConditionBeanJSON) {
    super(json);
    this.activityCover = decodeString(json.activityCover);
    this.activitySeenRecently = decodeBoolean(json.activitySeenRecently);
    this.activitySeenToday = decodeBoolean(json.activitySeenToday);
    this.circleCount = decodenumber(json.circleCount);
    this.circleCreatedRecently = decodeboolean(json.circleCreatedRecently);
    this.customAvatar = decodeboolean(json.customAvatar);
    this.customFamilyCover = decodeboolean(json.customFamilyCover);
    this.diduknowCoverShowable = decodeBoolean(json.diduknowCoverShowable);
    this.diduknowCreateCircleShowable = decodeBoolean(json.diduknowCreateCircleShowable);
    this.diduknowGreetingsShowable = decodeBoolean(json.diduknowGreetingsShowable);
    this.diduknowPremiumShowable = decodeBoolean(json.diduknowPremiumShowable);
    this.diduknowProfileShowable = decodeBoolean(json.diduknowProfileShowable);
    this.eventDayCount = decodenumber(json.eventDayCount);
    this.eventMonthCount = decodenumber(json.eventMonthCount);
    this.eventWeekCount = decodenumber(json.eventWeekCount);
    this.hasActivity = decodeBoolean(json.hasActivity);
    this.modifiedActivity = decodeboolean(json.modifiedActivity);
    this.modifiedActivityThisMonth = decodeboolean(json.modifiedActivityThisMonth);
    this.modifiedActivityThisWeek = decodeboolean(json.modifiedActivityThisWeek);
    this.modifiedActivityToday = decodeboolean(json.modifiedActivityToday);
    this.nbInvite = decodenumber(json.nbInvite);
    this.nbMember = decodenumber(json.nbMember);
    this.newLikesInActivity = decodeboolean(json.newLikesInActivity);
    this.openingMode = decodeEnum(json.openingMode);
    this.premium = decodeBoolean(json.premium);
    this.showDidYouKnow = decodeboolean(json.showDidYouKnow);
    this.storageUsage = decodeNumber(json.storageUsage);
    this.todayEvents = decodeArray(decodeLaunchpadEvent)(json.todayEvents);
    this.upcomingBirthdays = decodeArray(decodeLaunchpadEvent)(json.upcomingBirthdays);
    this.upcomingEvents = decodeArray(decodeLaunchpadEvent)(json.upcomingEvents);
    this.upcomingTimetablesEvents = decodeArray(decodeLaunchpadEvent)(json.upcomingTimetablesEvents);
    this.onDecode(json);
  }
}

function decodeLaunchpadConditionBean(json: LaunchpadConditionBeanJSON | undefined): LaunchpadConditionBean | undefined {
  return json === undefined ? undefined : new LaunchpadConditionBean(json);
}

function encodeLaunchpadConditionBean(obj: LaunchpadConditionBean | null): LaunchpadConditionBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    activityCover: encodeString(obj.activityCover),
    activitySeenRecently: encodeBoolean(obj.activitySeenRecently),
    activitySeenToday: encodeBoolean(obj.activitySeenToday),
    circleCount: encodenumber(obj.circleCount),
    circleCreatedRecently: encodeboolean(obj.circleCreatedRecently),
    customAvatar: encodeboolean(obj.customAvatar),
    customFamilyCover: encodeboolean(obj.customFamilyCover),
    diduknowCoverShowable: encodeBoolean(obj.diduknowCoverShowable),
    diduknowCreateCircleShowable: encodeBoolean(obj.diduknowCreateCircleShowable),
    diduknowGreetingsShowable: encodeBoolean(obj.diduknowGreetingsShowable),
    diduknowPremiumShowable: encodeBoolean(obj.diduknowPremiumShowable),
    diduknowProfileShowable: encodeBoolean(obj.diduknowProfileShowable),
    eventDayCount: encodenumber(obj.eventDayCount),
    eventMonthCount: encodenumber(obj.eventMonthCount),
    eventWeekCount: encodenumber(obj.eventWeekCount),
    hasActivity: encodeBoolean(obj.hasActivity),
    modifiedActivity: encodeboolean(obj.modifiedActivity),
    modifiedActivityThisMonth: encodeboolean(obj.modifiedActivityThisMonth),
    modifiedActivityThisWeek: encodeboolean(obj.modifiedActivityThisWeek),
    modifiedActivityToday: encodeboolean(obj.modifiedActivityToday),
    nbInvite: encodenumber(obj.nbInvite),
    nbMember: encodenumber(obj.nbMember),
    newLikesInActivity: encodeboolean(obj.newLikesInActivity),
    openingMode: encodeEnum(obj.openingMode),
    premium: encodeBoolean(obj.premium),
    showDidYouKnow: encodeboolean(obj.showDidYouKnow),
    storageUsage: encodeNumber(obj.storageUsage),
    todayEvents: encodeArray(encodeLaunchpadEvent)(obj.todayEvents),
    upcomingBirthdays: encodeArray(encodeLaunchpadEvent)(obj.upcomingBirthdays),
    upcomingEvents: encodeArray(encodeLaunchpadEvent)(obj.upcomingEvents),
    upcomingTimetablesEvents: encodeArray(encodeLaunchpadEvent)(obj.upcomingTimetablesEvents)
  } as LaunchpadConditionBeanJSON);
}

type LaunchpadEventJSON = {
  allDay?: string;
  color?: string;
  endDate?: string;
  eventId?: string;
  firstname?: string;
  startDate?: string;
  text?: string;
  where?: string;
};

export class LaunchpadEvent extends ServerBeanPrototype {
  allDay?: boolean;
  color?: string;
  endDate?: Date;
  /** @param eventId the eventId to set */
  eventId?: string;
  /** author's firstname or birthday's firstname
 @param firstname the author's firstname or birthday's firstname */
  firstname?: string;
  /** @param startDate the startDate to set */
  startDate?: Date;
  text?: string;
  where?: string;

  constructor(json: LaunchpadEventJSON) {
    super(json);
    this.allDay = decodeBoolean(json.allDay);
    this.color = decodeString(json.color);
    this.endDate = decodeDate(json.endDate);
    this.eventId = decodeMetaId(json.eventId);
    this.firstname = decodeString(json.firstname);
    this.startDate = decodeDate(json.startDate);
    this.text = decodeString(json.text);
    this.where = decodeString(json.where);
    this.onDecode(json);
  }
}

function decodeLaunchpadEvent(json: LaunchpadEventJSON | undefined): LaunchpadEvent | undefined {
  return json === undefined ? undefined : new LaunchpadEvent(json);
}

function encodeLaunchpadEvent(obj: LaunchpadEvent | null): LaunchpadEventJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    allDay: encodeBoolean(obj.allDay),
    color: encodeString(obj.color),
    endDate: encodeDate(obj.endDate),
    eventId: encodeMetaId(obj.eventId),
    firstname: encodeString(obj.firstname),
    startDate: encodeDate(obj.startDate),
    text: encodeString(obj.text),
    where: encodeString(obj.where)
  } as LaunchpadEventJSON);
}

type LocationBeanJSON = {
  accountId: string;
  address?: GeocodedAddressJSON;
  authRequestPending: GeolocSharingEnum;
  authorized: GeolocSharingEnum;
  authorizedEndDate?: string;
  deviceFlag?: LocationDeviceFlagsJSON;
  familyId: string;
  geolocSharing?: GeolocSharingEnum;
  geolocSharingEndDate?: string;
  lastLocationDeviceId?: string;
  lastPositionUpdateDate?: string;
  lastRefreshRequestSentDate?: string;
  locationState?: LocationStateEnum;
  mapURI?: string;
  modifDate: string;
  moveType: LocationMoveTypeEnum;
  placeId?: string;
  wallMessage?: IWallMessageJSON;
  wallMessageId?: string;
};

export class LocationBean extends ServerBeanPrototype {
  accountId!: number;
  address?: GeocodedAddress;
  /** @param isAuthRequestPending the isPending to set */
  authRequestPending!: GeolocSharingEnum;
  /** @param authorized the authorized to set */
  authorized!: GeolocSharingEnum;
  /** @param authorizedEndDate the authorizedEndDate to set */
  authorizedEndDate?: Date;
  deviceFlag?: LocationDeviceFlags;
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param geolocSharing the geolocSharing to set */
  geolocSharing?: GeolocSharingEnum;
  /** @param geolocSharingEndDate the geolocSharingEndDate to set */
  geolocSharingEndDate?: Date;
  /** @param locationDeviceId the locationDeviceId to set */
  lastLocationDeviceId?: string;
  /** @param lastPositionUpdateDate the lastPositionUpdateDate to set */
  lastPositionUpdateDate?: Date;
  /** @param lastRefreshRequestSentDate the lastRefreshRequestSentDate to set */
  lastRefreshRequestSentDate?: Date;
  /** @return the locationState: OK, NEVER (not yet localized), NO_DEVICE (not logged-in on a localizable device), REQUEST_PENDING (waiting for response...),
 CANNOT_CONNECT (timeout after a REQUEST_PENDING) . Basically REQUEST_PENDING shall be displayed as a loading animated icon and other error by the error icon */
  locationState?: LocationStateEnum;
  mapURI?: string;
  modifDate!: Date;
  moveType!: LocationMoveTypeEnum;
  placeId?: string;
  wallMessage?: IWallMessage;
  wallMessageId?: string;

  constructor(json: LocationBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.authRequestPending = decodeEnum(json.authRequestPending);
    this.authorized = decodeEnum(json.authorized);
    this.authorizedEndDate = decodeDate(json.authorizedEndDate);
    this.deviceFlag = decodeLocationDeviceFlags(json.deviceFlag);
    this.familyId = decodeMetaId(json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.geolocSharingEndDate = decodeDate(json.geolocSharingEndDate);
    this.lastLocationDeviceId = decodeString(json.lastLocationDeviceId);
    this.lastPositionUpdateDate = decodeDate(json.lastPositionUpdateDate);
    this.lastRefreshRequestSentDate = decodeDate(json.lastRefreshRequestSentDate);
    this.locationState = decodeEnum(json.locationState);
    this.mapURI = decodeString(json.mapURI);
    this.modifDate = decodeDate(json.modifDate);
    this.moveType = decodeEnum(json.moveType);
    this.placeId = decodeMetaId(json.placeId);
    this.wallMessage = decodeIWallMessage(json.wallMessage);
    this.wallMessageId = decodeMetaId(json.wallMessageId);
    this.onDecode(json);
  }
}

function decodeLocationBean(json: LocationBeanJSON | undefined): LocationBean | undefined {
  return json === undefined ? undefined : new LocationBean(json);
}

function encodeLocationBean(obj: LocationBean | null): LocationBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    address: encodeGeocodedAddress(obj.address),
    authRequestPending: encodeEnum(obj.authRequestPending),
    authorized: encodeEnum(obj.authorized),
    authorizedEndDate: encodeDate(obj.authorizedEndDate),
    deviceFlag: encodeLocationDeviceFlags(obj.deviceFlag),
    familyId: encodeMetaId(obj.familyId),
    geolocSharing: encodeEnum(obj.geolocSharing),
    geolocSharingEndDate: encodeDate(obj.geolocSharingEndDate),
    lastLocationDeviceId: encodeString(obj.lastLocationDeviceId),
    lastPositionUpdateDate: encodeDate(obj.lastPositionUpdateDate),
    lastRefreshRequestSentDate: encodeDate(obj.lastRefreshRequestSentDate),
    locationState: encodeEnum(obj.locationState),
    mapURI: encodeString(obj.mapURI),
    modifDate: encodeDate(obj.modifDate),
    moveType: encodeEnum(obj.moveType),
    placeId: encodeMetaId(obj.placeId),
    wallMessage: encodeIWallMessage(obj.wallMessage),
    wallMessageId: encodeMetaId(obj.wallMessageId)
  } as LocationBeanJSON);
}

type LocationDeviceFlagsJSON = {
  locationDeviceId?: string;
  locationServiceActive?: string;
};

export class LocationDeviceFlags extends ServerBeanPrototype {
  /** @param deviceId the deviceId to set for which the geotracking is enabled (other devices do not perform geotracking) */
  locationDeviceId?: string;
  /** Flag indicating if the location services on the device are enabled/disabled (ie location information turned off device-wide in the system parameters).
 Only relevant if deviceId is not null.
 @param locationServiceActive the locationServiceActive to set */
  locationServiceActive?: boolean;

  constructor(json: LocationDeviceFlagsJSON) {
    super(json);
    this.locationDeviceId = decodeString(json.locationDeviceId);
    this.locationServiceActive = decodeBoolean(json.locationServiceActive);
    this.onDecode(json);
  }
}

function decodeLocationDeviceFlags(json: LocationDeviceFlagsJSON | undefined): LocationDeviceFlags | undefined {
  return json === undefined ? undefined : new LocationDeviceFlags(json);
}

function encodeLocationDeviceFlags(obj: LocationDeviceFlags | null): LocationDeviceFlagsJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    locationDeviceId: encodeString(obj.locationDeviceId),
    locationServiceActive: encodeBoolean(obj.locationServiceActive)
  } as LocationDeviceFlagsJSON);
}

type MealBeanJSON = {
  accountId: string;
  date?: string;
  familyId?: string;
  metaId?: string;
  note?: string;
  rights?: FizRightBeanJSON;
  serves?: string;
  type?: MealTypeEnum;
};

export class MealBean extends ServerBeanPrototype {
  /** @param accountId creator of the dish */
  accountId!: number;
  date?: string;
  familyId?: string;
  metaId?: string;
  /** @param note the note to set */
  note?: string;
  rights?: FizRightBean;
  /** number fo serves
 @param serves */
  serves?: number;
  type?: MealTypeEnum;

  constructor(json: MealBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.date = decodeString(json.date);
    this.familyId = decodeMetaId(json.familyId);
    this.metaId = decodeMetaId(json.metaId);
    this.note = decodeString(json.note);
    this.rights = decodeFizRightBean(json.rights);
    this.serves = decodeNumber(json.serves);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeMealBean(json: MealBeanJSON | undefined): MealBean | undefined {
  return json === undefined ? undefined : new MealBean(json);
}

function encodeMealBean(obj: MealBean | null): MealBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    date: encodeString(obj.date),
    familyId: encodeMetaId(obj.familyId),
    metaId: encodeMetaId(obj.metaId),
    note: encodeString(obj.note),
    serves: encodeNumber(obj.serves),
    type: encodeEnum(obj.type)
  } as MealBeanJSON);
}

type MealInputBeanJSON = {
  date?: string;
  metaId?: string;
  note?: string;
  serves?: string;
  type?: MealTypeEnum;
};

export class MealInputBean extends ServerBeanPrototype {
  date?: string;
  metaId?: string;
  /** @param note the note to set */
  note?: string;
  /** number fo serves
 @param serves */
  serves?: number;
  type?: MealTypeEnum;

  constructor(json: MealInputBeanJSON) {
    super(json);
    this.date = decodeString(json.date);
    this.metaId = decodeMetaId(json.metaId);
    this.note = decodeString(json.note);
    this.serves = decodeNumber(json.serves);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeMealInputBean(json: MealInputBeanJSON | undefined): MealInputBean | undefined {
  return json === undefined ? undefined : new MealInputBean(json);
}

function encodeMealInputBean(obj: MealInputBean | null): MealInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    date: encodeString(obj.date),
    metaId: encodeMetaId(obj.metaId),
    note: encodeString(obj.note),
    serves: encodeNumber(obj.serves),
    type: encodeEnum(obj.type)
  } as MealInputBeanJSON);
}

type MealPlannerSharedBeanJSON = {
  range: DishRangeBeanJSON;
  settings: MealSettingsBeanJSON;
};

export class MealPlannerSharedBean extends ServerBeanPrototype {
  range!: DishRangeBean;
  settings!: MealSettingsBean;

  constructor(json: MealPlannerSharedBeanJSON) {
    super(json);
    this.range = decodeDishRangeBean(json.range);
    this.settings = decodeMealSettingsBean(json.settings);
    this.onDecode(json);
  }
}

function decodeMealPlannerSharedBean(json: MealPlannerSharedBeanJSON | undefined): MealPlannerSharedBean | undefined {
  return json === undefined ? undefined : new MealPlannerSharedBean(json);
}

function encodeMealPlannerSharedBean(obj: MealPlannerSharedBean | null): MealPlannerSharedBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    range: encodeDishRangeBean(obj.range),
    settings: encodeMealSettingsBean(obj.settings)
  } as MealPlannerSharedBeanJSON);
}

type MealSettingsBeanJSON = {
  canClear?: string;
  columns?: Array<MealSettingsColumnBeanJSON>;
  defaultAddMealToListId?: string;
  familyId?: string;
  showWeekEnd?: string;
  viewCalendar?: string;
};

export class MealSettingsBean extends ServerBeanPrototype {
  canClear?: boolean;
  columns?: Array<MealSettingsColumnBean>;
  defaultAddMealToListId?: string;
  familyId?: string;
  showWeekEnd?: boolean;
  viewCalendar?: boolean;

  constructor(json: MealSettingsBeanJSON) {
    super(json);
    this.canClear = decodeBoolean(json.canClear);
    this.columns = decodeArray(decodeMealSettingsColumnBean)(json.columns);
    this.defaultAddMealToListId = decodeMetaId(json.defaultAddMealToListId);
    this.familyId = decodeMetaId(json.familyId);
    this.showWeekEnd = decodeBoolean(json.showWeekEnd);
    this.viewCalendar = decodeBoolean(json.viewCalendar);
    this.onDecode(json);
  }
}

function decodeMealSettingsBean(json: MealSettingsBeanJSON | undefined): MealSettingsBean | undefined {
  return json === undefined ? undefined : new MealSettingsBean(json);
}

function encodeMealSettingsBean(obj: MealSettingsBean | null): MealSettingsBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    columns: encodeArray(encodeMealSettingsColumnBean)(obj.columns),
    defaultAddMealToListId: encodeMetaId(obj.defaultAddMealToListId),
    familyId: encodeMetaId(obj.familyId),
    showWeekEnd: encodeBoolean(obj.showWeekEnd),
    viewCalendar: encodeBoolean(obj.viewCalendar)
  } as MealSettingsBeanJSON);
}

type MealSettingsColumnBeanJSON = {
  display: string;
  emoji?: string;
  name?: string;
  timeSlot?: string;
  type: MealTypeEnum;
};

export class MealSettingsColumnBean extends ServerBeanPrototype {
  display!: boolean;
  emoji?: string;
  name?: string;
  timeSlot?: string;
  type!: MealTypeEnum;

  constructor(json: MealSettingsColumnBeanJSON) {
    super(json);
    this.display = decodeboolean(json.display);
    this.emoji = decodeString(json.emoji);
    this.name = decodeString(json.name);
    this.timeSlot = decodeString(json.timeSlot);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeMealSettingsColumnBean(json: MealSettingsColumnBeanJSON | undefined): MealSettingsColumnBean | undefined {
  return json === undefined ? undefined : new MealSettingsColumnBean(json);
}

function encodeMealSettingsColumnBean(obj: MealSettingsColumnBean | null): MealSettingsColumnBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    display: encodeboolean(obj.display),
    emoji: encodeString(obj.emoji),
    name: encodeString(obj.name),
    timeSlot: encodeString(obj.timeSlot),
    type: encodeEnum(obj.type)
  } as MealSettingsColumnBeanJSON);
}

type MealSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<MealBeanJSON>;
};

export class MealSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<MealBean>;

  constructor(json: MealSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeMealBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeMealSyncBean(json: MealSyncBeanJSON | undefined): MealSyncBean | undefined {
  return json === undefined ? undefined : new MealSyncBean(json);
}

function encodeMealSyncBean(obj: MealSyncBean | null): MealSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeMealBean)(obj.updatedCreated)
  } as MealSyncBeanJSON);
}

type MediaBeanJSON = {
  accountId?: string;
  bestMoment: string;
  color?: string;
  creationDate?: string;
  datasize?: string;
  durationMs?: string;
  familyId?: string;
  filerModifDate?: string;
  mediaId?: string;
  mediaPreviewStatus?: MediaPreviewStatusEnum;
  metaId?: string;
  mimeType?: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  name?: string;
  parentFolderId?: string;
  pictureUrl: string;
  pointedBy?: string;
  pointedByWhat?: MetaIdTypeEnum;
  readystate?: MediaContentState;
  resolutionX?: string;
  resolutionY?: string;
  rights: FizRightBeanJSON;
};

export class MediaBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId?: number;
  bestMoment!: boolean;
  color?: string;
  creationDate?: Date;
  /** @param dataSize the dataSize to set */
  datasize?: number;
  durationMs?: number;
  /** @param familyId the familyId to set */
  familyId?: string;
  filerModifDate?: Date;
  mediaId?: string;
  mediaPreviewStatus?: MediaPreviewStatusEnum;
  metaId?: string;
  mimeType?: string;
  moodMap?: Map<number, Array<MoodEnum>>;
  name?: string;
  parentFolderId?: string;
  pictureUrl!: string;
  pointedBy?: string;
  pointedByWhat?: MetaIdTypeEnum;
  readystate?: MediaContentState;
  /** @param resolutionX the resolutionX to set */
  resolutionX?: number;
  /** @param resolutionY the resolutionY to set */
  resolutionY?: number;
  rights!: FizRightBean;

  constructor(json: MediaBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeboolean(json.bestMoment);
    this.color = decodeString(json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.datasize = decodeNumber(json.datasize);
    this.durationMs = decodeNumber(json.durationMs);
    this.familyId = decodeMetaId(json.familyId);
    this.filerModifDate = decodeDate(json.filerModifDate);
    this.mediaId = decodeMetaId(json.mediaId);
    this.mediaPreviewStatus = decodeEnum(json.mediaPreviewStatus);
    this.metaId = decodeMetaId(json.metaId);
    this.mimeType = decodeString(json.mimeType);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.name = decodeString(json.name);
    this.parentFolderId = decodeMetaId(json.parentFolderId);
    this.pictureUrl = decodeString(json.pictureUrl);
    this.pointedBy = decodeMetaId(json.pointedBy);
    this.pointedByWhat = decodeEnum(json.pointedByWhat);
    this.readystate = decodeEnum(json.readystate);
    this.resolutionX = decodeNumber(json.resolutionX);
    this.resolutionY = decodeNumber(json.resolutionY);
    this.rights = decodeFizRightBean(json.rights);
    this.onDecode(json);
  }
}

function decodeMediaBean(json: MediaBeanJSON | undefined): MediaBean | undefined {
  return json === undefined ? undefined : new MediaBean(json);
}

function encodeMediaBean(obj: MediaBean | null): MediaBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    bestMoment: encodeboolean(obj.bestMoment),
    color: encodeString(obj.color),
    creationDate: encodeDate(obj.creationDate),
    datasize: encodeNumber(obj.datasize),
    durationMs: encodeNumber(obj.durationMs),
    familyId: encodeMetaId(obj.familyId),
    mediaId: encodeMetaId(obj.mediaId),
    metaId: encodeMetaId(obj.metaId),
    mimeType: encodeString(obj.mimeType),
    moodMap: encodeMap(encodeNumber,encodeArray(encodeEnum))(obj.moodMap),
    name: encodeString(obj.name),
    parentFolderId: encodeMetaId(obj.parentFolderId),
    pictureUrl: encodeString(obj.pictureUrl),
    pointedBy: encodeMetaId(obj.pointedBy),
    pointedByWhat: encodeEnum(obj.pointedByWhat),
    readystate: encodeEnum(obj.readystate),
    resolutionX: encodeNumber(obj.resolutionX),
    resolutionY: encodeNumber(obj.resolutionY)
  } as MediaBeanJSON);
}

type MediaFilterFrontImageJSON = {
  accountId?: string;
  familyId: string;
  frontMedia?: IMediaJSON;
  metaId: string;
  number: string;
  numberPictures: string;
  numberVideos: string;
  pictureUrl?: string;
  type: MediaFilterTypeEnum;
};

export class MediaFilterFrontImage extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId?: number;
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param frontMedia the frontMedia to set */
  frontMedia?: IMedia;
  /** do not use, frontKey is type+accountId.
 @param frontKey the frontKey to set */
  metaId!: string;
  /** @param number the number to set */
  number!: number;
  /** @param numberPictures the numberPictures to set */
  numberPictures!: number;
  /** @param numberVideos the numberVideos to set */
  numberVideos!: number;
  /** @param pictureUri the pictureUri to set */
  pictureUrl?: string;
  /** @param type the type to set */
  type!: MediaFilterTypeEnum;

  constructor(json: MediaFilterFrontImageJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.familyId = decodeMetaId(json.familyId);
    this.frontMedia = decodeIMedia(json.frontMedia);
    this.metaId = decodeString(json.metaId);
    this.number = decodenumber(json.number);
    this.numberPictures = decodenumber(json.numberPictures);
    this.numberVideos = decodenumber(json.numberVideos);
    this.pictureUrl = decodeString(json.pictureUrl);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeMediaFilterFrontImage(json: MediaFilterFrontImageJSON | undefined): MediaFilterFrontImage | undefined {
  return json === undefined ? undefined : new MediaFilterFrontImage(json);
}

function encodeMediaFilterFrontImage(obj: MediaFilterFrontImage | null): MediaFilterFrontImageJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    familyId: encodeMetaId(obj.familyId),
    frontMedia: encodeIMedia(obj.frontMedia),
    metaId: encodeString(obj.metaId),
    number: encodenumber(obj.number),
    numberPictures: encodenumber(obj.numberPictures),
    numberVideos: encodenumber(obj.numberVideos),
    pictureUrl: encodeString(obj.pictureUrl),
    type: encodeEnum(obj.type)
  } as MediaFilterFrontImageJSON);
}

type MediaListBeanJSON = {
  accountId?: string;
  familyId?: string;
} & PaginatedCollectionJSON<IMediaJSON>;

export class MediaListBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId?: number;
  /** @param familyId the familyId to set */
  familyId?: string;
  /** @param mediaList the mediaList to set */
  mediaList!: PaginatedCollection<IMedia>;

  constructor(json: MediaListBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.familyId = decodeMetaId(json.familyId);
    this.mediaList = decodePaginatedCollection(decodeIMedia)(json);
    this.onDecode(json);
  }
}

function decodeMediaListBean(json: MediaListBeanJSON | undefined): MediaListBean | undefined {
  return json === undefined ? undefined : new MediaListBean(json);
}

function encodeMediaListBean(obj: MediaListBean | null): MediaListBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    familyId: encodeMetaId(obj.familyId)
  } as MediaListBeanJSON, encodePaginatedCollection(encodeIMedia)(obj.mediaList));
}

type MediaQuotaJSON = {
  color: string;
  familyId?: string;
  familyQuota: string;
  familyRemain: string;
  familyUsed: string;
  rightFlag: PremiumRightFlagEnum;
  usedByOwner: {[key:string]:string};
};

export class MediaQuota extends ServerBeanPrototype {
  /** color in which the quota bar should be displayed
 @param color */
  color!: string;
  /** building quota might have no family thats why it is nullable, (bpierre: but I don't really understand the use case)
 quota concerning which family
 @param familyId */
  familyId?: string;
  /** total quota of the family
 @param familyQuota */
  familyQuota!: number;
  /** fake field that calculate remaining by doing familyQuota-familyUsed
 @param familyUsed */
  familyRemain!: number;
  /** total used by current family
 @param familyUsed */
  familyUsed!: number;
  /** flag to indicate if user can upload | should take premium or is limited
 @param rightFlag */
  rightFlag!: PremiumRightFlagEnum;
  /** map containing details about what is used by which user activity
 @param usedByOwner */
  usedByOwner!: Map<number, number>;

  constructor(json: MediaQuotaJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.familyId = decodeMetaId(json.familyId);
    this.familyQuota = decodenumber(json.familyQuota);
    this.familyRemain = decodenumber(json.familyRemain);
    this.familyUsed = decodenumber(json.familyUsed);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.usedByOwner = decodeMap(decodeNumber,decodeNumber)(json.usedByOwner);
    this.onDecode(json);
  }
}

function decodeMediaQuota(json: MediaQuotaJSON | undefined): MediaQuota | undefined {
  return json === undefined ? undefined : new MediaQuota(json);
}

function encodeMediaQuota(obj: MediaQuota | null): MediaQuotaJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    familyId: encodeMetaId(obj.familyId),
    familyQuota: encodenumber(obj.familyQuota),
    familyRemain: encodenumber(obj.familyRemain),
    familyUsed: encodenumber(obj.familyUsed),
    rightFlag: encodeEnum(obj.rightFlag),
    usedByOwner: encodeMap(encodeNumber,encodeNumber)(obj.usedByOwner)
  } as MediaQuotaJSON);
}

type MessageSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<IIMMessageJSON>;
};

export class MessageSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<IIMMessage>;

  constructor(json: MessageSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeIIMMessage)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeMessageSyncBean(json: MessageSyncBeanJSON | undefined): MessageSyncBean | undefined {
  return json === undefined ? undefined : new MessageSyncBean(json);
}

function encodeMessageSyncBean(obj: MessageSyncBean | null): MessageSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeIIMMessage)(obj.updatedCreated)
  } as MessageSyncBeanJSON);
}

type OpenGraphDataBeanJSON = {
  adultContent?: string;
  description?: string;
  icons: Array<OpenGraphMediaJSON>;
  images: Array<OpenGraphMediaJSON>;
  isError?: string;
  pollDate?: string;
  recipe?: RecipeInputBeanJSON;
  refUrl?: string;
  siteName?: string;
  title?: string;
  type?: string;
  url?: string;
  videos: Array<OpenGraphMediaJSON>;
};

export class OpenGraphDataBean extends ServerBeanPrototype {
  adultContent?: boolean;
  description?: string;
  icons!: Array<OpenGraphMedia>;
  images!: Array<OpenGraphMedia>;
  isError?: boolean;
  pollDate?: Date;
  recipe?: RecipeInputBean;
  refUrl?: string;
  siteName?: string;
  title?: string;
  type?: string;
  url?: string;
  videos!: Array<OpenGraphMedia>;

  constructor(json: OpenGraphDataBeanJSON) {
    super(json);
    this.adultContent = decodeBoolean(json.adultContent);
    this.description = decodeString(json.description);
    this.icons = decodeArray(decodeOpenGraphMedia)(json.icons);
    this.images = decodeArray(decodeOpenGraphMedia)(json.images);
    this.isError = decodeBoolean(json.isError);
    this.pollDate = decodeDate(json.pollDate);
    this.recipe = decodeRecipeInputBean(json.recipe);
    this.refUrl = decodeString(json.refUrl);
    this.siteName = decodeString(json.siteName);
    this.title = decodeString(json.title);
    this.type = decodeString(json.type);
    this.url = decodeString(json.url);
    this.videos = decodeArray(decodeOpenGraphMedia)(json.videos);
    this.onDecode(json);
  }
}

function decodeOpenGraphDataBean(json: OpenGraphDataBeanJSON | undefined): OpenGraphDataBean | undefined {
  return json === undefined ? undefined : new OpenGraphDataBean(json);
}

function encodeOpenGraphDataBean(obj: OpenGraphDataBean | null): OpenGraphDataBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    adultContent: encodeBoolean(obj.adultContent),
    description: encodeString(obj.description),
    icons: encodeArray(encodeOpenGraphMedia)(obj.icons),
    images: encodeArray(encodeOpenGraphMedia)(obj.images),
    isError: encodeBoolean(obj.isError),
    pollDate: encodeDate(obj.pollDate),
    recipe: encodeRecipeInputBean(obj.recipe),
    refUrl: encodeString(obj.refUrl),
    siteName: encodeString(obj.siteName),
    title: encodeString(obj.title),
    type: encodeString(obj.type),
    url: encodeString(obj.url),
    videos: encodeArray(encodeOpenGraphMedia)(obj.videos)
  } as OpenGraphDataBeanJSON);
}

type OpenGraphMediaJSON = {
  autoplay?: string;
  from?: string;
  height?: string;
  secureUrl?: string;
  type?: string;
  url?: string;
  width?: string;
};

export class OpenGraphMedia extends ServerBeanPrototype {
  /** usefull for video, when gif are interpreted as video and should have the same behavior (autoplay, loop, no controlls)
 @param autoplay */
  autoplay?: boolean;
  /** how did we get this info,<br> 
 - "og" means from opengraph metadata setted volontary by the owner of the targtted website
 - "head" means from other metadata in the html page
 - "html" means the result of parsing the webpage seeking for <img tag
 @param from */
  from?: string;
  /** height of the media, might be null, it is out of our control
 @param width */
  height?: number;
  /** https url of the media
 @param secureUrl */
  secureUrl?: string;
  /** mimeType of the media
 @param type */
  type?: string;
  /** url of the media
 @param url */
  url?: string;
  /** width of the media, might be null, it is out of our control
 @param width */
  width?: number;

  constructor(json: OpenGraphMediaJSON) {
    super(json);
    this.autoplay = decodeBoolean(json.autoplay);
    this.from = decodeString(json.from);
    this.height = decodeNumber(json.height);
    this.secureUrl = decodeString(json.secureUrl);
    this.type = decodeString(json.type);
    this.url = decodeString(json.url);
    this.width = decodeNumber(json.width);
    this.onDecode(json);
  }
}

function decodeOpenGraphMedia(json: OpenGraphMediaJSON | undefined): OpenGraphMedia | undefined {
  return json === undefined ? undefined : new OpenGraphMedia(json);
}

function encodeOpenGraphMedia(obj: OpenGraphMedia | null): OpenGraphMediaJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    autoplay: encodeBoolean(obj.autoplay),
    from: encodeString(obj.from),
    height: encodeNumber(obj.height),
    secureUrl: encodeString(obj.secureUrl),
    type: encodeString(obj.type),
    url: encodeString(obj.url),
    width: encodeNumber(obj.width)
  } as OpenGraphMediaJSON);
}

type OutlookCredentialBeanJSON = {
  credentialId: string;
  errorCode?: string;
  errorMessage?: string;
  linkable?: Array<OutlookLinkableCalendarBeanJSON>;
  linked: Array<CalendarBeanJSON>;
  name?: string;
};

export class OutlookCredentialBean extends ServerBeanPrototype {
  /** our internal id
 
 @param credentialId */
  credentialId!: string;
  errorCode?: string;
  errorMessage?: string;
  /** calendar from outlook than might be linked to our system Use this to pick
 calendars from outlook account
 
 @param linkable */
  linkable?: Array<OutlookLinkableCalendarBean>;
  /** calendar from outlook that are already linked to our system Use this in the UI
 for connected calendars
 
 @param linked */
  linked!: Array<CalendarBean>;
  name?: string;

  constructor(json: OutlookCredentialBeanJSON) {
    super(json);
    this.credentialId = decodeMetaId(json.credentialId);
    this.errorCode = decodeString(json.errorCode);
    this.errorMessage = decodeString(json.errorMessage);
    this.linkable = decodeArray(decodeOutlookLinkableCalendarBean)(json.linkable);
    this.linked = decodeArray(decodeCalendarBean)(json.linked);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodeOutlookCredentialBean(json: OutlookCredentialBeanJSON | undefined): OutlookCredentialBean | undefined {
  return json === undefined ? undefined : new OutlookCredentialBean(json);
}

function encodeOutlookCredentialBean(obj: OutlookCredentialBean | null): OutlookCredentialBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    credentialId: encodeMetaId(obj.credentialId),
    errorCode: encodeString(obj.errorCode),
    errorMessage: encodeString(obj.errorMessage),
    linkable: encodeArray(encodeOutlookLinkableCalendarBean)(obj.linkable),
    linked: encodeArray(encodeCalendarBean)(obj.linked),
    name: encodeString(obj.name)
  } as OutlookCredentialBeanJSON);
}

type OutlookLinkableCalendarBeanJSON = {
  color: string;
  linked: string;
  name: string;
  outlookId: string;
};

export class OutlookLinkableCalendarBean extends ServerBeanPrototype {
  color!: string;
  linked!: boolean;
  name!: string;
  outlookId!: string;

  constructor(json: OutlookLinkableCalendarBeanJSON) {
    super(json);
    this.color = decodeString(json.color);
    this.linked = decodeboolean(json.linked);
    this.name = decodeString(json.name);
    this.outlookId = decodeString(json.outlookId);
    this.onDecode(json);
  }
}

function decodeOutlookLinkableCalendarBean(json: OutlookLinkableCalendarBeanJSON | undefined): OutlookLinkableCalendarBean | undefined {
  return json === undefined ? undefined : new OutlookLinkableCalendarBean(json);
}

function encodeOutlookLinkableCalendarBean(obj: OutlookLinkableCalendarBean | null): OutlookLinkableCalendarBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    linked: encodeboolean(obj.linked),
    name: encodeString(obj.name),
    outlookId: encodeString(obj.outlookId)
  } as OutlookLinkableCalendarBeanJSON);
}

type PaginatedCollectionJSON<IApiKeyJSON> = {
  count?: string;
  datas: Array<IApiKeyJSON>;
  nextPageId?: string;
  remain?: string;
  size: string;
  start: string;
};

export class PaginatedCollection<IApiKey> extends ServerBeanPrototype {
  count?: number;
  datas!: Array<IApiKey>;
  nextPageId?: string;
  remain?: number;
  size!: number;
  start!: number;

  constructor(json: PaginatedCollectionJSON<any>, decodeIApiKey: objectDecoder<any, IApiKey>) {
    super(json);
    this.count = decodeNumber(json.count);
    this.datas = decodeArray(decodeIApiKey)(json.datas);
    this.nextPageId = decodeString(json.nextPageId);
    this.remain = decodeNumber(json.remain);
    this.size = decodeNumber(json.size);
    this.start = decodeNumber(json.start);
    this.onDecode(json);
  }
}

function decodePaginatedCollection<IApiKey>(decodeIApiKey: objectDecoder<any, IApiKey>) {
  return function(json: PaginatedCollectionJSON<any> | undefined): PaginatedCollection<IApiKey> | undefined {
    return json === undefined ? undefined : new PaginatedCollection<IApiKey>(json, decodeIApiKey);
  };
}

function encodePaginatedCollection<IApiKey>(encodeIApiKey: objectEncoder<IApiKey>) {
  return function(obj: PaginatedCollection<IApiKey> | null): PaginatedCollectionJSON<any> | undefined {
    if (obj == null) return undefined;
  return inline({
    count: encodeNumber(obj.count),
    datas: encodeArray(encodeIApiKey)(obj.datas),
    nextPageId: encodeString(obj.nextPageId),
    remain: encodeNumber(obj.remain),
    size: encodeNumber(obj.size),
    start: encodeNumber(obj.start)
  } as PaginatedCollectionJSON<IApiKeyJSON>);
  };
}

type PaginationRequestJSON = {
  count?: string;
  itemId?: string;
};

export class PaginationRequest extends ServerBeanPrototype {
  /** Several possible behavior: <ul>
 <li>When positive, this indicate the maximum number of element to return, ordered ascendently (incrementally) positioned after the 
 starting element identified by the itemId parameter.<br>
 Enables to implement the "load x more elements" feature.
 <li>When null, return the unpaginated list, not depending on the starting element indentified by the itemId parameter.
 <li>When negative, indicate to return all elements ordered descendely (decrementally) positioned before the starting element indetified 
 by the itemId parameter. <br>
 Enables to implement the "refresh list" feature when the metaId indicate the first element available on the client.
 @param count */
  count?: number;
  /** The id of the element in the unpaginated list, from which the resulting paginated list will start, excluding this element.<br>
 If null, the paginated list will start with the first element of the unpaginated list.
 @param itemId */
  itemId?: string;

  constructor(json: PaginationRequestJSON) {
    super(json);
    this.count = decodeNumber(json.count);
    this.itemId = decodeMetaId(json.itemId);
    this.onDecode(json);
  }
}

function decodePaginationRequest(json: PaginationRequestJSON | undefined): PaginationRequest | undefined {
  return json === undefined ? undefined : new PaginationRequest(json);
}

function encodePaginationRequest(obj: PaginationRequest | null): PaginationRequestJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    count: encodeNumber(obj.count),
    itemId: encodeMetaId(obj.itemId)
  } as PaginationRequestJSON);
}

type PaymentMethodBeanJSON = {
  accountId?: string;
  default?: string;
  emoji?: string;
  familyId: string;
  hidden?: string;
  locale?: string;
  metaId: string;
  name?: string;
  rights?: FizRightBeanJSON;
  sortingIndex?: string;
  systemCategoryId?: string;
};

export class PaymentMethodBean extends ServerBeanPrototype {
  /** if this is not null, this is a custom category and it returns the author */
  accountId?: number;
  /** @param isDefault the isDefault to set */
  default?: boolean;
  /** One char , the emoji associated with this category
 @param emoji the emoji to set */
  emoji?: string;
  /** @param familyId the familyId to set */
  familyId!: number;
  /** @param hidden the hidden to set */
  hidden?: boolean;
  /** The locale for this task category (locale are filter so we present a category only to one specific locale, may be null in this case it will be presented to any locale)<br>
 system category locale cannot be changed.
 @param locale the locale to set */
  locale?: string;
  metaId!: string;
  /** Name of the task catetory. If set to null,it won't be modified
 @param name the name to set */
  name?: string;
  rights?: FizRightBean;
  /** the long value to sort the the item with, to allow for a custom order. <br>
 Ascending order (the smallest and oldest item at the top of the list, the largest and newest at the bottom of the list)<br>
 Initialized with the currentTimeMillis for new items. 
 @param sortingIndex the sortingIndex to set */
  sortingIndex?: number;
  /** @param systemCategoryId the systemCategoryId */
  systemCategoryId?: number;

  constructor(json: PaymentMethodBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.default = decodeBoolean(json.default);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.hidden = decodeBoolean(json.hidden);
    this.locale = decodeString(json.locale);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.systemCategoryId = decodeNumber(json.systemCategoryId);
    this.onDecode(json);
  }
}

function decodePaymentMethodBean(json: PaymentMethodBeanJSON | undefined): PaymentMethodBean | undefined {
  return json === undefined ? undefined : new PaymentMethodBean(json);
}

function encodePaymentMethodBean(obj: PaymentMethodBean | null): PaymentMethodBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    emoji: encodeString(obj.emoji),
    familyId: encodeNumber(obj.familyId),
    hidden: encodeBoolean(obj.hidden),
    locale: encodeString(obj.locale),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    sortingIndex: encodeNumber(obj.sortingIndex)
  } as PaymentMethodBeanJSON);
}

type PaymentMethodInputBeanJSON = {
  emoji?: string;
  hidden?: string;
  metaId?: string;
  name?: string;
};

export class PaymentMethodInputBean extends ServerBeanPrototype {
  /** One char , the emoji associated with this category
 @param emoji the emoji to set */
  emoji?: string;
  /** @param hidden the hidden to set */
  hidden?: boolean;
  /** the id of the category. If this is a system category, objectId is <100000 */
  metaId?: string;
  /** Name of the task catetory. If set to null,it won't be modified
 @param name the name to set */
  name?: string;

  constructor(json: PaymentMethodInputBeanJSON) {
    super(json);
    this.emoji = decodeString(json.emoji);
    this.hidden = decodeBoolean(json.hidden);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodePaymentMethodInputBean(json: PaymentMethodInputBeanJSON | undefined): PaymentMethodInputBean | undefined {
  return json === undefined ? undefined : new PaymentMethodInputBean(json);
}

function encodePaymentMethodInputBean(obj: PaymentMethodInputBean | null): PaymentMethodInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    emoji: encodeString(obj.emoji),
    hidden: encodeBoolean(obj.hidden),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name)
  } as PaymentMethodInputBeanJSON);
}

type PaymentMethodSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<PaymentMethodBeanJSON>;
};

export class PaymentMethodSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<PaymentMethodBean>;

  constructor(json: PaymentMethodSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodePaymentMethodBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodePaymentMethodSyncBean(json: PaymentMethodSyncBeanJSON | undefined): PaymentMethodSyncBean | undefined {
  return json === undefined ? undefined : new PaymentMethodSyncBean(json);
}

function encodePaymentMethodSyncBean(obj: PaymentMethodSyncBean | null): PaymentMethodSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodePaymentMethodBean)(obj.updatedCreated)
  } as PaymentMethodSyncBeanJSON);
}

type PingPongPayloadBeanJSON = {
  clusterConnectedNodeIdList: Array<string>;
  databaseStatus: DatabaseHealthStatusBeanJSON;
  electorNumber?: string;
  leader: string;
  leaderServerId?: string;
};

export class PingPongPayloadBean extends ServerBeanPrototype {
  /** The list of node that the node sending this ping was connected to. If the node sending this ping is the leader,
 then this is the list of node of the cluster.
 @return */
  clusterConnectedNodeIdList!: Array<string>;
  /** the statuses for all databases
 @param databaseStatus statuses */
  databaseStatus!: DatabaseHealthStatusBean;
  /** The number of elector that participate in the election of the leader during the local election in the node sending this ping.
 IE when the node sending this ping has elected a leader, the election was performed by examining this number of elector.
 @return */
  electorNumber?: number;
  /** Indicate if the node sending this ping consider itself as the leader of the cluster or not
 @param leader */
  leader!: boolean;
  /** The server Id of the leader elected by the node sending this ping (ie the local leader of the node sending this ping)
 @param leaderServerId */
  leaderServerId?: string;

  constructor(json: PingPongPayloadBeanJSON) {
    super(json);
    this.clusterConnectedNodeIdList = decodeArray(decodeString)(json.clusterConnectedNodeIdList);
    this.databaseStatus = decodeDatabaseHealthStatusBean(json.databaseStatus);
    this.electorNumber = decodeNumber(json.electorNumber);
    this.leader = decodeboolean(json.leader);
    this.leaderServerId = decodeString(json.leaderServerId);
    this.onDecode(json);
  }
}

function decodePingPongPayloadBean(json: PingPongPayloadBeanJSON | undefined): PingPongPayloadBean | undefined {
  return json === undefined ? undefined : new PingPongPayloadBean(json);
}

function encodePingPongPayloadBean(obj: PingPongPayloadBean | null): PingPongPayloadBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    clusterConnectedNodeIdList: encodeArray(encodeString)(obj.clusterConnectedNodeIdList),
    databaseStatus: encodeDatabaseHealthStatusBean(obj.databaseStatus),
    electorNumber: encodeNumber(obj.electorNumber),
    leader: encodeboolean(obj.leader),
    leaderServerId: encodeString(obj.leaderServerId)
  } as PingPongPayloadBeanJSON);
}

type PlaceBeanJSON = {
  accountId: string;
  address?: GeocodedAddressJSON;
  contactId?: string;
  editable?: string;
  fWGeofencingIn?: string;
  fWGeofencingOut?: string;
  familyId: string;
  geofencingActive?: string;
  isTemporary: string;
  mapURI?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  name: string;
  placeId: string;
  placeType?: PlaceTypeEnum;
  text?: string;
  wifiMAC?: string;
  wifiSSID?: string;
};

export class PlaceBean extends ServerBeanPrototype {
  accountId!: number;
  address?: GeocodedAddress;
  contactId?: string;
  editable?: boolean;
  fWGeofencingIn?: boolean;
  fWGeofencingOut?: boolean;
  /** @param familyId the familyId to set */
  familyId!: string;
  geofencingActive?: boolean;
  isTemporary!: boolean;
  mapURI?: string;
  medias?: Array<IMedia>;
  metaId?: string;
  name!: string;
  placeId!: string;
  placeType?: PlaceTypeEnum;
  text?: string;
  wifiMAC?: string;
  wifiSSID?: string;

  constructor(json: PlaceBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.contactId = decodeMetaId(json.contactId);
    this.editable = decodeBoolean(json.editable);
    this.fWGeofencingIn = decodeBoolean(json.fWGeofencingIn);
    this.fWGeofencingOut = decodeBoolean(json.fWGeofencingOut);
    this.familyId = decodeMetaId(json.familyId);
    this.geofencingActive = decodeBoolean(json.geofencingActive);
    this.isTemporary = decodeboolean(json.isTemporary);
    this.mapURI = decodeString(json.mapURI);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.placeId = decodeMetaId(json.placeId);
    this.placeType = decodeEnum(json.placeType);
    this.text = decodeString(json.text);
    this.wifiMAC = decodeString(json.wifiMAC);
    this.wifiSSID = decodeString(json.wifiSSID);
    this.onDecode(json);
  }
}

function decodePlaceBean(json: PlaceBeanJSON | undefined): PlaceBean | undefined {
  return json === undefined ? undefined : new PlaceBean(json);
}

function encodePlaceBean(obj: PlaceBean | null): PlaceBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    address: encodeGeocodedAddress(obj.address),
    contactId: encodeMetaId(obj.contactId),
    editable: encodeBoolean(obj.editable),
    fWGeofencingIn: encodeBoolean(obj.fWGeofencingIn),
    fWGeofencingOut: encodeBoolean(obj.fWGeofencingOut),
    familyId: encodeMetaId(obj.familyId),
    geofencingActive: encodeBoolean(obj.geofencingActive),
    isTemporary: encodeboolean(obj.isTemporary),
    mapURI: encodeString(obj.mapURI),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    placeId: encodeMetaId(obj.placeId),
    placeType: encodeEnum(obj.placeType),
    text: encodeString(obj.text),
    wifiMAC: encodeString(obj.wifiMAC),
    wifiSSID: encodeString(obj.wifiSSID)
  } as PlaceBeanJSON);
}

type PlaceGeofencingBeanJSON = {
  familyId: string;
  geolocSharing?: GeolocSharingEnum;
  in: string;
  metaId?: string;
  out: string;
  place?: IPlaceJSON;
  placeId: string;
  publisherId: string;
  rightFlag: PremiumRightFlagEnum;
  subscriberId: string;
};

export class PlaceGeofencingBean extends ServerBeanPrototype {
  /** @param familyId the familyId to set */
  familyId!: string;
  /** @param geolocSharing the geolocSharing to set */
  geolocSharing?: GeolocSharingEnum;
  /** @param in the in to set */
  in!: boolean;
  /** @param metaId the metaId to set */
  metaId?: string;
  /** @param out the out to set */
  out!: boolean;
  /** @param place the place to set */
  place?: IPlace;
  /** @param placeId the placeId to set */
  placeId!: string;
  /** @param publisherId the publisherId to set */
  publisherId!: number;
  /** @param rightFlag the rightFlag to set */
  rightFlag!: PremiumRightFlagEnum;
  /** @param subscriberId the subscriberId to set */
  subscriberId!: number;

  constructor(json: PlaceGeofencingBeanJSON) {
    super(json);
    this.familyId = decodeMetaId(json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.in = decodeboolean(json.in);
    this.metaId = decodeMetaId(json.metaId);
    this.out = decodeboolean(json.out);
    this.place = decodeIPlace(json.place);
    this.placeId = decodeMetaId(json.placeId);
    this.publisherId = decodeNumber(json.publisherId);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.subscriberId = decodeNumber(json.subscriberId);
    this.onDecode(json);
  }
}

function decodePlaceGeofencingBean(json: PlaceGeofencingBeanJSON | undefined): PlaceGeofencingBean | undefined {
  return json === undefined ? undefined : new PlaceGeofencingBean(json);
}

function encodePlaceGeofencingBean(obj: PlaceGeofencingBean | null): PlaceGeofencingBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    familyId: encodeMetaId(obj.familyId),
    geolocSharing: encodeEnum(obj.geolocSharing),
    in: encodeboolean(obj.in),
    metaId: encodeMetaId(obj.metaId),
    out: encodeboolean(obj.out),
    place: encodeIPlace(obj.place),
    placeId: encodeMetaId(obj.placeId),
    publisherId: encodeNumber(obj.publisherId),
    rightFlag: encodeEnum(obj.rightFlag),
    subscriberId: encodeNumber(obj.subscriberId)
  } as PlaceGeofencingBeanJSON);
}

type PlaceNearbyResultJSON = {
  nearbyPlaces: Array<IPlaceJSON>;
  otherPlaces: Array<IPlaceJSON>;
};

export class PlaceNearbyResult extends ServerBeanPrototype {
  /** Place nearby the wanted position sorted by distance
 
 @param nearbyPlaces */
  nearbyPlaces!: Array<IPlace>;
  /** Other places sorted by name
 
 @param otherPlaces */
  otherPlaces!: Array<IPlace>;

  constructor(json: PlaceNearbyResultJSON) {
    super(json);
    this.nearbyPlaces = decodeArray(decodeIPlace)(json.nearbyPlaces);
    this.otherPlaces = decodeArray(decodeIPlace)(json.otherPlaces);
    this.onDecode(json);
  }
}

function decodePlaceNearbyResult(json: PlaceNearbyResultJSON | undefined): PlaceNearbyResult | undefined {
  return json === undefined ? undefined : new PlaceNearbyResult(json);
}

function encodePlaceNearbyResult(obj: PlaceNearbyResult | null): PlaceNearbyResultJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    nearbyPlaces: encodeArray(encodeIPlace)(obj.nearbyPlaces),
    otherPlaces: encodeArray(encodeIPlace)(obj.otherPlaces)
  } as PlaceNearbyResultJSON);
}

type PlaceSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<IPlaceJSON>;
};

export class PlaceSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<IPlace>;

  constructor(json: PlaceSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeIPlace)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodePlaceSyncBean(json: PlaceSyncBeanJSON | undefined): PlaceSyncBean | undefined {
  return json === undefined ? undefined : new PlaceSyncBean(json);
}

function encodePlaceSyncBean(obj: PlaceSyncBean | null): PlaceSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeIPlace)(obj.updatedCreated)
  } as PlaceSyncBeanJSON);
}

type PremiumPopupBeanJSON = {
  androidYearlyBasePlanId?: string;
  androidYearlyOfferId?: string;
  androidYearlySku?: string;
  atLaunchResetDate: string;
  content: PremiumPopupConfigurableContentBeanJSON;
  id: string;
  iosYearlyRedeemCode?: string;
  iosYearlySku?: string;
  type: PremiumPopupTypeEnum;
};

export class PremiumPopupBean extends ServerBeanPrototype {
  /** the id of the offer that contains the promotion in the yearly subscription sku<br>
 if null the promotion is using the default plan.
 @param androidYearlyBasePlanId the id of the plan */
  androidYearlyBasePlanId?: string;
  /** the id of the offer that contains the promotion in the yearly subscription sku<br>
 if null the promotion is using the base plan.
 @param androidYearlyOfferId the offerId (as returned by SubscriptionOfferDetails.getOfferId() */
  androidYearlyOfferId?: string;
  /** the sku that contains the promotion for android yearly subscription<br>
 if null this is no yearly promotion for android.<br>
 @param androidYearlySku the yearly sky that contains the android promotion */
  androidYearlySku?: string;
  /** The date after which the clients shall reset the flag to display the popup at launch.<ul>
 <li>The client shall store a date (in a persistent pref or somewhere) when he has displayed the popup at launch.</li>
 <li>If the date is stored in the said pref (ie pref!=null), the popup shall not be displayed at launch</li>
 <li>If the date stored in the pref is older that the date sent here by the server, remove the date from the pref and display the popup at launch </li>
 </ul>
 @param atLaunchResetDate the date */
  atLaunchResetDate!: Date;
  /** The server-defined content for the popup (text, resources, etc)
 @param content the content */
  content!: PremiumPopupConfigurableContentBean;
  /** an internal identifier of the promotion, may be sued for tracking purposes, for instance */
  id!: string;
  /** the redeem code that can apply to the yearly ios premium sku as returned by the getfreesku method<br>
 if null there is no code, but if there is a yearly sku, there is still a promotion
 @param iosYearlyRedeemCode the value of the yearly redeem code */
  iosYearlyRedeemCode?: string;
  /** the sku that is used for the promotion, with the redeem code. Not necessary the same as in the getfreesku api, but possibly.<br>
 if null there is no yearly promotion for ios, but if there is a yearly promo code, this is never null.
 @param iosYearlySku the yearly promotion sku */
  iosYearlySku?: string;
  /** The type of promotion that is offered. The different possible values are:<ul>
     <li>PROMO_YEARLY_50 : a back to school promotion with a 50 percent discount on the yearly subscription</li>
 </ul>
 @param type the enum PremiumPopupTypeEnum */
  type!: PremiumPopupTypeEnum;

  constructor(json: PremiumPopupBeanJSON) {
    super(json);
    this.androidYearlyBasePlanId = decodeString(json.androidYearlyBasePlanId);
    this.androidYearlyOfferId = decodeString(json.androidYearlyOfferId);
    this.androidYearlySku = decodeString(json.androidYearlySku);
    this.atLaunchResetDate = decodeDate(json.atLaunchResetDate);
    this.content = decodePremiumPopupConfigurableContentBean(json.content);
    this.id = decodeString(json.id);
    this.iosYearlyRedeemCode = decodeString(json.iosYearlyRedeemCode);
    this.iosYearlySku = decodeString(json.iosYearlySku);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodePremiumPopupBean(json: PremiumPopupBeanJSON | undefined): PremiumPopupBean | undefined {
  return json === undefined ? undefined : new PremiumPopupBean(json);
}

function encodePremiumPopupBean(obj: PremiumPopupBean | null): PremiumPopupBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    androidYearlyBasePlanId: encodeString(obj.androidYearlyBasePlanId),
    androidYearlyOfferId: encodeString(obj.androidYearlyOfferId),
    androidYearlySku: encodeString(obj.androidYearlySku),
    atLaunchResetDate: encodeDate(obj.atLaunchResetDate),
    content: encodePremiumPopupConfigurableContentBean(obj.content),
    id: encodeString(obj.id),
    iosYearlyRedeemCode: encodeString(obj.iosYearlyRedeemCode),
    iosYearlySku: encodeString(obj.iosYearlySku),
    type: encodeEnum(obj.type)
  } as PremiumPopupBeanJSON);
}

type PremiumPopupConfigurableContentBeanJSON = {
  bannerCover: CoverUriPhoneAndTabletBeanJSON;
  bannerText: string;
  bannerTitle: string;
  buttonText: string;
  colorAccent: string;
  countdownDate?: string;
  cover: CoverUriPhoneAndTabletBeanJSON;
  description: string;
  tagText: string;
  title: string;
};

export class PremiumPopupConfigurableContentBean extends ServerBeanPrototype {
  /** The cover URL for the banner
 @param bannerCover banner cover url */
  bannerCover!: CoverUriPhoneAndTabletBean;
  /** the body text in the banner
 @param bannerText banner body text */
  bannerText!: string;
  /** the title in the banner
 @param bannerTitle the banner title */
  bannerTitle!: string;
  /** The 'button' text.
 @param buttonText The 'button' text. */
  buttonText!: string;
  /** The color of the "highlighted" text in both mode, format #rrggbb.
 Highlighted texts is marked by a special character in the texts : [[ and ]]
 @param colorAccent the color */
  colorAccent!: string;
  /** The date to compute the countdown. May be null if the tag does not contain the countdown.
 If not null, this is used do display a countdown until this date
 @param tagDate the end-date of the count-down */
  countdownDate?: Date;
  /** The uri of the cover of the popup */
  cover!: CoverUriPhoneAndTabletBean;
  /** the 'description' text (part of highlighted text are in [[ ]]).<br>
 {price} shall be replaced by the price of the offer, and {{precentReduc}} shall be replaced by the percentage of reduction (ie 59 or 47 etc)
 all depending on the real store's price.
 @param description the 'description'  text */
  description!: string;
  /** The 'tag' text.
 @param tagText the 'tag' text */
  tagText!: string;
  /** the 'title' text (part of highlighted text are in [[ ]]).<br>
 {price} shall be replaced by the price of the offer, and {{precentReduc}} shall be replaced by the percentage of reduction (ie 59 or 47 etc)
 all depending on the real store's price.
 @param title the 'title' text */
  title!: string;

  constructor(json: PremiumPopupConfigurableContentBeanJSON) {
    super(json);
    this.bannerCover = decodeCoverUriPhoneAndTabletBean(json.bannerCover);
    this.bannerText = decodeString(json.bannerText);
    this.bannerTitle = decodeString(json.bannerTitle);
    this.buttonText = decodeString(json.buttonText);
    this.colorAccent = decodeString(json.colorAccent);
    this.countdownDate = decodeDate(json.countdownDate);
    this.cover = decodeCoverUriPhoneAndTabletBean(json.cover);
    this.description = decodeString(json.description);
    this.tagText = decodeString(json.tagText);
    this.title = decodeString(json.title);
    this.onDecode(json);
  }
}

function decodePremiumPopupConfigurableContentBean(json: PremiumPopupConfigurableContentBeanJSON | undefined): PremiumPopupConfigurableContentBean | undefined {
  return json === undefined ? undefined : new PremiumPopupConfigurableContentBean(json);
}

function encodePremiumPopupConfigurableContentBean(obj: PremiumPopupConfigurableContentBean | null): PremiumPopupConfigurableContentBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    bannerCover: encodeCoverUriPhoneAndTabletBean(obj.bannerCover),
    bannerText: encodeString(obj.bannerText),
    bannerTitle: encodeString(obj.bannerTitle),
    buttonText: encodeString(obj.buttonText),
    colorAccent: encodeString(obj.colorAccent),
    countdownDate: encodeDate(obj.countdownDate),
    cover: encodeCoverUriPhoneAndTabletBean(obj.cover),
    description: encodeString(obj.description),
    tagText: encodeString(obj.tagText),
    title: encodeString(obj.title)
  } as PremiumPopupConfigurableContentBeanJSON);
}

type PremiumRightBeanJSON = {
  accountIdOfPremiumProvider?: string;
  aiImport: PremiumRightFlagEnum;
  audio: string;
  budget: PremiumRightFlagEnum;
  canAcceptInvitation?: PremiumRightFlagEnum;
  canActivatePanicButton?: PremiumRightFlagEnum;
  canCreatePlace: PremiumRightFlagEnum;
  canFoundFamily: PremiumRightFlagEnum;
  canInvite: PremiumRightFlagEnum;
  canLinkCalendarByUrl: PremiumRightFlagEnum;
  canLinkGoogleCalendar: PremiumRightFlagEnum;
  canLinkOutlookCalendar: PremiumRightFlagEnum;
  canLinkiOSCalendar: PremiumRightFlagEnum;
  creditIds: Array<string>;
  fWPremiumMemberSubscriber: string;
  fWPremiumPopup: string;
  familyQuota: string;
  filer: PremiumRightFlagEnum;
  geoFencingActivated?: string;
  geoLocAutotrackActivated?: string;
  geoLocAvailable: string;
  hideSmartCard: PremiumRightFlagEnum;
  listPinable: PremiumRightFlagEnum;
  listSystemDeletable: PremiumRightFlagEnum;
  mealPlannerFlag: PremiumRightFlagEnum;
  nameOfPremiumProvider?: string;
  orangePremiumPopup: string;
  orangePremiumPopupType?: OrangeOptionsEnum;
  photoHD: string;
  premiumIntroPopupTypeOfPeriod?: CreditTypeOfPeriodEnum;
  recipeBoxFlag: PremiumRightFlagEnum;
  recipeCustomCategoriesFlag: PremiumRightFlagEnum;
  recipeExportToShoppingListFlag: PremiumRightFlagEnum;
  recipePlanInMealPlanner: PremiumRightFlagEnum;
  recurringTask: PremiumRightFlagEnum;
  specialDays: PremiumRightFlagEnum;
  technicalLimiFamilies: string;
  technicalLimitEvent: string;
  technicalLimitMembers: string;
  technicalLimitTask: string;
  technicalLimitTaskCategory: string;
  technicalLimitTaskList: string;
  timetable: PremiumRightFlagEnum;
  videoAvailable: string;
  yourCreditId?: string;
};

export class PremiumRightBean extends ServerBeanPrototype {
  /** for family-scoped premium only (familywall/sprint/orange/movistar premium packages), indicate the id of the account that gives the premium to this family.
 priority is given to the currently logged account.
 @param accountIdOfPremiumProvider the accountIdOfPremiumProvider to set */
  accountIdOfPremiumProvider?: number;
  /** Flag indicating the access to the aiImport feature
 @param the featureflag */
  aiImport!: PremiumRightFlagEnum;
  /** flag indicating if audio messages and wallmessage are available.
 this is a family-scoped flags, ie if one member brings this capability in one family everybody in that family has this capability
 @param audio the audio to set */
  audio!: boolean;
  /** @param budget the budget to set */
  budget!: PremiumRightFlagEnum;
  /** flag indicating if you can accept an invitation
 @param canAcceptInvitation the canAcceptInvitation to set flag indicating if you can accept an invitation */
  canAcceptInvitation?: PremiumRightFlagEnum;
  /** flag indicating if you can call help other members of the family with the panic button feature
 prototype feature only.
 @param canActivatePanicButton the canActivatePanicButton to set flag indicating if you can call help other members of the family with the panic button feature */
  canActivatePanicButton?: PremiumRightFlagEnum;
  /** true is the account can create a place in this family
 @param canCreatePlace the canCreatePlace to set */
  canCreatePlace!: PremiumRightFlagEnum;
  /** true is the account can create another family
 @param canFoundFamily the canFoundFamily to set */
  canFoundFamily!: PremiumRightFlagEnum;
  /** true is the account can invite somebody in this family
 @param canInvite the canInvite to set */
  canInvite!: PremiumRightFlagEnum;
  /** The flag indicating if the user can import external calendar  by url into the app.
 @param canLinkCalendarByUrl the canLinkCalendarByUrl to set */
  canLinkCalendarByUrl!: PremiumRightFlagEnum;
  /** The flag indicating if the user can import external google calendar into the app.
 @param canLinkGoogleCalendar the canLinkGoogleCalendar to set */
  canLinkGoogleCalendar!: PremiumRightFlagEnum;
  /** The flag indicating if the user can import external outlook.com calendar into the app.
 @param canLinkOutlookCalendar the canLinkOutlookCalendar to set */
  canLinkOutlookCalendar!: PremiumRightFlagEnum;
  /** indicate that you can import your native ios calendar into familywall locally with the native app
 @param canLinkiOSCalendar the canLinkiOSCalendar to set */
  canLinkiOSCalendar!: PremiumRightFlagEnum;
  /** @param creditIds the creditIds to set */
  creditIds!: Array<string>;
  /** return true if the currently logged account has subscribed to a premium (ie familywall premium, sprint premium, orange premium, movistar premium, etc)
 and it is active in the current family !
 @param isFWPremiumMemberSubscriber the isFWPremiumMemberSubscriber to set */
  fWPremiumMemberSubscriber!: boolean;
  /** True if the familywall premium is active. It is family-scoped (ie if one person brings the premium to a family everybody in that family benefit from it)
 This is generic flag set for all premium except for the orange premium (which has his own specific flag orangePremiumPopup)
 @param isFWPremiumPopup the isFWPremiumPopup to set */
  fWPremiumPopup!: boolean;
  /** Set the base with this value and the bonus to zero. (this is of course family-scoped)
 @param familyQuota the familyQuota to set */
  familyQuota!: number;
  /** @param filer the filer to set */
  filer!: PremiumRightFlagEnum;
  /** return true if the geofencing engine shall be started on the client, ie at least one family of this account has a geolocSharing preference set to PLACE_ONLY or ALWAYS
 (ie at least one of the member in the family is in PLACE_ONLY or ALWAYS in LOCATION_AUTHORIZATION or everybody is in PLACE_ONLY in compat. mode)
 @param geoFencingActivated the geoFencingActivated to set */
  geoFencingActivated?: boolean;
  /** return true if the autotracking engine shall be started on the client, ie at least one family of this account has a geolocSharing preference set to ALWAYS
 (ie maybe at least one of the member in the family is in PLACE_ONLY or ALWAYS in LOCATION_AUTHORIZATION)
 @param geoLocAutotrackActivated the geoLocAutotrackActivated to set */
  geoLocAutotrackActivated?: boolean;
  /** geolocation and geofencing available in premium true/false. This indicate if the localization menu ("always/place-only/never" for instance) appear, not if you actually CAN 
 geolocalize somebody. (this is in location api)
 this is a family-scoped flags, ie if one member brings this capability in one family everybody in that family has this capability
 @param isGeoLocAvailable */
  geoLocAvailable!: boolean;
  /** Flag indicating the access of the the show/hide smartcard feature, comprising the show/hide did you know / tips too
 @param hideSmartCard the featureflag show / hide smartcard */
  hideSmartCard!: PremiumRightFlagEnum;
  /** list pin premium flag
 @param listPinable premium flag */
  listPinable!: PremiumRightFlagEnum;
  /** system list deletable premium flag
 @param listSystemDeletable premium flag */
  listSystemDeletable!: PremiumRightFlagEnum;
  /** the flag indicate the flag for accessing to mealPlanner, but not the recipe box which is now separate
 @param mealPlannerFlag */
  mealPlannerFlag!: PremiumRightFlagEnum;
  /** for family-scoped premium only (familywall/sprint/orange/movistar premium packages), indicate the name of the account that gives the premium to this family.
 priority is given to the currently logged account.
 @param nameOfPremiumProvider the nameOfPremiumProvider to set */
  nameOfPremiumProvider?: string;
  /** This is the orange-specific version of the premium family flag. This is family-scoped (ie if one person brings the premium to a family everybody in that family benefit from it)
 @param isOrangePremiumPopup the isOrangePremiumPopup to set */
  orangePremiumPopup!: boolean;
  /** if orangePremiumPopup is true, this is not null and indicate the type of orange premium : BUNDLED or SUBSCRIBED 
 @param orangePremiumPopupType the orangePremiumPopupType to set */
  orangePremiumPopupType?: OrangeOptionsEnum;
  /** flag indicating if the photo are NOT resized when received on the server = photoHD
 this is a family-scoped flags, ie if one member brings this capability in one family everybody in that family has this capability
 @param photoHD the photoHD to set */
  photoHD!: boolean;
  /** Flag indicating that a premium intro popup shall be displayed (if the flag is present) of the type (given by the flag value MONTHLY or YEARLY )
 @param premiumIntroPopupTypeOfPeriod the premiumPopupTypeOfPeriod to set */
  premiumIntroPopupTypeOfPeriod?: CreditTypeOfPeriodEnum;
  /** indicate access to the recipe box
 @param recipeBoxFlag the recipeBoxFlag to set */
  recipeBoxFlag!: PremiumRightFlagEnum;
  /** indicate access custom categories, ie to add/remove/edit recipe categories
 @param recipeCustomCategoriesFlag the recipeCustomCategoriesFlag to set */
  recipeCustomCategoriesFlag!: PremiumRightFlagEnum;
  /** indicate access to recipe export to shopping list feature
 @param recipeExportToShoppingListFlag the recipeExportToShoppingListFlag to set */
  recipeExportToShoppingListFlag!: PremiumRightFlagEnum;
  /** indicate access to be able to plan a recipe from the recipebox into the meal planner directly
 @param recipePlanInMealPlanner the recipePlanInMealPlanner to set */
  recipePlanInMealPlanner!: PremiumRightFlagEnum;
  /** allows tasks (or item of lists) to be recurrent, if false only onetime tasks are allowed
 @param recurringTask the recurringTask to set */
  recurringTask!: PremiumRightFlagEnum;
  /** special days premium flag
 @param specialDays special days premium flag */
  specialDays!: PremiumRightFlagEnum;
  /** The technical limit (WHICH IS NOW USED BY ALL OUR PARTNERS TO HAVE THEIR OWN LIMIT so I prefer not to comment on this)<br>
 Of the maximum number of circle for a given account
 @param technicalLimiFamilies the technicalLimiFamilies to set */
  technicalLimiFamilies!: number;
  /** The technical limit<br>
 Of the maximum number of event for a given family
 @param technicalLimitEvent the technicalLimitEvent to set */
  technicalLimitEvent!: number;
  /** The technical limit (WHICH IS NOW USED BY ALL OUR PARTNERS TO HAVE THEIR OWN LIMIT so I prefer not to comment on this)<br>
 Of the maximum number of member in a circle
 @param technicalLimitMembers the technicalLimitMembers to set */
  technicalLimitMembers!: number;
  /** The technical limit of the maximum number of tasks for a given family,
 for all lists
 @param technicalLimitTask the limit as int */
  technicalLimitTask!: number;
  /** the technical limit of the maximum number of task categories for a given family
 @param technicalLimitTaskCategory limit as an int */
  technicalLimitTaskCategory!: number;
  /** The technical limit of the maximum number of lists for a given family
 @param technicalLimitTaskList the limit as int */
  technicalLimitTaskList!: number;
  /** allow access to the timetable feature
 @param timetable the timetable to set */
  timetable!: PremiumRightFlagEnum;
  /** flag indicating if video are avaiable
 this is a family-scoped flags, ie if one member brings this capability in one family everybody in that family has this capability
 @param video the video to set */
  videoAvailable!: boolean;
  /** family-scoped premium id: return the id of one credit that belongs to the currently logged account and give the premium to the family.
 @param yourCreditId the yourCreditId to set */
  yourCreditId?: string;

  constructor(json: PremiumRightBeanJSON) {
    super(json);
    this.accountIdOfPremiumProvider = decodeNumber(json.accountIdOfPremiumProvider);
    this.aiImport = decodeEnum(json.aiImport);
    this.audio = decodeboolean(json.audio);
    this.budget = decodeEnum(json.budget);
    this.canAcceptInvitation = decodeEnum(json.canAcceptInvitation);
    this.canActivatePanicButton = decodeEnum(json.canActivatePanicButton);
    this.canCreatePlace = decodeEnum(json.canCreatePlace);
    this.canFoundFamily = decodeEnum(json.canFoundFamily);
    this.canInvite = decodeEnum(json.canInvite);
    this.canLinkCalendarByUrl = decodeEnum(json.canLinkCalendarByUrl);
    this.canLinkGoogleCalendar = decodeEnum(json.canLinkGoogleCalendar);
    this.canLinkOutlookCalendar = decodeEnum(json.canLinkOutlookCalendar);
    this.canLinkiOSCalendar = decodeEnum(json.canLinkiOSCalendar);
    this.creditIds = decodeArray(decodeMetaId)(json.creditIds);
    this.fWPremiumMemberSubscriber = decodeboolean(json.fWPremiumMemberSubscriber);
    this.fWPremiumPopup = decodeboolean(json.fWPremiumPopup);
    this.familyQuota = decodenumber(json.familyQuota);
    this.filer = decodeEnum(json.filer);
    this.geoFencingActivated = decodeBoolean(json.geoFencingActivated);
    this.geoLocAutotrackActivated = decodeBoolean(json.geoLocAutotrackActivated);
    this.geoLocAvailable = decodeboolean(json.geoLocAvailable);
    this.hideSmartCard = decodeEnum(json.hideSmartCard);
    this.listPinable = decodeEnum(json.listPinable);
    this.listSystemDeletable = decodeEnum(json.listSystemDeletable);
    this.mealPlannerFlag = decodeEnum(json.mealPlannerFlag);
    this.nameOfPremiumProvider = decodeString(json.nameOfPremiumProvider);
    this.orangePremiumPopup = decodeboolean(json.orangePremiumPopup);
    this.orangePremiumPopupType = decodeEnum(json.orangePremiumPopupType);
    this.photoHD = decodeboolean(json.photoHD);
    this.premiumIntroPopupTypeOfPeriod = decodeEnum(json.premiumIntroPopupTypeOfPeriod);
    this.recipeBoxFlag = decodeEnum(json.recipeBoxFlag);
    this.recipeCustomCategoriesFlag = decodeEnum(json.recipeCustomCategoriesFlag);
    this.recipeExportToShoppingListFlag = decodeEnum(json.recipeExportToShoppingListFlag);
    this.recipePlanInMealPlanner = decodeEnum(json.recipePlanInMealPlanner);
    this.recurringTask = decodeEnum(json.recurringTask);
    this.specialDays = decodeEnum(json.specialDays);
    this.technicalLimiFamilies = decodenumber(json.technicalLimiFamilies);
    this.technicalLimitEvent = decodenumber(json.technicalLimitEvent);
    this.technicalLimitMembers = decodenumber(json.technicalLimitMembers);
    this.technicalLimitTask = decodenumber(json.technicalLimitTask);
    this.technicalLimitTaskCategory = decodenumber(json.technicalLimitTaskCategory);
    this.technicalLimitTaskList = decodenumber(json.technicalLimitTaskList);
    this.timetable = decodeEnum(json.timetable);
    this.videoAvailable = decodeboolean(json.videoAvailable);
    this.yourCreditId = decodeMetaId(json.yourCreditId);
    this.onDecode(json);
  }
}

function decodePremiumRightBean(json: PremiumRightBeanJSON | undefined): PremiumRightBean | undefined {
  return json === undefined ? undefined : new PremiumRightBean(json);
}

function encodePremiumRightBean(obj: PremiumRightBean | null): PremiumRightBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountIdOfPremiumProvider: encodeNumber(obj.accountIdOfPremiumProvider),
    aiImport: encodeEnum(obj.aiImport),
    audio: encodeboolean(obj.audio),
    budget: encodeEnum(obj.budget),
    canAcceptInvitation: encodeEnum(obj.canAcceptInvitation),
    canActivatePanicButton: encodeEnum(obj.canActivatePanicButton),
    canCreatePlace: encodeEnum(obj.canCreatePlace),
    canFoundFamily: encodeEnum(obj.canFoundFamily),
    canInvite: encodeEnum(obj.canInvite),
    canLinkCalendarByUrl: encodeEnum(obj.canLinkCalendarByUrl),
    canLinkGoogleCalendar: encodeEnum(obj.canLinkGoogleCalendar),
    canLinkOutlookCalendar: encodeEnum(obj.canLinkOutlookCalendar),
    canLinkiOSCalendar: encodeEnum(obj.canLinkiOSCalendar),
    creditIds: encodeArray(encodeMetaId)(obj.creditIds),
    fWPremiumMemberSubscriber: encodeboolean(obj.fWPremiumMemberSubscriber),
    fWPremiumPopup: encodeboolean(obj.fWPremiumPopup),
    familyQuota: encodenumber(obj.familyQuota),
    filer: encodeEnum(obj.filer),
    geoFencingActivated: encodeBoolean(obj.geoFencingActivated),
    geoLocAutotrackActivated: encodeBoolean(obj.geoLocAutotrackActivated),
    geoLocAvailable: encodeboolean(obj.geoLocAvailable),
    hideSmartCard: encodeEnum(obj.hideSmartCard),
    listPinable: encodeEnum(obj.listPinable),
    listSystemDeletable: encodeEnum(obj.listSystemDeletable),
    mealPlannerFlag: encodeEnum(obj.mealPlannerFlag),
    nameOfPremiumProvider: encodeString(obj.nameOfPremiumProvider),
    orangePremiumPopup: encodeboolean(obj.orangePremiumPopup),
    orangePremiumPopupType: encodeEnum(obj.orangePremiumPopupType),
    photoHD: encodeboolean(obj.photoHD),
    premiumIntroPopupTypeOfPeriod: encodeEnum(obj.premiumIntroPopupTypeOfPeriod),
    recipeBoxFlag: encodeEnum(obj.recipeBoxFlag),
    recipeCustomCategoriesFlag: encodeEnum(obj.recipeCustomCategoriesFlag),
    recipeExportToShoppingListFlag: encodeEnum(obj.recipeExportToShoppingListFlag),
    recipePlanInMealPlanner: encodeEnum(obj.recipePlanInMealPlanner),
    recurringTask: encodeEnum(obj.recurringTask),
    specialDays: encodeEnum(obj.specialDays),
    technicalLimiFamilies: encodenumber(obj.technicalLimiFamilies),
    technicalLimitEvent: encodenumber(obj.technicalLimitEvent),
    technicalLimitMembers: encodenumber(obj.technicalLimitMembers),
    technicalLimitTask: encodenumber(obj.technicalLimitTask),
    technicalLimitTaskCategory: encodenumber(obj.technicalLimitTaskCategory),
    technicalLimitTaskList: encodenumber(obj.technicalLimitTaskList),
    timetable: encodeEnum(obj.timetable),
    videoAvailable: encodeboolean(obj.videoAvailable),
    yourCreditId: encodeMetaId(obj.yourCreditId)
  } as PremiumRightBeanJSON);
}

type ProfileBeanJSON = {
  accountId?: string;
  addresses?: Array<IAddressJSON>;
  birthDate?: string;
  birthDateNoYear?: string;
  color?: string;
  devices?: Array<IDeviceJSON>;
  firstName?: string;
  gender?: GenderEnum;
  isAccountDeleted?: string;
  lastName?: string;
  locale?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  pictureDefault?: string;
  profileFamilyId?: string;
  timeZone?: string;
};

export class ProfileBean extends ServerBeanPrototype {
  accountId?: number;
  addresses?: Array<IAddress>;
  birthDate?: Date;
  birthDateNoYear?: boolean;
  /** @param color the color to set */
  color?: string;
  devices?: Array<IDevice>;
  /** @param firstName the firstName to set */
  firstName?: string;
  gender?: GenderEnum;
  isAccountDeleted?: boolean;
  /** @param lastName the lastName to set */
  lastName?: string;
  locale?: string;
  medias?: Array<IMedia>;
  metaId?: string;
  pictureDefault?: boolean;
  profileFamilyId?: number;
  timeZone?: string;

  constructor(json: ProfileBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = decodeString(json.color);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.firstName = decodeString(json.firstName);
    this.gender = decodeEnum(json.gender);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.lastName = decodeString(json.lastName);
    this.locale = decodeString(json.locale);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.timeZone = decodeTimeZone(json.timeZone);
    this.onDecode(json);
  }
}

function decodeProfileBean(json: ProfileBeanJSON | undefined): ProfileBean | undefined {
  return json === undefined ? undefined : new ProfileBean(json);
}

function encodeProfileBean(obj: ProfileBean | null): ProfileBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    addresses: encodeArray(encodeIAddress)(obj.addresses),
    birthDate: encodeDate(obj.birthDate),
    birthDateNoYear: encodeBoolean(obj.birthDateNoYear),
    color: encodeString(obj.color),
    devices: encodeArray(encodeIDevice)(obj.devices),
    firstName: encodeString(obj.firstName),
    gender: encodeEnum(obj.gender),
    isAccountDeleted: encodeBoolean(obj.isAccountDeleted),
    lastName: encodeString(obj.lastName),
    locale: encodeString(obj.locale),
    metaId: encodeMetaId(obj.metaId),
    pictureDefault: encodeBoolean(obj.pictureDefault),
    profileFamilyId: encodeNumber(obj.profileFamilyId),
    timeZone: encodeTimeZone(obj.timeZone)
  } as ProfileBeanJSON);
}

type ProgrammaticAdsBeanJSON = {
  active: string;
};

export class ProgrammaticAdsBean extends ServerBeanPrototype {
  active!: boolean;

  constructor(json: ProgrammaticAdsBeanJSON) {
    super(json);
    this.active = decodeboolean(json.active);
    this.onDecode(json);
  }
}

function decodeProgrammaticAdsBean(json: ProgrammaticAdsBeanJSON | undefined): ProgrammaticAdsBean | undefined {
  return json === undefined ? undefined : new ProgrammaticAdsBean(json);
}

function encodeProgrammaticAdsBean(obj: ProgrammaticAdsBean | null): ProgrammaticAdsBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    active: encodeboolean(obj.active)
  } as ProgrammaticAdsBeanJSON);
}

type PromoCodeBeanJSON = {
  creationDate: string;
  expirationDate: string;
  lastUsageDate?: string;
  maxUsageNumber: string;
  promoCodeCampaign: IPromoCodeCampaignJSON;
  usageNumber: string;
  value: string;
};

export class PromoCodeBean extends ServerBeanPrototype {
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** @param expirationDate the expirationDate to set */
  expirationDate!: Date;
  /** @param lastUsageDate the lastUsageDate to set */
  lastUsageDate?: Date;
  /** @param maxUsageNumber the maxUsageNumber to set */
  maxUsageNumber!: number;
  /** @param promoCodeCampaign the promoCodeCampaign to set */
  promoCodeCampaign!: IPromoCodeCampaign;
  /** @param usageNumber the usageNumber to set */
  usageNumber!: number;
  /** @param value the value to set */
  value!: string;

  constructor(json: PromoCodeBeanJSON) {
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.expirationDate = decodeDate(json.expirationDate);
    this.lastUsageDate = decodeDate(json.lastUsageDate);
    this.maxUsageNumber = decodenumber(json.maxUsageNumber);
    this.promoCodeCampaign = decodeIPromoCodeCampaign(json.promoCodeCampaign);
    this.usageNumber = decodenumber(json.usageNumber);
    this.value = decodeString(json.value);
    this.onDecode(json);
  }
}

function decodePromoCodeBean(json: PromoCodeBeanJSON | undefined): PromoCodeBean | undefined {
  return json === undefined ? undefined : new PromoCodeBean(json);
}

function encodePromoCodeBean(obj: PromoCodeBean | null): PromoCodeBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    expirationDate: encodeDate(obj.expirationDate),
    maxUsageNumber: encodenumber(obj.maxUsageNumber),
    promoCodeCampaign: encodeIPromoCodeCampaign(obj.promoCodeCampaign),
    value: encodeString(obj.value)
  } as PromoCodeBeanJSON);
}

type PromoCodeCampaignBeanJSON = {
  creationDate: string;
  creditDurationInDays?: string;
  creditType?: CreditTypeEnum;
  name: string;
};

export class PromoCodeCampaignBean extends ServerBeanPrototype {
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** @param creditDurationInDays the creditDurationInDays to set */
  creditDurationInDays?: number;
  /** @param creditType the creditType to set */
  creditType?: CreditTypeEnum;
  /** @param name the name to set */
  name!: string;

  constructor(json: PromoCodeCampaignBeanJSON) {
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.creditDurationInDays = decodeNumber(json.creditDurationInDays);
    this.creditType = decodeEnum(json.creditType);
    this.name = decodeString(json.name);
    this.onDecode(json);
  }
}

function decodePromoCodeCampaignBean(json: PromoCodeCampaignBeanJSON | undefined): PromoCodeCampaignBean | undefined {
  return json === undefined ? undefined : new PromoCodeCampaignBean(json);
}

function encodePromoCodeCampaignBean(obj: PromoCodeCampaignBean | null): PromoCodeCampaignBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    creditDurationInDays: encodeNumber(obj.creditDurationInDays),
    creditType: encodeEnum(obj.creditType),
    name: encodeString(obj.name)
  } as PromoCodeCampaignBeanJSON);
}

type PromoPushBeanJSON = {
  accountId: string;
  creationDate: string;
  promoPushCampaign: IPromoPushCampaignJSON;
  sendDate?: string;
};

export class PromoPushBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId!: number;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** @param promoPushCampaign the promoPushCampaign to set */
  promoPushCampaign!: IPromoPushCampaign;
  /** @param sendDate the sendDate to set */
  sendDate?: Date;

  constructor(json: PromoPushBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationDate = decodeDate(json.creationDate);
    this.promoPushCampaign = decodeIPromoPushCampaign(json.promoPushCampaign);
    this.sendDate = decodeDate(json.sendDate);
    this.onDecode(json);
  }
}

function decodePromoPushBean(json: PromoPushBeanJSON | undefined): PromoPushBean | undefined {
  return json === undefined ? undefined : new PromoPushBean(json);
}

function encodePromoPushBean(obj: PromoPushBean | null): PromoPushBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationDate: encodeDate(obj.creationDate),
    promoPushCampaign: encodeIPromoPushCampaign(obj.promoPushCampaign),
    sendDate: encodeDate(obj.sendDate)
  } as PromoPushBeanJSON);
}

type PromoPushCampaignBeanJSON = {
  active?: string;
  android?: string;
  creationDate: string;
  deeplinkClassId?: string;
  deeplinkClickMaxCount?: string;
  deeplinkPartnerType?: PartnerTypeEnum;
  deeplinkRecycle?: string;
  deeplinkValidationTimeHour?: string;
  deeplinkWebUrl?: string;
  iOS?: string;
  launchpadSection?: SectionEnum;
  name: string;
  promoPartnerType?: PartnerTypeEnum;
  pushJson?: FizJSONObject;
  pushPremiumFeatureHighlight?: string;
  pushScreenTarget?: PromoPushScreenTarget;
  trackingName?: string;
  url?: string;
};

export class PromoPushCampaignBean extends ServerBeanPrototype {
  /** @param active the active to set */
  active?: boolean;
  /** @param isAndroid the isAndroid to set */
  android?: boolean;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** @param deeplinkClassId the deeplinkClassId to set */
  deeplinkClassId?: string;
  /** @param deeplinkClickMaxCount the deeplinkClickMaxCount to set */
  deeplinkClickMaxCount?: number;
  /** @param partnerType the partnerType to set */
  deeplinkPartnerType?: PartnerTypeEnum;
  /** @param deeplinkRecycle the deeplinkRecycle to set */
  deeplinkRecycle?: boolean;
  /** @param deeplinkValidationTimeHour the deeplinkValidationTimeHour to set */
  deeplinkValidationTimeHour?: number;
  /** @param deeplinkWebUrl for deeplink that points exclusively to the web */
  deeplinkWebUrl?: string;
  /** @param isIOS the isIOS to set */
  iOS?: boolean;
  /** @param launchpadSection the launchpadSection to set */
  launchpadSection?: SectionEnum;
  /** @param name the name to set */
  name!: string;
  /** @param promoPartnerType the promoPartnerType to set */
  promoPartnerType?: PartnerTypeEnum;
  /** @param pushJson the json of text by lang */
  pushJson?: JsonFw;
  /** @param pushPremiumFeatureHighlight the pushPremiumFeatureHighlight to set */
  pushPremiumFeatureHighlight?: string;
  /** @param pushScreenTarget the pushScreenTarget to set */
  pushScreenTarget?: PromoPushScreenTarget;
  /** @param trackingName the trackingName to set */
  trackingName?: string;
  /** @param url the url to set */
  url?: string;

  constructor(json: PromoPushCampaignBeanJSON) {
    super(json);
    this.active = decodeBoolean(json.active);
    this.android = decodeBoolean(json.android);
    this.creationDate = decodeDate(json.creationDate);
    this.deeplinkClassId = decodeString(json.deeplinkClassId);
    this.deeplinkClickMaxCount = decodeNumber(json.deeplinkClickMaxCount);
    this.deeplinkPartnerType = decodeEnum(json.deeplinkPartnerType);
    this.deeplinkRecycle = decodeBoolean(json.deeplinkRecycle);
    this.deeplinkValidationTimeHour = decodeNumber(json.deeplinkValidationTimeHour);
    this.deeplinkWebUrl = decodeString(json.deeplinkWebUrl);
    this.iOS = decodeBoolean(json.iOS);
    this.launchpadSection = decodeEnum(json.launchpadSection);
    this.name = decodeString(json.name);
    this.promoPartnerType = decodeEnum(json.promoPartnerType);
    this.pushJson = decodeFizJSONObject(json.pushJson);
    this.pushPremiumFeatureHighlight = decodeString(json.pushPremiumFeatureHighlight);
    this.pushScreenTarget = decodeEnum(json.pushScreenTarget);
    this.trackingName = decodeString(json.trackingName);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodePromoPushCampaignBean(json: PromoPushCampaignBeanJSON | undefined): PromoPushCampaignBean | undefined {
  return json === undefined ? undefined : new PromoPushCampaignBean(json);
}

function encodePromoPushCampaignBean(obj: PromoPushCampaignBean | null): PromoPushCampaignBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    active: encodeBoolean(obj.active),
    android: encodeBoolean(obj.android),
    deeplinkClassId: encodeString(obj.deeplinkClassId),
    deeplinkClickMaxCount: encodeNumber(obj.deeplinkClickMaxCount),
    deeplinkPartnerType: encodeEnum(obj.deeplinkPartnerType),
    deeplinkRecycle: encodeBoolean(obj.deeplinkRecycle),
    deeplinkValidationTimeHour: encodeNumber(obj.deeplinkValidationTimeHour),
    deeplinkWebUrl: encodeString(obj.deeplinkWebUrl),
    iOS: encodeBoolean(obj.iOS),
    launchpadSection: encodeEnum(obj.launchpadSection),
    name: encodeString(obj.name),
    promoPartnerType: encodeEnum(obj.promoPartnerType),
    pushJson: encodeFizJSONObject(obj.pushJson),
    pushPremiumFeatureHighlight: encodeString(obj.pushPremiumFeatureHighlight),
    pushScreenTarget: encodeEnum(obj.pushScreenTarget),
    trackingName: encodeString(obj.trackingName),
    url: encodeString(obj.url)
  } as PromoPushCampaignBeanJSON);
}

type PromoPushCampainDetailBeanJSON = {
  accountNb: string;
  accountSentNb: string;
  accountWithTokenNb: string;
  active?: string;
  android?: string;
  creationDate: string;
  deeplinkClassId?: string;
  deeplinkClickMaxCount?: string;
  deeplinkPartnerType?: PartnerTypeEnum;
  deeplinkRecycle?: string;
  deeplinkValidationTimeHour?: string;
  deeplinkWebUrl?: string;
  iOS?: string;
  launchpadSection?: SectionEnum;
  name: string;
  promoPartnerType?: PartnerTypeEnum;
  pushJson?: FizJSONObject;
  pushPremiumFeatureHighlight?: string;
  pushScreenTarget?: PromoPushScreenTarget;
  trackingName?: string;
  url?: string;
};

export class PromoPushCampainDetailBean extends ServerBeanPrototype {
  /** @param accountNb the accountNb to set */
  accountNb!: number;
  /** @param accountSentNb the accountSentNb to set */
  accountSentNb!: number;
  /** @param accountWithTokenNb the accountWithTokenNb to set */
  accountWithTokenNb!: number;
  /** @param active
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setActive(java.lang.Boolean) */
  active?: boolean;
  /** @param isAndroid
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setAndroid(java.lang.Boolean) */
  android?: boolean;
  /** @param creationDate
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setCreationDate(java.util.Date) */
  creationDate!: Date;
  /** @param deeplinkClassId
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setDeeplinkClassId(java.lang.String) */
  deeplinkClassId?: string;
  /** @param deeplinkClickMaxCount
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setDeeplinkClickMaxCount(java.lang.Integer) */
  deeplinkClickMaxCount?: number;
  /** @param partnerType
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setDeeplinkPartnerType(com.jeronimo.fiz.api.account.PartnerTypeEnum) */
  deeplinkPartnerType?: PartnerTypeEnum;
  /** @param deeplinkRecycle
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setDeeplinkRecycle(java.lang.Boolean) */
  deeplinkRecycle?: boolean;
  /** @param deeplinkValidationTimeHour
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setDeeplinkValidationTimeHour(java.lang.Integer) */
  deeplinkValidationTimeHour?: number;
  deeplinkWebUrl?: string;
  /** @param isIOS
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setIOS(java.lang.Boolean) */
  iOS?: boolean;
  launchpadSection?: SectionEnum;
  /** @param name
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setName(java.lang.String) */
  name!: string;
  /** @param partnerType
 @see com.jeronimo.fiz.api.billing.IPromoPushCampaign#setPromoPartnerType(com.jeronimo.fiz.api.account.PartnerTypeEnum) */
  promoPartnerType?: PartnerTypeEnum;
  pushJson?: JsonFw;
  /** @param pushPremiumFeatureHighlight
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setPushPremiumFeatureHighlight(java.lang.String) */
  pushPremiumFeatureHighlight?: string;
  /** @param pushScreenTarget
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setPushScreenTarget(com.jeronimo.fiz.api.push.PromoPushScreenTarget) */
  pushScreenTarget?: PromoPushScreenTarget;
  /** @param trackingName
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setTrackingName(java.lang.String) */
  trackingName?: string;
  /** @param url
 @see com.jeronimo.fiz.api.billing.PromoPushCampaignBean#setUrl(java.lang.String) */
  url?: string;

  constructor(json: PromoPushCampainDetailBeanJSON) {
    super(json);
    this.accountNb = decodenumber(json.accountNb);
    this.accountSentNb = decodenumber(json.accountSentNb);
    this.accountWithTokenNb = decodenumber(json.accountWithTokenNb);
    this.active = decodeBoolean(json.active);
    this.android = decodeBoolean(json.android);
    this.creationDate = decodeDate(json.creationDate);
    this.deeplinkClassId = decodeString(json.deeplinkClassId);
    this.deeplinkClickMaxCount = decodeNumber(json.deeplinkClickMaxCount);
    this.deeplinkPartnerType = decodeEnum(json.deeplinkPartnerType);
    this.deeplinkRecycle = decodeBoolean(json.deeplinkRecycle);
    this.deeplinkValidationTimeHour = decodeNumber(json.deeplinkValidationTimeHour);
    this.deeplinkWebUrl = decodeString(json.deeplinkWebUrl);
    this.iOS = decodeBoolean(json.iOS);
    this.launchpadSection = decodeEnum(json.launchpadSection);
    this.name = decodeString(json.name);
    this.promoPartnerType = decodeEnum(json.promoPartnerType);
    this.pushJson = decodeFizJSONObject(json.pushJson);
    this.pushPremiumFeatureHighlight = decodeString(json.pushPremiumFeatureHighlight);
    this.pushScreenTarget = decodeEnum(json.pushScreenTarget);
    this.trackingName = decodeString(json.trackingName);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodePromoPushCampainDetailBean(json: PromoPushCampainDetailBeanJSON | undefined): PromoPushCampainDetailBean | undefined {
  return json === undefined ? undefined : new PromoPushCampainDetailBean(json);
}

function encodePromoPushCampainDetailBean(obj: PromoPushCampainDetailBean | null): PromoPushCampainDetailBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountNb: encodenumber(obj.accountNb),
    accountSentNb: encodenumber(obj.accountSentNb),
    accountWithTokenNb: encodenumber(obj.accountWithTokenNb),
    active: encodeBoolean(obj.active),
    android: encodeBoolean(obj.android),
    deeplinkClassId: encodeString(obj.deeplinkClassId),
    deeplinkClickMaxCount: encodeNumber(obj.deeplinkClickMaxCount),
    deeplinkPartnerType: encodeEnum(obj.deeplinkPartnerType),
    deeplinkRecycle: encodeBoolean(obj.deeplinkRecycle),
    deeplinkValidationTimeHour: encodeNumber(obj.deeplinkValidationTimeHour),
    deeplinkWebUrl: encodeString(obj.deeplinkWebUrl),
    iOS: encodeBoolean(obj.iOS),
    launchpadSection: encodeEnum(obj.launchpadSection),
    name: encodeString(obj.name),
    promoPartnerType: encodeEnum(obj.promoPartnerType),
    pushJson: encodeFizJSONObject(obj.pushJson),
    pushPremiumFeatureHighlight: encodeString(obj.pushPremiumFeatureHighlight),
    pushScreenTarget: encodeEnum(obj.pushScreenTarget),
    trackingName: encodeString(obj.trackingName),
    url: encodeString(obj.url)
  } as PromoPushCampainDetailBeanJSON);
}

type PromoPushExtraPayloadJSON = {
  ct?: string;
  sec?: SectionEnum;
  ta?: PromoPushScreenTarget;
  url?: string;
};

export class PromoPushExtraPayload extends ServerBeanPrototype {
  /** @param campaignTrackingName the campaignTrackingName to set */
  ct?: string;
  /** @param launchpadSection the launchpadSection to set */
  sec?: SectionEnum;
  /** @param target the target to set */
  ta?: PromoPushScreenTarget;
  /** @param url the url to set */
  url?: string;

  constructor(json: PromoPushExtraPayloadJSON) {
    super(json);
    this.ct = decodeString(json.ct);
    this.sec = decodeEnum(json.sec);
    this.ta = decodeEnum(json.ta);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodePromoPushExtraPayload(json: PromoPushExtraPayloadJSON | undefined): PromoPushExtraPayload | undefined {
  return json === undefined ? undefined : new PromoPushExtraPayload(json);
}

function encodePromoPushExtraPayload(obj: PromoPushExtraPayload | null): PromoPushExtraPayloadJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    ct: encodeString(obj.ct),
    sec: encodeEnum(obj.sec),
    ta: encodeEnum(obj.ta),
    url: encodeString(obj.url)
  } as PromoPushExtraPayloadJSON);
}

type PushMessageBeanJSON = {
  accountId?: string;
  authorIcon?: string;
  deviceId: string;
  extraInfo?: string;
  extraJson?: string;
  familyId?: string;
  image?: string;
  message: string;
  messageType: PushTypeEnum;
  metaId?: string;
  shadowMessageType?: PushTypeEnum;
  subtitle?: string;
  targetId?: string;
  title?: string;
} & GeocodedAddressJSON;

export class PushMessageBean extends ServerBeanPrototype {
  /** id of the account that triggered the push */
  accountId?: number;
  /** URL of the author of this push (to be displayed in the notification) */
  authorIcon?: string;
  /** the id of the device set in api devicesetconfig
 @param deviceId the deviceId to set */
  deviceId!: string;
  /** the extraInfo: other payload depending on the type of the message, for instance for new_comment push this is the id of the comment */
  extraInfo?: string;
  extraJson?: string;
  /** the familyId the push shall be assigned to
 @param familyId the familyId to set */
  familyId?: string;
  /** set the address associated for push that need it
 @param geocodedAddress */
  geocodedAddress?: GeocodedAddress;
  /** image this is the optional url to the image corresponding to "targetId" (to be displayed in the notification) */
  image?: string;
  /** the humain-readable message that can be displayed to the user without further processing the notification
 @param message the message to set */
  message!: string;
  /** the type of notification, or the type of object to be notified about. For instance, message, checkin, checkin-comment, etc...
 @param messageType the messageType to set */
  messageType!: PushTypeEnum;
  /** @param metaId the metaId to set */
  metaId?: string;
  /** In case of a PersistentPushWakeUp, this contains the type of message that can be displayed if no information from the server can be retrieved.<br>
 @param shadowMessageType the shadowMessageType to set */
  shadowMessageType?: PushTypeEnum;
  subtitle?: string;
  /** The if of the object to be notified about (ie for instance the threadid of the message thread being updated,
 or the checkin-id (if of the checkin)
 @param targetId the targetId to set */
  targetId?: string;
  /** @param title the title to set */
  title?: string;

  constructor(json: PushMessageBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.authorIcon = decodeString(json.authorIcon);
    this.deviceId = decodeString(json.deviceId);
    this.extraInfo = decodeString(json.extraInfo);
    this.extraJson = decodeString(json.extraJson);
    this.familyId = decodeMetaId(json.familyId);
    this.image = decodeString(json.image);
    this.message = decodeString(json.message);
    this.messageType = decodeEnum(json.messageType);
    this.metaId = decodeMetaId(json.metaId);
    this.shadowMessageType = decodeEnum(json.shadowMessageType);
    this.subtitle = decodeString(json.subtitle);
    this.targetId = decodeMetaId(json.targetId);
    this.title = decodeString(json.title);
    this.geocodedAddress = decodeGeocodedAddress(json);
    this.onDecode(json);
  }
}

function decodePushMessageBean(json: PushMessageBeanJSON | undefined): PushMessageBean | undefined {
  return json === undefined ? undefined : new PushMessageBean(json);
}

function encodePushMessageBean(obj: PushMessageBean | null): PushMessageBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    authorIcon: encodeString(obj.authorIcon),
    deviceId: encodeString(obj.deviceId),
    extraInfo: encodeString(obj.extraInfo),
    extraJson: encodeString(obj.extraJson),
    familyId: encodeMetaId(obj.familyId),
    image: encodeString(obj.image),
    message: encodeString(obj.message),
    messageType: encodeEnum(obj.messageType),
    metaId: encodeMetaId(obj.metaId),
    shadowMessageType: encodeEnum(obj.shadowMessageType),
    subtitle: encodeString(obj.subtitle),
    targetId: encodeMetaId(obj.targetId),
    title: encodeString(obj.title)
  } as PushMessageBeanJSON, encodeGeocodedAddress(obj.geocodedAddress));
}

type RecipeBeanJSON = {
  accountId: string;
  bestMoment: string;
  cookTime?: string;
  creationDate: string;
  description?: string;
  externalId?: string;
  familyId?: string;
  ingredients?: string;
  ingredientsList?: Array<RecipeIngredientBeanJSON>;
  instructions?: string;
  isFavorite: string;
  isMealSuggestion?: string;
  isRecipe?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  moodMap: {[key:string]:Array<MoodEnum>};
  moodStarShortcut: string;
  name?: string;
  prepTime?: string;
  recipeCategories?: Array<string>;
  recipeCategoryIdList?: Array<string>;
  rights?: FizRightBeanJSON;
  serves?: string;
  sortingIndex?: string;
  url?: string;
};

export class RecipeBean extends ServerBeanPrototype {
  accountId!: number;
  bestMoment!: boolean;
  cookTime?: number;
  creationDate!: Date;
  description?: string;
  externalId?: string;
  familyId?: string;
  ingredients?: string;
  ingredientsList?: Array<RecipeIngredientBean>;
  instructions?: string;
  isFavorite!: boolean;
  isMealSuggestion?: boolean;
  isRecipe?: boolean;
  medias?: Array<IMedia>;
  metaId?: string;
  moodMap!: Map<number, Array<MoodEnum>>;
  moodStarShortcut!: boolean;
  name?: string;
  prepTime?: number;
  recipeCategories?: Array<string>;
  recipeCategoryIdList?: Array<string>;
  rights?: FizRightBean;
  serves?: number;
  sortingIndex?: number;
  url?: string;

  constructor(json: RecipeBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.cookTime = decodeNumber(json.cookTime);
    this.creationDate = decodeDate(json.creationDate);
    this.description = decodeString(json.description);
    this.externalId = decodeMetaId(json.externalId);
    this.familyId = decodeMetaId(json.familyId);
    this.ingredients = decodeString(json.ingredients);
    this.ingredientsList = decodeArray(decodeRecipeIngredientBean)(json.ingredientsList);
    this.instructions = decodeString(json.instructions);
    this.isFavorite = decodeboolean(json.isFavorite);
    this.isMealSuggestion = decodeBoolean(json.isMealSuggestion);
    this.isRecipe = decodeBoolean(json.isRecipe);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.name = decodeString(json.name);
    this.prepTime = decodeNumber(json.prepTime);
    this.recipeCategories = decodeArray(decodeString)(json.recipeCategories);
    this.recipeCategoryIdList = decodeArray(decodeMetaId)(json.recipeCategoryIdList);
    this.rights = decodeFizRightBean(json.rights);
    this.serves = decodeNumber(json.serves);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodeRecipeBean(json: RecipeBeanJSON | undefined): RecipeBean | undefined {
  return json === undefined ? undefined : new RecipeBean(json);
}

function encodeRecipeBean(obj: RecipeBean | null): RecipeBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    bestMoment: encodeBoolean(obj.bestMoment),
    cookTime: encodeNumber(obj.cookTime),
    creationDate: encodeDate(obj.creationDate),
    description: encodeString(obj.description),
    familyId: encodeMetaId(obj.familyId),
    ingredients: encodeString(obj.ingredients),
    ingredientsList: encodeArray(encodeRecipeIngredientBean)(obj.ingredientsList),
    instructions: encodeString(obj.instructions),
    isFavorite: encodeboolean(obj.isFavorite),
    isMealSuggestion: encodeBoolean(obj.isMealSuggestion),
    isRecipe: encodeBoolean(obj.isRecipe),
    metaId: encodeMetaId(obj.metaId),
    moodMap: encodeMap(encodeNumber,encodeArray(encodeEnum))(obj.moodMap),
    moodStarShortcut: encodeBoolean(obj.moodStarShortcut),
    name: encodeString(obj.name),
    prepTime: encodeNumber(obj.prepTime),
    recipeCategories: encodeArray(encodeString)(obj.recipeCategories),
    recipeCategoryIdList: encodeArray(encodeMetaId)(obj.recipeCategoryIdList),
    serves: encodeNumber(obj.serves),
    sortingIndex: encodeNumber(obj.sortingIndex),
    url: encodeString(obj.url)
  } as RecipeBeanJSON);
}

type RecipeExternalBeanJSON = {
  cookTime?: string;
  description?: string;
  displaySectionList?: Array<RecipeExternalDisplaySectionEnum>;
  images: Array<OpenGraphMediaJSON>;
  ingredients?: string;
  ingredientsList?: Array<RecipeIngredientBeanJSON>;
  instructions?: string;
  isMealSuggestion?: string;
  isRecipe?: string;
  listId?: string;
  metaId?: string;
  name?: string;
  prepTime?: string;
  recipeCategories?: Array<string>;
  recipeCategoryIdList?: Array<string>;
  serves?: string;
  sortingIndex?: string;
  url?: string;
};

export class RecipeExternalBean extends ServerBeanPrototype {
  /** Cook time in minutes
 @param cookTime */
  cookTime?: number;
  /** the description of the recipe
 @param description */
  description?: string;
  displaySectionList?: Array<RecipeExternalDisplaySectionEnum>;
  /** images as list of OG beans 
 @param images */
  images!: Array<OpenGraphMedia>;
  /** the ingredients as a big textarea, separated by CR/CRLF
 @param ingredients */
  ingredients?: string;
  /** the ingredients as a list of beans
 @param ingredientsList the ingredientsList to set */
  ingredientsList?: Array<RecipeIngredientBean>;
  /** the step-by-step instructions
 @param instructions */
  instructions?: string;
  /** Flag to indicate if this MealRecipe shall be displayed in the mealplanner, as a suggestion for new meals.<br>
 If true or null, this item will be displayed, else it won't. <br>
 NOTE: even if this flag is false, associated meals in the mealplanner (already planner) shall be displayed.
 @param isMealSuggestion the isMealSuggestion to set */
  isMealSuggestion?: boolean;
  /** Flag to indicate if this MealRecipe shall be displayed in the recipebox.<br>
 If true or null, this item will be displayed in the recipebox, else it won't.
 @param isRecipe the isRecipe to set */
  isRecipe?: boolean;
  /** listId from where the suggestion comes from
 @param listId */
  listId?: string;
  /** the metaId of the recipe
 @param metaId */
  metaId?: string;
  /** the name of the recipe (ie salad, burger, ..)
 @param name */
  name?: string;
  /** preparation time in minute
 @param prepTime */
  prepTime?: number;
  /** the recipe's categories
 @param recipeCategories the recipeCategories to set */
  recipeCategories?: Array<string>;
  recipeCategoryIdList?: Array<string>;
  /** number fo serves
 @param serves */
  serves?: number;
  /** Clients must sort by this field descending (and by text in case of equality)
 @param sortingIndex */
  sortingIndex?: number;
  url?: string;

  constructor(json: RecipeExternalBeanJSON) {
    super(json);
    this.cookTime = decodeNumber(json.cookTime);
    this.description = decodeString(json.description);
    this.displaySectionList = decodeArray(decodeEnum)(json.displaySectionList);
    this.images = decodeArray(decodeOpenGraphMedia)(json.images);
    this.ingredients = decodeString(json.ingredients);
    this.ingredientsList = decodeArray(decodeRecipeIngredientBean)(json.ingredientsList);
    this.instructions = decodeString(json.instructions);
    this.isMealSuggestion = decodeBoolean(json.isMealSuggestion);
    this.isRecipe = decodeBoolean(json.isRecipe);
    this.listId = decodeMetaId(json.listId);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.prepTime = decodeNumber(json.prepTime);
    this.recipeCategories = decodeArray(decodeString)(json.recipeCategories);
    this.recipeCategoryIdList = decodeArray(decodeMetaId)(json.recipeCategoryIdList);
    this.serves = decodeNumber(json.serves);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodeRecipeExternalBean(json: RecipeExternalBeanJSON | undefined): RecipeExternalBean | undefined {
  return json === undefined ? undefined : new RecipeExternalBean(json);
}

function encodeRecipeExternalBean(obj: RecipeExternalBean | null): RecipeExternalBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    cookTime: encodeNumber(obj.cookTime),
    description: encodeString(obj.description),
    images: encodeArray(encodeOpenGraphMedia)(obj.images),
    ingredients: encodeString(obj.ingredients),
    ingredientsList: encodeArray(encodeRecipeIngredientBean)(obj.ingredientsList),
    instructions: encodeString(obj.instructions),
    isMealSuggestion: encodeBoolean(obj.isMealSuggestion),
    isRecipe: encodeBoolean(obj.isRecipe),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    prepTime: encodeNumber(obj.prepTime),
    recipeCategories: encodeArray(encodeString)(obj.recipeCategories),
    recipeCategoryIdList: encodeArray(encodeMetaId)(obj.recipeCategoryIdList),
    serves: encodeNumber(obj.serves),
    sortingIndex: encodeNumber(obj.sortingIndex),
    url: encodeString(obj.url)
  } as RecipeExternalBeanJSON);
}

type RecipeExternalSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<RecipeExternalBeanJSON>;
};

export class RecipeExternalSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<RecipeExternalBean>;

  constructor(json: RecipeExternalSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeRecipeExternalBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeRecipeExternalSyncBean(json: RecipeExternalSyncBeanJSON | undefined): RecipeExternalSyncBean | undefined {
  return json === undefined ? undefined : new RecipeExternalSyncBean(json);
}

function encodeRecipeExternalSyncBean(obj: RecipeExternalSyncBean | null): RecipeExternalSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeRecipeExternalBean)(obj.updatedCreated)
  } as RecipeExternalSyncBeanJSON);
}

type RecipeIngredientBeanJSON = {
  complementData?: string;
  metaId?: string;
  name?: string;
  originalTxt?: string;
  quantity?: string;
  quantityF?: string;
  unit?: string;
};

export class RecipeIngredientBean extends ServerBeanPrototype {
  /** @param complementData the complementData to set */
  complementData?: string;
  metaId?: string;
  /** The name of the ingredient. It can hold the whole line as it was typed, quantity and unit included ("200 g de
 farine"), which is how ingredients entered as text are stored. Once the quantities have been parsed, the name is
 only the ingredient itself ("farine"), without the quantity, the unit, nor the complement after the comma.
 @param name the name to set */
  name?: string;
  /** The original text for this ingredient, if quantity have been parsed. Not Persistent, will only be
 populated during the preview phase of a quantity parsing, during import or on demand.
 @param originalTxt the original text */
  originalTxt?: string;
  /** The quantity as text, which is what is stored: it keeps what was written even when it is not a number ("1/2",
 "2-3", "un peu"). See quantityF for the same quantity as a float, and note that quantityF is only used as input
 when this one is null.
 @param quantity the quantity to set */
  quantity?: string;
  /** The quantity, but as a float, when possible, else null. Note that this is outputted if possible to convert
 to a float, that this is taken into account as input when saving a recipe only if the quantity (of type string)
 is null.
 @param quantityF the quantity, as a float */
  quantityF?: number;
  /** The unit of the quantity, as an abbreviation taken from a fixed list (g, kg, mg, ml, cl, l, tbsp, tsp, cup, oz,
 fl oz, lb, pc, pack, can, btl, bag, sl, bch, box, jar...). The many ways a unit can be written in the text of an
 ingredient, in every supported language, are recognized by the quantity parsing and given back as one of these
 abbreviations. Null when there is no quantity, but a quantity always comes with a unit: a count of things with no
 unit written is a count of pieces, unit pc.
 @param unit the unit to set */
  unit?: string;

  constructor(json: RecipeIngredientBeanJSON) {
    super(json);
    this.complementData = decodeString(json.complementData);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.originalTxt = decodeString(json.originalTxt);
    this.quantity = decodeString(json.quantity);
    this.quantityF = decodeNumber(json.quantityF);
    this.unit = decodeString(json.unit);
    this.onDecode(json);
  }
}

function decodeRecipeIngredientBean(json: RecipeIngredientBeanJSON | undefined): RecipeIngredientBean | undefined {
  return json === undefined ? undefined : new RecipeIngredientBean(json);
}

function encodeRecipeIngredientBean(obj: RecipeIngredientBean | null): RecipeIngredientBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    complementData: encodeString(obj.complementData),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    originalTxt: encodeString(obj.originalTxt),
    quantity: encodeString(obj.quantity),
    quantityF: encodeNumber(obj.quantityF),
    unit: encodeString(obj.unit)
  } as RecipeIngredientBeanJSON);
}

type RecipeInputBeanJSON = {
  cookTime?: string;
  description?: string;
  ingredients?: string;
  ingredientsList?: Array<RecipeIngredientBeanJSON>;
  instructions?: string;
  isMealSuggestion?: string;
  isRecipe?: string;
  metaId?: string;
  name?: string;
  prepTime?: string;
  recipeCategories?: Array<string>;
  recipeCategoryIdList?: Array<string>;
  serves?: string;
  sortingIndex?: string;
  url?: string;
};

export class RecipeInputBean extends ServerBeanPrototype {
  /** Cook time in minutes
 @param cookTime */
  cookTime?: number;
  /** the description of the recipe
 @param description */
  description?: string;
  /** the ingredients as a big textarea, separated by CR/CRLF
 @param ingredients */
  ingredients?: string;
  /** the ingredients as a list of beans
 @param ingredientsList the ingredientsList to set */
  ingredientsList?: Array<RecipeIngredientBean>;
  /** the step-by-step instructions
 @param instructions */
  instructions?: string;
  /** Flag to indicate if this MealRecipe shall be displayed in the mealplanner, as a suggestion for new meals.<br>
 If true or null, this item will be displayed, else it won't. <br>
 NOTE: even if this flag is false, associated meals in the mealplanner (already planner) shall be displayed.
 @param isMealSuggestion the isMealSuggestion to set */
  isMealSuggestion?: boolean;
  /** Flag to indicate if this MealRecipe shall be displayed in the recipebox.<br>
 If true or null, this item will be displayed in the recipebox, else it won't.
 @param isRecipe the isRecipe to set */
  isRecipe?: boolean;
  /** the metaId of the recipe
 @param metaId */
  metaId?: string;
  /** the name of the recipe (ie salad, burger, ..)
 @param name */
  name?: string;
  /** preparation time in minute
 @param prepTime */
  prepTime?: number;
  /** the recipe's categories
 @param recipeCategories the recipeCategories to set */
  recipeCategories?: Array<string>;
  recipeCategoryIdList?: Array<string>;
  /** number fo serves
 @param serves */
  serves?: number;
  /** Clients must sort by this field descending (and by text in case of equality)
 @param sortingIndex */
  sortingIndex?: number;
  url?: string;

  constructor(json: RecipeInputBeanJSON) {
    super(json);
    this.cookTime = decodeNumber(json.cookTime);
    this.description = decodeString(json.description);
    this.ingredients = decodeString(json.ingredients);
    this.ingredientsList = decodeArray(decodeRecipeIngredientBean)(json.ingredientsList);
    this.instructions = decodeString(json.instructions);
    this.isMealSuggestion = decodeBoolean(json.isMealSuggestion);
    this.isRecipe = decodeBoolean(json.isRecipe);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.prepTime = decodeNumber(json.prepTime);
    this.recipeCategories = decodeArray(decodeString)(json.recipeCategories);
    this.recipeCategoryIdList = decodeArray(decodeMetaId)(json.recipeCategoryIdList);
    this.serves = decodeNumber(json.serves);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.url = decodeString(json.url);
    this.onDecode(json);
  }
}

function decodeRecipeInputBean(json: RecipeInputBeanJSON | undefined): RecipeInputBean | undefined {
  return json === undefined ? undefined : new RecipeInputBean(json);
}

function encodeRecipeInputBean(obj: RecipeInputBean | null): RecipeInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    cookTime: encodeNumber(obj.cookTime),
    description: encodeString(obj.description),
    ingredients: encodeString(obj.ingredients),
    ingredientsList: encodeArray(encodeRecipeIngredientBean)(obj.ingredientsList),
    instructions: encodeString(obj.instructions),
    isMealSuggestion: encodeBoolean(obj.isMealSuggestion),
    isRecipe: encodeBoolean(obj.isRecipe),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    prepTime: encodeNumber(obj.prepTime),
    recipeCategories: encodeArray(encodeString)(obj.recipeCategories),
    recipeCategoryIdList: encodeArray(encodeMetaId)(obj.recipeCategoryIdList),
    serves: encodeNumber(obj.serves),
    sortingIndex: encodeNumber(obj.sortingIndex),
    url: encodeString(obj.url)
  } as RecipeInputBeanJSON);
}

type RecipePuByUrlResultBeanJSON = {
  og?: OpenGraphDataBeanJSON;
  recipe?: RecipeBeanJSON;
};

export class RecipePuByUrlResultBean extends ServerBeanPrototype {
  /** if no recipe has been created the OpenGraphDataBean of the url is given (it might be in error state)
 You can use title and first image to prefill the recipe creation form
 @param og */
  og?: OpenGraphDataBean;
  /** if a recipe has been found on the page and successfully created this property is filled with the created Recipe */
  recipe?: RecipeBean;

  constructor(json: RecipePuByUrlResultBeanJSON) {
    super(json);
    this.og = decodeOpenGraphDataBean(json.og);
    this.recipe = decodeRecipeBean(json.recipe);
    this.onDecode(json);
  }
}

function decodeRecipePuByUrlResultBean(json: RecipePuByUrlResultBeanJSON | undefined): RecipePuByUrlResultBean | undefined {
  return json === undefined ? undefined : new RecipePuByUrlResultBean(json);
}

function encodeRecipePuByUrlResultBean(obj: RecipePuByUrlResultBean | null): RecipePuByUrlResultBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    og: encodeOpenGraphDataBean(obj.og),
    recipe: encodeRecipeBean(obj.recipe)
  } as RecipePuByUrlResultBeanJSON);
}

type RecipeSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<RecipeBeanJSON>;
};

export class RecipeSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<RecipeBean>;

  constructor(json: RecipeSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeRecipeBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeRecipeSyncBean(json: RecipeSyncBeanJSON | undefined): RecipeSyncBean | undefined {
  return json === undefined ? undefined : new RecipeSyncBean(json);
}

function encodeRecipeSyncBean(obj: RecipeSyncBean | null): RecipeSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeRecipeBean)(obj.updatedCreated)
  } as RecipeSyncBeanJSON);
}

type RecurrencyDescriptorJSON = {
  byDay?: string;
  byMonthDay?: string;
  endOccurence?: string;
  exdate?: Array<string>;
  rdate?: Array<string>;
  recurrency?: RecurrencyEnum;
  recurrencyDeletedOccurence?: Array<string>;
  recurrencyEndDate?: string;
  recurrencyInterval?: string;
  rrule?: string;
};

export class RecurrencyDescriptor extends ServerBeanPrototype {
  /** part of rrule string corresponding to BYDAY. Contains Days of the week.<br>
 see <a href="https://icalendar.org/iCalendar-RFC-5545/3-3-10-recurrence-rule.html">rrule spec</a><br>
 accept data like TU,WE or for monthly 2MO,-1FR */
  byDay?: string;
  /** part of the rrule string corresponding to BYMONTHDAY. Contains Days of the month.<br>
 see <a href="https://icalendar.org/iCalendar-RFC-5545/3-3-10-recurrence-rule.html">rrule spec</a><br>
 accept data like 1,15,-1 and defines which day of the month is accepted by a monthly recurrency
 @param byMonthDay */
  byMonthDay?: string;
  endOccurence?: number;
  /** do not use as input, generated with the deletedOccurence
 @param exdate */
  exdate?: Array<Date>;
  /** do not use as input, extra occurence date, for now we do not know what to do with that data
 @param rdate */
  rdate?: Array<Date>;
  /** the type of recurrency (daily, weekly, etc)
 @param recurrency */
  recurrency?: RecurrencyEnum;
  /** id (in the occurence sequence) of occurence that are excluded (ie all day from 7th of september except the 3rd occurence, ie the 9th)
 NEVER send it!!!!
 @param recurrencyDeletedOccurence */
  recurrencyDeletedOccurence?: Array<number>;
  /** the date at which the recurrency ends (ie every day until 7th of sept)<br>
 This follow the UNTIL RRULE SPEC. , therefore it is inclusive, and it is rounded by the server to the startDate of the last occurrence of the reccurency pattern (end-of-day UTC as allday) .
 @param endDate */
  recurrencyEndDate?: Date;
  /** please do not use yet as input while all client doesn't,
 used to skip occurence if DAILY and interval 3 it will occurs every 3 days
 @param interval */
  recurrencyInterval?: number;
  rrule?: string;

  constructor(json: RecurrencyDescriptorJSON) {
    super(json);
    this.byDay = decodeString(json.byDay);
    this.byMonthDay = decodeString(json.byMonthDay);
    this.endOccurence = decodeNumber(json.endOccurence);
    this.exdate = decodeArray(decodeDate)(json.exdate);
    this.rdate = decodeArray(decodeDate)(json.rdate);
    this.recurrency = decodeEnum(json.recurrency);
    this.recurrencyDeletedOccurence = decodeArray(decodeNumber)(json.recurrencyDeletedOccurence);
    this.recurrencyEndDate = decodeDate(json.recurrencyEndDate);
    this.recurrencyInterval = decodeNumber(json.recurrencyInterval);
    this.rrule = decodeString(json.rrule);
    this.onDecode(json);
  }
}

function decodeRecurrencyDescriptor(json: RecurrencyDescriptorJSON | undefined): RecurrencyDescriptor | undefined {
  return json === undefined ? undefined : new RecurrencyDescriptor(json);
}

function encodeRecurrencyDescriptor(obj: RecurrencyDescriptor | null): RecurrencyDescriptorJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    byDay: encodeString(obj.byDay),
    byMonthDay: encodeString(obj.byMonthDay),
    endOccurence: encodeNumber(obj.endOccurence),
    exdate: encodeArray(encodeDate)(obj.exdate),
    rdate: encodeArray(encodeDate)(obj.rdate),
    recurrency: encodeEnum(obj.recurrency),
    recurrencyEndDate: encodeDate(obj.recurrencyEndDate),
    recurrencyInterval: encodeNumber(obj.recurrencyInterval),
    rrule: encodeString(obj.rrule)
  } as RecurrencyDescriptorJSON);
}

type ReminderBeanJSON = {
  localId?: string;
  reminderType?: ReminderTypeEnum;
  reminderUnit?: ReminderUnitEnum;
  reminderValue?: string;
};

export class ReminderBean extends ServerBeanPrototype {
  /** @param localId the localId to set */
  localId?: number;
  reminderType?: ReminderTypeEnum;
  reminderUnit?: ReminderUnitEnum;
  reminderValue?: number;

  constructor(json: ReminderBeanJSON) {
    super(json);
    this.localId = decodeNumber(json.localId);
    this.reminderType = decodeEnum(json.reminderType);
    this.reminderUnit = decodeEnum(json.reminderUnit);
    this.reminderValue = decodeNumber(json.reminderValue);
    this.onDecode(json);
  }
}

function decodeReminderBean(json: ReminderBeanJSON | undefined): ReminderBean | undefined {
  return json === undefined ? undefined : new ReminderBean(json);
}

function encodeReminderBean(obj: ReminderBean | null): ReminderBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    localId: encodeNumber(obj.localId),
    reminderType: encodeEnum(obj.reminderType),
    reminderUnit: encodeEnum(obj.reminderUnit),
    reminderValue: encodeNumber(obj.reminderValue)
  } as ReminderBeanJSON);
}

type SettingsBeanJSON = {
  accountId?: string;
  geoTrackingHistory?: string;
  metaId?: string;
  promoAccept?: string;
  pushByEmail?: MailNotificationTypeEnum;
  pushForBestMoment?: string;
  pushForBudget?: string;
  pushForCheckin?: string;
  pushForComment?: string;
  pushForContact?: string;
  pushForEvent?: string;
  pushForFiler?: string;
  pushForMealPlanner?: string;
  pushForMessage?: string;
  pushForPicture?: string;
  pushForRecipe?: string;
  pushForSpecialDays?: string;
  pushForStatus?: string;
  pushForTask?: string;
  pushForTimetable?: string;
  pushGlobal?: string;
  reminderNotificationEnabled?: string;
};

export class SettingsBean extends ServerBeanPrototype {
  /** owner account id owning those settings
 @param accountId */
  accountId?: number;
  /** experimental settings used to define if all position of geotracking is recorded in an history, not implemented at this time 
 @param geoTrackingHistory */
  geoTrackingHistory?: boolean;
  metaId?: string;
  promoAccept?: boolean;
  pushByEmail?: MailNotificationTypeEnum;
  /** specific push for best moment, taken into account only if liked item push is already true
 @param pushForBestMoment */
  pushForBestMoment?: boolean;
  /** specific push for budget (reminder), taken into account only if pushGlobal is already true
 @param pushForBudget the pushForBudget to set */
  pushForBudget?: boolean;
  /** specific push for checkin, taken into account only if pushGlobal is already true
 correspond to push location, enable Comment_Checkin, New_Checkin, GeoFencingIn, GeoFencingOut, GeolocAutotrackRequest:
 @param pushForCheckin */
  pushForCheckin?: boolean;
  /** specific push for comment, taken into account only if commented item push is already true
 @param pushForComment */
  pushForComment?: boolean;
  pushForContact?: boolean;
  /** specific push for event, taken into account only if pushGlobal is already true
 @param pushForEvent */
  pushForEvent?: boolean;
  /** specific push for filer, taken into account only if pushGlobal is already true
 @param pushForFiler the pushForBudget to set */
  pushForFiler?: boolean;
  pushForMealPlanner?: boolean;
  /** specific push for msg, taken into account only if pushGlobal is already true
 @param pushForMessage */
  pushForMessage?: boolean;
  /** specific push for pictures, taken into account only if pushGlobal is already true
 @param pushForPicture the pushForPicture to set */
  pushForPicture?: boolean;
  pushForRecipe?: boolean;
  /** specific push for special days, taken into account only if pushGlobal is already true
 @param pushForSpecialDays true if pushes are active for special days */
  pushForSpecialDays?: boolean;
  /** specific push for tasks, taken into account only if pushGlobal is already true
 @param  pushForStatus */
  pushForStatus?: boolean;
  /** specific push for tasks, taken into account only if pushGlobal is already true
 @param pushForTask the pushForTask to set */
  pushForTask?: boolean;
  /** specific push for timetable (lifecycle but not reminder), taken into account only if pushGlobal is already true
 @param pushForTimetable the pushForTimetable to set */
  pushForTimetable?: boolean;
  /** global push on/off, take precedence over specific settings for push for event/message/etc
 @param pushGlobal */
  pushGlobal?: boolean;
  /** enable or disable reminders, however this is not implemented 
 @param reminderNotificationEnabled the reminderNotificationEnabled to set */
  reminderNotificationEnabled?: boolean;

  constructor(json: SettingsBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.geoTrackingHistory = decodeBoolean(json.geoTrackingHistory);
    this.metaId = decodeMetaId(json.metaId);
    this.promoAccept = decodeBoolean(json.promoAccept);
    this.pushByEmail = decodeEnum(json.pushByEmail);
    this.pushForBestMoment = decodeBoolean(json.pushForBestMoment);
    this.pushForBudget = decodeBoolean(json.pushForBudget);
    this.pushForCheckin = decodeBoolean(json.pushForCheckin);
    this.pushForComment = decodeBoolean(json.pushForComment);
    this.pushForContact = decodeBoolean(json.pushForContact);
    this.pushForEvent = decodeBoolean(json.pushForEvent);
    this.pushForFiler = decodeBoolean(json.pushForFiler);
    this.pushForMealPlanner = decodeBoolean(json.pushForMealPlanner);
    this.pushForMessage = decodeBoolean(json.pushForMessage);
    this.pushForPicture = decodeBoolean(json.pushForPicture);
    this.pushForRecipe = decodeBoolean(json.pushForRecipe);
    this.pushForSpecialDays = decodeBoolean(json.pushForSpecialDays);
    this.pushForStatus = decodeBoolean(json.pushForStatus);
    this.pushForTask = decodeBoolean(json.pushForTask);
    this.pushForTimetable = decodeBoolean(json.pushForTimetable);
    this.pushGlobal = decodeBoolean(json.pushGlobal);
    this.reminderNotificationEnabled = decodeBoolean(json.reminderNotificationEnabled);
    this.onDecode(json);
  }
}

function decodeSettingsBean(json: SettingsBeanJSON | undefined): SettingsBean | undefined {
  return json === undefined ? undefined : new SettingsBean(json);
}

function encodeSettingsBean(obj: SettingsBean | null): SettingsBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    geoTrackingHistory: encodeBoolean(obj.geoTrackingHistory),
    metaId: encodeMetaId(obj.metaId),
    promoAccept: encodeBoolean(obj.promoAccept),
    pushByEmail: encodeEnum(obj.pushByEmail),
    pushForBestMoment: encodeBoolean(obj.pushForBestMoment),
    pushForBudget: encodeBoolean(obj.pushForBudget),
    pushForCheckin: encodeBoolean(obj.pushForCheckin),
    pushForComment: encodeBoolean(obj.pushForComment),
    pushForContact: encodeBoolean(obj.pushForContact),
    pushForEvent: encodeBoolean(obj.pushForEvent),
    pushForFiler: encodeBoolean(obj.pushForFiler),
    pushForMealPlanner: encodeBoolean(obj.pushForMealPlanner),
    pushForMessage: encodeBoolean(obj.pushForMessage),
    pushForPicture: encodeBoolean(obj.pushForPicture),
    pushForRecipe: encodeBoolean(obj.pushForRecipe),
    pushForSpecialDays: encodeBoolean(obj.pushForSpecialDays),
    pushForStatus: encodeBoolean(obj.pushForStatus),
    pushForTask: encodeBoolean(obj.pushForTask),
    pushForTimetable: encodeBoolean(obj.pushForTimetable),
    pushGlobal: encodeBoolean(obj.pushGlobal),
    reminderNotificationEnabled: encodeBoolean(obj.reminderNotificationEnabled)
  } as SettingsBeanJSON);
}

type SettingsPerFamilyBeanJSON = {
  accountId?: string;
  calendarFirstDayOfWeek?: string;
  calendarWeekNb?: string;
  dailyBriefHourOfDelivery?: string;
  dailyBriefNothingPlannedActivated?: string;
  dailyBriefPushActivated?: string;
  defaultReminderType?: ReminderTypeEnum;
  defaultReminderUnit?: ReminderUnitEnum;
  defaultReminderValue?: string;
  editable?: string;
  familyId?: string;
  geolocSharing?: GeolocSharingEnum;
  mealplannerFirstDayOfWeek?: string;
  showDidYouKnow?: string;
  showDishes?: string;
  showSmartCard?: string;
  specialdaysColorAnniversary?: string;
  specialdaysColorBirthday?: string;
  specialdaysColorCelebration?: string;
  specialdaysFullname?: string;
};

export class SettingsPerFamilyBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId?: number;
  /** the nb of the first day of the week to be taken into account in the calendar display. 1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
 Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1. Default value depends on the locale of the user.
 @param calendarFirstDayOfWeek the calendarFirstDayOfWeek to set */
  calendarFirstDayOfWeek?: number;
  /** @param caledarWeekNb the calendarWeekNb to set */
  calendarWeekNb?: boolean;
  /** The hour of delivery of the daily brief relative to midnight for the current day. IE to send a daily brief for day X , we will send it at 9am in the morning if this equals to 9
 and it will send it at 6pm the day before if this equals to -6
 @param dailyBriefHourOfDelivery the dailyBriefHourOfDelivery to set */
  dailyBriefHourOfDelivery?: number;
  /** flag indicating if the daily brief is sent even if empty, for this family/account
 @param dailyBriefNothingPlannedActivated the dailyBriefNothingPlannedActivated to set */
  dailyBriefNothingPlannedActivated?: boolean;
  /** flag indicating if the daily brief is active for this family/account
 @param dailyBriefPushActivated the dailyBriefPushActivated to set */
  dailyBriefPushActivated?: boolean;
  /** default reminder type for events (reminders have type,unit and value), not used in UI but actually used in the event manager to initialize events
 @param defaultReminderType the value */
  defaultReminderType?: ReminderTypeEnum;
  /** default reminder unit for events (reminders have type,unit and value), not used in UI but actually used in the event manager to initialize events
 @param defaultReminderUnit the value */
  defaultReminderUnit?: ReminderUnitEnum;
  /** default reminder value for events (reminders have type,unit and value), not used in UI but actually used in the event manager to initialize events
 @param defaultReminderValue the value */
  defaultReminderValue?: number;
  /** true if the settings is yours
 @param editable the value */
  editable?: boolean;
  /** @param familyId the familyId to set */
  familyId?: string;
  /** the geolocalization sharing status
 @param value */
  geolocSharing?: GeolocSharingEnum;
  /** the nb of the first day of the week to be taken into account in the meal planner display. 1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
 Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1. Default value depends on the locale of the user.
 @param mealplannerFirstDayOfWeek the mealplannerFirstDayOfWeek to set */
  mealplannerFirstDayOfWeek?: number;
  /** flag indicating, when the smartcard is displayed, if the did you know are included in the smartcard
 @param showDidYouKnow the value */
  showDidYouKnow?: boolean;
  /** @param showDishes the showDishes to set */
  showDishes?: boolean;
  /** flag indicating if the smartcard is displayed on the dashboard for this family and this account
 @param showSmartCard the value */
  showSmartCard?: boolean;
  specialdaysColorAnniversary?: string;
  specialdaysColorBirthday?: string;
  specialdaysColorCelebration?: string;
  specialdaysFullname?: boolean;

  constructor(json: SettingsPerFamilyBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.calendarWeekNb = decodeBoolean(json.calendarWeekNb);
    this.dailyBriefHourOfDelivery = decodeNumber(json.dailyBriefHourOfDelivery);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.mealplannerFirstDayOfWeek = decodeNumber(json.mealplannerFirstDayOfWeek);
    this.showDidYouKnow = decodeBoolean(json.showDidYouKnow);
    this.showDishes = decodeBoolean(json.showDishes);
    this.showSmartCard = decodeBoolean(json.showSmartCard);
    this.specialdaysColorAnniversary = decodeMetaId(json.specialdaysColorAnniversary);
    this.specialdaysColorBirthday = decodeMetaId(json.specialdaysColorBirthday);
    this.specialdaysColorCelebration = decodeMetaId(json.specialdaysColorCelebration);
    this.specialdaysFullname = decodeBoolean(json.specialdaysFullname);
    this.onDecode(json);
  }
}

function decodeSettingsPerFamilyBean(json: SettingsPerFamilyBeanJSON | undefined): SettingsPerFamilyBean | undefined {
  return json === undefined ? undefined : new SettingsPerFamilyBean(json);
}

function encodeSettingsPerFamilyBean(obj: SettingsPerFamilyBean | null): SettingsPerFamilyBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    calendarFirstDayOfWeek: encodeNumber(obj.calendarFirstDayOfWeek),
    calendarWeekNb: encodeBoolean(obj.calendarWeekNb),
    dailyBriefHourOfDelivery: encodeNumber(obj.dailyBriefHourOfDelivery),
    dailyBriefNothingPlannedActivated: encodeBoolean(obj.dailyBriefNothingPlannedActivated),
    dailyBriefPushActivated: encodeBoolean(obj.dailyBriefPushActivated),
    defaultReminderType: encodeEnum(obj.defaultReminderType),
    defaultReminderUnit: encodeEnum(obj.defaultReminderUnit),
    defaultReminderValue: encodeNumber(obj.defaultReminderValue),
    editable: encodeBoolean(obj.editable),
    familyId: encodeMetaId(obj.familyId),
    geolocSharing: encodeEnum(obj.geolocSharing),
    mealplannerFirstDayOfWeek: encodeNumber(obj.mealplannerFirstDayOfWeek),
    showDidYouKnow: encodeBoolean(obj.showDidYouKnow),
    showDishes: encodeBoolean(obj.showDishes),
    showSmartCard: encodeBoolean(obj.showSmartCard),
    specialdaysColorAnniversary: encodeMetaId(obj.specialdaysColorAnniversary),
    specialdaysColorBirthday: encodeMetaId(obj.specialdaysColorBirthday),
    specialdaysColorCelebration: encodeMetaId(obj.specialdaysColorCelebration),
    specialdaysFullname: encodeBoolean(obj.specialdaysFullname)
  } as SettingsPerFamilyBeanJSON);
}

type ShoppingIngredientInputBeanJSON = {
  dishMetaId: string;
  ingredientList?: Array<string>;
};

export class ShoppingIngredientInputBean extends ServerBeanPrototype {
  /** the dishMetaId or the recipeMetaId to add to the shopping list
 @param */
  dishMetaId!: string;
  /** if set to null the take all the ingredients in DB or the name of the recipe (if no ingredients in DB)
 @param ingredientList the ingredientList to set */
  ingredientList?: Array<string>;

  constructor(json: ShoppingIngredientInputBeanJSON) {
    super(json);
    this.dishMetaId = decodeMetaId(json.dishMetaId);
    this.ingredientList = decodeArray(decodeMetaId)(json.ingredientList);
    this.onDecode(json);
  }
}

function decodeShoppingIngredientInputBean(json: ShoppingIngredientInputBeanJSON | undefined): ShoppingIngredientInputBean | undefined {
  return json === undefined ? undefined : new ShoppingIngredientInputBean(json);
}

function encodeShoppingIngredientInputBean(obj: ShoppingIngredientInputBean | null): ShoppingIngredientInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    dishMetaId: encodeMetaId(obj.dishMetaId),
    ingredientList: encodeArray(encodeMetaId)(obj.ingredientList)
  } as ShoppingIngredientInputBeanJSON);
}

type ShoppingIngredientInputBean2JSON = {
  dishMetaId: string;
  ingredientList?: Array<RecipeIngredientBeanJSON>;
};

export class ShoppingIngredientInputBean2 extends ServerBeanPrototype {
  /** the dishMetaId or the recipeMetaId to add to the shopping list
 @param dishMetaId the dish or recipe to add */
  dishMetaId!: string;
  /** The ingredients to add. If set to null, all the ingredients of the recipe are added, or the name of the recipe
 itself if it has no ingredient.<br>
 Each ingredient is matched on its metaId against the ingredients of the recipe, and every field that is not null
 in the bean overrides the one stored in the recipe: this is how the result of a quantity parsing is sent back,
 and it also allows to change a quantity before adding it. An ingredient without metaId (or with one that is not
 in the recipe) is taken as it is passed.
 @param ingredientList the ingredientList to set */
  ingredientList?: Array<RecipeIngredientBean>;

  constructor(json: ShoppingIngredientInputBean2JSON) {
    super(json);
    this.dishMetaId = decodeMetaId(json.dishMetaId);
    this.ingredientList = decodeArray(decodeRecipeIngredientBean)(json.ingredientList);
    this.onDecode(json);
  }
}

function decodeShoppingIngredientInputBean2(json: ShoppingIngredientInputBean2JSON | undefined): ShoppingIngredientInputBean2 | undefined {
  return json === undefined ? undefined : new ShoppingIngredientInputBean2(json);
}

function encodeShoppingIngredientInputBean2(obj: ShoppingIngredientInputBean2 | null): ShoppingIngredientInputBean2JSON | undefined {
  if (obj == null) return undefined;
  return inline({
    dishMetaId: encodeMetaId(obj.dishMetaId),
    ingredientList: encodeArray(encodeRecipeIngredientBean)(obj.ingredientList)
  } as ShoppingIngredientInputBean2JSON);
}

type SimplePaginatedCollectionJSON<IPromoCodeJSON> = {
  count?: string;
  datas: Array<IPromoCodeJSON>;
  nextPageId?: string;
  size?: string;
  start?: string;
};

export class SimplePaginatedCollection<IPromoCode> extends ServerBeanPrototype {
  count?: number;
  datas!: Array<IPromoCode>;
  nextPageId?: string;
  size?: number;
  start?: number;

  constructor(json: SimplePaginatedCollectionJSON<any>, decodeIPromoCode: objectDecoder<any, IPromoCode>) {
    super(json);
    this.count = decodeNumber(json.count);
    this.datas = decodeArray(decodeIPromoCode)(json.datas);
    this.nextPageId = decodeString(json.nextPageId);
    this.size = decodeNumber(json.size);
    this.start = decodeNumber(json.start);
    this.onDecode(json);
  }
}

function decodeSimplePaginatedCollection<IPromoCode>(decodeIPromoCode: objectDecoder<any, IPromoCode>) {
  return function(json: SimplePaginatedCollectionJSON<any> | undefined): SimplePaginatedCollection<IPromoCode> | undefined {
    return json === undefined ? undefined : new SimplePaginatedCollection<IPromoCode>(json, decodeIPromoCode);
  };
}

function encodeSimplePaginatedCollection<IPromoCode>(encodeIPromoCode: objectEncoder<IPromoCode>) {
  return function(obj: SimplePaginatedCollection<IPromoCode> | null): SimplePaginatedCollectionJSON<any> | undefined {
    if (obj == null) return undefined;
  return inline({
    count: encodeNumber(obj.count),
    datas: encodeArray(encodeIPromoCode)(obj.datas),
    nextPageId: encodeString(obj.nextPageId),
    size: encodeNumber(obj.size),
    start: encodeNumber(obj.start)
  } as SimplePaginatedCollectionJSON<IPromoCodeJSON>);
  };
}

type SimplePaginationRequestJSON = {
  count?: string;
  pageId?: string;
};

export class SimplePaginationRequest extends ServerBeanPrototype {
  /** Several possible behavior: <ul>
 <li>When positive, this indicate the maximum number of element to return, ordered ascendently (incrementally) positioned after the 
 starting element identified by the itemId parameter.<br>
 Enables to implement the "load x more elements" feature.
 <li>When null, return the unpaginated list, not depending on the starting element indentified by the itemId parameter.
 <li>When negative, indicate to return all elements ordered descendely (decrementally) positioned before the starting element indetified 
 by the itemId parameter. <br>
 Enables to implement the "refresh list" feature when the metaId indicate the first element available on the client.
 @param count */
  count?: number;
  /** The id of the element in the unpaginated list, from which the resulting paginated list will start, excluding this element.<br>
 If null, the paginated list will start with the first element of the unpaginated list.
 @param itemId */
  pageId?: string;

  constructor(json: SimplePaginationRequestJSON) {
    super(json);
    this.count = decodeNumber(json.count);
    this.pageId = decodeString(json.pageId);
    this.onDecode(json);
  }
}

function decodeSimplePaginationRequest(json: SimplePaginationRequestJSON | undefined): SimplePaginationRequest | undefined {
  return json === undefined ? undefined : new SimplePaginationRequest(json);
}

function encodeSimplePaginationRequest(obj: SimplePaginationRequest | null): SimplePaginationRequestJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    count: encodeNumber(obj.count),
    pageId: encodeString(obj.pageId)
  } as SimplePaginationRequestJSON);
}

type SmsStubBeanJSON = {
  date: string;
  from?: string;
  message: string;
  to?: string;
};

export class SmsStubBean extends ServerBeanPrototype {
  date!: Date;
  from?: string;
  message!: string;
  to?: string;

  constructor(json: SmsStubBeanJSON) {
    super(json);
    this.date = decodeDate(json.date);
    this.from = decodeString(json.from);
    this.message = decodeString(json.message);
    this.to = decodeString(json.to);
    this.onDecode(json);
  }
}

function decodeSmsStubBean(json: SmsStubBeanJSON | undefined): SmsStubBean | undefined {
  return json === undefined ? undefined : new SmsStubBean(json);
}

function encodeSmsStubBean(obj: SmsStubBean | null): SmsStubBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    date: encodeDate(obj.date),
    from: encodeString(obj.from),
    message: encodeString(obj.message),
    to: encodeString(obj.to)
  } as SmsStubBeanJSON);
}

type StatusBeanJSON = {
  accountNumbers: string;
  clusterStatus: ClusterStatusJSON;
  errorMessage?: string;
  startTime: string;
  statusOfServer: StatusServerEnum;
};

export class StatusBean extends ServerBeanPrototype {
  /** @param accountNumbers the accountNumbers to set */
  accountNumbers!: number;
  clusterStatus!: ClusterStatus;
  /** @param errorMessage the errorMessage to set */
  errorMessage?: string;
  /** @param startTime the startTime to set */
  startTime!: Date;
  /** @param statusOfServer the statusOfServer to set */
  statusOfServer!: StatusServerEnum;

  constructor(json: StatusBeanJSON) {
    super(json);
    this.accountNumbers = decodeNumber(json.accountNumbers);
    this.clusterStatus = decodeClusterStatus(json.clusterStatus);
    this.errorMessage = decodeString(json.errorMessage);
    this.startTime = decodeDate(json.startTime);
    this.statusOfServer = decodeEnum(json.statusOfServer);
    this.onDecode(json);
  }
}

function decodeStatusBean(json: StatusBeanJSON | undefined): StatusBean | undefined {
  return json === undefined ? undefined : new StatusBean(json);
}

function encodeStatusBean(obj: StatusBean | null): StatusBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountNumbers: encodeNumber(obj.accountNumbers),
    clusterStatus: encodeClusterStatus(obj.clusterStatus),
    errorMessage: encodeString(obj.errorMessage),
    startTime: encodeDate(obj.startTime),
    statusOfServer: encodeEnum(obj.statusOfServer)
  } as StatusBeanJSON);
}

type SubscriptionTicketBeanJSON = {
  accountState: AccountStateBeanJSON;
  receiptValid: string;
};

export class SubscriptionTicketBean extends ServerBeanPrototype {
  /** @param accountState the accountState to set */
  accountState!: AccountStateBean;
  /** @param isReceiptValid the isReceiptValid to set */
  receiptValid!: boolean;

  constructor(json: SubscriptionTicketBeanJSON) {
    super(json);
    this.accountState = decodeAccountStateBean(json.accountState);
    this.receiptValid = decodeboolean(json.receiptValid);
    this.onDecode(json);
  }
}

function decodeSubscriptionTicketBean(json: SubscriptionTicketBeanJSON | undefined): SubscriptionTicketBean | undefined {
  return json === undefined ? undefined : new SubscriptionTicketBean(json);
}

function encodeSubscriptionTicketBean(obj: SubscriptionTicketBean | null): SubscriptionTicketBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountState: encodeAccountStateBean(obj.accountState),
    receiptValid: encodeboolean(obj.receiptValid)
  } as SubscriptionTicketBeanJSON);
}

type SyncRequestJSON = {
  date?: string;
  itemId: string;
  syncToken?: string;
};

export class SyncRequest extends ServerBeanPrototype {
  /** the date of last sync
 @param date */
  date?: Date;
  /** the threadid of the message list to sync
 @param itemId */
  itemId!: string;
  /** the token given on last sync
 @param syncToken */
  syncToken?: string;

  constructor(json: SyncRequestJSON) {
    super(json);
    this.date = decodeDate(json.date);
    this.itemId = decodeMetaId(json.itemId);
    this.syncToken = decodeString(json.syncToken);
    this.onDecode(json);
  }
}

function decodeSyncRequest(json: SyncRequestJSON | undefined): SyncRequest | undefined {
  return json === undefined ? undefined : new SyncRequest(json);
}

function encodeSyncRequest(obj: SyncRequest | null): SyncRequestJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    date: encodeDate(obj.date),
    itemId: encodeMetaId(obj.itemId),
    syncToken: encodeString(obj.syncToken)
  } as SyncRequestJSON);
}

type TaskBeanJSON = {
  accountId?: string;
  assignee?: Array<AssigneeBeanJSON>;
  assigneeIds?: Array<string>;
  bestMoment?: string;
  comments?: Array<ICommentJSON>;
  complete?: string;
  completedDate?: string;
  creationDate?: string;
  description?: string;
  dueDate?: string;
  editable?: string;
  familyId: string;
  lastAction?: UserActionEnum;
  lastActionAuthor?: string;
  lastActionDate?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  modifDate: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  quantity?: string;
  refId?: string;
  reminder?: IReminderJSON;
  sortingIndex: string;
  taskCategoryId?: string;
  taskId?: string;
  taskListId?: string;
  text?: string;
  toAll?: string;
  unit?: string;
} & RecurrencyDescriptorJSON;

export class TaskBean extends ServerBeanPrototype {
  accountId?: number;
  assignee?: Array<AssigneeBean>;
  assigneeIds?: Array<number>;
  bestMoment?: boolean;
  comments?: Array<IComment>;
  complete?: boolean;
  completedDate?: Date;
  creationDate?: Date;
  description?: string;
  dueDate?: Date;
  editable?: boolean;
  familyId!: string;
  lastAction?: UserActionEnum;
  lastActionAuthor?: number;
  lastActionDate?: Date;
  medias?: Array<IMedia>;
  metaId?: string;
  modifDate!: Date;
  moodMap?: Map<number, Array<MoodEnum>>;
  moodStarShortcut?: boolean;
  quantity?: number;
  recurrencyDescriptor?: RecurrencyDescriptor;
  refId?: string;
  reminder?: IReminder;
  sortingIndex!: number;
  taskCategoryId?: string;
  taskId?: string;
  taskListId?: string;
  text?: string;
  toAll?: boolean;
  unit?: string;

  constructor(json: TaskBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.assignee = decodeArray(decodeAssigneeBean)(json.assignee);
    this.assigneeIds = decodeArray(decodeNumber)(json.assigneeIds);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.complete = decodeBoolean(json.complete);
    this.completedDate = decodeDate(json.completedDate);
    this.creationDate = decodeDate(json.creationDate);
    this.description = decodeString(json.description);
    this.dueDate = decodeDate(json.dueDate);
    this.editable = decodeBoolean(json.editable);
    this.familyId = decodeMetaId(json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.quantity = decodeNumber(json.quantity);
    this.refId = decodeMetaId(json.refId);
    this.reminder = decodeIReminder(json.reminder);
    this.sortingIndex = decodenumber(json.sortingIndex);
    this.taskCategoryId = decodeMetaId(json.taskCategoryId);
    this.taskId = decodeMetaId(json.taskId);
    this.taskListId = decodeMetaId(json.taskListId);
    this.text = decodeString(json.text);
    this.toAll = decodeBoolean(json.toAll);
    this.unit = decodeString(json.unit);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeTaskBean(json: TaskBeanJSON | undefined): TaskBean | undefined {
  return json === undefined ? undefined : new TaskBean(json);
}

function encodeTaskBean(obj: TaskBean | null): TaskBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    assignee: encodeArray(encodeAssigneeBean)(obj.assignee),
    assigneeIds: encodeArray(encodeNumber)(obj.assigneeIds),
    complete: encodeBoolean(obj.complete),
    description: encodeString(obj.description),
    dueDate: encodeDate(obj.dueDate),
    metaId: encodeMetaId(obj.metaId),
    quantity: encodeNumber(obj.quantity),
    refId: encodeMetaId(obj.refId),
    reminder: encodeIReminder(obj.reminder),
    sortingIndex: encodenumber(obj.sortingIndex),
    taskCategoryId: encodeMetaId(obj.taskCategoryId),
    taskId: encodeMetaId(obj.taskId),
    taskListId: encodeMetaId(obj.taskListId),
    text: encodeString(obj.text),
    toAll: encodeBoolean(obj.toAll),
    unit: encodeString(obj.unit)
  } as TaskBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type TaskCategoryBeanJSON = {
  accountId?: string;
  emoji?: string;
  familyId: string;
  filterTasklistId?: string;
  hiddenByTaskList: Array<string>;
  initialSortingIndex: string;
  locale?: string;
  metaId: string;
  name?: string;
  rights?: FizRightBeanJSON;
  sortingIndexByTaskList: {[key:string]:string};
  systemCategoryId?: string;
  taskListType?: TaskListTypeEnum;
};

export class TaskCategoryBean extends ServerBeanPrototype {
  /** if this is not null, this is a custom category and it returns the author */
  accountId?: number;
  /** One char , the emoji associated with this category
 @param emoji the emoji to set */
  emoji?: string;
  /** @param familyId the familyId to set */
  familyId!: number;
  /** The id of the tasklist for this category, if this category is only available to the tasklist. If this category is available for all list, this is null.<br>
 This combines with the taskListType too.
 @param tasklistId the tasklistId to set */
  filterTasklistId?: string;
  /** The list of tasklist metaId for which this task category is hidden and shall not be displayed. all tasks of this tasklist belonging to this category are now uncategorized
 @param hiddenByTaskList the hiddenByTaskList to set */
  hiddenByTaskList!: Array<string>;
  /** @param initialSortingIndex the initialSortingIndex to set */
  initialSortingIndex!: number;
  /** The locale for this task category (locale are filter so we present a category only to one specific locale, may be null in this case it will be presented to any locale)<br>
 system category locale cannot be changed.
 @param locale the locale to set */
  locale?: string;
  metaId!: string;
  /** Name of the task catetory. If set to null,it won't be modified
 @param name the name to set */
  name?: string;
  rights?: FizRightBean;
  /** A map, that will indicate, for each tasklist of the family, the sorting index of this task category within this list
 @param sortingIndexByTaskList the sortingIndexByTaskList to set */
  sortingIndexByTaskList!: Map<string, number>;
  /** @param systemCategoryId the systemCategoryId */
  systemCategoryId?: number;
  /** The type of tasklist this category is referring to (ie task category for shopping list only, or todos only, etc...) , or for any type of list if null)
 @param taskListType the taskListType to set */
  taskListType?: TaskListTypeEnum;

  constructor(json: TaskCategoryBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.filterTasklistId = decodeMetaId(json.filterTasklistId);
    this.hiddenByTaskList = decodeArray(decodeMetaId)(json.hiddenByTaskList);
    this.initialSortingIndex = decodeNumber(json.initialSortingIndex);
    this.locale = decodeString(json.locale);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndexByTaskList = decodeMap(decodeMetaId,decodeNumber)(json.sortingIndexByTaskList);
    this.systemCategoryId = decodeNumber(json.systemCategoryId);
    this.taskListType = decodeEnum(json.taskListType);
    this.onDecode(json);
  }
}

function decodeTaskCategoryBean(json: TaskCategoryBeanJSON | undefined): TaskCategoryBean | undefined {
  return json === undefined ? undefined : new TaskCategoryBean(json);
}

function encodeTaskCategoryBean(obj: TaskCategoryBean | null): TaskCategoryBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    emoji: encodeString(obj.emoji),
    familyId: encodeNumber(obj.familyId),
    filterTasklistId: encodeMetaId(obj.filterTasklistId),
    hiddenByTaskList: encodeArray(encodeMetaId)(obj.hiddenByTaskList),
    initialSortingIndex: encodeNumber(obj.initialSortingIndex),
    locale: encodeString(obj.locale),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    sortingIndexByTaskList: encodeMap(encodeMetaId,encodeNumber)(obj.sortingIndexByTaskList),
    taskListType: encodeEnum(obj.taskListType)
  } as TaskCategoryBeanJSON);
}

type TaskCategoryInputBeanJSON = {
  emoji?: string;
  filterTasklistId?: string;
  metaId?: string;
  name?: string;
  taskListType?: TaskListTypeEnum;
};

export class TaskCategoryInputBean extends ServerBeanPrototype {
  /** One char , the emoji associated with this category
 @param emoji the emoji to set */
  emoji?: string;
  /** The id of the tasklist for this category, if this category is only available to the tasklist. If this category is available for all list, this is null.<br>
 This combines with the taskListType too.
 @param tasklistId the tasklistId to set */
  filterTasklistId?: string;
  /** the id of the category. If this is a system category, objectId is <100000 */
  metaId?: string;
  /** Name of the task catetory. If set to null,it won't be modified
 @param name the name to set */
  name?: string;
  /** The type of tasklist this category is referring to (ie task category for shopping list only, or todos only, etc...) , or for any type of list if null)
 @param taskListType the taskListType to set */
  taskListType?: TaskListTypeEnum;

  constructor(json: TaskCategoryInputBeanJSON) {
    super(json);
    this.emoji = decodeString(json.emoji);
    this.filterTasklistId = decodeMetaId(json.filterTasklistId);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.taskListType = decodeEnum(json.taskListType);
    this.onDecode(json);
  }
}

function decodeTaskCategoryInputBean(json: TaskCategoryInputBeanJSON | undefined): TaskCategoryInputBean | undefined {
  return json === undefined ? undefined : new TaskCategoryInputBean(json);
}

function encodeTaskCategoryInputBean(obj: TaskCategoryInputBean | null): TaskCategoryInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    emoji: encodeString(obj.emoji),
    filterTasklistId: encodeMetaId(obj.filterTasklistId),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    taskListType: encodeEnum(obj.taskListType)
  } as TaskCategoryInputBeanJSON);
}

type TaskCategorySyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<TaskCategoryBeanJSON>;
};

export class TaskCategorySyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<TaskCategoryBean>;

  constructor(json: TaskCategorySyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeTaskCategoryBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeTaskCategorySyncBean(json: TaskCategorySyncBeanJSON | undefined): TaskCategorySyncBean | undefined {
  return json === undefined ? undefined : new TaskCategorySyncBean(json);
}

function encodeTaskCategorySyncBean(obj: TaskCategorySyncBean | null): TaskCategorySyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeTaskCategoryBean)(obj.updatedCreated)
  } as TaskCategorySyncBeanJSON);
}

type TaskInputBeanJSON = {
  assignee?: Array<string>;
  description?: string;
  dueDate?: string;
  metaId?: string;
  quantity?: string;
  refId?: string;
  reminder?: IReminderJSON;
  taskCategoryId?: string;
  taskId?: string;
  taskListId?: string;
  text?: string;
  toAll?: string;
  unit?: string;
} & RecurrencyDescriptorJSON;

export class TaskInputBean extends ServerBeanPrototype {
  assignee?: Array<number>;
  /** description of the item, suitable for url and open graph use
 
 @param description */
  description?: string;
  dueDate?: Date;
  metaId?: string;
  /** How much of it is needed, to be read with the unit. Adding an ingredient that is already in a shopping list sums
 the quantities when the unit is the same. Null when no quantity is known, which is the case for a plain task.
 @param quantity the quantity to set */
  quantity?: number;
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** the id of Object referenced by the task (ie for instance if the task comes from a meal in the mealplanner, it is the id of the meal)
 
 @param refObjectId
            metaid of the ref object */
  refId?: string;
  reminder?: IReminder;
  /** metaid of a taskCategory this task belong to
 
 @param taskCategoryId
            the taskCategoryId to set */
  taskCategoryId?: string;
  taskId?: string;
  /** return the task list
 
 @param taskListId */
  taskListId?: string;
  text?: string;
  toAll?: boolean;
  /** The unit of the quantity, mostly used on a shopping list ("2 kg potatoes"). It is an abbreviation from the same
 fixed list as the unit of a recipe ingredient (g, kg, ml, cl, l, tbsp, tsp, pc, pack, can...). Null when there is
 no quantity.
 @param unit the unit to set */
  unit?: string;

  constructor(json: TaskInputBeanJSON) {
    super(json);
    this.assignee = decodeArray(decodeNumber)(json.assignee);
    this.description = decodeString(json.description);
    this.dueDate = decodeDate(json.dueDate);
    this.metaId = decodeMetaId(json.metaId);
    this.quantity = decodeNumber(json.quantity);
    this.refId = decodeMetaId(json.refId);
    this.reminder = decodeIReminder(json.reminder);
    this.taskCategoryId = decodeMetaId(json.taskCategoryId);
    this.taskId = decodeMetaId(json.taskId);
    this.taskListId = decodeMetaId(json.taskListId);
    this.text = decodeString(json.text);
    this.toAll = decodeBoolean(json.toAll);
    this.unit = decodeString(json.unit);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeTaskInputBean(json: TaskInputBeanJSON | undefined): TaskInputBean | undefined {
  return json === undefined ? undefined : new TaskInputBean(json);
}

function encodeTaskInputBean(obj: TaskInputBean | null): TaskInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    assignee: encodeArray(encodeNumber)(obj.assignee),
    description: encodeString(obj.description),
    dueDate: encodeDate(obj.dueDate),
    metaId: encodeMetaId(obj.metaId),
    quantity: encodeNumber(obj.quantity),
    refId: encodeMetaId(obj.refId),
    reminder: encodeIReminder(obj.reminder),
    taskCategoryId: encodeMetaId(obj.taskCategoryId),
    taskId: encodeMetaId(obj.taskId),
    taskListId: encodeMetaId(obj.taskListId),
    text: encodeString(obj.text),
    toAll: encodeBoolean(obj.toAll),
    unit: encodeString(obj.unit)
  } as TaskInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type TaskListBeanJSON = {
  accountId?: string;
  bestMoment?: string;
  color?: string;
  comments?: Array<ICommentJSON>;
  completedHidden?: string;
  creationDate?: string;
  description?: string;
  emoji?: string;
  familyId?: string;
  inputFile?: Array<FizFile>;
  lastAction?: UserActionEnum;
  lastActionAuthor?: string;
  lastActionDate?: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  name?: string;
  pinSortingIndex?: string;
  remainingTaskNumber?: string;
  rights?: FizRightBeanJSON;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
  sortingIndex?: string;
  suggestedId?: string;
  systemId?: string;
  taskCategoriesHidden?: string;
  taskListType?: TaskListTypeEnum;
  taskSorting?: TaskSortingEnum;
  totalTaskNumber?: string;
};

export class TaskListBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId?: number;
  /** @param bestMoment the bestMoment to set */
  bestMoment?: boolean;
  color?: string;
  /** @param comments the comments to set */
  comments?: Array<IComment>;
  /** @param completedHidden the completedHidden to set */
  completedHidden?: boolean;
  /** @param creationDate the creationDate to set */
  creationDate?: Date;
  /** @param description the description to set */
  description?: string;
  /** @param emoji the emoji to set */
  emoji?: string;
  /** @param familyId the familyId to set */
  familyId?: string;
  inputFile?: Array<FizFile>;
  /** @param lastAction the lastAction to set */
  lastAction?: UserActionEnum;
  /** @param lastActionAuthor the lastActionAuthor to set */
  lastActionAuthor?: number;
  /** @param lastActionDate the lastActionDate to set */
  lastActionDate?: Date;
  medias?: Array<IMedia>;
  /** @param metaId the metaId to set */
  metaId?: string;
  /** @param moodMap the moodMap to set */
  moodMap?: Map<number, Array<MoodEnum>>;
  /** @param moodStarShortcut the moodStarShortcut to set */
  moodStarShortcut?: boolean;
  /** @param name the name to set */
  name?: string;
  /** if it is null it is not pinned, else a sorting on those value indicated the position in the pinned lists
 @param pinSortingIndex the pinSortingIndex to set */
  pinSortingIndex?: number;
  /** @param remainingTaskNumber the remainingTaskNumber to set */
  remainingTaskNumber?: number;
  /** @param right the right to set */
  rights?: FizRightBean;
  /** @param sharedMemberIds the sharedMemberIds to set */
  sharedMemberIds?: Array<number>;
  /** @param isSharedToAll the isSharedToAll to set */
  sharedToAll?: boolean;
  /** @param sortingIndex the sortingIndex to set */
  sortingIndex?: number;
  /** Don't know what this is */
  suggestedId?: number;
  /** @param systemId the systemId to set */
  systemId?: number;
  /** @param taskCategoriesHidden the taskCategoriesHidden to set */
  taskCategoriesHidden?: boolean;
  /** @param taskListType the taskListType to set */
  taskListType?: TaskListTypeEnum;
  /** @param taskSorting the taskSorting to set */
  taskSorting?: TaskSortingEnum;
  /** @param totalTaskNumber the totalTaskNumber to set */
  totalTaskNumber?: number;

  constructor(json: TaskListBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.color = decodeString(json.color);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.completedHidden = decodeBoolean(json.completedHidden);
    this.creationDate = decodeDate(json.creationDate);
    this.description = decodeString(json.description);
    this.emoji = decodeString(json.emoji);
    this.familyId = decodeMetaId(json.familyId);
    this.inputFile = decodeArray(decodeFizFile)(json.inputFile);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.name = decodeString(json.name);
    this.pinSortingIndex = decodeNumber(json.pinSortingIndex);
    this.remainingTaskNumber = decodeNumber(json.remainingTaskNumber);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.suggestedId = decodeNumber(json.suggestedId);
    this.systemId = decodeNumber(json.systemId);
    this.taskCategoriesHidden = decodeBoolean(json.taskCategoriesHidden);
    this.taskListType = decodeEnum(json.taskListType);
    this.taskSorting = decodeEnum(json.taskSorting);
    this.totalTaskNumber = decodeNumber(json.totalTaskNumber);
    this.onDecode(json);
  }
}

function decodeTaskListBean(json: TaskListBeanJSON | undefined): TaskListBean | undefined {
  return json === undefined ? undefined : new TaskListBean(json);
}

function encodeTaskListBean(obj: TaskListBean | null): TaskListBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    color: encodeString(obj.color),
    completedHidden: encodeBoolean(obj.completedHidden),
    description: encodeString(obj.description),
    emoji: encodeString(obj.emoji),
    inputFile: encodeArray(encodeFizFile)(obj.inputFile),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    pinSortingIndex: encodeNumber(obj.pinSortingIndex),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll),
    sortingIndex: encodeNumber(obj.sortingIndex),
    systemId: encodeNumber(obj.systemId),
    taskCategoriesHidden: encodeBoolean(obj.taskCategoriesHidden),
    taskListType: encodeEnum(obj.taskListType),
    taskSorting: encodeEnum(obj.taskSorting)
  } as TaskListBeanJSON);
}

type TaskListSettingsBeanJSON = {
  taskListSorting?: TaskListSortingEnum;
};

export class TaskListSettingsBean extends ServerBeanPrototype {
  /** @param taskListSorting the taskListSorting to set */
  taskListSorting?: TaskListSortingEnum;

  constructor(json: TaskListSettingsBeanJSON) {
    super(json);
    this.taskListSorting = decodeEnum(json.taskListSorting);
    this.onDecode(json);
  }
}

function decodeTaskListSettingsBean(json: TaskListSettingsBeanJSON | undefined): TaskListSettingsBean | undefined {
  return json === undefined ? undefined : new TaskListSettingsBean(json);
}

function encodeTaskListSettingsBean(obj: TaskListSettingsBean | null): TaskListSettingsBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    taskListSorting: encodeEnum(obj.taskListSorting)
  } as TaskListSettingsBeanJSON);
}

type TaskSuggestionBeanJSON = {
  alternates: Array<string>;
  categoryId?: string;
  value: string;
};

export class TaskSuggestionBean extends ServerBeanPrototype {
  /** @param alternates the alternates to set */
  alternates!: Array<string>;
  /** The default category for this suggestion, as the "integer" id and not metaId, therefore must be 
 converted before use as "taskCategory/{familyId}_{categoryId}" where familyId is the "integer" familyId of the tasklist the suggestion will go into, 
 and categoryId is this property.<br>
 This is done this way so the client build its own version of the metaId for all family it manages, and avoid to sync the suggestionList for each family.
 @param categoryId the categoryId to set */
  categoryId?: number;
  /** The String value of this suggestion, for instance "Sugar", or "Milk".
 @param value the value to set */
  value!: string;

  constructor(json: TaskSuggestionBeanJSON) {
    super(json);
    this.alternates = decodeArray(decodeString)(json.alternates);
    this.categoryId = decodeNumber(json.categoryId);
    this.value = decodeString(json.value);
    this.onDecode(json);
  }
}

function decodeTaskSuggestionBean(json: TaskSuggestionBeanJSON | undefined): TaskSuggestionBean | undefined {
  return json === undefined ? undefined : new TaskSuggestionBean(json);
}

function encodeTaskSuggestionBean(obj: TaskSuggestionBean | null): TaskSuggestionBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    alternates: encodeArray(encodeString)(obj.alternates),
    categoryId: encodeNumber(obj.categoryId),
    value: encodeString(obj.value)
  } as TaskSuggestionBeanJSON);
}

type TaskSuggestionSyncBeanJSON = {
  isSync: string;
  listType: TaskListTypeEnum;
  locale: string;
  suggestions?: Array<string>;
  syncToken: string;
};

export class TaskSuggestionSyncBean extends ServerBeanPrototype {
  /** if true this only contains partial response, if false it contains all response 
 and client shall delete local list before taking "updatedCreated"
 @param isSync */
  isSync!: boolean;
  /** @param listType the listType to set */
  listType!: TaskListTypeEnum;
  /** @param locale the locale to set */
  locale!: string;
  /** The suggestion list, will be null if fast sync or empty
 @param suggestions the suggestions to set */
  suggestions?: Array<string>;
  /** @param syncToken the syncToken to set */
  syncToken!: string;

  constructor(json: TaskSuggestionSyncBeanJSON) {
    super(json);
    this.isSync = decodeboolean(json.isSync);
    this.listType = decodeEnum(json.listType);
    this.locale = decodeString(json.locale);
    this.suggestions = decodeArray(decodeString)(json.suggestions);
    this.syncToken = decodeString(json.syncToken);
    this.onDecode(json);
  }
}

function decodeTaskSuggestionSyncBean(json: TaskSuggestionSyncBeanJSON | undefined): TaskSuggestionSyncBean | undefined {
  return json === undefined ? undefined : new TaskSuggestionSyncBean(json);
}

function encodeTaskSuggestionSyncBean(obj: TaskSuggestionSyncBean | null): TaskSuggestionSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    isSync: encodeboolean(obj.isSync),
    listType: encodeEnum(obj.listType),
    locale: encodeString(obj.locale),
    suggestions: encodeArray(encodeString)(obj.suggestions),
    syncToken: encodeString(obj.syncToken)
  } as TaskSuggestionSyncBeanJSON);
}

type TaskSuggestionSyncBeanWCategoryJSON = {
  isSync: string;
  listType: TaskListTypeEnum;
  locale: string;
  suggestions?: Array<TaskSuggestionBeanJSON>;
  syncToken: string;
};

export class TaskSuggestionSyncBeanWCategory extends ServerBeanPrototype {
  /** if true this only contains partial response, if false it contains all response 
 and client shall delete local list before taking "updatedCreated"
 @param isSync */
  isSync!: boolean;
  /** The type of list for this suggestion response
 @param listType the listType to set */
  listType!: TaskListTypeEnum;
  /** The locale for this suggestion response
 @param locale the locale to set */
  locale!: string;
  /** The suggestion list, will be null if fast sync or empty
 @param suggestions the suggestions to set */
  suggestions?: Array<TaskSuggestionBean>;
  /** Sync Token...
 @param syncToken the syncToken to set */
  syncToken!: string;

  constructor(json: TaskSuggestionSyncBeanWCategoryJSON) {
    super(json);
    this.isSync = decodeboolean(json.isSync);
    this.listType = decodeEnum(json.listType);
    this.locale = decodeString(json.locale);
    this.suggestions = decodeArray(decodeTaskSuggestionBean)(json.suggestions);
    this.syncToken = decodeString(json.syncToken);
    this.onDecode(json);
  }
}

function decodeTaskSuggestionSyncBeanWCategory(json: TaskSuggestionSyncBeanWCategoryJSON | undefined): TaskSuggestionSyncBeanWCategory | undefined {
  return json === undefined ? undefined : new TaskSuggestionSyncBeanWCategory(json);
}

function encodeTaskSuggestionSyncBeanWCategory(obj: TaskSuggestionSyncBeanWCategory | null): TaskSuggestionSyncBeanWCategoryJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    isSync: encodeboolean(obj.isSync),
    listType: encodeEnum(obj.listType),
    locale: encodeString(obj.locale),
    suggestions: encodeArray(encodeTaskSuggestionBean)(obj.suggestions),
    syncToken: encodeString(obj.syncToken)
  } as TaskSuggestionSyncBeanWCategoryJSON);
}

type TaskSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<TaskBeanJSON>;
};

export class TaskSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<TaskBean>;

  constructor(json: TaskSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeTaskBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeTaskSyncBean(json: TaskSyncBeanJSON | undefined): TaskSyncBean | undefined {
  return json === undefined ? undefined : new TaskSyncBean(json);
}

function encodeTaskSyncBean(obj: TaskSyncBean | null): TaskSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeTaskBean)(obj.updatedCreated)
  } as TaskSyncBeanJSON);
}

type TimetableBeanJSON = {
  accountId: string;
  allDay?: string;
  calendarFirstDayOfWeek?: string;
  creationDate: string;
  dailyBriefNothingPlannedActivated?: string;
  dailyBriefPushActivated?: string;
  defaultReminderType?: ReminderTypeEnum;
  defaultReminderUnit?: ReminderUnitEnum;
  defaultReminderValue?: string;
  emoji?: string;
  endDate?: string;
  familyId: string;
  finishDate?: string;
  firstOccurrenceOffset?: string;
  icalSubscriptionUrl?: string;
  metaId: string;
  name?: string;
  reminderActivated?: string;
  rights?: FizRightBeanJSON;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
  showWeekends?: string;
  startDate?: string;
} & RecurrencyDescriptorJSON;

export class TimetableBean extends ServerBeanPrototype {
  accountId!: number;
  /** always true for timetable, allows to compute correct reccurrence of all weeks */
  allDay?: boolean;
  /** the first day of the week, as specified in settingsperfamily: <br> 
 the nb of the first day of the week to be taken into account in the calendar display. 1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
 Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1. Default value depends on the locale of the user.
 @param calendarFirstDayOfWeek the calendarFirstDayOfWeek to set */
  calendarFirstDayOfWeek?: number;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** flag indicating if the timetable daily brief is sent even if empty
 @param dailyBriefNothingPlannedActivated the dailyBriefNothingPlannedActivated to set */
  dailyBriefNothingPlannedActivated?: boolean;
  /** flag indicating if the timetable daily brief is active
 @param dailyBriefPushActivated the dailyBriefPushActivated to set */
  dailyBriefPushActivated?: boolean;
  /** default reminder type for timetable events (reminders have type,unit and value)
 @param defaultReminderType */
  defaultReminderType?: ReminderTypeEnum;
  /** default reminder unit for timetable events (reminders have type,unit and value)
 @param defaultReminderUnit */
  defaultReminderUnit?: ReminderUnitEnum;
  /** default reminder value for timetable events (reminders have type,unit and value)
 @param defaultReminderValue */
  defaultReminderValue?: number;
  /** the emoji of the timetable
 @param emoji the emoji to set */
  emoji?: string;
  /** The endDate of the first occurence of the timetable, ie the date of the last day of the last week of the first occurrence
 DO NOT USE THAT FOR UI */
  endDate?: Date;
  /** @param familyId the familyId to set */
  familyId!: number;
  /** The date at which the timetable finish, ie the date of the last occurrence of the timetable, use that for UI<br>
 note before you yell: finishDate is not exactly as the recurrencyEndDate because it may exist with a recurrency=NONE which is not the case of recurrencyEndDate<br>
 but is the recurrencyEndDate in all other cases and stored in the database in the recurrencyEndDate
 @param finishDate the finishDate to set */
  finishDate?: Date;
  /** The offset of the first occurrence of the recurrence, used to display the correct name of the current occurrence in the UI<br>&nbsp;<br>
 Correspond in the UI to "your schedule starts" or "1st xxx of schedule" and could be "Week A", "Week B", "Week C", etc<br> 
 In this example, if "Week A" offset=0, if "Week B" offset = 1, etc...
 @param firstOccurrenceOffset the firstOccurrenceOffset to set */
  firstOccurrenceOffset?: number;
  /** Optional, The URL of the ical subscription, if this timetable has subscribed to an external ical url<br>
 If not null:<ul>
     <li>The recurrency MUST be NONE and the timetable is a one-time timetable.</li>
     <li>The events from the ics from the url will be automatically imported and merged with existing events in the timetable and sync'ed to client</li>
     <li>Those events will have a different metaid: <pre>extCalendarByUrlEvent/{timetableLongId}_{eventId}</pre>
         where {timetableLongId} is the last Long (456) in the timetable own metaid (timetable/123_456);
         and the {eventId} a generated sequence of long starting at zero, local to the timetable.</li>
     <li>Those events will have a different type: EXTERNAL</li>
 </ul>
 @param icalSubscriptionUrl the ical url subscription */
  icalSubscriptionUrl?: string;
  metaId!: string;
  /** The name of the timetable
 @param name the name to set */
  name?: string;
  /** the reccurrency descriptor of the timetable */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** Indicate if the reminder is activated for the currently loggued account. In db there is a value for each members.<br>
 Combined with defaultReminderType it indicate if there is an alarm for any events in this timetable targetted to the loggued member, but
 defaultReminderType is a global flag for all members in this timetable.
 @param reminderActivated the reminderActivated to set */
  reminderActivated?: boolean;
  rights?: FizRightBean;
  /** list of members who can see this list. This list always contains the author of the list.<br>
 Those are account ids (member). <br>
 @param sharedMemberIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this budget is shared<br>
 If null it is in case of an update to indicate it is not changed. */
  sharedToAll?: boolean;
  /** flag indicating if we shall display weekends
 @param showWeekends the showWeekends to set */
  showWeekends?: boolean;
  /** the startDate of the timetable, ie date of the first day of the first week
 @param */
  startDate?: Date;

  constructor(json: TimetableBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.allDay = decodeBoolean(json.allDay);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.creationDate = decodeDate(json.creationDate);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.emoji = decodeString(json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.familyId = decodeNumber(json.familyId);
    this.finishDate = decodeDate(json.finishDate);
    this.firstOccurrenceOffset = decodeNumber(json.firstOccurrenceOffset);
    this.icalSubscriptionUrl = decodeString(json.icalSubscriptionUrl);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.showWeekends = decodeBoolean(json.showWeekends);
    this.startDate = decodeDate(json.startDate);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeTimetableBean(json: TimetableBeanJSON | undefined): TimetableBean | undefined {
  return json === undefined ? undefined : new TimetableBean(json);
}

function encodeTimetableBean(obj: TimetableBean | null): TimetableBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    allDay: encodeBoolean(obj.allDay),
    calendarFirstDayOfWeek: encodeNumber(obj.calendarFirstDayOfWeek),
    creationDate: encodeDate(obj.creationDate),
    dailyBriefNothingPlannedActivated: encodeBoolean(obj.dailyBriefNothingPlannedActivated),
    dailyBriefPushActivated: encodeBoolean(obj.dailyBriefPushActivated),
    defaultReminderType: encodeEnum(obj.defaultReminderType),
    defaultReminderUnit: encodeEnum(obj.defaultReminderUnit),
    defaultReminderValue: encodeNumber(obj.defaultReminderValue),
    emoji: encodeString(obj.emoji),
    endDate: encodeDate(obj.endDate),
    familyId: encodeNumber(obj.familyId),
    finishDate: encodeDate(obj.finishDate),
    firstOccurrenceOffset: encodeNumber(obj.firstOccurrenceOffset),
    icalSubscriptionUrl: encodeString(obj.icalSubscriptionUrl),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    reminderActivated: encodeBoolean(obj.reminderActivated),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll),
    showWeekends: encodeBoolean(obj.showWeekends),
    startDate: encodeDate(obj.startDate)
  } as TimetableBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type TimetableInputBeanJSON = {
  allDay?: string;
  calendarFirstDayOfWeek?: string;
  dailyBriefNothingPlannedActivated?: string;
  dailyBriefPushActivated?: string;
  defaultReminderType?: ReminderTypeEnum;
  defaultReminderUnit?: ReminderUnitEnum;
  defaultReminderValue?: string;
  emoji?: string;
  endDate?: string;
  finishDate?: string;
  firstOccurrenceOffset?: string;
  icalSubscriptionUrl?: string;
  metaId?: string;
  name?: string;
  reminderActivated?: string;
  sharedMemberIds?: Array<string>;
  sharedToAll?: string;
  showWeekends?: string;
  startDate?: string;
} & RecurrencyDescriptorJSON;

export class TimetableInputBean extends ServerBeanPrototype {
  /** always true for timetable, allows to compute correct reccurrence of all weeks */
  allDay?: boolean;
  /** the first day of the week, as specified in settingsperfamily: <br> 
 the nb of the first day of the week to be taken into account in the calendar display. 1=monday , 7=sunday. Note that in java.util.Calendar class sunday=1 and saturday=7.<br>
 Therefore javaCalendarDay = apiDay>=7?1:thisDay+1 . Day<1 or >7 are invalid and defaulted to 1. Default value depends on the locale of the user.
 @param calendarFirstDayOfWeek the calendarFirstDayOfWeek to set */
  calendarFirstDayOfWeek?: number;
  /** flag indicating if the timetable daily brief is sent even if empty
 @param dailyBriefNothingPlannedActivated the dailyBriefNothingPlannedActivated to set */
  dailyBriefNothingPlannedActivated?: boolean;
  /** flag indicating if the timetable daily brief is active
 @param dailyBriefPushActivated the dailyBriefPushActivated to set */
  dailyBriefPushActivated?: boolean;
  /** default reminder type for timetable events (reminders have type,unit and value)
 @param defaultReminderType */
  defaultReminderType?: ReminderTypeEnum;
  /** default reminder unit for timetable events (reminders have type,unit and value)
 @param defaultReminderUnit */
  defaultReminderUnit?: ReminderUnitEnum;
  /** default reminder value for timetable events (reminders have type,unit and value)
 @param defaultReminderValue */
  defaultReminderValue?: number;
  /** the emoji of the timetable
 @param emoji the emoji to set */
  emoji?: string;
  /** The endDate of the first occurence of the timetable, ie the date of the last day of the last week of the first occurrence
 DO NOT USE THAT FOR UI */
  endDate?: Date;
  /** The date at which the timetable finish, ie the date of the last occurrence of the timetable, use that for UI<br>
 note before you yell: finishDate is not exactly as the recurrencyEndDate because it may exist with a recurrency=NONE which is not the case of recurrencyEndDate<br>
 but is the recurrencyEndDate in all other cases and stored in the database in the recurrencyEndDate
 @param finishDate the finishDate to set */
  finishDate?: Date;
  /** The offset of the first occurrence of the recurrence, used to display the correct name of the current occurrence in the UI<br>&nbsp;<br>
 Correspond in the UI to "your schedule starts" or "1st xxx of schedule" and could be "Week A", "Week B", "Week C", etc<br> 
 In this example, if "Week A" offset=0, if "Week B" offset = 1, etc...
 @param firstOccurrenceOffset the firstOccurrenceOffset to set */
  firstOccurrenceOffset?: number;
  /** Optional, The URL of the ical subscription, if this timetable has subscribed to an external ical url<br>
 If not null:<ul>
     <li>The recurrency MUST be NONE and the timetable is a one-time timetable.</li>
     <li>The events from the ics from the url will be automatically imported and merged with existing events in the timetable and sync'ed to client</li>
     <li>Those events will have a different metaid: <pre>extCalendarByUrlEvent/{timetableLongId}_{eventId}</pre>
         where {timetableLongId} is the last Long (456) in the timetable own metaid (timetable/123_456);
         and the {eventId} a generated sequence of long starting at zero, local to the timetable.</li>
     <li>Those events will have a different type: EXTERNAL</li>
 </ul>
 @param icalSubscriptionUrl the ical url subscription */
  icalSubscriptionUrl?: string;
  /** the metaId of the timetable, type=calendarTimetable
 @param metaId the metaId to set */
  metaId?: string;
  /** The name of the timetable
 @param name the name to set */
  name?: string;
  /** the reccurrency descriptor of the timetable */
  recurrencyDescriptor?: RecurrencyDescriptor;
  /** Indicate if the reminder is activated for the currently loggued account. In db there is a value for each members.<br>
 Combined with defaultReminderType it indicate if there is an alarm for any events in this timetable targetted to the loggued member, but
 defaultReminderType is a global flag for all members in this timetable.
 @param reminderActivated the reminderActivated to set */
  reminderActivated?: boolean;
  /** list of members who can see this list. This list always contains the author of the list.<br>
 Those are account ids (member). <br>
 @param sharedMemberIds */
  sharedMemberIds?: Array<number>;
  /** flag indicating if this budget is shared<br>
 If null it is in case of an update to indicate it is not changed. */
  sharedToAll?: boolean;
  /** flag indicating if we shall display weekends
 @param showWeekends the showWeekends to set */
  showWeekends?: boolean;
  /** the startDate of the timetable, ie date of the first day of the first week
 @param */
  startDate?: Date;

  constructor(json: TimetableInputBeanJSON) {
    super(json);
    this.allDay = decodeBoolean(json.allDay);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.emoji = decodeString(json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.finishDate = decodeDate(json.finishDate);
    this.firstOccurrenceOffset = decodeNumber(json.firstOccurrenceOffset);
    this.icalSubscriptionUrl = decodeString(json.icalSubscriptionUrl);
    this.metaId = decodeMetaId(json.metaId);
    this.name = decodeString(json.name);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.showWeekends = decodeBoolean(json.showWeekends);
    this.startDate = decodeDate(json.startDate);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.onDecode(json);
  }
}

function decodeTimetableInputBean(json: TimetableInputBeanJSON | undefined): TimetableInputBean | undefined {
  return json === undefined ? undefined : new TimetableInputBean(json);
}

function encodeTimetableInputBean(obj: TimetableInputBean | null): TimetableInputBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    allDay: encodeBoolean(obj.allDay),
    calendarFirstDayOfWeek: encodeNumber(obj.calendarFirstDayOfWeek),
    dailyBriefNothingPlannedActivated: encodeBoolean(obj.dailyBriefNothingPlannedActivated),
    dailyBriefPushActivated: encodeBoolean(obj.dailyBriefPushActivated),
    defaultReminderType: encodeEnum(obj.defaultReminderType),
    defaultReminderUnit: encodeEnum(obj.defaultReminderUnit),
    defaultReminderValue: encodeNumber(obj.defaultReminderValue),
    emoji: encodeString(obj.emoji),
    endDate: encodeDate(obj.endDate),
    finishDate: encodeDate(obj.finishDate),
    firstOccurrenceOffset: encodeNumber(obj.firstOccurrenceOffset),
    icalSubscriptionUrl: encodeString(obj.icalSubscriptionUrl),
    metaId: encodeMetaId(obj.metaId),
    name: encodeString(obj.name),
    reminderActivated: encodeBoolean(obj.reminderActivated),
    sharedMemberIds: encodeArray(encodeNumber)(obj.sharedMemberIds),
    sharedToAll: encodeBoolean(obj.sharedToAll),
    showWeekends: encodeBoolean(obj.showWeekends),
    startDate: encodeDate(obj.startDate)
  } as TimetableInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor));
}

type TimetableSyncBeanJSON = {
  deletedIds: Array<string>;
  isSync: string;
  syncToken: string;
  updatedCreated: Array<TimetableBeanJSON>;
};

export class TimetableSyncBean extends ServerBeanPrototype {
  deletedIds!: Array<string>;
  isSync!: boolean;
  syncToken!: string;
  updatedCreated!: Array<TimetableBean>;

  constructor(json: TimetableSyncBeanJSON) {
    super(json);
    this.deletedIds = decodeArray(decodeMetaId)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = decodeString(json.syncToken);
    this.updatedCreated = decodeArray(decodeTimetableBean)(json.updatedCreated);
    this.onDecode(json);
  }
}

function decodeTimetableSyncBean(json: TimetableSyncBeanJSON | undefined): TimetableSyncBean | undefined {
  return json === undefined ? undefined : new TimetableSyncBean(json);
}

function encodeTimetableSyncBean(obj: TimetableSyncBean | null): TimetableSyncBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    deletedIds: encodeArray(encodeMetaId)(obj.deletedIds),
    isSync: encodeboolean(obj.isSync),
    syncToken: encodeString(obj.syncToken),
    updatedCreated: encodeArray(encodeTimetableBean)(obj.updatedCreated)
  } as TimetableSyncBeanJSON);
}

type TokenAndAccountLogInfoBeanJSON = {
  accessToken?: AccessTokenBeanJSON;
  email?: string;
  invitationId?: string;
  logInfo?: AccountLoginInfoJSON;
  recipeId?: string;
  redirectUrl?: string;
  tokenType?: TokenTypeEnum;
};

export class TokenAndAccountLogInfoBean extends ServerBeanPrototype {
  accessToken?: AccessTokenBean;
  email?: string;
  invitationId?: string;
  /** The login info bean as when we log, may be null if this token does not allow the user to log-in.
 @param logInfo the logInfo to set */
  logInfo?: AccountLoginInfo;
  recipeId?: string;
  /** The url where this token shall redirect on the web
 @param redirectURl the redirectURl to set */
  redirectUrl?: string;
  tokenType?: TokenTypeEnum;

  constructor(json: TokenAndAccountLogInfoBeanJSON) {
    super(json);
    this.accessToken = decodeAccessTokenBean(json.accessToken);
    this.email = decodeString(json.email);
    this.invitationId = decodeMetaId(json.invitationId);
    this.logInfo = decodeAccountLoginInfo(json.logInfo);
    this.recipeId = decodeMetaId(json.recipeId);
    this.redirectUrl = decodeString(json.redirectUrl);
    this.tokenType = decodeEnum(json.tokenType);
    this.onDecode(json);
  }
}

function decodeTokenAndAccountLogInfoBean(json: TokenAndAccountLogInfoBeanJSON | undefined): TokenAndAccountLogInfoBean | undefined {
  return json === undefined ? undefined : new TokenAndAccountLogInfoBean(json);
}

function encodeTokenAndAccountLogInfoBean(obj: TokenAndAccountLogInfoBean | null): TokenAndAccountLogInfoBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accessToken: encodeAccessTokenBean(obj.accessToken),
    email: encodeString(obj.email),
    invitationId: encodeMetaId(obj.invitationId),
    logInfo: encodeAccountLoginInfo(obj.logInfo),
    recipeId: encodeMetaId(obj.recipeId),
    redirectUrl: encodeString(obj.redirectUrl),
    tokenType: encodeEnum(obj.tokenType)
  } as TokenAndAccountLogInfoBeanJSON);
}

type TokenBeanJSON = {
  accountId?: string;
  accountIdentifierId?: string;
  clickMaxCount?: string;
  clickcount: string;
  clientPartnerType?: PartnerTypeEnum;
  creationDate: string;
  email?: string;
  expirationDate?: string;
  familyId?: string;
  persistentNameRef?: string;
  sms?: string;
  smsInternational?: string;
  tokenId: string;
  tokenRefMetaId?: string;
  type: TokenTypeEnum;
};

export class TokenBean extends ServerBeanPrototype {
  accountId?: number;
  /** @param accountIdentifierId the accountIdentifierId to set */
  accountIdentifierId?: number;
  /** @param clickMaxCount the clickMaxCount to set */
  clickMaxCount?: number;
  /** @param clickcount the clickcount to set */
  clickcount!: number;
  /** @param clientPartnerType the clientPartnerType to set */
  clientPartnerType?: PartnerTypeEnum;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  /** @param email the email to set */
  email?: string;
  /** @param expirationDate the expirationDate to set */
  expirationDate?: Date;
  /** @param familyId the familyId to set */
  familyId?: number;
  /** @param persistentNameRef the persistentNameRef to set */
  persistentNameRef?: string;
  /** @param sms the sms to set */
  sms?: string;
  /** @param smsInternational the smsInternational to set */
  smsInternational?: boolean;
  /** @param tokenId the tokenId to set */
  tokenId!: number;
  tokenRefMetaId?: string;
  /** @param type the type to set */
  type!: TokenTypeEnum;

  constructor(json: TokenBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.accountIdentifierId = decodeNumber(json.accountIdentifierId);
    this.clickMaxCount = decodeNumber(json.clickMaxCount);
    this.clickcount = decodenumber(json.clickcount);
    this.clientPartnerType = decodeEnum(json.clientPartnerType);
    this.creationDate = decodeDate(json.creationDate);
    this.email = decodeString(json.email);
    this.expirationDate = decodeDate(json.expirationDate);
    this.familyId = decodeNumber(json.familyId);
    this.persistentNameRef = decodeString(json.persistentNameRef);
    this.sms = decodeString(json.sms);
    this.smsInternational = decodeBoolean(json.smsInternational);
    this.tokenId = decodenumber(json.tokenId);
    this.tokenRefMetaId = decodeMetaId(json.tokenRefMetaId);
    this.type = decodeEnum(json.type);
    this.onDecode(json);
  }
}

function decodeTokenBean(json: TokenBeanJSON | undefined): TokenBean | undefined {
  return json === undefined ? undefined : new TokenBean(json);
}

function encodeTokenBean(obj: TokenBean | null): TokenBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    accountIdentifierId: encodeNumber(obj.accountIdentifierId),
    clickMaxCount: encodeNumber(obj.clickMaxCount),
    clickcount: encodenumber(obj.clickcount),
    clientPartnerType: encodeEnum(obj.clientPartnerType),
    creationDate: encodeDate(obj.creationDate),
    email: encodeString(obj.email),
    expirationDate: encodeDate(obj.expirationDate),
    familyId: encodeNumber(obj.familyId),
    persistentNameRef: encodeString(obj.persistentNameRef),
    sms: encodeString(obj.sms),
    smsInternational: encodeBoolean(obj.smsInternational),
    tokenId: encodenumber(obj.tokenId),
    tokenRefMetaId: encodeMetaId(obj.tokenRefMetaId),
    type: encodeEnum(obj.type)
  } as TokenBeanJSON);
}

type TokenUrlBeanJSON = {
  expirationDate?: string;
  link: string;
};

export class TokenUrlBean extends ServerBeanPrototype {
  /** the date at which this inviation will be invalidated. Typically inviation by links are limited in time
 @param expirationDate */
  expirationDate?: Date;
  /** the link of the inviation, anybody that clicks on this link can join
 @param link */
  link!: string;

  constructor(json: TokenUrlBeanJSON) {
    super(json);
    this.expirationDate = decodeDate(json.expirationDate);
    this.link = decodeString(json.link);
    this.onDecode(json);
  }
}

function decodeTokenUrlBean(json: TokenUrlBeanJSON | undefined): TokenUrlBean | undefined {
  return json === undefined ? undefined : new TokenUrlBean(json);
}

function encodeTokenUrlBean(obj: TokenUrlBean | null): TokenUrlBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    expirationDate: encodeDate(obj.expirationDate),
    link: encodeString(obj.link)
  } as TokenUrlBeanJSON);
}

type TwoCheckoutPriceBeanJSON = {
  buyUrl: string;
  currency: string;
  priceFloat: string;
  trialDays: string;
};

export class TwoCheckoutPriceBean extends ServerBeanPrototype {
  buyUrl!: string;
  currency!: string;
  priceFloat!: number;
  trialDays!: number;

  constructor(json: TwoCheckoutPriceBeanJSON) {
    super(json);
    this.buyUrl = decodeString(json.buyUrl);
    this.currency = decodeString(json.currency);
    this.priceFloat = decodeNumber(json.priceFloat);
    this.trialDays = decodenumber(json.trialDays);
    this.onDecode(json);
  }
}

function decodeTwoCheckoutPriceBean(json: TwoCheckoutPriceBeanJSON | undefined): TwoCheckoutPriceBean | undefined {
  return json === undefined ? undefined : new TwoCheckoutPriceBean(json);
}

function encodeTwoCheckoutPriceBean(obj: TwoCheckoutPriceBean | null): TwoCheckoutPriceBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    buyUrl: encodeString(obj.buyUrl),
    currency: encodeString(obj.currency),
    priceFloat: encodeNumber(obj.priceFloat),
    trialDays: encodenumber(obj.trialDays)
  } as TwoCheckoutPriceBeanJSON);
}

type TwoCheckoutPricePromoBeanJSON = {
  buyUrl: string;
  currency: string;
  endDate?: string;
  percent: string;
  priceFloat: string;
  trialDays: string;
};

export class TwoCheckoutPricePromoBean extends ServerBeanPrototype {
  buyUrl!: string;
  currency!: string;
  endDate?: Date;
  percent!: number;
  priceFloat!: number;
  trialDays!: number;

  constructor(json: TwoCheckoutPricePromoBeanJSON) {
    super(json);
    this.buyUrl = decodeString(json.buyUrl);
    this.currency = decodeString(json.currency);
    this.endDate = decodeDate(json.endDate);
    this.percent = decodeNumber(json.percent);
    this.priceFloat = decodeNumber(json.priceFloat);
    this.trialDays = decodenumber(json.trialDays);
    this.onDecode(json);
  }
}

function decodeTwoCheckoutPricePromoBean(json: TwoCheckoutPricePromoBeanJSON | undefined): TwoCheckoutPricePromoBean | undefined {
  return json === undefined ? undefined : new TwoCheckoutPricePromoBean(json);
}

function encodeTwoCheckoutPricePromoBean(obj: TwoCheckoutPricePromoBean | null): TwoCheckoutPricePromoBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    buyUrl: encodeString(obj.buyUrl),
    currency: encodeString(obj.currency),
    endDate: encodeDate(obj.endDate),
    percent: encodeNumber(obj.percent),
    priceFloat: encodeNumber(obj.priceFloat),
    trialDays: encodenumber(obj.trialDays)
  } as TwoCheckoutPricePromoBeanJSON);
}

type TwoCheckoutUrlsBean2JSON = {
  monthly: TwoCheckoutPriceBeanJSON;
  monthlyPromo?: TwoCheckoutPricePromoBeanJSON;
  yearly: TwoCheckoutPriceBeanJSON;
  yearlyPromo?: TwoCheckoutPricePromoBeanJSON;
};

export class TwoCheckoutUrlsBean2 extends ServerBeanPrototype {
  monthly!: TwoCheckoutPriceBean;
  monthlyPromo?: TwoCheckoutPricePromoBean;
  yearly!: TwoCheckoutPriceBean;
  yearlyPromo?: TwoCheckoutPricePromoBean;

  constructor(json: TwoCheckoutUrlsBean2JSON) {
    super(json);
    this.monthly = decodeTwoCheckoutPriceBean(json.monthly);
    this.monthlyPromo = decodeTwoCheckoutPricePromoBean(json.monthlyPromo);
    this.yearly = decodeTwoCheckoutPriceBean(json.yearly);
    this.yearlyPromo = decodeTwoCheckoutPricePromoBean(json.yearlyPromo);
    this.onDecode(json);
  }
}

function decodeTwoCheckoutUrlsBean2(json: TwoCheckoutUrlsBean2JSON | undefined): TwoCheckoutUrlsBean2 | undefined {
  return json === undefined ? undefined : new TwoCheckoutUrlsBean2(json);
}

function encodeTwoCheckoutUrlsBean2(obj: TwoCheckoutUrlsBean2 | null): TwoCheckoutUrlsBean2JSON | undefined {
  if (obj == null) return undefined;
  return inline({
    monthly: encodeTwoCheckoutPriceBean(obj.monthly),
    monthlyPromo: encodeTwoCheckoutPricePromoBean(obj.monthlyPromo),
    yearly: encodeTwoCheckoutPriceBean(obj.yearly),
    yearlyPromo: encodeTwoCheckoutPricePromoBean(obj.yearlyPromo)
  } as TwoCheckoutUrlsBean2JSON);
}

type VcardImportPreviewBeanJSON = {
  content: Array<ContactBeanJSON>;
  count: string;
  created: string;
  error: string;
  ignored: string;
  updated: string;
};

export class VcardImportPreviewBean extends ServerBeanPrototype {
  /** filled only in preview mode, contacts with a metaId will be updated, the others added */
  content!: Array<ContactBean>;
  /** number of contacts in the vcard file */
  count!: number;
  /** number of contacts not already present in the server, and actually new in the vcard file, therefore created on the server */
  created!: number;
  /** number of contacts in error */
  error!: number;
  /** number of contacts not checked in the indexes in input */
  ignored!: number;
  /** number of contacts already in the server and that therefore have been updated (identified by name matching) */
  updated!: number;

  constructor(json: VcardImportPreviewBeanJSON) {
    super(json);
    this.content = decodeArray(decodeContactBean)(json.content);
    this.count = decodenumber(json.count);
    this.created = decodenumber(json.created);
    this.error = decodenumber(json.error);
    this.ignored = decodenumber(json.ignored);
    this.updated = decodenumber(json.updated);
    this.onDecode(json);
  }
}

function decodeVcardImportPreviewBean(json: VcardImportPreviewBeanJSON | undefined): VcardImportPreviewBean | undefined {
  return json === undefined ? undefined : new VcardImportPreviewBean(json);
}

function encodeVcardImportPreviewBean(obj: VcardImportPreviewBean | null): VcardImportPreviewBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    content: encodeArray(encodeContactBean)(obj.content),
    count: encodenumber(obj.count),
    created: encodenumber(obj.created),
    error: encodenumber(obj.error),
    ignored: encodenumber(obj.ignored),
    updated: encodenumber(obj.updated)
  } as VcardImportPreviewBeanJSON);
}

type WallMessageBeanJSON = {
  accountId: string;
  bestMoment?: string;
  comments?: Array<ICommentJSON>;
  creationDate: string;
  editable?: string;
  event?: IEventJSON;
  extra?: FizJSONObject;
  familyId: string;
  medias?: Array<IMediaJSON>;
  metaId?: string;
  modifDate: string;
  moodMap?: {[key:string]:Array<MoodEnum>};
  moodStarShortcut?: string;
  nested?: IHasMetaIdJSON;
  place?: IPlaceJSON;
  postAccountId: string;
  refAction?: RefObjectActionEnum;
  refId?: string;
  refType?: RefObjectTypeEnum;
  rights?: FizRightBeanJSON;
  sortingDate: string;
  text?: string;
  wallMessageId: string;
};

export class WallMessageBean extends ServerBeanPrototype {
  /** @param accountId the accountId to set */
  accountId!: number;
  bestMoment?: boolean;
  /** @param wallMessageComments the wallMessageComments to set */
  comments?: Array<IComment>;
  /** @param creationDate the creationDate to set */
  creationDate!: Date;
  editable?: boolean;
  event?: IEvent;
  extra?: JsonFw;
  /** @param familyId the familyId to set */
  familyId!: string;
  medias?: Array<IMedia>;
  metaId?: string;
  /** @param modifDate the modifDate to set */
  modifDate!: Date;
  moodMap?: Map<number, Array<MoodEnum>>;
  /** @param moodStarShortcut the moodStarShortcut to set */
  moodStarShortcut?: boolean;
  /** @param nested the nested to set */
  nested?: IHasMetaId;
  place?: IPlace;
  /** @param postAccountId the postAccountId to set */
  postAccountId!: number;
  /** @param refObjectAction the refObjectAction to set */
  refAction?: RefObjectActionEnum;
  /** @param refObjectId the refObjectId to set */
  refId?: string;
  /** @param refObjectType the refObjectType to set */
  refType?: RefObjectTypeEnum;
  rights?: FizRightBean;
  sortingDate!: Date;
  /** @param text the text to set */
  text?: string;
  /** @param wallMessageId the wallMessageId to set */
  wallMessageId!: string;

  constructor(json: WallMessageBeanJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.creationDate = decodeDate(json.creationDate);
    this.editable = decodeBoolean(json.editable);
    this.event = decodeIEvent(json.event);
    this.extra = decodeFizJSONObject(json.extra);
    this.familyId = decodeMetaId(json.familyId);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = decodeMetaId(json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.nested = decodeDynamic(json.nested) as IHasMetaId;
    this.place = decodeIPlace(json.place);
    this.postAccountId = decodeNumber(json.postAccountId);
    this.refAction = decodeEnum(json.refAction);
    this.refId = decodeMetaId(json.refId);
    this.refType = decodeEnum(json.refType);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingDate = decodeDate(json.sortingDate);
    this.text = decodeString(json.text);
    this.wallMessageId = decodeMetaId(json.wallMessageId);
    this.onDecode(json);
  }
}

function decodeWallMessageBean(json: WallMessageBeanJSON | undefined): WallMessageBean | undefined {
  return json === undefined ? undefined : new WallMessageBean(json);
}

function encodeWallMessageBean(obj: WallMessageBean | null): WallMessageBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    creationDate: encodeDate(obj.creationDate),
    editable: encodeBoolean(obj.editable),
    event: encodeIEvent(obj.event),
    extra: encodeFizJSONObject(obj.extra),
    familyId: encodeMetaId(obj.familyId),
    medias: encodeArray(encodeIMedia)(obj.medias),
    metaId: encodeMetaId(obj.metaId),
    modifDate: encodeDate(obj.modifDate),
    nested: encodeDynamic(obj.nested),
    place: encodeIPlace(obj.place),
    postAccountId: encodeNumber(obj.postAccountId),
    refAction: encodeEnum(obj.refAction),
    refId: encodeMetaId(obj.refId),
    refType: encodeEnum(obj.refType),
    rights: encodeFizRightBean(obj.rights),
    sortingDate: encodeDate(obj.sortingDate),
    text: encodeString(obj.text),
    wallMessageId: encodeMetaId(obj.wallMessageId)
  } as WallMessageBeanJSON);
}

type WeatherBeanJSON = {
  celciusFloat: string;
  city: string;
  date: string;
  icon?: string;
  tempAsString: string;
  weather: WeatherEnum;
};

export class WeatherBean extends ServerBeanPrototype {
  celciusFloat!: number;
  /** city of the current Weather
 @param city */
  city!: string;
  /** date of the weather information
 @param date */
  date!: Date;
  /** icon url for the weather, it is better to use our own icons depending of the WeatherEnum
 @param icon */
  icon?: string;
  /** temparature as string
 @param tempAsString */
  tempAsString!: string;
  /** global weather
 @param weather */
  weather!: WeatherEnum;

  constructor(json: WeatherBeanJSON) {
    super(json);
    this.celciusFloat = decodeNumber(json.celciusFloat);
    this.city = decodeString(json.city);
    this.date = decodeDate(json.date);
    this.icon = decodeString(json.icon);
    this.tempAsString = decodeString(json.tempAsString);
    this.weather = decodeEnum(json.weather);
    this.onDecode(json);
  }
}

function decodeWeatherBean(json: WeatherBeanJSON | undefined): WeatherBean | undefined {
  return json === undefined ? undefined : new WeatherBean(json);
}

function encodeWeatherBean(obj: WeatherBean | null): WeatherBeanJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    celciusFloat: encodeNumber(obj.celciusFloat),
    city: encodeString(obj.city),
    date: encodeDate(obj.date),
    icon: encodeString(obj.icon),
    tempAsString: encodeString(obj.tempAsString),
    weather: encodeEnum(obj.weather)
  } as WeatherBeanJSON);
}

type WebSocketPushMessageJSON = {
  accountId?: string;
  push?: PushMessageBeanJSON;
  type?: string;
};

export class WebSocketPushMessage extends ServerBeanPrototype {
  /** accountId target of the push, need to find which server(s) has a websocket connected with this user
 @param accountId */
  accountId?: number;
  /** if it is a push then this property contains it
 @param push */
  push?: PushMessageBean;
  /** web type of message might be "push" "SessionClosed" "pingok"
 maybe an enum would be better */
  type?: string;

  constructor(json: WebSocketPushMessageJSON) {
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.push = decodePushMessageBean(json.push);
    this.type = decodeString(json.type);
    this.onDecode(json);
  }
}

function decodeWebSocketPushMessage(json: WebSocketPushMessageJSON | undefined): WebSocketPushMessage | undefined {
  return json === undefined ? undefined : new WebSocketPushMessage(json);
}

function encodeWebSocketPushMessage(obj: WebSocketPushMessage | null): WebSocketPushMessageJSON | undefined {
  if (obj == null) return undefined;
  return inline({
    accountId: encodeNumber(obj.accountId),
    push: encodePushMessageBean(obj.push),
    type: encodeString(obj.type)
  } as WebSocketPushMessageJSON);
}

// ============================================================================
// Types Registry (internal use for dynamic access)
// ============================================================================

const types: Record<string, any> = {
  ServerBeanPrototype,
  ServerError,
  AFizApiException: ServerError,
  AFizApiUnattendedException: ServerError,
  CCareUserAlreadyExistsException: ServerError,
  "702": ServerError,
  CCareUserNotFoundException: ServerError,
  "701": ServerError,
  FizAccountAlreadyExistsException: ServerError,
  "2": ServerError,
  FizAccountAlreadyHasAFirstFamilyException: ServerError,
  "11": ServerError,
  FizAccountAlreadyInThisFamilyException: ServerError,
  "12": ServerError,
  FizAccountBlockedForPasswordException: ServerError,
  "26": ServerError,
  FizAccountDoesNotExistException: ServerError,
  "507": ServerError,
  FizAccountIdentifierNotValidatedException: ServerError,
  "4": ServerError,
  FizAccountNotFoundException: ServerError,
  "1": ServerError,
  FizAccountNotFoundInSessionException: ServerError,
  "501": ServerError,
  FizAdultContentException: ServerError,
  "181818": ServerError,
  FizApiAccIdentifierInvalidException: ServerError,
  "21": ServerError,
  FizApiAccIdentifierNotvalidatedException: ServerError,
  "24": ServerError,
  FizApiAddressNotGeocodableException: ServerError,
  "28": ServerError,
  FizApiDistinctOccurenceIntersectException: ServerError,
  "23": ServerError,
  FizApiDuplicateModelException: ServerError,
  "63": ServerError,
  FizApiEmailInvalidException: ServerError,
  "17": ServerError,
  FizApiIcalContentInvalidException: ServerError,
  "408": ServerError,
  FizApiIcalUrlDuplicateException: ServerError,
  "406": ServerError,
  FizApiIcalUrlInvalidException: ServerError,
  "405": ServerError,
  FizApiInvalidParameterException: ServerError,
  "502": ServerError,
  FizApiKeyInsufficientRightsException: ServerError,
  "509": ServerError,
  FizApiKeyNotFoundException: ServerError,
  "10": ServerError,
  FizApiModelDoesNotExistException: ServerError,
  "503": ServerError,
  FizApiModelRightException: ServerError,
  "504": ServerError,
  FizApiMsisdnInvalidException: ServerError,
  "22": ServerError,
  FizApiPremiumRequiredException: ServerError,
  "505": ServerError,
  FizApiPromoCodeExpiredException: ServerError,
  "403": ServerError,
  FizApiStringTooLongException: ServerError,
  "5020": ServerError,
  FizApiTimetableEventWillBeDeletedException: ServerError,
  "407": ServerError,
  FizApiUnattendedExceptionDefaultImpl: ServerError,
  "500": ServerError,
  FizApiUserBlockedException: ServerError,
  "18": ServerError,
  FizApplicationVersionIncompatibleException: ServerError,
  "14": ServerError,
  FizAutologinTokenExpiredException: ServerError,
  "8": ServerError,
  FizContactAlreadyExistsException: ServerError,
  "200": ServerError,
  FizCredentialInvalidException: ServerError,
  "3": ServerError,
  FizDeviceIdMismatchException: ServerError,
  "15": ServerError,
  FizFamilyAlreadyExistWithThisNameException: ServerError,
  "13": ServerError,
  FizFamilyDoesNotExistException: ServerError,
  "510": ServerError,
  FizGPlayStoreCannotTalkToGoogleException: ServerError,
  "402": ServerError,
  FizGeofenceForThisPlaceDisabledException: ServerError,
  "29": ServerError,
  FizGeolocDisabledException: ServerError,
  "27": ServerError,
  FizGeolocSettingsDisabledException: ServerError,
  "30": ServerError,
  FizITunesCannotTalkToAppleException: ServerError,
  "401": ServerError,
  FizInvalidTokenException: ServerError,
  "16": ServerError,
  FizInvitationAlreadyExistException: ServerError,
  "19": ServerError,
  FizLimitReachedException: ServerError,
  "610": ServerError,
  FizMediaCorruptedException: ServerError,
  "602": ServerError,
  FizMediaQuotaExceededException: ServerError,
  "601": ServerError,
  FizNotEnougthRightException: ServerError,
  "7": ServerError,
  FizPersistenceOptimisticLockException: ServerError,
  "508": ServerError,
  FizPremiumOngoingException: ServerError,
  "65": ServerError,
  FizRuntimeLimitReachedException: ServerError,
  "611": ServerError,
  FizSecurityException: ServerError,
  "506": ServerError,
  FizTokenNeededException: ServerError,
  "31": ServerError,
  AccessTokenBean,
  AccountActivityBean,
  "25": AccountActivityBean,
  AccountBean,
  AccountIdentifierBean,
  AccountIdentifierInfo,
  AccountLoginInfo,
  AccountSecurityBean,
  AccountStateBean,
  AddressBean,
  AdminRightBean,
  AiInboxResponseBean,
  ApiKeyBean,
  ApplicationBlockedPopupBean,
  "49": ApplicationBlockedPopupBean,
  AssigneeBean,
  AttendeeBean,
  BackgroundThreadStatusBean,
  BroadcastSignalMessage,
  "800": BroadcastSignalMessage,
  BudgetBean,
  "58": BudgetBean,
  BudgetCategoryBean,
  "51": BudgetCategoryBean,
  BudgetCategoryInputBean,
  "54": BudgetCategoryInputBean,
  BudgetCategorySyncBean,
  "55": BudgetCategorySyncBean,
  BudgetInputBean,
  "57": BudgetInputBean,
  BudgetSyncBean,
  "61": BudgetSyncBean,
  BudgetTransactionBean,
  "60": BudgetTransactionBean,
  BudgetTransactionInputBean,
  "59": BudgetTransactionInputBean,
  BudgetTransactionSyncBean,
  "62": BudgetTransactionSyncBean,
  CCareUserBean,
  "700": CCareUserBean,
  CacheInvalidatedMessageBean,
  "810": CacheInvalidatedMessageBean,
  CalendarBean,
  "3100": CalendarBean,
  CalendarGroupBean,
  CalendarSharedBean,
  CalendarSubscriptionResponseBean,
  CalendarSuggestionBean,
  CalendarTimetableBean,
  "42": CalendarTimetableBean,
  CategoryBean,
  "37": CategoryBean,
  CategoryDescriptor,
  CategoryInputBean,
  "36": CategoryInputBean,
  CleanResultBean,
  ClusterNodeStatus,
  "812": ClusterNodeStatus,
  ClusterStatus,
  "813": ClusterStatus,
  ColorBean,
  "35": ColorBean,
  ColorInputBean,
  "34": ColorInputBean,
  CommentBean,
  CommentResultBean,
  "77": CommentResultBean,
  ContactBean,
  ContactSyncBean,
  "-292618997": ContactSyncBean,
  CoverUriConfigurableBean,
  "81": CoverUriConfigurableBean,
  CoverUriPhoneAndTabletBean,
  "82": CoverUriPhoneAndTabletBean,
  CreditBean,
  DashboardTileBean,
  "11000": DashboardTileBean,
  DashboardTileInputBean,
  "11001": DashboardTileInputBean,
  DatabaseHealthStatusBean,
  "814": DatabaseHealthStatusBean,
  DatabaseHealthStatusValue,
  "815": DatabaseHealthStatusValue,
  DeviceBean,
  DeviceConfigBean,
  DishBean,
  "8005": DishBean,
  DishRangeBean,
  "1533985075": DishRangeBean,
  DishSyncBean,
  "8003": DishSyncBean,
  EventBean,
  EventInputBean,
  "1660334400": EventInputBean,
  EventListAndCalendar,
  "68": EventListAndCalendar,
  EventSyncBean,
  "706324869": EventSyncBean,
  ExploreBean,
  "11002": ExploreBean,
  ExtendedFamilyMemberBean,
  ExternalImportBean,
  "3200": ExternalImportBean,
  ExternalImportSyncBean,
  "90": ExternalImportSyncBean,
  FamilyBean,
  FamilyMemberBean,
  FileSyncBean,
  "73": FileSyncBean,
  FilerInputBean,
  "75": FilerInputBean,
  FizApiClientSideOperationAlreadyPerformed,
  "511": FizApiClientSideOperationAlreadyPerformed,
  FizRightBean,
  FolderBean,
  "72": FolderBean,
  FolderInputBean,
  "71": FolderInputBean,
  FolderSyncBean,
  "70": FolderSyncBean,
  ForgotPasswordResponseBean,
  GeocodedAddress,
  GoogleCredentialBean,
  GoogleLinkableCalendarBean,
  HomeHubValidationBean,
  IAGenerateRecipeParameters,
  "79": IAGenerateRecipeParameters,
  IAccount,
  IAccountIdentifier,
  IAddress,
  "-1106903189": IAddress,
  IApiKey,
  IAttendee,
  IBroadcastable,
  IComment,
  "991187414": IComment,
  IContact,
  "992315287": IContact,
  ICredit,
  "-1905165150": ICredit,
  IDevice,
  IDeviceConfig,
  IEvent,
  "-2137700399": IEvent,
  IExtendedFamily,
  IExtendedFamilyMember,
  "1456840928": IExtendedFamilyMember,
  IFamily,
  "-1834734323": IFamily,
  IFamilyMember,
  "-1192827385": IFamilyMember,
  IFilerInputBean,
  "74": IFilerInputBean,
  IHasMetaId,
  "85571313": IHasMetaId,
  IIMMessage,
  "-883752934": IIMMessage,
  IIMParticipant,
  IIMThread,
  "1698643863": IIMThread,
  IInvitation,
  "860376258": IInvitation,
  ILocation,
  IMedia,
  "-2130819813": IMedia,
  IPlace,
  "-2127843778": IPlace,
  IPlaceGeofencing,
  "-660611813": IPlaceGeofencing,
  IProfile,
  "-268636896": IProfile,
  IPromoCode,
  IPromoCodeCampaign,
  IPromoPushCampaign,
  "44": IPromoPushCampaign,
  IReminder,
  ISettingsPerFamily,
  ISyncBean,
  "1896517879": ISyncBean,
  ITaskList,
  "854072108": ITaskList,
  IToken,
  IWallMessage,
  "8001": IWallMessage,
  IcalImportPreviewBean,
  IcalImportResultBean,
  InboundEmailPreference,
  InvitationBean,
  "155667": InvitationBean,
  InvitationReceivedBean,
  InvitationSendingBean,
  ItunesReceiptStatusBean,
  "64": ItunesReceiptStatusBean,
  LaunchpadActivityBean,
  LaunchpadActivityItemBean,
  LaunchpadBean,
  LaunchpadConditionBean,
  LaunchpadEvent,
  LocationBean,
  LocationDeviceFlags,
  MealBean,
  "8006": MealBean,
  MealInputBean,
  "8008": MealInputBean,
  MealPlannerSharedBean,
  MealSettingsBean,
  MealSettingsColumnBean,
  MealSyncBean,
  "8007": MealSyncBean,
  MediaBean,
  MediaFilterFrontImage,
  MediaListBean,
  MediaQuota,
  MessageSyncBean,
  "1618477554": MessageSyncBean,
  OpenGraphDataBean,
  OpenGraphMedia,
  OutlookCredentialBean,
  OutlookLinkableCalendarBean,
  PaginatedCollection,
  PaginationRequest,
  PaymentMethodBean,
  "52": PaymentMethodBean,
  PaymentMethodInputBean,
  "53": PaymentMethodInputBean,
  PaymentMethodSyncBean,
  "56": PaymentMethodSyncBean,
  PingPongPayloadBean,
  "811": PingPongPayloadBean,
  PlaceBean,
  PlaceGeofencingBean,
  PlaceNearbyResult,
  PlaceSyncBean,
  "-1710402830": PlaceSyncBean,
  PremiumPopupBean,
  "76": PremiumPopupBean,
  PremiumPopupConfigurableContentBean,
  "80": PremiumPopupConfigurableContentBean,
  PremiumRightBean,
  ProfileBean,
  ProgrammaticAdsBean,
  "78": ProgrammaticAdsBean,
  PromoCodeBean,
  PromoCodeCampaignBean,
  PromoPushBean,
  PromoPushCampaignBean,
  PromoPushCampainDetailBean,
  "50": PromoPushCampainDetailBean,
  PromoPushExtraPayload,
  "43": PromoPushExtraPayload,
  PushMessageBean,
  "-1018410819": PushMessageBean,
  RecipeBean,
  "8004": RecipeBean,
  RecipeExternalBean,
  "8009": RecipeExternalBean,
  RecipeExternalSyncBean,
  "8010": RecipeExternalSyncBean,
  RecipeIngredientBean,
  RecipeInputBean,
  RecipePuByUrlResultBean,
  RecipeSyncBean,
  "8002": RecipeSyncBean,
  RecurrencyDescriptor,
  ReminderBean,
  SettingsBean,
  SettingsPerFamilyBean,
  ShoppingIngredientInputBean,
  ShoppingIngredientInputBean2,
  SimplePaginatedCollection,
  SimplePaginationRequest,
  SmsStubBean,
  StatusBean,
  SubscriptionTicketBean,
  SyncRequest,
  TaskBean,
  "-346040587": TaskBean,
  TaskCategoryBean,
  "47": TaskCategoryBean,
  TaskCategoryInputBean,
  "46": TaskCategoryInputBean,
  TaskCategorySyncBean,
  "66": TaskCategorySyncBean,
  TaskInputBean,
  "67": TaskInputBean,
  TaskListBean,
  TaskListSettingsBean,
  "38": TaskListSettingsBean,
  TaskSuggestionBean,
  "8012": TaskSuggestionBean,
  TaskSuggestionSyncBean,
  "8011": TaskSuggestionSyncBean,
  TaskSuggestionSyncBeanWCategory,
  "8013": TaskSuggestionSyncBeanWCategory,
  TaskSyncBean,
  "379942320": TaskSyncBean,
  TimetableBean,
  "39": TimetableBean,
  TimetableInputBean,
  "41": TimetableInputBean,
  TimetableSyncBean,
  "40": TimetableSyncBean,
  TokenAndAccountLogInfoBean,
  "48": TokenAndAccountLogInfoBean,
  TokenBean,
  TokenUrlBean,
  TwoCheckoutPriceBean,
  TwoCheckoutPricePromoBean,
  TwoCheckoutUrlsBean2,
  VcardImportPreviewBean,
  WallMessageBean,
  WeatherBean,
  WebSocketPushMessage,
  "1720010054": WebSocketPushMessage,
};

// ============================================================================
// API Methods
// ============================================================================

var executorTs: (method: string, model: Record<string,Function>, decoder: Function, args: ArrayLike<any>)=> Promise<any>;

function setExecutorTs(exe: (method: string, model: Record<string,Function>, decoder: Function, args: ArrayLike<any>)=> Promise<any>) {
  executorTs = exe;
}

// ============================================================================
// Legacy Method Registration (registerMethod calls)
// ============================================================================

registerMethod("accaddidentifier", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'validationmethod', 'password'], decodeStructure(decodeIAccount));
registerMethod("accaddidentifier2", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'validationmethod', 'password'], decodeStructure(decodeIAccountIdentifier));
registerMethod("accchangeaccountidentifier", ['oldid', {name:'type', encode:encodeEnum}, 'countryCode', 'oldidentifier', 'newidentifier', 'validationmethod', 'password'], decodeStructure(decodeIAccountIdentifier));
registerMethod("accchangepassword", ['password', 'newpassword'], decodeStructure(decodeString));
registerMethod("acccheckpassword", ['password'], decodeStructure(decodeboolean));
registerMethod("acccreatefamily", ['name', 'role', 'customFamilyRole', 'cover'], decodeStructure(decodeNumber));
registerMethod("acccreatesubaccount", ['role', 'customFamilyRole', 'firstname', 'birthday', 'timezone', 'locale', 'picture', 'homeAddress', 'workAddress'], decodeStructure(decodeNumber));
registerMethod("accdeeplink", ['page', 'directWebPage'], decodeStructure(decodeString));
registerMethod("accgenerateDeepLoginLink", ['page', 'webWanted', 'dev'], decodeStructure(decodeString));
registerMethod("accgetallfamily", ['withStateBean'], decodeStructure(decodeIExtendedFamily));
registerMethod("accgetfamily", [], decodeStructure(decodeIFamily));
registerMethod("accgetloggedaccount", [], decodeStructure(decodeIAccount));
registerMethod("accgetpremium", [], decodeStructure(decodePremiumRightBean));
registerMethod("accgetsecuritystate", [], decodeStructure(decodeAccountSecurityBean));
registerMethod("accgetstate", ['deviceId', 'modelType', 'applicationVersion', 'timezone', 'locale', 'buildTimestamp'], decodeStructure(decodeAccountStateBean));
registerMethod("accinvite", ['identifier', 'password', 'role', 'customFamilyRole', 'firstname', 'mobile', 'birthday', 'timezone', 'locale', 'picture', 'homeAddress', 'workAddress'], decodeStructure(decodeNumber));
registerMethod("accremoveidentifier", ['id', 'password'], decodeStructure(decodeIAccount));
registerMethod("accremoveidentifier2", ['id', 'password'], decodeStructure(decodeIAccountIdentifier));
registerMethod("accsendaccountidentifiervalidationcode", ['id', {name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'validationmethod'], decodeStructure(decodeBoolean));
registerMethod("accsendwelcomeemail", [], decodeStructure(decodeBoolean));
registerMethod("accsetprofile", ['accountId', 'pseudo', 'firstname', 'gender', 'role', 'customFamilyRole', 'mobile', 'email', 'birthday', 'timezone', 'locale', 'picture', 'homeAddress', 'workAddress', 'color', 'publishProfileChanged', 'customFirstName', 'customAvatar'], decodeStructure(decodeNumber));
registerMethod("accsetterms", ['termsChecked', 'termsHtcChecked', 'termsOrangeFamilyPlaceChecked', 'termsSprintChecked', 'termsProximusFamilyChecked'], decodeStructure(decodeAccountLoginInfo));
registerMethod("accupdatefamily", ['name', 'file', 'cover'], decodeStructure(decodeIFamily));
registerMethod("accvalidateaccountidentifierwithcode", ['id', {name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'code', 'autoacceptpendinginvite'], decodeStructure(decodeIAccount));
registerMethod("accvalidateaccountidentifierwithcode2", ['id', {name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'code', 'autoacceptpendinginvite'], decodeStructure(decodeIAccountIdentifier));
registerMethod("accvalidatechangeaccountidentifier", ['oldid', {name:'type', encode:encodeEnum}, 'countryCode', 'oldidentifier', 'newidentifier', 'code'], decodeStructure(decodeIAccountIdentifier));
registerMethod("adminchange", ['right', 'accountid'], decodeStructure(decodeAdminRightBean));
registerMethod("admindelete2", ['deleteAuthoredPost'], decodeStructure(decodeBoolean));
registerMethod("admingetright", ['accountId'], decodeStructure(decodeEnum));
registerMethod("adminlist", [], decodeStructure(decodeAdminRightBean));
registerMethod("adminremove", ['accountId', 'deleteAuthoredPost'], decodeStructure(decodeBoolean));
registerMethod("adminwipefamily", [], decodeStructure(decodeBoolean));
registerMethod("albumall", ['accountId', 'bestMoment', 'mood', 'pg'], decodeStructure(decodeMediaListBean));
registerMethod("albumfrontbycreator", [], decodeStructure(decodeArray(decodeMediaFilterFrontImage)));
registerMethod("albumquota", [], decodeStructure(decodeMediaQuota));
registerMethod("budgetcategorydelete", ['id'], decodeStructure(decodeboolean));
registerMethod("budgetcategoryget", ['id'], decodeStructure(decodeBudgetCategoryBean));
registerMethod("budgetcategorylist", ['budgetTransactionType', 'locale'], decodeStructure(decodeArray(decodeBudgetCategoryBean)));
registerMethod("budgetcategoryput", [{encode:encodeBudgetCategoryInputBean}, 'prevId'], decodeStructure(decodeBudgetCategoryBean));
registerMethod("budgetcategorysync", ['syncToken'], decodeStructure(decodeBudgetCategorySyncBean));
registerMethod("budgetclose", ['metaId'], decodeStructure(decodeboolean));
registerMethod("budgetdelete", ['id'], decodeStructure(decodeBoolean));
registerMethod("budgetexportcsvurl", ['id', {name:'from', encode:encodeDate}, 'to'], decodeStructure(decodeString));
registerMethod("budgetget", ['id'], decodeStructure(decodeBudgetBean));
registerMethod("budgetlist", [], decodeStructure(decodeArray(decodeBudgetBean)));
registerMethod("budgetmarkaspaid", ['metaId', 'value'], decodeStructure(decodeArray(decodeBudgetTransactionBean)));
registerMethod("budgetpaymentmethoddelete", ['id'], decodeStructure(decodeboolean));
registerMethod("budgetpaymentmethodget", ['id'], decodeStructure(decodePaymentMethodBean));
registerMethod("budgetpaymentmethodlist", ['locale'], decodeStructure(decodeArray(decodePaymentMethodBean)));
registerMethod("budgetpaymentmethodput", [{encode:encodePaymentMethodInputBean}, 'prevId'], decodeStructure(decodePaymentMethodBean));
registerMethod("budgetpaymentmethodsync", ['syncToken'], decodeStructure(decodePaymentMethodSyncBean));
registerMethod("budgetput", [{encode:encodeBudgetInputBean}], decodeStructure(decodeBudgetBean));
registerMethod("budgetsync", ['syncToken'], decodeStructure(decodeBudgetSyncBean));
registerMethod("budgettransactiondelete", ['option', 'id'], decodeStructure(decodeBoolean));
registerMethod("budgettransactiondeleteoption", ['id'], decodeStructure(decodeArray(decodeEnum)));
registerMethod("budgettransactionget", ['id'], decodeStructure(decodeBudgetTransactionBean));
registerMethod("budgettransactionlist", [], decodeStructure(decodeArray(decodeBudgetTransactionBean)));
registerMethod("budgettransactionput", ['option', {encode:encodeBudgetTransactionInputBean}, 'file'], decodeStructure(decodeBudgetTransactionBean));
registerMethod("budgettransactionsync", ['syncToken'], decodeStructure(decodeBudgetTransactionSyncBean));
registerMethod("budgettransactionupdateoption", [{encode:encodeBudgetTransactionInputBean}], decodeStructure(decodeArray(decodeEnum)));
registerMethod("colordelete", ['id'], decodeStructure(decodeboolean));
registerMethod("colorget", ['id'], decodeStructure(decodeColorBean));
registerMethod("colorlist", [], decodeStructure(decodeArray(decodeColorBean)));
registerMethod("colorput", [{encode:encodeColorInputBean}], decodeStructure(decodeColorBean));
registerMethod("credit2checkouthomehubconfirmpurchase", ['code'], decodeStructure(decodeBoolean));
registerMethod("credit2checkouthomehuburl", ['code'], decodeStructure(decodeHomeHubValidationBean));
registerMethod("credit2checkouturl2", [], decodeStructure(decodeTwoCheckoutUrlsBean2));
registerMethod("creditget", [], decodeStructure(decodeArray(decodeICredit)));
registerMethod("creditgetPromoCode", ['value'], decodeStructure(decodeIPromoCode));
registerMethod("creditgetfreesku", ['creditType', 'paymentType', 'typeOfPeriod'], decodeStructure(decodeString));
registerMethod("creditgetmanualrenewalllink", ['creditId'], decodeStructure(decodeString));
registerMethod("creditgoogleplaytoken", ['deviceId', 'token', 'creditType', 'sku'], decodeStructure(decodeSubscriptionTicketBean));
registerMethod("credititunesIos7ticket", ['deviceId', 'receipt'], decodeStructure(decodeSubscriptionTicketBean));
registerMethod("credititunesreceiptstatus", ['deviceId', 'receipt', 'trialDurationProductIdList'], decodeStructure(decodeItunesReceiptStatusBean));
registerMethod("credititunesticket", ['deviceId', 'receipt'], decodeStructure(decodeSubscriptionTicketBean));
registerMethod("creditlistall", [], decodeStructure(decodeArray(decodeICredit)));
registerMethod("creditsetautorenewall", ['creditId', 'auto'], decodeStructure(decodeICredit));
registerMethod("creditswitchfamily", ['creditId', 'existingFamilyId', 'newFamilyId'], decodeStructure(decodeICredit));
registerMethod("creditusepromocode", ['value'], decodeStructure(decodeICredit));
registerMethod("ctccomment", ['contactId', 'text'], decodeStructure(decodeIComment));
registerMethod("ctcdelete", ['contactIds'], decodeStructure(decodeboolean));
registerMethod("ctcget", ['contactId'], decodeStructure(decodeIContact));
registerMethod("ctclist", [], decodeStructure(decodeArray(decodeIContact)));
registerMethod("ctcput", [{encode:encodeIContact}, 'pictures'], decodeStructure(decodeIContact));
registerMethod("ctcsync", ['syncToken', 'date'], decodeStructure(decodeContactSyncBean));
registerMethod("ctcvcardimport", ['file', 'isPreview', 'indexes'], decodeStructure(decodeVcardImportPreviewBean));
registerMethod("ctcvcardurl", ['contactId'], decodeStructure(decodeString));
registerMethod("deviceackpush", ['pushIds'], decodeStructure(decodeBoolean));
registerMethod("devicecheckpush", [{encode:encodeDeviceConfigBean}, 'isBackground'], decodeStructure(decodeArray(decodePushMessageBean)));
registerMethod("devicedelete", ['deviceId'], decodeStructure(decodeboolean));
registerMethod("devicelist", [], decodeStructure(decodeArray(decodeIDeviceConfig)));
registerMethod("devicelogout", ['config'], decodeStructure(decodeboolean));
registerMethod("devicesetconfig", ['config'], decodeStructure(decodeboolean));
registerMethod("evtaddComment", ['eventId', 'text', 'mood'], decodeStructure(decodeCommentResultBean(decodeIEvent)));
registerMethod("evtbatchupdate", ['metaId', 'input'], decodeStructure(decodenumber));
registerMethod("evtcalcheckurl", ['url'], decodeStructure(decodeboolean));
registerMethod("evtcaldelete", ['metaId'], decodeStructure(decodeboolean));
registerMethod("evtcallist", ['withtask', 'withmeal', 'withfolder', 'withAllFamilies', 'withExternal', 'withOnError', 'withSpecialDays'], decodeStructure(decodeCalendarGroupBean));
registerMethod("evtcalsubscribe2", ['url'], decodeStructure(decodeCalendarSubscriptionResponseBean));
registerMethod("evtcalupdate", [{encode:encodeCalendarBean}], decodeStructure(decodeboolean));
registerMethod("evtcreate", [{encode:encodeEventInputBean}], decodeStructure(decodeIEvent));
registerMethod("evtdelete", ['option', 'eventId'], decodeStructure(decodeboolean));
registerMethod("evtdeleteoption", ['eventId'], decodeStructure(decodeArray(decodeEnum)));
registerMethod("evtexternalimportdelete", ['deleteAttachedItems', 'id'], decodeStructure(decodeMap(decodeMetaId,decodeNumber)));
registerMethod("evtget", ['eventId'], decodeStructure(decodeIEvent));
registerMethod("evtgetbirthday", ['contactId'], decodeStructure(decodeIEvent));
registerMethod("evticalimport", ['file', 'isPreview', 'indexes'], decodeStructure(decodeIcalImportPreviewBean));
registerMethod("evticalurl", ['calendarId', 'eventId'], decodeStructure(decodeString));
registerMethod("evticalvisibleurl", ['refresh', 'calendarId', 'eventId'], decodeStructure(decodeString));
registerMethod("evticalvisibleurldelete", ['calendarId'], decodeStructure(decodeboolean));
registerMethod("evtlistinterval", [{name:'from', encode:encodeDate}, 'to', 'accountId', 'attendeeId'], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evtlistinterval2", [{name:'from', encode:encodeDate}, 'to', 'accountId', 'attendeeId', 'calendarId', 'limit'], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evtlistintervalandcalendar", [{name:'from', encode:encodeDate}, 'to', 'accountId', 'attendeeId', 'calendarId', 'activeCalendar', 'limit', 'activeTimetable'], decodeStructure(decodeEventListAndCalendar));
registerMethod("evtnavigate", ['eventId', 'offset', 'accountId'], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evtncsync", ['tokenValue', 'syncToken'], decodeStructure(decodeCalendarSharedBean));
registerMethod("evtsetexternalerror", ['error'], decodeStructure(decodeboolean));
registerMethod("evtsharedlink", ['timetableId', {name:'from', encode:encodeString}, 'to'], decodeStructure(decodeTokenUrlBean));
registerMethod("evtsync", ['syncToken', 'date', 'calendarId'], decodeStructure(decodeEventSyncBean));
registerMethod("evttimetableClose", ['timetableId'], decodeStructure(decodeboolean));
registerMethod("evttimetableCopySlice", ['timetableId', 'srcSliceNb', 'destSliceNb'], decodeStructure(decodeboolean));
registerMethod("evttimetableCopySliceByDate", ['timetableId', 'startDate', 'endDate', 'targetStart'], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evttimetableCopySliceWResult", ['timetableId', 'srcSliceNb', 'destSliceNb'], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evttimetableResetSlice", ['timetableId', 'sliceNb'], decodeStructure(decodeboolean));
registerMethod("evttimetableResetSliceByDate", ['timetableId', 'startDate', 'endDate'], decodeStructure(decodeArray(decodeMetaId)));
registerMethod("evttimetableput", [{encode:encodeTimetableInputBean}, 'allowDeleteEvent'], decodeStructure(decodeTimetableBean));
registerMethod("evtupdate", ['option', {encode:encodeEventInputBean}], decodeStructure(decodeIEvent));
registerMethod("evtupdateoption", [{encode:encodeEventInputBean}], decodeStructure(decodeArray(decodeEnum)));
registerMethod("famacceptinvitation", ['iid', 'v', 'validationmethod'], decodeStructure(decodeboolean));
registerMethod("famblockinvite", ['iid', 'v', 'block'], decodeStructure(decodeInvitationReceivedBean));
registerMethod("famcancelinvite", ['invitationId', 'v'], decodeStructure(decodeboolean));
registerMethod("famgetinvitation", ['iid', 'v'], decodeStructure(decodeInvitationReceivedBean));
registerMethod("famgetinvitationlinkbean", [], decodeStructure(decodeTokenUrlBean));
registerMethod("famlistfamily", ['withStateBean'], decodeStructure(decodeArray(decodeIExtendedFamily)));
registerMethod("famlistinvite", ['pg'], decodeStructure(decodeArray(decodeIInvitation)));
registerMethod("famlogfamily", ['familyId'], decodeStructure(decodeIFamily));
registerMethod("famresendinvite", ['iid', 'deviceComposerUsed'], decodeStructure(decodeInvitationSendingBean));
registerMethod("famsendinvite", ['email', 'phone', 'inviteeid', 'role', 'adminRight', 'customFamilyRole', 'firstname', 'picture', 'deviceComposerUsed', 'test'], decodeStructure(decodeInvitationSendingBean));
registerMethod("famsetfirst", ['familyId'], decodeStructure(decodeboolean));
registerMethod("famshowincominginvite", ['pg'], decodeStructure(decodeArray(decodeInvitationReceivedBean)));
registerMethod("famupdateinvitation", ['iid', 'email', 'phone', 'role', 'adminRight', 'customFamilyRole', 'firstname', 'picture'], decodeStructure(decodeIInvitation));
registerMethod("filerclose", ['metaId'], decodeStructure(decodeboolean));
registerMethod("filerdeletefile", ['id'], decodeStructure(decodeBoolean));
registerMethod("filerdeletefolder", ['id'], decodeStructure(decodeBoolean));
registerMethod("filerduplicatefolder", ['id', 'targetId'], decodeStructure(decodeFolderBean));
registerMethod("filergetfile", ['id'], decodeStructure(decodeIMedia));
registerMethod("filergetfolder", ['id'], decodeStructure(decodeFolderBean));
registerMethod("filerlistfile", [], decodeStructure(decodeArray(decodeIMedia)));
registerMethod("filerlistfolder", [], decodeStructure(decodeArray(decodeFolderBean)));
registerMethod("filerputfile", [{encode:encodeIFilerInputBean}, 'file'], decodeStructure(decodeIMedia));
registerMethod("filerputfolder", [{encode:encodeFolderInputBean}], decodeStructure(decodeFolderBean));
registerMethod("filersyncfile", ['syncToken'], decodeStructure(decodeFileSyncBean));
registerMethod("filersyncfolder", ['syncToken'], decodeStructure(decodeFolderSyncBean));
registerMethod("geoaddress", ['address'], decodeStructure(decodeGeocodedAddress));
registerMethod("geoaddresswithcontext", ['address', 'latitudeE6', 'longitudeE6', 'start', 'count'], decodeStructure(decodePaginatedCollection(decodeGeocodedAddress)));
registerMethod("geocheck", ['geocodedAddress'], decodeStructure(decodeGeocodedAddress));
registerMethod("geodetailedaddress", ['country', 'state', 'zipCode', 'town', 'line'], decodeStructure(decodeGeocodedAddress));
registerMethod("georeverse", ['latitudeE6', 'longitudeE6'], decodeStructure(decodeGeocodedAddress));
registerMethod("googleAuthUri", [], decodeStructure(decodeString));
registerMethod("googlegetcredential", ['credentialId'], decodeStructure(decodeGoogleCredentialBean));
registerMethod("googlelogin", ['code'], decodeStructure(decodeboolean));
registerMethod("googlelogin2", ['code'], decodeStructure(decodeGoogleCredentialBean));
registerMethod("googlesavetoken", ['tokenType', 'accessToken', 'refreshToken', 'expiresDate'], decodeStructure(decodeboolean));
registerMethod("googlesavetoken2", ['tokenType', 'accessToken', 'refreshToken', 'expiresDate'], decodeStructure(decodeGoogleCredentialBean));
registerMethod("googleselectcalendar2", ['credentialId', 'googleId'], decodeStructure(decodeCalendarSubscriptionResponseBean));
registerMethod("imgetpremium", [], decodeStructure(decodePremiumRightBean));
registerMethod("immarkasread", ['threadId'], decodeStructure(decodeIIMThread));
registerMethod("immessagelist2", ['threadId', 'pg'], decodeStructure(decodeSimplePaginatedCollection(decodeIIMMessage)));
registerMethod("immessagelistgrp", ['threadId', 'count'], decodeStructure(decodeArray(decodeSimplePaginatedCollection(decodeIIMMessage))));
registerMethod("immessagesync", ['threadId', 'syncToken', 'date'], decodeStructure(decodeMessageSyncBean));
registerMethod("immessagesyncgrp", ['request'], decodeStructure(decodeArray(decodeMessageSyncBean)));
registerMethod("imnewthread", ['to'], decodeStructure(decodeIIMThread));
registerMethod("imsend", ['threadId', 'to', 'text', 'media', {name:'type', encode:encodeEnum}, 'externalId'], decodeStructure(decodeIIMMessage));
registerMethod("imthreadlist", ['filter', 'isLoggedFamily'], decodeStructure(decodeArray(decodeIIMThread)));
registerMethod("launchpadclick", ['section', 'date'], decodeStructure(decodeboolean));
registerMethod("launchpadcondition", ['activityWanted'], decodeStructure(decodeLaunchpadConditionBean));
registerMethod("launchpadget2", ['address', 'conditions', 'actions'], decodeStructure(decodeLaunchpadBean));
registerMethod("launchpadget3", ['token', 'address', 'conditions'], decodeStructure(decodeLaunchpadBean));
registerMethod("launchpadgetexplore", ['token'], decodeStructure(decodeExploreBean));
registerMethod("launchpadlisttiles", [], decodeStructure(decodeArray(decodeDashboardTileBean)));
registerMethod("launchpadmovetile", ['tileId', 'prevId'], decodeStructure(decodeMap(decodeMetaId,decodeNumber)));
registerMethod("launchpadseen", ['screen', 'clear'], decodeStructure(decodeboolean));
registerMethod("launchpadupdatetile", [{encode:encodeDashboardTileInputBean}], decodeStructure(decodeDashboardTileBean));
registerMethod("locacceptpickmeup", ['targetId'], decodeStructure(decodeBoolean));
registerMethod("localarmpanicbutton", ['geocodedAddress'], decodeStructure(decodeBoolean));
registerMethod("locclearAlarmpanicbutton", [], decodeStructure(decodeBoolean));
registerMethod("locget", ['accountId'], decodeStructure(decodeILocation));
registerMethod("locgetbyplace", ['placeId'], decodeStructure(decodeArray(decodeILocation)));
registerMethod("locgetdeviceflag", [], decodeStructure(decodeLocationDeviceFlags));
registerMethod("locgetgeofencingsforpublisher", ['withPlace'], decodeStructure(decodeArray(decodeIPlaceGeofencing)));
registerMethod("locgetgeofencingsforsubscriber", ['placeId'], decodeStructure(decodeMap(decodeNumber,decodeIPlaceGeofencing)));
registerMethod("locgetpositions2", [], decodeStructure(decodeArray(decodeILocation)));
registerMethod("lochistory", ['date'], decodeStructure(decodePaginatedCollection(decodeILocation)));
registerMethod("locpublisfencing", [{name:'type', encode:encodeEnum}, 'placeId', 'deviceId'], decodeStructure(decodeILocation));
registerMethod("locpublishaddress", ['text', 'address', 'latitudeE6', 'longitudeE6', 'isTemporary', 'picture'], decodeStructure(decodeIWallMessage));
registerMethod("locpublishauto", ['geocodedAddress', 'deviceId', 'fromRequestAccountId'], decodeStructure(decodeILocation));
registerMethod("locpublishpickmeup", ['targetId', 'address', 'latitudeE6', 'longitudeE6'], decodeStructure(decodeBoolean));
registerMethod("locpublishplacelocation", ['text', 'placeId', 'moveType', 'picture'], decodeStructure(decodeIWallMessage));
registerMethod("locrequestautotrack", ['publisherId'], decodeStructure(decodeBoolean));
registerMethod("locrequestpositionrefresh", ['accountId'], decodeStructure(decodeBoolean));
registerMethod("locrespondtogeorequest", ['accept', 'tempDuration', 'geocodedAddress', 'deviceId'], decodeStructure(decodeBoolean));
registerMethod("locsetdeviceflag", [{encode:encodeLocationDeviceFlags}], decodeStructure(decodeLocationDeviceFlags));
registerMethod("locsetgeofencingsettings", ['placeId', 'publisherId', {name:'in', encode:encodeBoolean}, 'out'], decodeStructure(decodeIPlaceGeofencing));
registerMethod("locsetperuserauthflag", ['flags', 'tempDuration', 'geocodedAddress', 'deviceId'], decodeStructure(decodeBoolean));
registerMethod("log2check", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'validated'], decodeStructure(decodeBoolean));
registerMethod("log2checkinvitation", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode'], decodeStructure(decodeBoolean));
registerMethod("log2checkvalidationcode", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'code'], decodeStructure(decodeBoolean));
registerMethod("log2create", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'password', 'partnerType', 'validationmethod', 'locale'], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2deeplink", ['TK', 'fid'], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2forgotpassword2", ['identifier'], decodeStructure(decodeForgotPasswordResponseBean));
registerMethod("log2generateaccesstokeinbydeeplinktoken", ['token', 'tokentype', 'deviceId'], decodeStructure(decodeAccessTokenBean));
registerMethod("log2generateaccesstokenbypassword", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'password', 'tokentype', 'deviceId', 'clientId', 'clientSecret'], decodeStructure(decodeAccessTokenBean));
registerMethod("log2get", [], decodeStructure(decodeArray(decodeIAccount)));
registerMethod("log2getdeeplinkinfo", ['token', 'tokentype', 'deviceId'], decodeStructure(decodeTokenAndAccountLogInfoBean));
registerMethod("log2in", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'password', 'generateAutologinToken', 'clientId', 'clientSecret'], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2loginByAutologinToken", ['identifier', 'token'], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2out", [], decodeStructure(decodeboolean));
registerMethod("log2renew", [], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2sendaccountidentifiervalidationcode", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode'], decodeStructure(decodeBoolean));
registerMethod("log2token", ['token'], decodeStructure(decodeTokenAndAccountLogInfoBean));
registerMethod("log2validateidentifier", [{name:'type', encode:encodeEnum}, 'identifier', 'countryCode', 'code', 'autoacceptpendinginvite'], decodeStructure(decodeAccountLoginInfo));
registerMethod("metaaddComment", ['id', 'text', 'mood'], decodeStructure(decodeCommentResultBean(decodeIHasMetaId)));
registerMethod("metaaddpictures", ['id', 'pictures'], decodeStructure(decodeDynamic));
registerMethod("metadelete", ['id'], decodeStructure(decodeDynamic));
registerMethod("metaget", ['id'], decodeStructure(decodeDynamic));
registerMethod("metalist", ['id'], decodeStructure(decodeDynamic));
registerMethod("metamood", ['id', 'add', 'remove'], decodeStructure(decodeDynamic));
registerMethod("metapictures", ['id', 'pictures'], decodeStructure(decodeDynamic));
registerMethod("metasync", ['id', 'listId', 'syncToken', 'date'], decodeStructure(decodeDynamic));
registerMethod("metaupdatetext", ['id', 'text'], decodeStructure(decodeDynamic));
registerMethod("mpadditemtolist2", ['ingredients', 'listId'], decodeStructure(decodeboolean));
registerMethod("mpcategorydelete", ['id'], decodeStructure(decodeboolean));
registerMethod("mpcategoryget", ['id'], decodeStructure(decodeCategoryBean));
registerMethod("mpcategorylist", [], decodeStructure(decodeArray(decodeCategoryBean)));
registerMethod("mpcategoryput", [{encode:encodeCategoryInputBean}, 'prevId'], decodeStructure(decodeCategoryBean));
registerMethod("mpclear", [{name:'from', encode:encodeString}, 'to'], decodeStructure(decodeboolean));
registerMethod("mpcopy", [{name:'from', encode:encodeString}, 'to', 'targetFrom'], decodeStructure(decodeArray(decodeDishBean)));
registerMethod("mpcreate", ['name', 'date', {name:'type', encode:encodeEnum}], decodeStructure(decodeArray(decodeDishBean)));
registerMethod("mpcreateByRecipeId", ['recipeId', 'date', {name:'type', encode:encodeEnum}], decodeStructure(decodeDishBean));
registerMethod("mpgenerateIA", [{encode:encodeIAGenerateRecipeParameters}], decodeStructure(decodeRecipeInputBean));
registerMethod("mplistinterval", [{name:'from', encode:encodeString}, 'to'], decodeStructure(decodeDishRangeBean));
registerMethod("mpmealput", [{encode:encodeMealInputBean}], decodeStructure(decodeMealBean));
registerMethod("mpmove", ['metaId', 'date', {name:'type', encode:encodeEnum}], decodeStructure(decodeArray(decodeDishBean)));
registerMethod("mpncrecipe", ['tokenvalue', 'recipeMetaId'], decodeStructure(decodeRecipeBean));
registerMethod("mpncshared", ['tokenvalue'], decodeStructure(decodeMealPlannerSharedBean));
registerMethod("mpquantityparse", ['recipeids'], decodeStructure(decodeArray(decodeRecipeBean)));
registerMethod("mprecipelink", ['metaId'], decodeStructure(decodeTokenUrlBean));
registerMethod("mprecipeput", ['recipe', 'picture'], decodeStructure(decodeRecipeBean));
registerMethod("mprecipeputbyid", ['id', 'recipeCategories', 'recipeCategoryId'], decodeStructure(decodeRecipeBean));
registerMethod("mprecipeputbyurl", ['url', 'recipeCategories', 'recipeCategoryId'], decodeStructure(decodeRecipePuByUrlResultBean));
registerMethod("mpsettingsget", [], decodeStructure(decodeMealSettingsBean));
registerMethod("mpsettingsset", ['settings'], decodeStructure(decodeMealSettingsBean));
registerMethod("mpsharedlink", [{name:'from', encode:encodeString}, 'to'], decodeStructure(decodeTokenUrlBean));
registerMethod("outlookAuthUri", [], decodeStructure(decodeString));
registerMethod("outlookgetcredential", ['credentialId'], decodeStructure(decodeOutlookCredentialBean));
registerMethod("outlooklogin", ['code'], decodeStructure(decodeOutlookCredentialBean));
registerMethod("outlooksavetoken", ['tokenType', 'accessToken', 'refreshToken', 'expiresDate', 'redirectUri', 'useSecret'], decodeStructure(decodeOutlookCredentialBean));
registerMethod("outlookselectcalendar2", ['credentialId', 'outlookId'], decodeStructure(decodeCalendarSubscriptionResponseBean));
registerMethod("outlooksync", ['calendarId', 'syncToken'], decodeStructure(decodeEventSyncBean));
registerMethod("poicreate", ['name', 'geocodedAddress', 'placeType', 'isTemporary', 'geofencingActive', 'contactId', 'text', 'wifiSSID', 'wifiMAC', 'picture'], decodeStructure(decodeIPlace));
registerMethod("poicreatesimple", ['name', 'address', 'placeType', 'isTemporary', 'geofencingActive', 'contactId', 'text', 'wifiSSID', 'wifiMAC', 'picture'], decodeStructure(decodeIPlace));
registerMethod("poidelete", ['placeId'], decodeStructure(decodeboolean));
registerMethod("poiget", ['placeId'], decodeStructure(decodeIPlace));
registerMethod("poigetall", [], decodeStructure(decodeArray(decodeIPlace)));
registerMethod("poinearby", ['latitudeE6', 'longitudeE6'], decodeStructure(decodePlaceNearbyResult));
registerMethod("poisync", ['syncToken', 'date'], decodeStructure(decodePlaceSyncBean));
registerMethod("poiupdate", ['placeId', 'name', 'geocodedAddress', 'placeType', 'isTemporary', 'geofencingActive', 'contactId', 'text', 'wifiSSID', 'wifiMAC', 'picture'], decodeStructure(decodeIPlace));
registerMethod("prfgetProfile", ['oid'], decodeStructure(decodeIProfile));
registerMethod("prfgetProfiles", [], decodeStructure(decodeMap(decodeMetaId,decodeIProfile)));
registerMethod("prfgetPublicProfiles", ['oid'], decodeStructure(decodeMap(decodeMetaId,decodeIProfile)));
registerMethod("prfupdate", [{encode:encodeIProfile}, 'picture'], decodeStructure(decodeIProfile));
registerMethod("prfupdate2", ['role', 'customFamilyRole', {encode:encodeIProfile}, 'picture'], decodeStructure(decodeIProfile));
registerMethod("settingsaiinboxcheck", ['email'], decodeStructure(decodeAiInboxResponseBean));
registerMethod("settingsaiinboxsave", ['email'], decodeStructure(decodeAiInboxResponseBean));
registerMethod("settingsfeedback", [{name:'type', encode:encodeEnum}, 'score', 'comment'], decodeStructure(decodeboolean));
registerMethod("settingsget", [], decodeStructure(decodeSettingsBean));
registerMethod("settingsgetperfamily", ['familyId'], decodeStructure(decodeISettingsPerFamily));
registerMethod("settingsset", ['pushGlobal', 'pushForEvent', 'pushForMessage', 'pushForCheckin', 'pushForPicture', 'geoTrackingHistory', 'reminderNotificationEnabled', 'pushForTask', 'pushForStatus', 'pushForComment', 'pushForBestMoment', 'pushForTimetable', 'pushForBudget', 'pushForFiler', 'pushForSpecialDays', 'pushByEmail', 'promoAccept', 'pushForMealPlanner', 'pushForRecipe', 'pushForContact'], decodeStructure(decodeSettingsBean));
registerMethod("settingssetperfamily", [{encode:encodeISettingsPerFamily}], decodeStructure(decodeISettingsPerFamily));
registerMethod("settingsshutdowngeolocsharing", [], decodeStructure(decodeboolean));
registerMethod("statusget", [], decodeStructure(decodeStatusBean));
registerMethod("stublistsms", ['number'], decodeStructure(decodeArray(decodeSmsStubBean)));
registerMethod("taskcategorydelete", ['id'], decodeStructure(decodeboolean));
registerMethod("taskcategoryget", ['id'], decodeStructure(decodeTaskCategoryBean));
registerMethod("taskcategorylist", ['tasklistType', 'locale', 'filterTasklistId'], decodeStructure(decodeArray(decodeTaskCategoryBean)));
registerMethod("taskcategoryput", [{encode:encodeTaskCategoryInputBean}, 'prevId', 'tasklistId', 'locale', 'hidden'], decodeStructure(decodeTaskCategoryBean));
registerMethod("taskcategorysync", ['syncToken'], decodeStructure(decodeTaskCategorySyncBean));
registerMethod("taskcloselist", [], decodeStructure(decodeboolean));
registerMethod("taskcreate", ['text', 'dueDate', 'assignee', 'reminder'], decodeStructure(decodeTaskBean));
registerMethod("taskcreate2", [{encode:encodeTaskInputBean}, 'picture'], decodeStructure(decodeTaskBean));
registerMethod("taskcreatelist", [{encode:encodeITaskList}], decodeStructure(decodeITaskList));
registerMethod("taskdelete", ['taskId'], decodeStructure(decodeboolean));
registerMethod("taskdeletelist", ['id'], decodeStructure(decodeBoolean));
registerMethod("taskduplicatelist", ['id'], decodeStructure(decodeITaskList));
registerMethod("taskget", ['taskId'], decodeStructure(decodeTaskBean));
registerMethod("taskgetsettings", [], decodeStructure(decodeTaskListSettingsBean));
registerMethod("taskgetsuggestedlist", [], decodeStructure(decodeITaskList));
registerMethod("taskgettasklists", [], decodeStructure(decodeArray(decodeITaskList)));
registerMethod("taskgettasksuggestions", ['tasklistType', 'syncToken', 'locale'], decodeStructure(decodeTaskSuggestionSyncBean));
registerMethod("taskgettasksuggestionswcat", ['tasklistType', 'syncToken', 'locale'], decodeStructure(decodeTaskSuggestionSyncBeanWCategory));
registerMethod("tasklist", ['listId'], decodeStructure(decodeArray(decodeTaskBean)));
registerMethod("taskmark", ['taskId', 'complete', 'completedDateForTesting'], decodeStructure(decodeTaskBean));
registerMethod("taskmetamark", ['id', 'complete'], decodeStructure(decodeboolean));
registerMethod("taskmove", ['taskId', 'taskListId', 'prevTaskId', 'taskCategoryId'], decodeStructure(decodeMap(decodeMetaId,decodeNumber)));
registerMethod("taskmovelist", ['id', 'prevId'], decodeStructure(decodeMap(decodeMetaId,decodeNumber)));
registerMethod("taskpinlist", ['id', 'pin'], decodeStructure(decodeITaskList));
registerMethod("taskrespondsuggested", ['id', 'accept'], decodeStructure(decodeITaskList));
registerMethod("taskrestoresystemlist", [], decodeStructure(decodenumber));
registerMethod("tasksync", ['syncToken', 'date'], decodeStructure(decodeTaskSyncBean));
registerMethod("taskupdate", ['taskId', 'text', 'dueDate', 'assignee', 'reminder'], decodeStructure(decodeTaskBean));
registerMethod("taskupdate2", [{encode:encodeTaskInputBean}, 'picture'], decodeStructure(decodeTaskBean));
registerMethod("taskupdatelist", [{encode:encodeITaskList}], decodeStructure(decodeITaskList));
registerMethod("wallactivityById", ['masterNested'], decodeStructure(decodeMap(decodeNumber,decodeAccountActivityBean)));
registerMethod("wallactivityget", ['accountId', 'masterNested'], decodeStructure(decodeAccountActivityBean));
registerMethod("walladdComment", ['wall_message_id', 'comment', 'mood'], decodeStructure(decodeCommentResultBean(decodeIWallMessage)));
registerMethod("wallbyids", ['id', 'masterNested'], decodeStructure(decodeArray(decodeIWallMessage)));
registerMethod("walldelete", ['wallMessageId'], decodeStructure(decodeboolean));
registerMethod("wallget", ['date', 'accountId', {name:'type', encode:encodeArray(encodeEnum)}, 'hasJoin', 'mood', 'bestMoment', 'afterId', 'nb', 'nested', 'masterNested', 'sortBy'], decodeStructure(decodeArray(decodeIWallMessage)));
registerMethod("walllastbyaccount", ['filter'], decodeStructure(decodeMap(decodeNumber,decodeIWallMessage)));
registerMethod("wallmood", ['wall_message_id', 'add', 'remove'], decodeStructure(decodeIWallMessage));
registerMethod("wallpublish", ['tagline'], decodeStructure(decodeIWallMessage));
registerMethod("wallpublishmultiplepics", ['description', 'picture', 'nbOfPicturesUpload', 'wallMessageClientId', 'clientPicId', 'finishupload', 'familyIds', 'comment'], decodeStructure(decodeIWallMessage));
registerMethod("wallpublishref", ['tagline', 'refObjectType', 'refObjectId'], decodeStructure(decodeIWallMessage));
registerMethod("webapiurl", [], decodeStructure(decodeString));
registerMethod("webget", [{name:'var', encode:encodeString}], decodeStructure(decodeString));
registerMethod("webgetExternalWebUrl", ['partnerType'], decodeStructure(decodeString));
registerMethod("webgetWebSocketUrl", [], decodeStructure(decodeString));
registerMethod("webhomehubvalidatecode", ['code'], decodeStructure(decodeBoolean));
registerMethod("webiaimportemail", ['email', {name:'from', encode:encodeString}, 'ical'], decodeStructure(decodeIcalImportResultBean));
registerMethod("webjslog", ['text'], decodeStructure(decodeboolean));
registerMethod("webog", ['url', 'refresh'], decodeStructure(decodeOpenGraphDataBean));
registerMethod("webset", [{name:'var', encode:encodeString}, 'value'], decodeStructure(decodeString));

export const methodsTs = {
  /**
   * same as addidentifier2 but return the account
   * @param identifier the new identifier
   * @param countryCode two char country code needed for identifier of type msisdn that that not provided as internationnal
   * @param validationmethod the method to valdiate the account identifier. Optional. If null won't try to validate the identifier.
   * @param password the password of the account. A password is needed to change an account's identifiers.
   */
  accaddidentifier(TYPE: AccountIdentifierTypeEnum, identifier: string, countryCode: string, validationmethod: AccountIdentifierValidationMethodEnum | undefined, password: string): Promise<IAccount> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validationmethod': encodeEnum, 'password': encodeString};
    return executorTs('accaddidentifier', model, decodeStructure(decodeIAccount), arguments);
  },
  /**
   * add a new account identifier to this account and send back the whole new
 account<br>
 If the account identifier is already existing, a
 FizAccountAlreadyExistsException shall be thrown. The account in session
 shall be updated, and the new account returned.
   * @param identifier the new identifier
   * @param countryCode two char country code needed for identifier of type msisdn that that not provided as internationnal
   * @param validationmethod the method to valdiate the account identifier. Optional. If null won't try to validate the identifier.
   * @param password the password of the account. A password is needed to change an account's identifiers.
   */
  accaddidentifier2(TYPE: AccountIdentifierTypeEnum, identifier: string, countryCode: string, validationmethod: AccountIdentifierValidationMethodEnum | undefined, password: string): Promise<IAccountIdentifier> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validationmethod': encodeEnum, 'password': encodeString};
    return executorTs('accaddidentifier2', model, decodeStructure(decodeIAccountIdentifier), arguments);
  },
  /**
   * Change an account identifier of one type by another account identifier.<ul>
 <li>If the old account identifier is identified by oldid, it can be changed by another identifier of any type.<br>
 <li>If the old account identifier is identified it its value, it can only be changed by an identifier of the same type<br>
 For instance, change an email identifier by another one, or change a msisdn by another one.</ul>
 If applicable to the identifier type (ie MSISDN), the validation code is sent if validationmethod is not null.
 The change of identifier is immediate, even if the new identifier is not validated.
   * @param validationmethod the method to valdiate the account identifier. Optional. If null won't try to validate the identifier.
   * @param password the password of the account. A password is needed to change an account's identifiers.
   */
  accchangeaccountidentifier(oldid: number | undefined, TYPE: AccountIdentifierTypeEnum | undefined, countryCode: string | undefined, oldidentifier: string | undefined, newidentifier: string, validationmethod: AccountIdentifierValidationMethodEnum | undefined, password: string): Promise<IAccountIdentifier> {
    const model = {'oldid': encodeNumber, 'type': encodeEnum, 'countryCode': encodeString, 'oldidentifier': encodeString, 'newidentifier': encodeString, 'validationmethod': encodeEnum, 'password': encodeString};
    return executorTs('accchangeaccountidentifier', model, decodeStructure(decodeIAccountIdentifier), arguments);
  },
  /**
   * This method allows to change of password
   * @param password the current password (maybe null if password has never been
            set) the new password
   * @param newpassword the new wanted password (if null will be generated)
   */
  accchangepassword(password?: string, newpassword?: string): Promise<string> {
    const model = {'password': encodeString, 'newpassword': encodeString};
    return executorTs('accchangepassword', model, decodeStructure(decodeString), arguments);
  },
  /**
   * This method check the password of the current account, if it is correctly sent again (for change password scenario)
   * @param password the current password (maybe null if password has never been
            set)
   */
  acccheckpassword(password?: string): Promise<boolean> {
    const model = {'password': encodeString};
    return executorTs('acccheckpassword', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Create a new family. An extra-family will be created with you as the founder.
 In this case, you can chain the api calls to set-up the customFirstname and customAvatar for this new family as a founder using chaining
 call such as: a01call=acccreatefamily&a01name=newfamily&a01multifamily=true&a02call=accsetprofile&a02customFirstname=newfirstname
 <br>
 The second call will be in the <i>scope</i> of the newly created family. For subsequent call, the scope of the new family must be used.
   * @param name the name of the family
   * @param cover cover (extra image) of the family
   */
  acccreatefamily(name: string, role?: FamilyRoleTypeEnum, customFamilyRole?: string, cover?: FizFile): Promise<number> {
    const model = {'name': encodeString, 'role': encodeEnum, 'customFamilyRole': encodeString, 'cover': encodeFizFile};
    return executorTs('acccreatefamily', model, decodeStructure(decodeNumber), arguments);
  },
  /**
   * create an account without login potential
 This account is a "subaccount" anyone in the family can take control of it.
 It might be use for a little kid or a pet
   */
  acccreatesubaccount(role: FamilyRoleTypeEnum, customFamilyRole: string | undefined, firstname: string, birthday?: Date, timezone?: string, locale?: string, picture?: FizFile, homeAddress?: string, workAddress?: string): Promise<number> {
    const model = {'role': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'birthday': encodeDate, 'timezone': encodeTimeZone, 'locale': encodeString, 'picture': encodeFizFile, 'homeAddress': encodeString, 'workAddress': encodeString};
    return executorTs('acccreatesubaccount', model, decodeStructure(decodeNumber), arguments);
  },
  /**
   * generate a deep login link that contains a login token
 use only one of those parameters
   * @param page page of the app where we want to go
   */
  accdeeplink(page?: DeepLinkPageEnum, directWebPage?: string): Promise<string> {
    const model = {'page': encodeEnum, 'directWebPage': encodeString};
    return executorTs('accdeeplink', model, decodeStructure(decodeString), arguments);
  },
  /**
   * DO NOT USE ANYMORE IT IS N'IMP
 generate a deep login link that contains a login token
   * @param page that the link will go to on the web, for instance may be map.php. If null, it will be home.php
   * @param webWanted if pass to true and calling useragent will not lead to a download we return null
   */
  accgenerateDeepLoginLink(page?: string, webWanted?: boolean, dev?: boolean): Promise<string> {
    const model = {'page': encodeString, 'webWanted': encodeBoolean, 'dev': encodeBoolean};
    return executorTs('accgenerateDeepLoginLink', model, decodeStructure(decodeString), arguments);
  },
  /**
   * api that return the current families with alot of information: all members, all profiles, all contacts, all poi
   */
  accgetallfamily(withStateBean?: boolean): Promise<IExtendedFamily> {
    const model = {'withStateBean': encodeBoolean};
    return executorTs('accgetallfamily', model, decodeStructure(decodeIExtendedFamily), arguments);
  },
  /**
   * return the family corresponding to the logged account
   */
  accgetfamily(): Promise<IFamily> {
    const model = {};
    return executorTs('accgetfamily', model, decodeStructure(decodeIFamily), arguments);
  },
  /**
   * return the currently logged-in account<br>
 The returned account contains all the AccountIdentifier(s) and all the
 family information attached to this account<br>
 However, the validationToken shall _NOT_ be transmitted in the
 accountIdentifier(s) (do not annotate the field)<br>
   */
  accgetloggedaccount(): Promise<IAccount> {
    const model = {};
    return executorTs('accgetloggedaccount', model, decodeStructure(decodeIAccount), arguments);
  },
  /**
   * retrieve the matrix for the premium rights
   */
  accgetpremium(): Promise<PremiumRightBean> {
    const model = {};
    return executorTs('accgetpremium', model, decodeStructure(decodePremiumRightBean), arguments);
  },
  /**
   * return the security bean for the currently loggued account, containing info about security such as the "hasPassword" flag.
   */
  accgetsecuritystate(): Promise<AccountSecurityBean> {
    const model = {};
    return executorTs('accgetsecuritystate', model, decodeStructure(decodeAccountSecurityBean), arguments);
  },
  /**
   * <h2>return the current state of the logged account.</h2>
 Basically returns, for each "premium'izable" features, a boolean indicating if the feature is active or inactive.<br>
 Also return extra information about which which partner has been linked to the account.<br>
 Extra features:<ul>
 <li>Check that the deviceId is the SAME that the one used to generate the authentication token !<br>
 The applicationVersion is required and shall contains a human-readable description of the version of the application.
 <li>It will use the timezone+locale to update the profile on the server.
 <li>Use modelType and buildTimestamp to perform a force-update behavior: if the server requires the client 
 to be upgraded, it will return a FizApplicationVersionIncompatibleException error.
 </ul>
 <h2>Force Update</h2>
 The force update feature is a feature that enables the server to invalidate any given versions of the client and force the user to update to 
 the newest version available on the appstore.<br>
 Whenever a client is opened on a device (android/iphone), the client calls the accgetstate (IAccountApi.getAccountState) api in order to retrieve
 the premium status for the currently logged account. During this call the client's version is checked and if the server determines that the version
 is too old, it returns an error to the client, and the clients display a message in a popup indicating that a new version must be downloaded.
 The client then forward the user to the familywall appstore page, therefore mandating the update.<br>
 Note about the force update mechanism:<ul>
 <li>The force update mechanism is used only to make users upgrade to a next version of a client, in order to have homogeneous clients features. 
 For instance, when we update the client to have the multifamily features, clients not supporting multifamily will not be able to respond to 
 multifamily invitation, which will be a burden in the user experience.
 <li>The server APIS must still be BACKWARD COMPATIBLE even if there is a force update mechanism.
 <li>Because of delay in application publication, the server is always updated before a new client is pushed to the app-store. Therefore the 
 force-update mechanism cannot replace backward compatible apis.
 <li>There is no push-message mechanism (gcm/apns/..) to broadcast an update messages to the clients.
 <li>Background activities of the clients are not affected.
 <li>Force update is based on the date of the build of the client. This enables 2 different branches (ie 1.X and 2.X) to be compatible with the server. 
 However when the force update mechanism is used to make users upgrade to version, say, 3.2, while keeping a version 1.X compatible, a new version
 1.X must be built. 
 </ul> 
 The behavior of the forceUpdate mechanism in accgetstate api is:<ul>
 <li>if buildTimestamp is not present, there is no forceupdate mechanism, the client can use the server. This is done for compatibility purposes with
 clients that do not support the forceupdate.
 <li>for each possible value of "modelType", the api select a target platform: android, iphone or ipad (or more...)
 <li>for each platform, there is a configuration on the server that indicate the minimum date of the build to be used with that server.
 <li>the client must store the date of the build, and compute the number of seconds since 01-Jan-1970-UTC for the time of the build
 <li>the client must send this timestamp in the buildTimestamp parameter
 <li>if the client timestamp is before the configured value on the server, the server return an ex error code 14 ( FizApplicationVersionIncompatibleException)
 </ul>
 <br>
   * @param deviceId the id of the device performing the getstate.
   * @param modelType the modelType of the device performing the getstate.
   * @param applicationVersion the applicationVersion of the device performing the getstate.
   * @param locale the locale of the user to update in his profile
   * @param buildTimestamp the timestamp of the build in seconds after 1jan1970:0h0m0sUTC
   */
  accgetstate(deviceId: string, modelType: DeviceModelTypeEnum, applicationVersion: string, timezone?: string, locale?: string, buildTimestamp?: number): Promise<AccountStateBean> {
    const model = {'deviceId': encodeString, 'modelType': encodeEnum, 'applicationVersion': encodeString, 'timezone': encodeTimeZone, 'locale': encodeString, 'buildTimestamp': encodeNumber};
    return executorTs('accgetstate', model, decodeStructure(decodeAccountStateBean), arguments);
  },
  /**
   * If the account is not the family manager, a AFizApiUnattendedException
 shall be thrown. If the account already exist, a
 FizAccountAlreadyExistsException shall be thrown. The account in session
 shall be updated, and the new account returned.
 NOTE: this api is used to perform invite and account creation at the same time. For other invitation (by email or sms)
 the new api faminvite shall be used. If the identifier is detected as an email, a FizApiInvalidParameterException exception will be thrown
   * @param identifier email or msisdn of the invitee
   * @param mobile the phone
   * @param birthday date of birth
   * @param timezone timezone of the user
   * @param picture picture of the user
   */
  accinvite(identifier: string, password: string | undefined, role: FamilyRoleTypeEnum, customFamilyRole: string | undefined, firstname: string, mobile?: string, birthday?: Date, timezone?: string, locale?: string, picture?: FizFile, homeAddress?: string, workAddress?: string): Promise<number> {
    const model = {'identifier': encodeString, 'password': encodeString, 'role': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'mobile': encodeString, 'birthday': encodeDate, 'timezone': encodeTimeZone, 'locale': encodeString, 'picture': encodeFizFile, 'homeAddress': encodeString, 'workAddress': encodeString};
    return executorTs('accinvite', model, decodeStructure(decodeNumber), arguments);
  },
  /**
   * same as accremoveidentifier but return the account
   * @param password the password of the account. A password is needed to change an account's identifiers.
   */
  accremoveidentifier(id: number, password: string): Promise<IAccount> {
    const model = {'id': encodeNumber, 'password': encodeString};
    return executorTs('accremoveidentifier', model, decodeStructure(decodeIAccount), arguments);
  },
  /**
   * remove an account identifier. You must still have at least one email/login/msisdn after the operation.
   * @param password the password of the account. A password is needed to change an account's identifiers.
   */
  accremoveidentifier2(id: number, password: string): Promise<IAccountIdentifier> {
    const model = {'id': encodeNumber, 'password': encodeString};
    return executorTs('accremoveidentifier2', model, decodeStructure(decodeIAccountIdentifier), arguments);
  },
  /**
   * api that will send to an account identifier a validation message containing a code or a link.
 This api will only work with Msisdn-type of account identifiers and will send an SMS using ISmsManager<br>
 This api will also work with Email-type of account identifiers and will send the code via email<br>
 This api send a either a NEW or an existing validation code, depending on the type of validationmethod. 
 For instance, for TOKEN, it will first try to find a valid existsing token to resent, before regenerating a new one.
   * @param validationmethod the method to valdiate the account identifier. Optional. If null won't try to validate the identifier.
   */
  accsendaccountidentifiervalidationcode(id: number | undefined, TYPE: AccountIdentifierTypeEnum | undefined, identifier: string | undefined, countryCode: string | undefined, validationmethod: AccountIdentifierValidationMethodEnum): Promise<boolean> {
    const model = {'id': encodeNumber, 'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validationmethod': encodeEnum};
    return executorTs('accsendaccountidentifiervalidationcode', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * retrieve the matrix for the premium rights
   */
  accsendwelcomeemail(): Promise<boolean> {
    const model = {};
    return executorTs('accsendwelcomeemail', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Set the profile of the current account (second page of registration
 process)
   * @param accountId account of the profile to modify : if null it is yours, if not
            you have to be administrator to modify the account
   * @param pseudo DEPRECATED only here for compatibility purposes with old iphone client
   * @param firstname firstname of the user in his default no-family profile
   * @param role role of the user in the family
   * @param mobile the mobile number (if null no change, if empty String will delete, else it store the value)
   * @param email the email address (if null no change, if empty String will delete, else it store the value)
   * @param birthday date of birth
   * @param timezone timezone of the user
   * @param locale locale such as en_GB or fr_FR
   * @param homeAddress home address of the user
   * @param color a color in format #abcd12 as in the web
   * @param customFirstName the firstname of the profile associated with this family (firstname is the default)
   * @param customAvatar the picture./avatar of the profile associated with this family (picture is the default)
   */
  accsetprofile(accountId?: number, pseudo?: string, firstname?: string, gender?: GenderEnum, role?: FamilyRoleTypeEnum, customFamilyRole?: string, mobile?: string, email?: string, birthday?: Date, timezone?: string, locale?: string, picture?: FizFile, homeAddress?: string, workAddress?: string, color?: string, publishProfileChanged?: boolean, customFirstName?: string, customAvatar?: FizFile): Promise<number> {
    const model = {'accountId': encodeNumber, 'pseudo': encodeString, 'firstname': encodeString, 'gender': encodeEnum, 'role': encodeEnum, 'customFamilyRole': encodeString, 'mobile': encodeString, 'email': encodeString, 'birthday': encodeDate, 'timezone': encodeTimeZone, 'locale': encodeString, 'picture': encodeFizFile, 'homeAddress': encodeString, 'workAddress': encodeString, 'color': encodeString, 'publishProfileChanged': encodeBoolean, 'customFirstName': encodeString, 'customAvatar': encodeFizFile};
    return executorTs('accsetprofile', model, decodeStructure(decodeNumber), arguments);
  },
  /**
   * set a value of acceptance of terms and condition
   * @param termsChecked if null nothing is done else the value is set
   */
  accsetterms(termsChecked?: boolean, termsHtcChecked?: boolean, termsOrangeFamilyPlaceChecked?: boolean, termsSprintChecked?: boolean, termsProximusFamilyChecked?: boolean): Promise<AccountLoginInfo> {
    const model = {'termsChecked': encodeBoolean, 'termsHtcChecked': encodeBoolean, 'termsOrangeFamilyPlaceChecked': encodeBoolean, 'termsSprintChecked': encodeBoolean, 'termsProximusFamilyChecked': encodeBoolean};
    return executorTs('accsetterms', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * Update the family name and/or picture
   * @param name the name of the family, if null no update
   * @param file image of the family, if null no update
   */
  accupdatefamily(name?: string, file?: FizFile, cover?: FizFile): Promise<IFamily> {
    const model = {'name': encodeString, 'file': encodeFizFile, 'cover': encodeFizFile};
    return executorTs('accupdatefamily', model, decodeStructure(decodeIFamily), arguments);
  },
  /**
   * same as validateaccountidentifierwithcode2 but return the account
   * @param autoacceptpendinginvite set to true if asked to accept pending invitation while doing this
   */
  accvalidateaccountidentifierwithcode(id: number | undefined, TYPE: AccountIdentifierTypeEnum | undefined, identifier: string | undefined, countryCode: string | undefined, code: string, autoacceptpendinginvite?: boolean): Promise<IAccount> {
    const model = {'id': encodeNumber, 'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString, 'autoacceptpendinginvite': encodeBoolean};
    return executorTs('accvalidateaccountidentifierwithcode', model, decodeStructure(decodeIAccount), arguments);
  },
  /**
   * Will validate an identifier based on a code entered by the user
   * @param autoacceptpendinginvite set to true if asked to accept pending invitation while doing this
   */
  accvalidateaccountidentifierwithcode2(id: number | undefined, TYPE: AccountIdentifierTypeEnum | undefined, identifier: string | undefined, countryCode: string | undefined, code: string, autoacceptpendinginvite?: boolean): Promise<IAccountIdentifier> {
    const model = {'id': encodeNumber, 'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString, 'autoacceptpendinginvite': encodeBoolean};
    return executorTs('accvalidateaccountidentifierwithcode2', model, decodeStructure(decodeIAccountIdentifier), arguments);
  },
  /**
   * Actually validate an account identifier change with a code or a link
   */
  accvalidatechangeaccountidentifier(oldid: number | undefined, TYPE: AccountIdentifierTypeEnum | undefined, countryCode: string | undefined, oldidentifier: string | undefined, newidentifier: string, code: string): Promise<IAccountIdentifier> {
    const model = {'oldid': encodeNumber, 'type': encodeEnum, 'countryCode': encodeString, 'oldidentifier': encodeString, 'newidentifier': encodeString, 'code': encodeString};
    return executorTs('accvalidatechangeaccountidentifier', model, decodeStructure(decodeIAccountIdentifier), arguments);
  },
  /**
   * assign a right to a list of account within a given family
   * @param right the new right to set
   * @param accountid the list of account to be affected by the new right
   */
  adminchange(right: FamilyAdminRightEnum | undefined, accountid: Array<number>): Promise<AdminRightBean> {
    const model = {'right': encodeEnum, 'accountid': encodeArray(encodeNumber)};
    return executorTs('adminchange', model, decodeStructure(decodeAdminRightBean), arguments);
  },
  /**
   * Delete the currently logged account<br>Will remove the account from all his families and then delete the account completely
 Depending on the boolean given to that api, either really delete the post authored by the account, or keep them in the family.
   * @param deleteAuthoredPost if true, delete the post authored by the account, else keep them with a family profile
   */
  admindelete2(deleteAuthoredPost: boolean): Promise<boolean> {
    const model = {'deleteAuthoredPost': encodeboolean};
    return executorTs('admindelete2', model, decodeStructure(decodeBoolean), arguments);
  },
  admingetright(accountId?: number): Promise<FamilyAdminRightEnum> {
    const model = {'accountId': encodeNumber};
    return executorTs('admingetright', model, decodeStructure(decodeEnum), arguments);
  },
  /**
   * return the currents rights of the family members
   */
  adminlist(): Promise<AdminRightBean> {
    const model = {};
    return executorTs('adminlist', model, decodeStructure(decodeAdminRightBean), arguments);
  },
  /**
   * Remove a member from the current family, without deleting the corresponding account<br>
 Depending on the boolean given to that api, either really delete the post authored by the account, or keep them in the family. 
 If the removed account is the founder of this family, the founder tag is transfered to another admin member.
   * @param accountId the accountId to remove from the family
   * @param deleteAuthoredPost if true, delete the post authored by the account, else keep them with a family profile
   */
  adminremove(accountId: number, deleteAuthoredPost: boolean): Promise<boolean> {
    const model = {'accountId': encodeNumber, 'deleteAuthoredPost': encodeboolean};
    return executorTs('adminremove', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Wipe-out the entire family, if the caller is the founder/superadmin. Actually perform a removeFromFamily on all member of said family.
   */
  adminwipefamily(): Promise<boolean> {
    const model = {};
    return executorTs('adminwipefamily', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * return all the media of this family, eventually filtered
   * @param accountId only media whose author is this account
   * @param bestMoment only media with flag bestMoment setted to this value
   * @param mood only media for whom somebody has set this mood
   */
  albumall(accountId?: number, bestMoment?: boolean, mood?: MoodEnum, pg?: PaginationRequest): Promise<MediaListBean> {
    const model = {'accountId': encodeNumber, 'bestMoment': encodeBoolean, 'mood': encodeEnum, 'pg': encodePaginationRequest};
    return executorTs('albumall', model, decodeStructure(decodeMediaListBean), arguments);
  },
  /**
   * return the front media for each creator
   */
  albumfrontbycreator(): Promise<Array<MediaFilterFrontImage>> {
    const model = {};
    return executorTs('albumfrontbycreator', model, decodeStructure(decodeArray(decodeMediaFilterFrontImage)), arguments);
  },
  /**
   * list the quota status of the family
   */
  albumquota(): Promise<MediaQuota> {
    const model = {};
    return executorTs('albumquota', model, decodeStructure(decodeMediaQuota), arguments);
  },
  /**
   * delete budget categories
   */
  budgetcategorydelete(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('budgetcategorydelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * get a budget category by its metaId (if right to read it)
 If not allowed or not exists, it returns null
   */
  budgetcategoryget(id: string): Promise<BudgetCategoryBean> {
    const model = {'id': encodeMetaId};
    return executorTs('budgetcategoryget', model, decodeStructure(decodeBudgetCategoryBean), arguments);
  },
  /**
   * list all task categories of this type
   * @param locale locale
   */
  budgetcategorylist(budgetTransactionType?: BudgetTransactionType, locale?: string): Promise<Array<BudgetCategoryBean>> {
    const model = {'budgetTransactionType': encodeEnum, 'locale': encodeString};
    return executorTs('budgetcategorylist', model, decodeStructure(decodeArray(decodeBudgetCategoryBean)), arguments);
  },
  /**
   * create or update a budget category. p<br>
 update or create a budget category, can update its properties (from input)
 <br>
   * @param input : the input bean. Note: to reorder, specify the tasklistId the reorder will be affected upon
   */
  budgetcategoryput(__inline: BudgetCategoryInputBean, prevId?: string): Promise<BudgetCategoryBean> {
    const model = {'__inline': encodeBudgetCategoryInputBean, 'prevId': encodeMetaId};
    return executorTs('budgetcategoryput', model, decodeStructure(decodeBudgetCategoryBean), arguments);
  },
  /**
   * sync budget categories
   */
  budgetcategorysync(syncToken?: string): Promise<BudgetCategorySyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('budgetcategorysync', model, decodeStructure(decodeBudgetCategorySyncBean), arguments);
  },
  /**
   * called when a user closes a budget screen: this will check for modification and send the good push notification in this case.
   */
  budgetclose(metaId?: string): Promise<boolean> {
    const model = {'metaId': encodeMetaId};
    return executorTs('budgetclose', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * delete a budget altogether with all transactions within
   */
  budgetdelete(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('budgetdelete', model, decodeStructure(decodeBoolean), arguments);
  },
  budgetexportcsvurl(id: Array<string>, FROM?: Date, to?: Date): Promise<string> {
    const model = {'id': encodeArray(encodeMetaId), 'from': encodeDate, 'to': encodeDate};
    return executorTs('budgetexportcsvurl', model, decodeStructure(decodeString), arguments);
  },
  /**
   * get a budget
   * @param id metaId
   */
  budgetget(id: string): Promise<BudgetBean> {
    const model = {'id': encodeMetaId};
    return executorTs('budgetget', model, decodeStructure(decodeBudgetBean), arguments);
  },
  /**
   * list all budget available for the currently loggued account
   */
  budgetlist(): Promise<Array<BudgetBean>> {
    const model = {};
    return executorTs('budgetlist', model, decodeStructure(decodeArray(decodeBudgetBean)), arguments);
  },
  /**
   * mark a list of ids as paid (or not paid if value is false)
   * @param metaId list of id to change (id with occurence number at the end)
   * @param value considered as true if null
   */
  budgetmarkaspaid(metaId: Array<string>, value?: boolean): Promise<Array<BudgetTransactionBean>> {
    const model = {'metaId': encodeArray(encodeMetaId), 'value': encodeBoolean};
    return executorTs('budgetmarkaspaid', model, decodeStructure(decodeArray(decodeBudgetTransactionBean)), arguments);
  },
  /**
   * delete payment methods
   */
  budgetpaymentmethoddelete(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('budgetpaymentmethoddelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * get a payment method by its metaId (if right to read it)
 If not allowed or not exists, it returns null
   */
  budgetpaymentmethodget(id: string): Promise<PaymentMethodBean> {
    const model = {'id': encodeMetaId};
    return executorTs('budgetpaymentmethodget', model, decodeStructure(decodePaymentMethodBean), arguments);
  },
  /**
   * list all payment method of this type
   * @param locale locale
   */
  budgetpaymentmethodlist(locale?: string): Promise<Array<PaymentMethodBean>> {
    const model = {'locale': encodeString};
    return executorTs('budgetpaymentmethodlist', model, decodeStructure(decodeArray(decodePaymentMethodBean)), arguments);
  },
  /**
   * create or update a budget category. p<br>
 update or create a budget category, can update its properties (from input)
 <br>
   * @param input : the input bean. Note: to reorder, specify the tasklistId the reorder will be affected upon
   */
  budgetpaymentmethodput(__inline: PaymentMethodInputBean, prevId?: string): Promise<PaymentMethodBean> {
    const model = {'__inline': encodePaymentMethodInputBean, 'prevId': encodeMetaId};
    return executorTs('budgetpaymentmethodput', model, decodeStructure(decodePaymentMethodBean), arguments);
  },
  /**
   * sync payment methods
   */
  budgetpaymentmethodsync(syncToken?: string): Promise<PaymentMethodSyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('budgetpaymentmethodsync', model, decodeStructure(decodePaymentMethodSyncBean), arguments);
  },
  /**
   * create or update a budget
   * @param input value information for the budget
   */
  budgetput(__inline: BudgetInputBean): Promise<BudgetBean> {
    const model = {'__inline': encodeBudgetInputBean};
    return executorTs('budgetput', model, decodeStructure(decodeBudgetBean), arguments);
  },
  /**
   * sync budgets
   */
  budgetsync(syncToken?: string): Promise<BudgetSyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('budgetsync', model, decodeStructure(decodeBudgetSyncBean), arguments);
  },
  /**
   * delete a transaction
   */
  budgettransactiondelete(option: RecurrencyActionOptionEnum | undefined, id: Array<string>): Promise<boolean> {
    const model = {'option': encodeEnum, 'id': encodeArray(encodeMetaId)};
    return executorTs('budgettransactiondelete', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Return to the client the various delete option, which may be multiple in case of recurring event.
 IE before proposing "all events", "only this occurence", "all occurence from this" options to a delete command, a client
 must call this api to know which ones are relevant or not.
   */
  budgettransactiondeleteoption(id: string): Promise<Array<RecurrencyActionOptionEnum>> {
    const model = {'id': encodeMetaId};
    return executorTs('budgettransactiondeleteoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
  },
  /**
   * get a transaction of a budget by its metaid
   */
  budgettransactionget(id: string): Promise<BudgetTransactionBean> {
    const model = {'id': encodeMetaId};
    return executorTs('budgettransactionget', model, decodeStructure(decodeBudgetTransactionBean), arguments);
  },
  /**
   * list all transactions of all budgets
   */
  budgettransactionlist(): Promise<Array<BudgetTransactionBean>> {
    const model = {};
    return executorTs('budgettransactionlist', model, decodeStructure(decodeArray(decodeBudgetTransactionBean)), arguments);
  },
  /**
   * create a budget's transaction
   */
  budgettransactionput(option: RecurrencyActionOptionEnum | undefined, __inline: BudgetTransactionInputBean, file?: Array<FizFile>): Promise<BudgetTransactionBean> {
    const model = {'option': encodeEnum, '__inline': encodeBudgetTransactionInputBean, 'file': encodeArray(encodeFizFile)};
    return executorTs('budgettransactionput', model, decodeStructure(decodeBudgetTransactionBean), arguments);
  },
  /**
   * sync budget transcations
   */
  budgettransactionsync(syncToken?: string): Promise<BudgetTransactionSyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('budgettransactionsync', model, decodeStructure(decodeBudgetTransactionSyncBean), arguments);
  },
  /**
   * Return to the client the various delete option, which may be multiple in case of recurring event.
 IE before proposing "all events", "only this occurence", "all occurence from this" options to a delete command, a client
 must call this api to know which ones are relevant or not.
   */
  budgettransactionupdateoption(__inline: BudgetTransactionInputBean): Promise<Array<RecurrencyActionOptionEnum>> {
    const model = {'__inline': encodeBudgetTransactionInputBean};
    return executorTs('budgettransactionupdateoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
  },
  colordelete(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('colordelete', model, decodeStructure(decodeboolean), arguments);
  },
  colorget(id: string): Promise<ColorBean> {
    const model = {'id': encodeMetaId};
    return executorTs('colorget', model, decodeStructure(decodeColorBean), arguments);
  },
  /**
   * return the list of color as to be displayed in the palette such as ColorListActivity
   */
  colorlist(): Promise<Array<ColorBean>> {
    const model = {};
    return executorTs('colorlist', model, decodeStructure(decodeArray(decodeColorBean)), arguments);
  },
  /**
   * Change the name of an existing color, or change the color code.<br>
 You create a inputColor with a metaId and a name, and it will update the name of the color in the palette and in every events where is color is used.
 If the existing color is a system palette color, the returned ColorBean will have a different metaId, as a new custom color will be created to reflect the changes to the system 
 color (which is hardcoded therefore readonly).
   */
  colorput(__inline: ColorInputBean): Promise<ColorBean> {
    const model = {'__inline': encodeColorInputBean};
    return executorTs('colorput', model, decodeStructure(decodeColorBean), arguments);
  },
  /**
   * call it after the buy has been done
   */
  credit2checkouthomehubconfirmpurchase(code: string): Promise<boolean> {
    const model = {'code': encodeString};
    return executorTs('credit2checkouthomehubconfirmpurchase', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * get the url to go to benefit from the offer
   */
  credit2checkouthomehuburl(code: string): Promise<HomeHubValidationBean> {
    const model = {'code': encodeString};
    return executorTs('credit2checkouthomehuburl', model, decodeStructure(decodeHomeHubValidationBean), arguments);
  },
  credit2checkouturl2(): Promise<TwoCheckoutUrlsBean2> {
    const model = {};
    return executorTs('credit2checkouturl2', model, decodeStructure(decodeTwoCheckoutUrlsBean2), arguments);
  },
  /**
   * gets the user's credits
   */
  creditget(): Promise<Array<ICredit>> {
    const model = {};
    return executorTs('creditget', model, decodeStructure(decodeArray(decodeICredit)), arguments);
  },
  /**
   * get a promo code from its value without using it , may return null...
   */
  creditgetPromoCode(value: string): Promise<IPromoCode> {
    const model = {'value': encodeString};
    return executorTs('creditgetPromoCode', model, decodeStructure(decodeIPromoCode), arguments);
  },
  /**
   * ask for a sku in the "FW multifamily purchase" scenario that is not yet subscribed and can be used to subscribe to a new family
   * @param creditType type of credit to query for (familywall or sprint or any other premium that can be purchased on the stores
   * @param paymentType type of payment, ie itunes or gplay
   * @param typeOfPeriod type of period, ie monthly or yearly (nullable for compatibility)
   */
  creditgetfreesku(creditType: CreditTypeEnum, paymentType: CreditPaymentTypeEnum, typeOfPeriod?: CreditTypeOfPeriodEnum): Promise<string> {
    const model = {'creditType': encodeEnum, 'paymentType': encodeEnum, 'typeOfPeriod': encodeEnum};
    return executorTs('creditgetfreesku', model, decodeStructure(decodeString), arguments);
  },
  creditgetmanualrenewalllink(creditId: string): Promise<string> {
    const model = {'creditId': encodeMetaId};
    return executorTs('creditgetmanualrenewalllink', model, decodeStructure(decodeString), arguments);
  },
  /**
   * Validate/add a new google play store purchase token from a payment.
   * @param deviceId id of the device that perform the purchase, must match the deviceid used to generte the oauth token used to authenticate this request
   * @param token the token to validate from the store
   * @param creditType (optional) the type of credit to validate against, when there are more than one possible credit type for a given client (ie sprint normal/plus)
   * @param sku (optional) the sku to validate in case several sku for the same client is possible (ie FW Multifamily purchase)
   */
  creditgoogleplaytoken(deviceId: string, token: string, creditType?: CreditTypeEnum, sku?: string): Promise<SubscriptionTicketBean> {
    const model = {'deviceId': encodeString, 'token': encodeString, 'creditType': encodeEnum, 'sku': encodeString};
    return executorTs('creditgoogleplaytoken', model, decodeStructure(decodeSubscriptionTicketBean), arguments);
  },
  /**
   * Validate a iTune receipt from a payment, but with the new ios7 apis
   */
  credititunesIos7ticket(deviceId: string, receipt: string): Promise<SubscriptionTicketBean> {
    const model = {'deviceId': encodeString, 'receipt': encodeString};
    return executorTs('credititunesIos7ticket', model, decodeStructure(decodeSubscriptionTicketBean), arguments);
  },
  /**
   * Parse a receipt to check if the user is entitled a trial or not, in order to display on the device the correct price, and promotion..
 Additionally, this api return the number of days of the premium, for each productId in the list .(it is in a config file on the server)
   * @param deviceId the deviceId of the querying ios device
   * @param receipt the receipt to validate
   * @param trialDurationProductIdList the list of productId to receive the trial period length (in days). Example: com.familywall.premium.V2.2
   */
  credititunesreceiptstatus(deviceId: string, receipt: string, trialDurationProductIdList?: Array<string>): Promise<ItunesReceiptStatusBean> {
    const model = {'deviceId': encodeString, 'receipt': encodeString, 'trialDurationProductIdList': encodeArray(encodeString)};
    return executorTs('credititunesreceiptstatus', model, decodeStructure(decodeItunesReceiptStatusBean), arguments);
  },
  /**
   * Validate a iTune receipt from a payment.
   */
  credititunesticket(deviceId: string, receipt: string): Promise<SubscriptionTicketBean> {
    const model = {'deviceId': encodeString, 'receipt': encodeString};
    return executorTs('credititunesticket', model, decodeStructure(decodeSubscriptionTicketBean), arguments);
  },
  /**
   * List all the credits of all the members in the family
   */
  creditlistall(): Promise<Array<ICredit>> {
    const model = {};
    return executorTs('creditlistall', model, decodeStructure(decodeArray(decodeICredit)), arguments);
  },
  /**
   * Change the auto-renewal option of the credit, by integrating with payment platforms and change the setting of the corresponding subscription.<br>
 For the moment, only work with 2 checkout.
   * @param creditId must be a twocheckout credit for now
   * @param auto just false is accepted for now
   */
  creditsetautorenewall(creditId: string, auto: CreditAutoRenewType): Promise<ICredit> {
    const model = {'creditId': encodeMetaId, 'auto': encodeEnum};
    return executorTs('creditsetautorenewall', model, decodeStructure(decodeICredit), arguments);
  },
  /**
   * change the family assignation of an existing credit, from family "existing" to family "new"
   */
  creditswitchfamily(creditId: string, existingFamilyId: string, newFamilyId: string): Promise<ICredit> {
    const model = {'creditId': encodeMetaId, 'existingFamilyId': encodeMetaId, 'newFamilyId': encodeMetaId};
    return executorTs('creditswitchfamily', model, decodeStructure(decodeICredit), arguments);
  },
  /**
   * use a promo code and return the corresponding credit, created
   */
  creditusepromocode(value: string): Promise<ICredit> {
    const model = {'value': encodeString};
    return executorTs('creditusepromocode', model, decodeStructure(decodeICredit), arguments);
  },
  /**
   * comment an event
   */
  ctccomment(contactId: string, text: string): Promise<IComment> {
    const model = {'contactId': encodeMetaId, 'text': encodeString};
    return executorTs('ctccomment', model, decodeStructure(decodeIComment), arguments);
  },
  /**
   * delete a list of contact
   * @param contactIds ids to delete
   */
  ctcdelete(contactIds: Array<string>): Promise<boolean> {
    const model = {'contactIds': encodeArray(encodeMetaId)};
    return executorTs('ctcdelete', model, decodeStructure(decodeboolean), arguments);
  },
  ctcget(contactId: string): Promise<IContact> {
    const model = {'contactId': encodeMetaId};
    return executorTs('ctcget', model, decodeStructure(decodeIContact), arguments);
  },
  /**
   * Return all accessible contacts
   */
  ctclist(): Promise<Array<IContact>> {
    const model = {};
    return executorTs('ctclist', model, decodeStructure(decodeArray(decodeIContact)), arguments);
  },
  /**
   * update or create a contact
   */
  ctcput(__inline: IContact, pictures?: Array<FizFile>): Promise<IContact> {
    const model = {'__inline': encodeIContact, 'pictures': encodeArray(encodeFizFile)};
    return executorTs('ctcput', model, decodeStructure(decodeIContact), arguments);
  },
  /**
   * return the ContactSyncBean asociated to asked Date
   */
  ctcsync(syncToken?: string, date?: Date): Promise<ContactSyncBean> {
    const model = {'syncToken': encodeString, 'date': encodeDate};
    return executorTs('ctcsync', model, decodeStructure(decodeContactSyncBean), arguments);
  },
  /**
   * import a vcard file into the family address book.
 This method can be used in preview mode to see what will be imported without actually importing.
 Contacts are matched by firstName+lastName. If a match is found, the contact is updated, otherwise created.
   * @param file a vCard file (FizFile or URL)
   * @param isPreview if true will return a view of the file (in content) but will not modify anything
   * @param indexes if null or empty means that we want all the contacts, else we will only import the contacts whose index in file are in this list of indexes
   */
  ctcvcardimport(file: FizFile, isPreview?: boolean, indexes?: Array<number>): Promise<VcardImportPreviewBean> {
    const model = {'file': encodeFizFile, 'isPreview': encodeBoolean, 'indexes': encodeArray(encodeNumber)};
    return executorTs('ctcvcardimport', model, decodeStructure(decodeVcardImportPreviewBean), arguments);
  },
  /**
   * generate the url of the vcard export of the familywall address book
   * @param contactId (optional) if present, the url will only contains one contact...
   */
  ctcvcardurl(contactId?: string): Promise<string> {
    const model = {'contactId': encodeMetaId};
    return executorTs('ctcvcardurl', model, decodeStructure(decodeString), arguments);
  },
  /**
   * acknowledge the display of this push message in a hard way
   */
  deviceackpush(pushIds: Array<string>): Promise<boolean> {
    const model = {'pushIds': encodeArray(encodeMetaId)};
    return executorTs('deviceackpush', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Check if pending push message are to be delivered to the client.
 Must be called by the client in 3 different cases:<ul>
 <li>just after a push token is send to the server using setdeviceconfig (so relogging will purge the waiting push messages)
 <li>when the PushTypeEnum.PersistentPushWakeUp push message is received
 <li>periodically once every 4 hours or so
 </ul>
 VERY important: if FizTokenNeededException is thrown, regenerate a push token from the client !<br>
   * @param config theDeviceId of the device that retrive the push. There is a message queue per device, this identifie the queue
   * @param isBackground optional flag to send if this call is performed in the case "once every 4 hours", for debugging purposes
   */
  devicecheckpush(__inline: DeviceConfigBean, isBackground?: boolean): Promise<Array<PushMessageBean>> {
    const model = {'__inline': encodeDeviceConfigBean, 'isBackground': encodeBoolean};
    return executorTs('devicecheckpush', model, decodeStructure(decodeArray(decodePushMessageBean)), arguments);
  },
  /**
   * delete the push token of this deviceId (if yours). won't delete other info as they are kept for future reference (ccare for instance)<br>
 Also work if you don't have a session but are identified by correct client_id & secret , for mobile devices. Use deviceId UUID to clear the token. 
   Useful to manage push errors (from android unloggued devices for instance)
   * @param deviceId the id of the device to delete as guid
   */
  devicedelete(deviceId: string): Promise<boolean> {
    const model = {'deviceId': encodeString};
    return executorTs('devicedelete', model, decodeStructure(decodeboolean), arguments);
  },
  devicelist(): Promise<Array<IDeviceConfig>> {
    const model = {};
    return executorTs('devicelist', model, decodeStructure(decodeArray(decodeIDeviceConfig)), arguments);
  },
  /**
   * delete push tokenswith this type and notificationTokenId in order to not have anoying notification after logging out.<br>
 Basically same api as delete but can fetch the device by its id or by the value of the token
   */
  devicelogout(config: DeviceConfigBean): Promise<boolean> {
    const model = {'config': encodeDeviceConfigBean};
    return executorTs('devicelogout', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * set the config of the loggued device for receiving notifications<br>
 If it is the same as before, some counters are reinitialized
   */
  devicesetconfig(config: DeviceConfigBean): Promise<boolean> {
    const model = {'config': encodeDeviceConfigBean};
    return executorTs('devicesetconfig', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * comment an event
   */
  evtaddComment(eventId: string, text: string, mood?: MoodEnum): Promise<CommentResultBean<IEvent>> {
    const model = {'eventId': encodeMetaId, 'text': encodeString, 'mood': encodeEnum};
    return executorTs('evtaddComment', model, decodeStructure(decodeCommentResultBean(decodeIEvent)), arguments);
  },
  /**
   * Update an event
   * @param metaId all event/import metaIds
   * @param input the input of the event
   */
  evtbatchupdate(metaId: Array<string>, input: EventInputBean): Promise<number> {
    const model = {'metaId': encodeArray(encodeMetaId), 'input': encodeEventInputBean};
    return executorTs('evtbatchupdate', model, decodeStructure(decodenumber), arguments);
  },
  /**
   * check if the given url is a usable ical url
   */
  evtcalcheckurl(url: string): Promise<boolean> {
    const model = {'url': encodeString};
    return executorTs('evtcalcheckurl', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * delete a CalendarBean, or a GoogleCredentialBean/OutlookCredentialBean and all its calendar
   */
  evtcaldelete(metaId: string): Promise<boolean> {
    const model = {'metaId': encodeMetaId};
    return executorTs('evtcaldelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * list all calendar (internal familywall family calendar) and external calendar (imported or available)
   * @param withtask (does the client support display of the calendar of the task with due date?)
   * @param withmeal (does the client support display of the calendar of the mealplanner?)
   * @param withfolder (does the client support display of calendarFolder)
   * @param withAllFamilies (does the client support display of allFamily calendarFolder ?)
   * @param withExternal (does the client support display of externalCalendarByUrl)
   * @param withOnError (does the client support display of outlook/google calendar with error)
   */
  evtcallist(withtask?: boolean, withmeal?: boolean, withfolder?: boolean, withAllFamilies?: boolean, withExternal?: boolean, withOnError?: boolean, withSpecialDays?: boolean): Promise<CalendarGroupBean> {
    const model = {'withtask': encodeBoolean, 'withmeal': encodeBoolean, 'withfolder': encodeBoolean, 'withAllFamilies': encodeBoolean, 'withExternal': encodeBoolean, 'withOnError': encodeBoolean, 'withSpecialDays': encodeBoolean};
    return executorTs('evtcallist', model, decodeStructure(decodeCalendarGroupBean), arguments);
  },
  /**
   * add a calendar by url
 it will create a calendar that will be viewable in calList with withExternal=true
 this calendar works as the google and outlooks ones
   */
  evtcalsubscribe2(url: string): Promise<CalendarSubscriptionResponseBean> {
    const model = {'url': encodeString};
    return executorTs('evtcalsubscribe2', model, decodeStructure(decodeCalendarSubscriptionResponseBean), arguments);
  },
  /**
   * metaId is mandatory in the fields, others are not
   */
  evtcalupdate(__inline: CalendarBean): Promise<boolean> {
    const model = {'__inline': encodeCalendarBean};
    return executorTs('evtcalupdate', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Create an event.
   * @param ComJeronimoFizGeneratedForInline0 the input of the event
   */
  evtcreate(__inline: EventInputBean): Promise<IEvent> {
    const model = {'__inline': encodeEventInputBean};
    return executorTs('evtcreate', model, decodeStructure(decodeIEvent), arguments);
  },
  /**
   * Delete the event of the given id
   * @param option for occurence exception, the kind of delete wanted. In this case eventId pust be the identifier of an occurence !
   * @param eventId id of the event we want to delete
   */
  evtdelete(option: RecurrencyActionOptionEnum | undefined, eventId: Array<string>): Promise<boolean> {
    const model = {'option': encodeEnum, 'eventId': encodeArray(encodeMetaId)};
    return executorTs('evtdelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Return to the client the various delete option, which may be multiple in case of recurring event.
 IE before proposing "all events", "only this occurence", "all occurence from this" options to a delete command, a client
 must call this api to know which ones are relevant or not.
   */
  evtdeleteoption(eventId: string): Promise<Array<RecurrencyActionOptionEnum>> {
    const model = {'eventId': encodeMetaId};
    return executorTs('evtdeleteoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
  },
  /**
   * Delete an external import. This api itself is not bound to event imports, however for the moment, only event import exists and therefore I put the api in "evt".<br>
 You can delete imports in bulk (the parameter is a list of metaId of imports to delete), and you can specify whether the attached elements (events, etc..) are deleted
 along with the import entry, or not (in the latter case, their external import id is cleared).<br>
 Return the number of attached items that have been affected by this operation.
 Limitation: all imports must belong to the same owner (in this case family).<br>
   * @param deleteAttachedItems a flag indicating if (true) we delete the attached items (events) of the imports, or if we just clear their external import id.
   * @param id the list of id of external import to delete.
   */
  evtexternalimportdelete(deleteAttachedItems: boolean, id: Array<string>): Promise<Map<string, number>> {
    const model = {'deleteAttachedItems': encodeboolean, 'id': encodeArray(encodeMetaId)};
    return executorTs('evtexternalimportdelete', model, decodeStructure(decodeMap(decodeMetaId,decodeNumber)), arguments);
  },
  /**
   * Get the event of the given id
   * @param eventId id of the event we want to get
   */
  evtget(eventId: string): Promise<IEvent> {
    const model = {'eventId': encodeMetaId};
    return executorTs('evtget', model, decodeStructure(decodeIEvent), arguments);
  },
  /**
   * Get the event of the given id, returning only the next instance of the birthday event 
 (now birthdays are multiple events and not recurrent events)
   * @param contactId contactId of the contact we want the birthday<br>
            If the contactId is an accountId it should work too
   */
  evtgetbirthday(contactId: string): Promise<IEvent> {
    const model = {'contactId': encodeMetaId};
    return executorTs('evtgetbirthday', model, decodeStructure(decodeIEvent), arguments);
  },
  /**
   * must be used instead of icalsend
   * @param file an URL or a File
   * @param isPreview if true will return a view of the file (in content) but will not modify anything
   * @param indexes if null or empty means that we want all the events, else we will only import the events whose index in file are in this list of indexes
   */
  evticalimport(file: FizFile, isPreview?: boolean, indexes?: Array<number>): Promise<IcalImportPreviewBean> {
    const model = {'file': encodeFizFile, 'isPreview': encodeBoolean, 'indexes': encodeArray(encodeNumber)};
    return executorTs('evticalimport', model, decodeStructure(decodeIcalImportPreviewBean), arguments);
  },
  /**
   * generate the url of the ical export of the familywall family calendar (for ios to import it in the phone)
   * @param calendarId the id of the calendar to sync
   * @param eventId (optional) if present, the url will only contains one event, used to share only one event...
   */
  evticalurl(calendarId?: string, eventId?: string): Promise<string> {
    const model = {'calendarId': encodeMetaId, 'eventId': encodeMetaId};
    return executorTs('evticalurl', model, decodeStructure(decodeString), arguments);
  },
  /**
   * invalidate old url and create a new one
   * @param refresh : if true wants a new one, if null=>false
   * @param calendarId identifier to calendar to associate with this ical url, if null this is the default family calendar (allow to generate ical url for other cal such as google etc)
   */
  evticalvisibleurl(refresh?: boolean, calendarId?: string, eventId?: string): Promise<string> {
    const model = {'refresh': encodeBoolean, 'calendarId': encodeMetaId, 'eventId': encodeMetaId};
    return executorTs('evticalvisibleurl', model, decodeStructure(decodeString), arguments);
  },
  /**
   * invalidate current url
   * @param calendarId identifier to calendar to associate with this ical url, if null this is the default family calendar (allow to generate ical url for other cal such as google etc)
   */
  evticalvisibleurldelete(calendarId?: string): Promise<boolean> {
    const model = {'calendarId': encodeMetaId};
    return executorTs('evticalvisibleurldelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * list all event instance in a interval of the family calendar (old method for client that manage only 1 cal)<br>
 if no interval it wil return the first instance of each event<br>
 if missing one limit it will return the matching instance closest of the limit
   * @param from date of begin of the interval (if null will only return one instance per recurrent event, the one that start the lastest before "to").
   * @param to date of end of the interval.
   * @param accountId only events created by one of those accountId (if none given,no filtering)
   * @param attendeeId only events where the intersection of the attendee and the given ids is not empty (if none given,no filtering)
   */
  evtlistinterval(FROM?: Date, to?: Date, accountId?: Array<number>, attendeeId?: Array<number>): Promise<Array<IEvent>> {
    const model = {'from': encodeDate, 'to': encodeDate, 'accountId': encodeArray(encodeNumber), 'attendeeId': encodeArray(encodeNumber)};
    return executorTs('evtlistinterval', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
  },
  /**
   * list all event instances in an interval and several calendars<br>
   * @param from date of begin of the interval (if null will only return one instance per recurrent event, the one that start the lastest before "to").
   * @param to date of end of the interval.
   * @param accountId only events created by one of those accountId (if none given,no filtering)
   * @param attendeeId only events where the intersection of the attendee and the given ids is not empty (if none given,no filtering)
   * @param calendarId list of identifier of the calendars to include in the list, if null or empty, return an empty event list.
   * @param limit number of events to return, when events are ordered by startdate, and all days are put first in the day
   */
  evtlistinterval2(FROM?: Date, to?: Date, accountId?: Array<number>, attendeeId?: Array<number>, calendarId?: Array<string>, limit?: number): Promise<Array<IEvent>> {
    const model = {'from': encodeDate, 'to': encodeDate, 'accountId': encodeArray(encodeNumber), 'attendeeId': encodeArray(encodeNumber), 'calendarId': encodeArray(encodeMetaId), 'limit': encodeNumber};
    return executorTs('evtlistinterval2', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
  },
  /**
   * list all event instances in an interval and several calendars, and return the list of calendars too.<br>
 automatically select the calendars in the family that are activated by the user.<br>
 used for the widget in ios for instance
   * @param from date of begin of the interval (if null will only return one instance per recurrent event, the one that start the lastest before "to").
   * @param to date of end of the interval.
   * @param accountId only events created by one of those accountId (if none given,no filtering)
   * @param attendeeId only events where the intersection of the attendee and the given ids is not empty (if none given,no filtering)
   * @param calendarId list of identifier of the calendars to include in the list, if null or empty, return an empty event list.
   * @param activeCalendar if true, calendarId is ignored and instead the api takes all calendar marked "active" or displayed in the calendar list
   * @param limit number of events to return, when events are ordered by startdate, and all days are put first in the day
   * @param activeTimetable if true, and if activeCalendar is NOT true, calendarId is ignored and instead all active timetables are returned
   */
  evtlistintervalandcalendar(FROM: Date, to: Date, accountId?: Array<number>, attendeeId?: Array<number>, calendarId?: Array<string>, activeCalendar?: boolean, limit?: number, activeTimetable?: boolean): Promise<EventListAndCalendar> {
    const model = {'from': encodeDate, 'to': encodeDate, 'accountId': encodeArray(encodeNumber), 'attendeeId': encodeArray(encodeNumber), 'calendarId': encodeArray(encodeMetaId), 'activeCalendar': encodeBoolean, 'limit': encodeNumber, 'activeTimetable': encodeBoolean};
    return executorTs('evtlistintervalandcalendar', model, decodeStructure(decodeEventListAndCalendar), arguments);
  },
  /**
   * This method allow to navigate into the events with a pagination system
   * @param eventId reference to start the navigation this event will be excluded
            of the navigation (if null it will use now as starting point)
   * @param offset positive number if you want N next event after the eventId,
            negative if you want those before
   * @param accountId filter event of those accounts
   */
  evtnavigate(eventId: string | undefined, offset: number, accountId?: Array<number>): Promise<Array<IEvent>> {
    const model = {'eventId': encodeMetaId, 'offset': encodenumber, 'accountId': encodeArray(encodeNumber)};
    return executorTs('evtnavigate', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
  },
  evtncsync(tokenValue: string, syncToken?: string): Promise<CalendarSharedBean> {
    const model = {'tokenValue': encodeString, 'syncToken': encodeString};
    return executorTs('evtncsync', model, decodeStructure(decodeCalendarSharedBean), arguments);
  },
  /**
   * method for testing error mode of calendars
   */
  evtsetexternalerror(error?: string): Promise<boolean> {
    const model = {'error': encodeString};
    return executorTs('evtsetexternalerror', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * return a link for sharing calendar to someone by url
   */
  evtsharedlink(timetableId: string, FROM?: string, to?: string): Promise<TokenUrlBean> {
    const model = {'timetableId': encodeMetaId, 'from': encodeString, 'to': encodeString};
    return executorTs('evtsharedlink', model, decodeStructure(decodeTokenUrlBean), arguments);
  },
  /**
   * Synchronize a calendar (specified by calendarId, or default to family calendar). Note that the calendar MAY BE "calendarTask" and in this case pseudo events are generated 
 from the task's db, however, android&iphone clients DO NOT use that, they use their own local task database to generate pseudo events on local side, which is more efficient.<br>
 calendarTask is only used for ical urls generated with the api icalUrl.
   * @param syncToken token of sync opaque version
   * @param date of last sync (or maybe before but not after to not miss changes)
   * @param calendarId id of the calendar to sync
   */
  evtsync(syncToken?: string, date?: Date, calendarId?: string): Promise<EventSyncBean> {
    const model = {'syncToken': encodeString, 'date': encodeDate, 'calendarId': encodeMetaId};
    return executorTs('evtsync', model, decodeStructure(decodeEventSyncBean), arguments);
  },
  /**
   * called when a user closes a timetable screen: this will check for modification and send the TimetableUpdate push notification in this case.
   */
  evttimetableClose(timetableId?: string): Promise<boolean> {
    const model = {'timetableId': encodeMetaId};
    return executorTs('evttimetableClose', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Copy all events in a given timetable SLICE, from a source slice to a destination slice.<br>
 Slice are weekA/weekB/weekC if recurrence is WEEKLY, MonthA/MonthB/etc if recurrence is MONTHLY, etc. 
 This makes sense only if the recurrence pattern has interval>1.<br>

 Interval name is already used to define a recurrency occurrence (IntervalRecurrent3 for instance) therefore this new name "slice"

 <br>

 NOTE sliceNb does not take into account the "firstOccurrenceOffset" which would be better named firstSliceOffset
   * @param timetableId the metaId of the timetable
   * @param srcSliceNb the identifier of the source slice, ie if WEEKLY recurrency, zero means the first week of the pattern, one the second week, etc...
   * @param destSliceNb the identifier of the target slice
   */
  evttimetableCopySlice(timetableId: string, srcSliceNb: number, destSliceNb: number): Promise<boolean> {
    const model = {'timetableId': encodeMetaId, 'srcSliceNb': encodenumber, 'destSliceNb': encodenumber};
    return executorTs('evttimetableCopySlice', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Copy all events in a timetable included in an interval between a start date to an end date, to another slice of the same size starting at a target start date.<br>
 NOTE: the startDate and the targetStart shall be on the same hour, minutes, seconds, to displace the events without changing the time of the event.
   * @param timetableId id of the timetable to copy event from/to
   * @param startDate the start date of the interval
   * @param endDate the end date of the interval
   * @param targetStart the start date of the target interval
   */
  evttimetableCopySliceByDate(timetableId: string, startDate: Date, endDate: Date, targetStart: Date): Promise<Array<IEvent>> {
    const model = {'timetableId': encodeMetaId, 'startDate': encodeDate, 'endDate': encodeDate, 'targetStart': encodeDate};
    return executorTs('evttimetableCopySliceByDate', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
  },
  /**
   * Copy all events in a given timetable SLICE, from a source slice to a destination slice.<br>
 New version of the api timetableCopySlice, but return all created event also
 <br>
 Slice are weekA/weekB/weekC if recurrence is WEEKLY, MonthA/MonthB/etc if recurrence is MONTHLY, etc.
 This makes sense only if the recurrence pattern has interval>1.<br>

 Interval name is already used to define a recurrence occurrence (IntervalRecurrent3 for instance) therefore this new name "slice"

 <br>

 NOTE sliceNb does not take into account the "firstOccurrenceOffset" which would be better named firstSliceOffset
   * @param timetableId the metaId of the timetable
   * @param srcSliceNb the identifier of the source slice, ie if WEEKLY recurrency, zero means the first week of the pattern, one the second week, etc...
   * @param destSliceNb the identifier of the target slice
   */
  evttimetableCopySliceWResult(timetableId: string, srcSliceNb: number, destSliceNb: number): Promise<Array<IEvent>> {
    const model = {'timetableId': encodeMetaId, 'srcSliceNb': encodenumber, 'destSliceNb': encodenumber};
    return executorTs('evttimetableCopySliceWResult', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
  },
  /**
   * Remove all events in a given timetable SLICE.<br>
 Slice are weekA/weekB/weekC if recurrence is WEEKLY, MonthA/MonthB/etc if recurrence is MONTHLY, etc. 
 This makes sense only if the recurrency pattern has interval>1.<br>
 
 Interval name is already used to define a recurrency occurrence (IntervalRecurrent3 for instance) therefor this new name "slice"
 
 <br>
 
 NOTE sliceNb does not take into account the "firstOccurrenceOffset" which would be better named firstSliceOffset
   * @param timetableId the metaId of the timetable
   * @param sliceNb the identifier of the slice to reset, ie if WEEKLY recurrency, zero means the first week of the pattern, one the second week, etc...
   */
  evttimetableResetSlice(timetableId: string, sliceNb: number): Promise<boolean> {
    const model = {'timetableId': encodeMetaId, 'sliceNb': encodenumber};
    return executorTs('evttimetableResetSlice', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Reset all events in a given timetable between a start date to an end date.<br>
   */
  evttimetableResetSliceByDate(timetableId: string, startDate: Date, endDate: Date): Promise<Array<string>> {
    const model = {'timetableId': encodeMetaId, 'startDate': encodeDate, 'endDate': encodeDate};
    return executorTs('evttimetableResetSliceByDate', model, decodeStructure(decodeArray(decodeMetaId)), arguments);
  },
  /**
   * Create or update a timetable. Validate various date paramters as follow because TimetableInputBean are IHasDate and IHasRecurrency but with a twist:<ul>
 <li>timetables are always considered as allday , the allday properties is not taken into account anyway and you can pass null if you want</li>
 <li>timetable startDate startDate of timetable, is therefore always rounded to start-of-the-day UTC, and rounded to the just previous start-of-occurence according to the recurrency.</li>
 <li>timetable recurrency can be anything actually, even if the UI only allow for WEEKLY, this is not enforced by the server that adapt. Mandatory for creation, even if you put recurrency=NONE.</li>
 <li>timetable endDate is NOT taken into account but always recomputed to match the end of the day of the last day of the first occurrence</li>
 <li>timetable has a FINISH DATE which is actually the recurrencyEndDate, but also exist in case there are no recurrency. This is rounded by the server to the end-of-the-day UTC (as in allday events)
     and rounded to the just next end-of-occurence according to the recurrency. For instance if recurrency is weekly and value is wednesday, it will be rounded to next sunday in france.
 </ul>
   * @param timetable input parameters of the timetable
   * @param allowDeleteEvent if true, events will be deleted if they are beyond the calendar upper boundary
   */
  evttimetableput(__inline: TimetableInputBean, allowDeleteEvent?: boolean): Promise<TimetableBean> {
    const model = {'__inline': encodeTimetableInputBean, 'allowDeleteEvent': encodeBoolean};
    return executorTs('evttimetableput', model, decodeStructure(decodeTimetableBean), arguments);
  },
  /**
   * Update an event
   * @param option if the event is recurrent, tells if you want to update this occurence, all occurences, the next occurrences
   */
  evtupdate(option: RecurrencyActionOptionEnum | undefined, __inline: EventInputBean): Promise<IEvent> {
    const model = {'option': encodeEnum, '__inline': encodeEventInputBean};
    return executorTs('evtupdate', model, decodeStructure(decodeIEvent), arguments);
  },
  /**
   * Return to the client the various delete option, which may be multiple in case of recurring event.
 IE before proposing "all events", "only this occurence", "all occurence from this" options to a delete command, a client
 must call this api to know which ones are relevant or not.
   * @param ComJeronimoFizGeneratedForInline0 input of update
   */
  evtupdateoption(__inline: EventInputBean): Promise<Array<RecurrencyActionOptionEnum>> {
    const model = {'__inline': encodeEventInputBean};
    return executorTs('evtupdateoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
  },
  /**
   * accept an invitation and join the family
   * @param iid the iid (metaid) of the invitation
   * @param v the tokenvalue of the invitation, optional, only required if the invitation is not linked to the invitee's account (by a different email for instance)
   * @param validationmethod (optional) if the account has an not-validated email, if it is not the same as the invitation email, we cannot automatically validate it, therefore we send a validation message
   */
  famacceptinvitation(iid: string, v?: string, validationmethod?: AccountIdentifierValidationMethodEnum): Promise<boolean> {
    const model = {'iid': encodeMetaId, 'v': encodeString, 'validationmethod': encodeEnum};
    return executorTs('famacceptinvitation', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * block or unblock an existing invitation ( only for invitee)
   * @param iid the iid (metaid) of the invitation
   * @param v the tokenvalue of the invitation, optional, only required if the invitee account is not loggued (for instance not existing yet)
   * @param block if true will block, if false will unblock
   */
  famblockinvite(iid: string, v: string | undefined, block: boolean): Promise<InvitationReceivedBean> {
    const model = {'iid': encodeMetaId, 'v': encodeString, 'block': encodeboolean};
    return executorTs('famblockinvite', model, decodeStructure(decodeInvitationReceivedBean), arguments);
  },
  /**
   * delete an invitation by its IDs<br> inviter might cancel an invitation by this way <br> Invitee might refuse invitation by this way
   */
  famcancelinvite(invitationId: string, v?: string): Promise<boolean> {
    const model = {'invitationId': encodeMetaId, 'v': encodeString};
    return executorTs('famcancelinvite', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Retrieve an invitation informations from the token value. Do not requires that the user is logged-in.
 Used to display invitation page. Different from famlistinvite which return invitation for the currently logged account.<br>
 if tokenValue is ont present, the account must be logged and the invitation must belong to that account
   */
  famgetinvitation(iid: string, v?: string): Promise<InvitationReceivedBean> {
    const model = {'iid': encodeMetaId, 'v': encodeString};
    return executorTs('famgetinvitation', model, decodeStructure(decodeInvitationReceivedBean), arguments);
  },
  /**
   * Create an invitation by links to be used for multiple anonymous invitation such as in whatsapp invitation.<br>
 The inviation is not nominative and anybody who has this link can join.<br>
 The inviation typically is limited in time.
   */
  famgetinvitationlinkbean(): Promise<TokenUrlBean> {
    const model = {};
    return executorTs('famgetinvitationlinkbean', model, decodeStructure(decodeTokenUrlBean), arguments);
  },
  /**
   * return all families of the current user, along with all members information (account, profile, members)
   */
  famlistfamily(withStateBean?: boolean): Promise<Array<IExtendedFamily>> {
    const model = {'withStateBean': encodeBoolean};
    return executorTs('famlistfamily', model, decodeStructure(decodeArray(decodeIExtendedFamily)), arguments);
  },
  /**
   * list existing pending invitation for the current family<br>
 Blocked invitation: invitation with status = BlockingStatusEnum.BlockedShown are shown (but not the status isself) but if status=BlockedUnshown they are not shown
   */
  famlistinvite(pg?: PaginationRequest): Promise<Array<IInvitation>> {
    const model = {'pg': encodePaginationRequest};
    return executorTs('famlistinvite', model, decodeStructure(decodeArray(decodeIInvitation)), arguments);
  },
  /**
   * test method to enable changing the family authenticated in session when using legacy mode
   */
  famlogfamily(familyId: string): Promise<IFamily> {
    const model = {'familyId': encodeMetaId};
    return executorTs('famlogfamily', model, decodeStructure(decodeIFamily), arguments);
  },
  /**
   * send again an existing invitation
   */
  famresendinvite(iid: string, deviceComposerUsed?: boolean): Promise<InvitationSendingBean> {
    const model = {'iid': encodeMetaId, 'deviceComposerUsed': encodeBoolean};
    return executorTs('famresendinvite', model, decodeStructure(decodeInvitationSendingBean), arguments);
  },
  /**
   * Create a new invitation within the multifamily for the currently logged family to a given email or phoneNumber.
 Only one of (email/phone/inviteeid) may be non-null. Behavior is different depending on both cases. <ul>
 <li>if email is present, will send an invitation email to that email and will NOT return the invitation token value 
 <li>if phoneNumber is present, will NOT send the invitation, but will return the invitation token value in the response, for
 the client to send the invitation via the client's device
 <li>if inviteeid is present, will assume that the invitation target is an existing account of familywall whose id is the inviteeid.
 Will send a push message to this user. This user will be able to see this incoming invitation
 </ul>
   * @param email email to send the invitation to
   * @param phone phone number to create the invitation for
   * @param role the role of the invitee
   * @param adminRight the admin right of the invitee (if null will be deduced from role)
   * @param customFamilyRole the custom family role of the invitee
   * @param firstname the firstname of the invitee
   * @param picture the picture/avatar of the invitation
   * @param deviceComposerUsed boolean indicating if we should actually send the sms(=false or null) or if the dev is using its own composer and the server don't send the sms (=true)
   * @param test Boolean if true, the server will test for errors but don't actually create or send the invitation (validity of the email, phone, existing in the family, etc...) but it will return null
   */
  famsendinvite(email?: string, phone?: string, inviteeid?: number, role?: FamilyRoleTypeEnum, adminRight?: FamilyAdminRightEnum, customFamilyRole?: string, firstname?: string, picture?: FizFile, deviceComposerUsed?: boolean, test?: boolean): Promise<InvitationSendingBean> {
    const model = {'email': encodeString, 'phone': encodeString, 'inviteeid': encodeNumber, 'role': encodeEnum, 'adminRight': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'picture': encodeFizFile, 'deviceComposerUsed': encodeBoolean, 'test': encodeBoolean};
    return executorTs('famsendinvite', model, decodeStructure(decodeInvitationSendingBean), arguments);
  },
  /**
   * set the first family as a given one, unset the old first family.
 Normally this has no functional interest, but technically it is useful (for unit testing for instance)
   */
  famsetfirst(familyId: string): Promise<boolean> {
    const model = {'familyId': encodeMetaId};
    return executorTs('famsetfirst', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * list received invitation to other families, if those invitation has been detected or specified to be corresponding to this account.
 Because it is RECEIVED invitation, the boolean showBlocked indicate if you will receive the invitation YOU HAVE BLOCKED or not. <br>
 However, in listinvite (returning invitation SENT), the fact that you see it or not is governed by the status in the invitation (BlockingStatusEnum.BlockedShown or BlockedUnshown).
   * @param pg //@param showBlocked if true will return the invitation YOU have blocked, if absent or false, blocked invitation will not be returned.
   */
  famshowincominginvite(pg?: PaginationRequest): Promise<Array<InvitationReceivedBean>> {
    const model = {'pg': encodePaginationRequest};
    return executorTs('famshowincominginvite', model, decodeStructure(decodeArray(decodeInvitationReceivedBean)), arguments);
  },
  /**
   * update an existing invitation belonging to your current family.<br>
 If an argument is missing, it is not updated. $empty works for removing an existing attribute to the invitation.<br>
 As for the creation, you cannot update an invitation using both email or phoneNumber, those are exclusive.
 Moreover, you cannot update an invitation email or phone that has been created with an inviteeid, and you cannot update the inviteeid either.<br>
 If an email is set, it implies that the phoneNumber is consequently cleared and that the invitation is meant to be sent by email.<br>
 If a phoneNumber is set, it implies that the email is consequently cleared and that the invitation is meant to be sent by SMS.<br>
 
 To resent an invitation after it has been updated, the API resendinvite must be called.<br>
   * @param iid the invitation to update, mandatory
   * @param email email to send the invitation to
   * @param phone phone number to create the invitation for
   * @param role the role of the invitee
   * @param adminRight the admin right of the invitee (if null will be deduced from role)
   * @param customFamilyRole the custom family role of the invitee
   * @param firstname the firstname of the invitee
   * @param picture the picture of the invitee
   */
  famupdateinvitation(iid: string, email?: string, phone?: string, role?: FamilyRoleTypeEnum, adminRight?: FamilyAdminRightEnum, customFamilyRole?: string, firstname?: string, picture?: FizFile): Promise<IInvitation> {
    const model = {'iid': encodeMetaId, 'email': encodeString, 'phone': encodeString, 'role': encodeEnum, 'adminRight': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'picture': encodeFizFile};
    return executorTs('famupdateinvitation', model, decodeStructure(decodeIInvitation), arguments);
  },
  /**
   * called when a user closes a folder screen: this will check for modification and send the good push notification in this case.
 if metaId is null it closes all folders
   */
  filerclose(metaId?: string): Promise<boolean> {
    const model = {'metaId': encodeMetaId};
    return executorTs('filerclose', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * delete a file in the filer
   * @param id id of the file
   */
  filerdeletefile(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('filerdeletefile', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * delete a folder altogether
   * @param id the folderId
   */
  filerdeletefolder(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('filerdeletefolder', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * duplicate a folder
   */
  filerduplicatefolder(id: string, targetId: string): Promise<FolderBean> {
    const model = {'id': encodeMetaId, 'targetId': encodeMetaId};
    return executorTs('filerduplicatefolder', model, decodeStructure(decodeFolderBean), arguments);
  },
  /**
   * get a specific file details of the filer
   * @param id id of the file
   */
  filergetfile(id: string): Promise<IMedia> {
    const model = {'id': encodeMetaId};
    return executorTs('filergetfile', model, decodeStructure(decodeIMedia), arguments);
  },
  /**
   * get a folder
   * @param id metaId
   */
  filergetfolder(id: string): Promise<FolderBean> {
    const model = {'id': encodeMetaId};
    return executorTs('filergetfolder', model, decodeStructure(decodeFolderBean), arguments);
  },
  /**
   * List all files of the filer
   */
  filerlistfile(): Promise<Array<IMedia>> {
    const model = {};
    return executorTs('filerlistfile', model, decodeStructure(decodeArray(decodeIMedia)), arguments);
  },
  /**
   * list all folder available for the currently loggued account
   */
  filerlistfolder(): Promise<Array<FolderBean>> {
    const model = {};
    return executorTs('filerlistfolder', model, decodeStructure(decodeArray(decodeFolderBean)), arguments);
  },
  /**
   * Create (upload) or update a file in the filer.
   * @param input input of the filePut operation
   * @param file the binary to upload, only possible if create (id null)
   */
  filerputfile(__inline: IFilerInputBean, file?: FizFile): Promise<IMedia> {
    const model = {'__inline': encodeIFilerInputBean, 'file': encodeFizFile};
    return executorTs('filerputfile', model, decodeStructure(decodeIMedia), arguments);
  },
  /**
   * create or update a folder
   * @param input value information for the folder
   */
  filerputfolder(__inline: FolderInputBean): Promise<FolderBean> {
    const model = {'__inline': encodeFolderInputBean};
    return executorTs('filerputfolder', model, decodeStructure(decodeFolderBean), arguments);
  },
  /**
   * sync files of the filer
   * @param syncToken the sync token
   */
  filersyncfile(syncToken?: string): Promise<FileSyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('filersyncfile', model, decodeStructure(decodeFileSyncBean), arguments);
  },
  /**
   * sync folder
   * @param syncToken the sync token
   */
  filersyncfolder(syncToken?: string): Promise<FolderSyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('filersyncfolder', model, decodeStructure(decodeFolderSyncBean), arguments);
  },
  /**
   * Trasform a detailed address in a GeocodedAddress with full infos
   */
  geoaddress(address: string): Promise<GeocodedAddress> {
    const model = {'address': encodeString};
    return executorTs('geoaddress', model, decodeStructure(decodeGeocodedAddress), arguments);
  },
  /**
   * Trasform a detailed address in a GeocodedAddress with full infos
   */
  geoaddresswithcontext(address: string, latitudeE6?: number, longitudeE6?: number, start?: number, count?: number): Promise<PaginatedCollection<GeocodedAddress>> {
    const model = {'address': encodeString, 'latitudeE6': encodeNumber, 'longitudeE6': encodeNumber, 'start': encodeNumber, 'count': encodeNumber};
    return executorTs('geoaddresswithcontext', model, decodeStructure(decodePaginatedCollection(decodeGeocodedAddress)), arguments);
  },
  /**
   * Trasform a detailed address in a GeocodedAddress with full infos
   */
  geocheck(geocodedAddress: GeocodedAddress): Promise<GeocodedAddress> {
    const model = {'geocodedAddress': encodeGeocodedAddress};
    return executorTs('geocheck', model, decodeStructure(decodeGeocodedAddress), arguments);
  },
  /**
   * Trasform a detailed address in a GeocodedAddress with full infos
   * @param country country
   * @param state state
   * @param zipCode zipCode
   * @param town town
   * @param line line of the the address (number and street)
   */
  geodetailedaddress(country: string, state: string, zipCode: string, town: string, line: string): Promise<GeocodedAddress> {
    const model = {'country': encodeString, 'state': encodeString, 'zipCode': encodeString, 'town': encodeString, 'line': encodeString};
    return executorTs('geodetailedaddress', model, decodeStructure(decodeGeocodedAddress), arguments);
  },
  /**
   * Trasform a detailed address in a GeocodedAddress with full infos
   */
  georeverse(latitudeE6: number, longitudeE6: number): Promise<GeocodedAddress> {
    const model = {'latitudeE6': encodenumber, 'longitudeE6': encodenumber};
    return executorTs('georeverse', model, decodeStructure(decodeGeocodedAddress), arguments);
  },
  /**
   * return the auth uri to send the users to, for authentication. works for web, not for other devices where the AppAuth library takes care directly to provide access/refresh tokens.
   */
  googleAuthUri(): Promise<string> {
    const model = {};
    return executorTs('googleAuthUri', model, decodeStructure(decodeString), arguments);
  },
  googlegetcredential(credentialId: string): Promise<GoogleCredentialBean> {
    const model = {'credentialId': encodeMetaId};
    return executorTs('googlegetcredential', model, decodeStructure(decodeGoogleCredentialBean), arguments);
  },
  /**
   * after the users return from the webview, call this api with the authorization code to finish the authentification
   * @param code the oauth2 authorization code
   */
  googlelogin(code: string): Promise<boolean> {
    const model = {'code': encodeString};
    return executorTs('googlelogin', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * after the users return from the webview, call this api with the authorization code to finish the authentification
   * @param code the oauth2 authorization code
   */
  googlelogin2(code: string): Promise<GoogleCredentialBean> {
    const model = {'code': encodeString};
    return executorTs('googlelogin2', model, decodeStructure(decodeGoogleCredentialBean), arguments);
  },
  /**
   * when the AppAuth (http://openid.github.io/AppAuth-iOS/ ) framework is directly used, it provides with the access and refresh tokens which are passed 
 directly to this api to connect the user's google account
   * @param tokenType type of token, because each device (android/iphone/etc) correspond to a different client id and therefore a different refresh token method.
   * @param accessToken the access token of the user's google account
   * @param refreshToken the refresh token of the user's google account
   * @param expiresDate the expiration date of the access token
   */
  googlesavetoken(tokenType: GoogleTokenType, accessToken: string, refreshToken: string, expiresDate: Date): Promise<boolean> {
    const model = {'tokenType': encodeEnum, 'accessToken': encodeString, 'refreshToken': encodeString, 'expiresDate': encodeDate};
    return executorTs('googlesavetoken', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * when the AppAuth (http://openid.github.io/AppAuth-iOS/ ) framework is directly used, it provides with the access and refresh tokens which are passed 
 directly to this api to connect the user's google account
   * @param tokenType type of token, because each device (android/iphone/etc) correspond to a different client id and therefore a different refresh token method.
   * @param accessToken the access token of the user's google account
   * @param refreshToken the refresh token of the user's google account
   * @param expiresDate the expiration date of the access token
   */
  googlesavetoken2(tokenType: GoogleTokenType, accessToken: string, refreshToken: string, expiresDate: Date): Promise<GoogleCredentialBean> {
    const model = {'tokenType': encodeEnum, 'accessToken': encodeString, 'refreshToken': encodeString, 'expiresDate': encodeDate};
    return executorTs('googlesavetoken2', model, decodeStructure(decodeGoogleCredentialBean), arguments);
  },
  googleselectcalendar2(credentialId: string, googleId: Array<string>): Promise<CalendarSubscriptionResponseBean> {
    const model = {'credentialId': encodeMetaId, 'googleId': encodeArray(encodeString)};
    return executorTs('googleselectcalendar2', model, decodeStructure(decodeCalendarSubscriptionResponseBean), arguments);
  },
  /**
   * Return the premium right bean matching globally the instant messaging.<br>
 Only "photoHD" , "audio" and "videoAvailable" are meaningful in this api. Quota for instance is always zero and not managed. 
 <br><center>warning: this api is heavy and consuming quite some server resources. Call sparingly .</center></br>
   */
  imgetpremium(): Promise<PremiumRightBean> {
    const model = {};
    return executorTs('imgetpremium', model, decodeStructure(decodePremiumRightBean), arguments);
  },
  /**
   * the read date of current user become the date of the last message (if it wasn't already, and even if the last message has been deleted)
   */
  immarkasread(threadId: string): Promise<IIMThread> {
    const model = {'threadId': encodeMetaId};
    return executorTs('immarkasread', model, decodeStructure(decodeIIMThread), arguments);
  },
  /**
   * list content of thread
   */
  immessagelist2(threadId: string, pg?: SimplePaginationRequest): Promise<SimplePaginatedCollection<IIMMessage>> {
    const model = {'threadId': encodeMetaId, 'pg': encodeSimplePaginationRequest};
    return executorTs('immessagelist2', model, decodeStructure(decodeSimplePaginatedCollection(decodeIIMMessage)), arguments);
  },
  /**
   * list content of several thread
   * @param count number of item per thread
   */
  immessagelistgrp(threadId: Array<string>, count?: number): Promise<Array<SimplePaginatedCollection<IIMMessage>>> {
    const model = {'threadId': encodeArray(encodeMetaId), 'count': encodeNumber};
    return executorTs('immessagelistgrp', model, decodeStructure(decodeArray(decodeSimplePaginatedCollection(decodeIIMMessage))), arguments);
  },
  /**
   * sync content of thread
 WARNING : a thread might contains a lot of message.<br>
 So good way of use is start by loading a part of the list with "messagelist" and then sync to handle deleted / new ones<br>
   */
  immessagesync(threadId: string, syncToken?: string, date?: Date): Promise<MessageSyncBean> {
    const model = {'threadId': encodeMetaId, 'syncToken': encodeString, 'date': encodeDate};
    return executorTs('immessagesync', model, decodeStructure(decodeMessageSyncBean), arguments);
  },
  immessagesyncgrp(request: Array<SyncRequest>): Promise<Array<MessageSyncBean>> {
    const model = {'request': encodeArray(encodeSyncRequest)};
    return executorTs('immessagesyncgrp', model, decodeStructure(decodeArray(decodeMessageSyncBean)), arguments);
  },
  /**
   * create a conversation between current user and the "to" account ids.<br>
 the server might decide to recycle an old thread between the same people (actually it does when only one accountId in to)
   */
  imnewthread(to: Array<number>): Promise<IIMThread> {
    const model = {'to': encodeArray(encodeNumber)};
    return executorTs('imnewthread', model, decodeStructure(decodeIIMThread), arguments);
  },
  /**
   * Send a new message to all the particpant of the thread
 If threadId is not set a new thread is created with the to paramater (which is ignored if threadId is set)
   * @param threadId the id of the thread, only possible if the thread already exist. exclusive with "to" parameter
   * @param text the text of the message
   * @param media the optional media of the message to be published (audio/video/image)
   * @param type the type of message for special messages. optional. if null will use "text" normal message.
   * @param externalId an optional identifier of special messages
   */
  imsend(threadId?: string, to?: Array<number>, text?: string, media?: FizFile, TYPE?: IMMessageTypeEnum, externalId?: string): Promise<IIMMessage> {
    const model = {'threadId': encodeMetaId, 'to': encodeArray(encodeNumber), 'text': encodeString, 'media': encodeFizFile, 'type': encodeEnum, 'externalId': encodeString};
    return executorTs('imsend', model, decodeStructure(decodeIIMMessage), arguments);
  },
  /**
   * list all thread
   * @param filter if null no filtering, if a familyId return only thread of the family (don't try another filter type yet)
   */
  imthreadlist(filter?: string, isLoggedFamily?: boolean): Promise<Array<IIMThread>> {
    const model = {'filter': encodeMetaId, 'isLoggedFamily': encodeBoolean};
    return executorTs('imthreadlist', model, decodeStructure(decodeArray(decodeIIMThread)), arguments);
  },
  /**
   * use this when user go to a section from the launchpad, it will update the last access date of this section in db (family member data)
   * @param date USE null, means now, use something else for debugging purpose
   */
  launchpadclick(section: SectionEnum, date?: Date): Promise<boolean> {
    const model = {'section': encodeEnum, 'date': encodeDate};
    return executorTs('launchpadclick', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * get current condition for the user used for debug only
   */
  launchpadcondition(activityWanted?: boolean): Promise<LaunchpadConditionBean> {
    const model = {'activityWanted': encodeBoolean};
    return executorTs('launchpadcondition', model, decodeStructure(decodeLaunchpadConditionBean), arguments);
  },
  /**
   * get the LaunchpadBean
   * @param address for weather data, if null might use something from config or from map datas
   * @param conditions MUST be null!!! fields here just for debug
   */
  launchpadget2(address?: GeocodedAddress, conditions?: LaunchpadConditionBean, actions?: Array<CallToActionTypeEnum>): Promise<LaunchpadBean> {
    const model = {'address': encodeGeocodedAddress, 'conditions': encodeLaunchpadConditionBean, 'actions': encodeArray(encodeEnum)};
    return executorTs('launchpadget2', model, decodeStructure(decodeLaunchpadBean), arguments);
  },
  /**
   * get the LaunchpadBean
   * @param token must be null on first call of session, after it must be previous given token in LaunchpadBean
   * @param address for weather data, if null might use something from config or from map datas
   * @param conditions MUST be null!!! fields here just for debug
   */
  launchpadget3(token?: string, address?: GeocodedAddress, conditions?: LaunchpadConditionBean): Promise<LaunchpadBean> {
    const model = {'token': encodeString, 'address': encodeGeocodedAddress, 'conditions': encodeLaunchpadConditionBean};
    return executorTs('launchpadget3', model, decodeStructure(decodeLaunchpadBean), arguments);
  },
  launchpadgetexplore(token?: string): Promise<ExploreBean> {
    const model = {'token': encodeString};
    return executorTs('launchpadgetexplore', model, decodeStructure(decodeExploreBean), arguments);
  },
  launchpadlisttiles(): Promise<Array<DashboardTileBean>> {
    const model = {};
    return executorTs('launchpadlisttiles', model, decodeStructure(decodeArray(decodeDashboardTileBean)), arguments);
  },
  launchpadmovetile(tileId: string, prevId: string): Promise<Map<string, number>> {
    const model = {'tileId': encodeMetaId, 'prevId': encodeMetaId};
    return executorTs('launchpadmovetile', model, decodeStructure(decodeMap(decodeMetaId,decodeNumber)), arguments);
  },
  /**
   * Use this when displaying a LaunchPadActivityBean having a screenSeen property, it will flag the section as "seens" in the database,
 thus not repeating displaying this 'text'.
   * @param clear USE null, can use true for debugging purpose
   */
  launchpadseen(screen: string, clear?: boolean): Promise<boolean> {
    const model = {'screen': encodeString, 'clear': encodeBoolean};
    return executorTs('launchpadseen', model, decodeStructure(decodeboolean), arguments);
  },
  launchpadupdatetile(__inline: DashboardTileInputBean): Promise<DashboardTileBean> {
    const model = {'__inline': encodeDashboardTileInputBean};
    return executorTs('launchpadupdatetile', model, decodeStructure(decodeDashboardTileBean), arguments);
  },
  /**
   * send a pickMeUp response message to somebody, saying "ok!"
   * @param targetId the accountId of the target of the message in the current family scope
   */
  locacceptpickmeup(targetId: number): Promise<boolean> {
    const model = {'targetId': encodeNumber};
    return executorTs('locacceptpickmeup', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * send a panic button alarm to all members of the family
   */
  localarmpanicbutton(geocodedAddress?: GeocodedAddress): Promise<boolean> {
    const model = {'geocodedAddress': encodeGeocodedAddress};
    return executorTs('localarmpanicbutton', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * if an alarm has been raised for this family, clear the alarm.
   */
  locclearAlarmpanicbutton(): Promise<boolean> {
    const model = {};
    return executorTs('locclearAlarmpanicbutton', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * BETA API: get the location for one account specifically
   */
  locget(accountId: number): Promise<ILocation> {
    const model = {'accountId': encodeNumber};
    return executorTs('locget', model, decodeStructure(decodeILocation), arguments);
  },
  /**
   * Get all users whose last location is a given place
   * @param placeId the placeID of the place we want the informations
   */
  locgetbyplace(placeId: string): Promise<Array<ILocation>> {
    const model = {'placeId': encodeMetaId};
    return executorTs('locgetbyplace', model, decodeStructure(decodeArray(decodeILocation)), arguments);
  },
  /**
   * get the value of the location devices flag (common to all families). If deviceid is not the same as the deviceid of the caller, there is another devices sending geotracking.
 Here a popup shall be displayed to ask if the user want to change device and setdeviceflag must be called.
   */
  locgetdeviceflag(): Promise<LocationDeviceFlags> {
    const model = {};
    return executorTs('locgetdeviceflag', model, decodeStructure(decodeLocationDeviceFlags), arguments);
  },
  /**
   * return all requested geofencing request/subscriptions I am the publishers of, across all my families<br>
 Basically return all geofencing I must register and activate on a device.<br> however a better way to do it is to:
 <pre>
     -> flags indicating that the fw (familywall) geofencing is active on a place are added to the place object
 			-> whenever poisync is called to synchronize the places, if those flag has changed for the publisher, they will be returned and shall be detected by the device to activate the geofencing on those places
 	   -> whenever this flag is set and the geofencing shall be activated on a place, a special push message (silent GeolocFencingNewPlace) is sent to the device
		   -> this enables to "wake-up" a new geofencing place rapidly when a subscriber wants to follow somebody on a place
         -> this push is also sent when the last subscriber is removed from a place for a given publisher, the client can silently receive and remove this place.
     -> the device shall perform a poisync and activate the geofencing accordingly, enabling the geofencing on places where the flag is new and REMOVING the geofencing on places where the flag has changed to off.
     -> whenever the geofencing api locpublisfencing is called and the geofencing is turned off for this place, the error 27 FizGeolocDisabledException is thrown
             -> this may be proven useful in case subscriber does not subscribe to the geofencing anymore
 </pre>
   */
  locgetgeofencingsforpublisher(withPlace?: boolean): Promise<Array<IPlaceGeofencing>> {
    const model = {'withPlace': encodeBoolean};
    return executorTs('locgetgeofencingsforpublisher', model, decodeStructure(decodeArray(decodeIPlaceGeofencing)), arguments);
  },
  /**
   * return the geofencing I subscribe to for a given place. It will return "fake" entries for all possible subscribers
   */
  locgetgeofencingsforsubscriber(placeId: string): Promise<Map<number, IPlaceGeofencing>> {
    const model = {'placeId': encodeMetaId};
    return executorTs('locgetgeofencingsforsubscriber', model, decodeStructure(decodeMap(decodeNumber,decodeIPlaceGeofencing)), arguments);
  },
  /**
   * Allow to get the family members last known locations with the infamous "fake".
 This actually return the list of positions to display on the map, depending on the family and the permission associated to all members.
 It combines the manual checkins (performed and stored on the wall) and the automatic checkins and trackings (performed on the PLocationRT table).
   */
  locgetpositions2(): Promise<Array<ILocation>> {
    const model = {};
    return executorTs('locgetpositions2', model, decodeStructure(decodeArray(decodeILocation)), arguments);
  },
  /**
   * BETA API: get all the history of the location, this is normally not enabled for real users and is just used to debug the geoloc feature of native apps
   */
  lochistory(date?: Date): Promise<PaginatedCollection<ILocation>> {
    const model = {'date': encodeDate};
    return executorTs('lochistory', model, decodeStructure(decodePaginatedCollection(decodeILocation)), arguments);
  },
  /**
   * Publish an autotracking event from the devices
   */
  locpublisfencing(TYPE: LocationMoveTypeEnum, placeId: string, deviceId?: string): Promise<ILocation> {
    const model = {'type': encodeEnum, 'placeId': encodeMetaId, 'deviceId': encodeString};
    return executorTs('locpublisfencing', model, decodeStructure(decodeILocation), arguments);
  },
  /**
   * publish a manual checkin logged-in account location, by taking the address as a simple string<br/>
 This address will be geocoded to have all informations
   * @param address address of the check-in
   * @param isTemporary this method create a poi and isTemporary indicates if it should be temporary (if empty => true)
   * @param picture picture of the checkin
   */
  locpublishaddress(text: string | undefined, address: string, latitudeE6?: number, longitudeE6?: number, isTemporary?: boolean, picture?: Array<FizFile>): Promise<IWallMessage> {
    const model = {'text': encodeString, 'address': encodeString, 'latitudeE6': encodeNumber, 'longitudeE6': encodeNumber, 'isTemporary': encodeBoolean, 'picture': encodeArray(encodeFizFile)};
    return executorTs('locpublishaddress', model, decodeStructure(decodeIWallMessage), arguments);
  },
  /**
   * Publish an autotracking event from the devices<br>
 change the position of the current user to the new geocoded coordinate for every family for which the currnet user has authorized it<br>
 In order to know if the device shall enable his autotrack feature, the flag geoLocAutotrackActivated on PremiumRightBean (accgetstate) is used (if flag=true, autotracking shall be embedded on the device)
   * @param deviceId the deviceId that locale the user. If this device id is different from the declared localization device, error code will be returned.
   * @param fromRequestAccountId optionnally, the accountId that silently pushed a geolocrequest, the geoloc response push will be sent to that account.
   */
  locpublishauto(geocodedAddress: GeocodedAddress, deviceId: string, fromRequestAccountId?: number): Promise<ILocation> {
    const model = {'geocodedAddress': encodeGeocodedAddress, 'deviceId': encodeString, 'fromRequestAccountId': encodeNumber};
    return executorTs('locpublishauto', model, decodeStructure(decodeILocation), arguments);
  },
  /**
   * send a pickMeUp request message to somebody
   * @param targetId the accountId of the target of the message in the current family scope
   * @param address the address the current user is, will be put in the puckMeUp request message
   * @param latitudeE6 the latitude the current user is, will be put in the puckMeUp request message
   * @param longitudeE6 the longitude the current user is, will be put in the puckMeUp request message
   */
  locpublishpickmeup(targetId: number, address: string, latitudeE6: number, longitudeE6: number): Promise<boolean> {
    const model = {'targetId': encodeNumber, 'address': encodeString, 'latitudeE6': encodeNumber, 'longitudeE6': encodeNumber};
    return executorTs('locpublishpickmeup', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * publish a MANUAL CHECKING, a Place Location event : check in, check out, and put it on the wall.<br>
 AND ALSO moveType=AUTO is used by kids@home from ORANGE only.
 If moveType=Auto the behavior does not display a checkin on the wall but check if anyone has subscribed to the kids@home service and send send a notification<br>
 This method does not record the manual checkin in the real time location table (LOCATION_RT) but store the manual checkin on the wall (even if AUTO and the kids at home scenario is used)
   * @param text text about the checkin
   * @param moveType IN=checkin, AUTO=deprecated kids@home,
   */
  locpublishplacelocation(text: string | undefined, placeId: string, moveType: LocationMoveTypeEnum, picture?: Array<FizFile>): Promise<IWallMessage> {
    const model = {'text': encodeString, 'placeId': encodeMetaId, 'moveType': encodeEnum, 'picture': encodeArray(encodeFizFile)};
    return executorTs('locpublishplacelocation', model, decodeStructure(decodeIWallMessage), arguments);
  },
  /**
   * request a user to enable its autotracking feature (ie his settings to be set to "always")
   * @param publisherId id to sent request
   */
  locrequestautotrack(publisherId: number): Promise<boolean> {
    const model = {'publisherId': encodeNumber};
    return executorTs('locrequestautotrack', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * send a transparent push position refresh to the whole family, or only to one account if the accountId is specified
   * @param accountId null=to all members, else the member to send the transparent push to
   */
  locrequestpositionrefresh(accountId?: number): Promise<boolean> {
    const model = {'accountId': encodeNumber};
    return executorTs('locrequestpositionrefresh', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * accept pending geoloc request(s). The subscriber given by subscriberId is accepted and user-per-user auth mode is set accordingly. <br>
 Corresponding push notification 'GeolocAutotrackAccepted' or 'GeolocAutotrackDeclined' will be sent to the subscriber.
   * @param accept a map indexed by its subscriberId, if true accept else it is a decline
   * @param tempDuration a map indexed by the subscriberId, indicate the duration of a temporary sharing, in seconds. Must be null if sharing is not always
   * @param geocodedAddress optional location of the device while accepting the sharing (allow for a position to be sent right away with the push response)
   * @param deviceId optional locationDeviceId, must be present of an address is sent
   */
  locrespondtogeorequest(accept: Map<number, boolean>, tempDuration?: Map<number, number>, geocodedAddress?: GeocodedAddress, deviceId?: string): Promise<boolean> {
    const model = {'accept': encodeMap(encodeNumber,encodeBoolean), 'tempDuration': encodeMap(encodeNumber,encodeNumber), 'geocodedAddress': encodeGeocodedAddress, 'deviceId': encodeString};
    return executorTs('locrespondtogeorequest', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * set the location device flags for the tracking device (common to all families). If the deviceid changes, this new device is the geotracking devices, and the old one is disabled.
 As a result, deviceid must only be sent if this device has been declared as the new geotracking device.<br>
 if the deviceid is sent but the boolean is false, the devicelocation service has been turned off (error state)
   */
  locsetdeviceflag(__inline: LocationDeviceFlags): Promise<LocationDeviceFlags> {
    const model = {'__inline': encodeLocationDeviceFlags};
    return executorTs('locsetdeviceflag', model, decodeStructure(decodeLocationDeviceFlags), arguments);
  },
  /**
   * update a geofencing request for a given place and a given member. If isin and isout is both false, this will delete the request in the database.
 If the request does not exist yet, it will create it.
   * @param placeId the id of the place to set the geofencing
   */
  locsetgeofencingsettings(placeId: string, publisherId: number, IN?: boolean, out?: boolean): Promise<IPlaceGeofencing> {
    const model = {'placeId': encodeMetaId, 'publisherId': encodeNumber, 'in': encodeBoolean, 'out': encodeBoolean};
    return executorTs('locsetgeofencingsettings', model, decodeStructure(decodeIPlaceGeofencing), arguments);
  },
  /**
   * set a bunch of flags by subscribers identifiers. http syntax is a00flags.[subscriberId]=[authvalue], ie a00flags.123=ALWAYS&a00flags.456=NEVER&a00tempDuration.123=3600
   * @param flags map indexed by subscribers account ids
   * @param tempDuration the value of the sharing in seconds. Must only be used with an ALWAYS flag, else it must be null. If flag=ALWAYS and value is null, it means forever.
   */
  locsetperuserauthflag(flags: Map<number, GeolocSharingEnum>, tempDuration?: Map<number, number>, geocodedAddress?: GeocodedAddress, deviceId?: string): Promise<boolean> {
    const model = {'flags': encodeMap(encodeNumber,encodeEnum), 'tempDuration': encodeMap(encodeNumber,encodeNumber), 'geocodedAddress': encodeGeocodedAddress, 'deviceId': encodeString};
    return executorTs('locsetperuserauthflag', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * return true if this identifier is free
   * @param type type of identifier
   * @param identifier value of identifier
   * @param countryCode countrycode (used for "local" phone number)
   * @param validated if true, check even if the identifier is not validated, and return false if taken and not yet validated
   */
  log2check(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode?: string, validated?: boolean): Promise<boolean> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validated': encodeBoolean};
    return executorTs('log2check', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * return check that account is free and has been invited by someone
   * @param type type of identifier
   * @param identifier value of identifier
   * @param countryCode countrycode (used for "local" phone number)
   */
  log2checkinvitation(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode?: string): Promise<boolean> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString};
    return executorTs('log2checkinvitation', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Will check that a validation code is ok or not, but not perform the actual validation in the database (in order not to lock the msisdn at this time)
   */
  log2checkvalidationcode(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode: string | undefined, code: string): Promise<boolean> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString};
    return executorTs('log2checkvalidationcode', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * create a new account into the platform with at least one email<br>
 Open a session with the created account, even if the account identifier
 is not validated yet. (see loginByPassword for detail about the session).
   */
  log2create(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode: string | undefined, password: string, partnerType?: PartnerTypeEnum, validationmethod?: AccountIdentifierValidationMethodEnum, locale?: string): Promise<AccountLoginInfo> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'password': encodeString, 'partnerType': encodeEnum, 'validationmethod': encodeEnum, 'locale': encodeString};
    return executorTs('log2create', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * open a session with a deep link token
   */
  log2deeplink(TK: string, fid?: string): Promise<AccountLoginInfo> {
    const model = {'TK': encodeString, 'fid': encodeMetaId};
    return executorTs('log2deeplink', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * send a forgot-password email to the account identified by the identifier
   * @param identifier the identifier of the account to sent a forgot password email
   */
  log2forgotpassword2(identifier: string): Promise<ForgotPasswordResponseBean> {
    const model = {'identifier': encodeString};
    return executorTs('log2forgotpassword2', model, decodeStructure(decodeForgotPasswordResponseBean), arguments);
  },
  /**
   * generate an OAuth2 access token based on a deeplink token<br>
 THE CALL MUST BE PERFORMED USING HTTPS.
   */
  log2generateaccesstokeinbydeeplinktoken(token: string, tokentype: AccessTokenTypeEnum, deviceId: string): Promise<AccessTokenBean> {
    const model = {'token': encodeString, 'tokentype': encodeEnum, 'deviceId': encodeString};
    return executorTs('log2generateaccesstokeinbydeeplinktoken', model, decodeStructure(decodeAccessTokenBean), arguments);
  },
  /**
   * Generate an OAuth2 access token based on user's credentials and client's credentials<br>
 In order to obtain the OAuth2 access token, the client must provide:<ul>
 <li>identifier and password: this shall authenticate the user
 <li>deviceId: a UUID identifying the device in which runs the client (same mechanism as devicesetconfig api)
 <li>clientId and clientSecret: an id+key identifying the client. The key must authorize such call. The clientid+clientSecret
 must be passed in URL with client_id and client_secret parameters, or using basic_auth http mechanism.
 <li>the type of access token which wants the client
 </ul>
 THE CALL MUST BE PERFORMED USING HTTPS.
   * @param identifier identifier of the account(login, msisdn, email)
   * @param password password of the account
   * @param tokentype the type of access token to generate: either bearer or mac
   * @param deviceId UUID identifying the device where the client runs
 Any existing accessToken for this device is automatically removed
   */
  log2generateaccesstokenbypassword(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode: string | undefined, password: string, tokentype: AccessTokenTypeEnum, deviceId: string, clientId?: string, clientSecret?: string): Promise<AccessTokenBean> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'password': encodeString, 'tokentype': encodeEnum, 'deviceId': encodeString, 'clientId': encodeString, 'clientSecret': encodeString};
    return executorTs('log2generateaccesstokenbypassword', model, decodeStructure(decodeAccessTokenBean), arguments);
  },
  log2get(): Promise<Array<IAccount>> {
    const model = {};
    return executorTs('log2get', model, decodeStructure(decodeArray(decodeIAccount)), arguments);
  },
  /**
   * When the token is retrieved from the web. If the token is a logged token this will generate and
 return a new oauth token for the web (DeepLoginLink, InvitationAccepted, ForgotPassword, AccountIdentifierValidation)
   * @param token the token value
   * @param tokentype the type of oauth token that will be generated (client choose)
   * @param deviceId the deviceId of the client to generate the oauth token
   */
  log2getdeeplinkinfo(token: string, tokentype: AccessTokenTypeEnum, deviceId: string): Promise<TokenAndAccountLogInfoBean> {
    const model = {'token': encodeString, 'tokentype': encodeEnum, 'deviceId': encodeString};
    return executorTs('log2getdeeplinkinfo', model, decodeStructure(decodeTokenAndAccountLogInfoBean), arguments);
  },
  /**
   * log-in into the platform using the password. By calling this method the
 system will provide a session token enabling the user to perform
 authenticated operations. However this is transparent to the API because
 this is sent via the api session layer (usually under the form of a
 JSESSIONID).<br>
 Note that an account may not have a password (inexistent password) in the
 database. In this case the passwork is not verified.<br>
   * @param identifier identifier of the account(login, msisdn, email)
   * @param password password of the account
   */
  log2in(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode: string | undefined, password: string, generateAutologinToken?: boolean, clientId?: string, clientSecret?: string): Promise<AccountLoginInfo> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'password': encodeString, 'generateAutologinToken': encodeBoolean, 'clientId': encodeString, 'clientSecret': encodeString};
    return executorTs('log2in', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * Login with an autologin token retrieved by "accgenerateautologintoken"
   * @param identifier the identifier of the account to login with
   * @param token the autologin token previously generated
   */
  log2loginByAutologinToken(identifier: string, token: string): Promise<AccountLoginInfo> {
    const model = {'identifier': encodeString, 'token': encodeString};
    return executorTs('log2loginByAutologinToken', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * logout, disconnect the user. This shall be used by web interface only when using privilegied access. Else you shall use header-based authentification
   */
  log2out(): Promise<boolean> {
    const model = {};
    return executorTs('log2out', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * reload info from database for accounts, used for managing premium in web
   */
  log2renew(): Promise<AccountLoginInfo> {
    const model = {};
    return executorTs('log2renew', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * api that will send to an account identifier a validation message containing a code or a link.
 This api will only work with Msisdn-type of account identifiers and will send an SMS using ISmsManager<br>
 This api will also work with Email-type of account identifiers and will send the code via email<br>
 This api send a NEW validation code, if needed but it is doubtful, and shall be updated to support resending an existing validation code...
   */
  log2sendaccountidentifiervalidationcode(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode?: string): Promise<boolean> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString};
    return executorTs('log2sendaccountidentifiervalidationcode', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Activate a token such as forgotpassword, invitation, etc... from url with /t?v=Azerty 
 Perform what the token is meant to be (depending on the type of token, forgotpassword, invitation, etc)
 Open a web session if token allows it
   */
  log2token(token: string): Promise<TokenAndAccountLogInfoBean> {
    const model = {'token': encodeString};
    return executorTs('log2token', model, decodeStructure(decodeTokenAndAccountLogInfoBean), arguments);
  },
  /**
   * validate a code for a given identifier, and log with it
   */
  log2validateidentifier(TYPE: AccountIdentifierTypeEnum | undefined, identifier: string, countryCode: string | undefined, code: string, autoacceptpendinginvite?: boolean): Promise<AccountLoginInfo> {
    const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString, 'autoacceptpendinginvite': encodeBoolean};
    return executorTs('log2validateidentifier', model, decodeStructure(decodeAccountLoginInfo), arguments);
  },
  /**
   * Comment an entity with a metaId (same as the comment api), but return the commented object itself with its new list of comments. <br>
 Sometimes the commented entity changes during the comment operation, (for birthday for instance where a new event occurrence happens).
 So the returned object is the commented entity, whether it is exactly the one matching the id parameter, or another one, or a new one.
   * @param id the Id of the instance to comment
   * @param text the text of the comment
   * @param mood optional mood flag for this comment
   */
  metaaddComment(id: string, text: string, mood?: MoodEnum): Promise<CommentResultBean<IHasMetaId>> {
    const model = {'id': encodeMetaId, 'text': encodeString, 'mood': encodeEnum};
    return executorTs('metaaddComment', model, decodeStructure(decodeCommentResultBean(decodeIHasMetaId)), arguments);
  },
  /**
   * add pictures to an object (if right to)
   */
  metaaddpictures(id: string, pictures: Array<FizFile>): Promise<unknown> {
    const model = {'id': encodeMetaId, 'pictures': encodeArray(encodeFizFile)};
    return executorTs('metaaddpictures', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * delete any object (if right to do it)
   */
  metadelete(id: Array<string>): Promise<unknown> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('metadelete', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * get any object by its metaId (if right to read it)
 If not allowed or not exists, it returns null
   */
  metaget(id: string): Promise<unknown> {
    const model = {'id': encodeMetaId};
    return executorTs('metaget', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * list all items of this type
   */
  metalist(id: MetaIdTypeEnum): Promise<unknown> {
    const model = {'id': encodeEnum};
    return executorTs('metalist', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * set the mood to the object, if possible, must be "moodable". Used to post best moments.
   */
  metamood(id: string, add?: Array<MoodEnum>, remove?: Array<MoodEnum>): Promise<unknown> {
    const model = {'id': encodeMetaId, 'add': encodeArray(encodeEnum), 'remove': encodeArray(encodeEnum)};
    return executorTs('metamood', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * update pictures associated to an object (if right to)
   */
  metapictures(id: string, pictures: Array<FizFile>): Promise<unknown> {
    const model = {'id': encodeMetaId, 'pictures': encodeArray(encodeFizFile)};
    return executorTs('metapictures', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * return the syncBean associated to the given type of data
   */
  metasync(id: MetaIdTypeEnum, listId?: string, syncToken?: string, date?: Date): Promise<unknown> {
    const model = {'id': encodeEnum, 'listId': encodeMetaId, 'syncToken': encodeString, 'date': encodeDate};
    return executorTs('metasync', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * update text of a comment / wallMessage / immessage, can only update his own text
   * @param text new text
   */
  metaupdatetext(id: string, text: string): Promise<unknown> {
    const model = {'id': encodeMetaId, 'text': encodeString};
    return executorTs('metaupdatetext', model, decodeStructure(decodeDynamic), arguments);
  },
  /**
   * Add a meal or a recipe to a shopping list. Supersedes additemtolist. The input is the metaId of the dish or recipe,
 plus the ingredients to add: unlike additemtolist these are full ingredients and not only their ids, so the quantity
 and the unit obtained from quantityparse are added to the shopping list item. If the ingredient list is null, all the
 ingredients of the dish/recipe are added, in the order of the recipe, or the name of the recipe itself when it has no
 ingredient.<br>
 Each ingredient is looked up by its name in the target list, which decides what happens:<ul>
 <li>the item is already there and completed (already bought): it is unmarked and reused, and its quantity and unit
 are replaced by the ones being added (cleared if the ingredient has no quantity). No new item is created.
 <li>the item is already there, not completed, with the same unit: the quantities are summed on the existing item.
 <li>the item is already there but with another unit, or without any quantity: a second item is created, because
 quantities in different units cannot be summed.
 <li>the item is not there: it is created, with a category guessed from the same item in the other lists or from the
 task suggestions.
 </ul>
 Every created or reused item points back to the dish or recipe it comes from (its refId).
   * @param ingredients ingredients to add to the list, composed of a metaid for the recipe or dish, and the ingredients to add (if this list is null add all)
   * @param listId id of the tasklist to add all ingredients to. If null, the list used last time (the defaultAddMealToListId family preference) is used, and the family shopping list if there is none. The list finally used is stored as the new default.
   */
  mpadditemtolist2(ingredients: Array<ShoppingIngredientInputBean2>, listId?: string): Promise<boolean> {
    const model = {'ingredients': encodeArray(encodeShoppingIngredientInputBean2), 'listId': encodeMetaId};
    return executorTs('mpadditemtolist2', model, decodeStructure(decodeboolean), arguments);
  },
  mpcategorydelete(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('mpcategorydelete', model, decodeStructure(decodeboolean), arguments);
  },
  mpcategoryget(id: string): Promise<CategoryBean> {
    const model = {'id': encodeMetaId};
    return executorTs('mpcategoryget', model, decodeStructure(decodeCategoryBean), arguments);
  },
  /**
   * return the list of categories as to be displayed in the list
   */
  mpcategorylist(): Promise<Array<CategoryBean>> {
    const model = {};
    return executorTs('mpcategorylist', model, decodeStructure(decodeArray(decodeCategoryBean)), arguments);
  },
  /**
   * Change an existing category.
 You create a input category with a metaId and a name, and it will update the name of the category and in every recipe where is category is used.
   */
  mpcategoryput(__inline: CategoryInputBean, prevId?: string): Promise<CategoryBean> {
    const model = {'__inline': encodeCategoryInputBean, 'prevId': encodeMetaId};
    return executorTs('mpcategoryput', model, decodeStructure(decodeCategoryBean), arguments);
  },
  /**
   * remove all dishes from a given date (inclusive) to a given date (exclusive)
   */
  mpclear(FROM: string, to: string): Promise<boolean> {
    const model = {'from': encodeString, 'to': encodeString};
    return executorTs('mpclear', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * copy a range to another : return the newly created ones
   */
  mpcopy(FROM: string, to: string, targetFrom: string): Promise<Array<DishBean>> {
    const model = {'from': encodeString, 'to': encodeString, 'targetFrom': encodeString};
    return executorTs('mpcopy', model, decodeStructure(decodeArray(decodeDishBean)), arguments);
  },
  /**
   * Create a dish directly with a name.<br>The name is lowercased and then searched in the MEAL_RECIPE, it does not create duplicate 
 of MEAL_RECIPE but reuse existing recipe if found, else it create a mealrecipe with the lowercased name.
   * @param date date of the meal
   * @param type type of the meal
   */
  mpcreate(name: Array<string>, date: string, TYPE: MealTypeEnum): Promise<Array<DishBean>> {
    const model = {'name': encodeArray(encodeString), 'date': encodeString, 'type': encodeEnum};
    return executorTs('mpcreate', model, decodeStructure(decodeArray(decodeDishBean)), arguments);
  },
  /**
   * Create a dish from a recipeId, the corresponding recipe must exist.
   * @param recipeId id of the recipe
   * @param date date of the meal
   * @param type type of the meal
   */
  mpcreateByRecipeId(recipeId: string, date: string, TYPE: MealTypeEnum): Promise<DishBean> {
    const model = {'recipeId': encodeMetaId, 'date': encodeString, 'type': encodeEnum};
    return executorTs('mpcreateByRecipeId', model, decodeStructure(decodeDishBean), arguments);
  },
  /**
   * generate a recipe using the ia
   * @param input the parameters for the ia model to generate the recipe
   */
  mpgenerateIA(__inline: IAGenerateRecipeParameters): Promise<RecipeInputBean> {
    const model = {'__inline': encodeIAGenerateRecipeParameters};
    return executorTs('mpgenerateIA', model, decodeStructure(decodeRecipeInputBean), arguments);
  },
  /**
   * List all planned dished from a given date (inclusive) to a given date (exclusive)
   * @param from inclusive date from
   * @param to exclusive date to
   */
  mplistinterval(FROM: string, to: string): Promise<DishRangeBean> {
    const model = {'from': encodeString, 'to': encodeString};
    return executorTs('mplistinterval', model, decodeStructure(decodeDishRangeBean), arguments);
  },
  /**
   * create or edit a meal. If the input meal has a metaid, it edits an existing meal.
 If the input meal has a date/type, it looks for this date/type in the database<br>
 For a selected meal by metaId, it nevers update the existing date/type<br>
 When the meal is selected, it updates the number of servings, and not the date/type.
   * @param meal the meal to create or update.
   */
  mpmealput(__inline: MealInputBean): Promise<MealBean> {
    const model = {'__inline': encodeMealInputBean};
    return executorTs('mpmealput', model, decodeStructure(decodeMealBean), arguments);
  },
  /**
   * Move a meal or create via a mealrecipe, based on on the type of metaId.<br>
 If the metaId is of type "dish", it move an existing dish into a new meal(date/type).
 If the metaId is of type "recipe", it create a new dish with the given recipe and place it in the meal(date/type)
   * @param metaId list of metaIds, either a dish or a recipe
   * @param date date of the meal target of the dish
   * @param type type of meal target of the dish
   */
  mpmove(metaId: Array<string>, date: string, TYPE: MealTypeEnum): Promise<Array<DishBean>> {
    const model = {'metaId': encodeArray(encodeMetaId), 'date': encodeString, 'type': encodeEnum};
    return executorTs('mpmove', model, decodeStructure(decodeArray(decodeDishBean)), arguments);
  },
  /**
   * To be used when connected by token (sharing the planning by url link, with a token inside the link, without an authenticated account<br>
 This allows you to retrieve a shared recipe without being actually connected with an account to the service. There are 3 ways to use this api:<ul>
 <li>Do not pass tokenValue/recipeMetaId: the session must be intialized before by RecipeTokenClickHandler by clicking on the token and invoking /t?v=qsdfa
 This is a legacy and deprecated way only usable by web. recipe MetaId is inside the token.
 <li>Pass a tokenValue which is a recipe sharing token value, and no recipeMetaId : This api will return the associated recipe bean. You need either to have an open session
 or go through the RecipeTokenClickHandler before, in order for it to be allowed to call this api through ApiAccessRightRulesetEnum.MEALPLANNER_ANONYMOUS_SHARING 
 <li>Pass a tokenValue which is a meal planner sharing token value and a recipeMetaId : This api will return the corresponding recipeBean if it is in the shared meal planner.
 Same restriction on session apply
 </ul>
 WARNING WARNING : this count as clicking on the token for maxClickCount ! therefore it is preferable not to set a maxClickCount on the tokens.
   */
  mpncrecipe(tokenvalue?: string, recipeMetaId?: string): Promise<RecipeBean> {
    const model = {'tokenvalue': encodeString, 'recipeMetaId': encodeMetaId};
    return executorTs('mpncrecipe', model, decodeStructure(decodeRecipeBean), arguments);
  },
  /**
   * To be used when connected by token (sharing the planning by url link, with a token inside the link, without an authenticated account<br>
 This allows you to retrieve a shared recipe without being actually connected with an account to the service. 
 range is inside the token
   */
  mpncshared(tokenvalue: string): Promise<MealPlannerSharedBean> {
    const model = {'tokenvalue': encodeString};
    return executorTs('mpncshared', model, decodeStructure(decodeMealPlannerSharedBean), arguments);
  },
  /**
   * Return the recipes with their ingredients parsed: the quantity, the unit and a name without them are extracted from
 the text of each ingredient, and the text as it was written is returned in originalTxt. Nothing is parsed again for
 an ingredient that already has a quantity in the database, its stored values are returned as they are.<br>
 This is a preview: nothing is written, and a following get of the same recipe returns the unparsed ingredients. To
 keep the result, send it back with recipeput.<br>
 The unit is an abbreviation taken from a fixed list (g, kg, ml, cl, l, tbsp, tsp, cup, oz, lb, pc, pack, can...), and
 a quantity is never returned without a unit: a bare count ("2 pâtes feuilletées") is a count of pieces, unit pc. An
 ingredient where no quantity can be found keeps its whole text as its name, with no quantity and no unit. The
 ingredients of a recipe are returned in the order of the recipe.
   * @param recipeids list of recipe to parse, if null it will parse all the recipes
   */
  mpquantityparse(recipeids?: Array<string>): Promise<Array<RecipeBean>> {
    const model = {'recipeids': encodeArray(encodeMetaId)};
    return executorTs('mpquantityparse', model, decodeStructure(decodeArray(decodeRecipeBean)), arguments);
  },
  mprecipelink(metaId: string): Promise<TokenUrlBean> {
    const model = {'metaId': encodeMetaId};
    return executorTs('mprecipelink', model, decodeStructure(decodeTokenUrlBean), arguments);
  },
  /**
   * create or edit a recipe. If the input recipe has a metaid, it edits an existing recipe.<br>
 If the recipe has a name, check if that name is an url, and if it is actually an url, scrap the url from its content to create/fill the recipe.
   * @param recipe the recipe to create or update.
   */
  mprecipeput(recipe: RecipeInputBean, picture?: Array<FizFile>): Promise<RecipeBean> {
    const model = {'recipe': encodeRecipeInputBean, 'picture': encodeArray(encodeFizFile)};
    return executorTs('mprecipeput', model, decodeStructure(decodeRecipeBean), arguments);
  },
  /**
   * Create a recipe by an externalId
   * @param id the recipe external id to import (for instance the old tendance cuisine id)
   * @param recipeCategories the category to put the recipe into
   */
  mprecipeputbyid(id: string, recipeCategories?: RecipeSystemCategoryEnum, recipeCategoryId?: string): Promise<RecipeBean> {
    const model = {'id': encodeMetaId, 'recipeCategories': encodeEnum, 'recipeCategoryId': encodeMetaId};
    return executorTs('mprecipeputbyid', model, decodeStructure(decodeRecipeBean), arguments);
  },
  /**
   * Create a recipe by scrapping an url of its content using xschema tags, and creating it in the specified categories
   */
  mprecipeputbyurl(url: string, recipeCategories?: RecipeSystemCategoryEnum, recipeCategoryId?: string): Promise<RecipePuByUrlResultBean> {
    const model = {'url': encodeString, 'recipeCategories': encodeEnum, 'recipeCategoryId': encodeMetaId};
    return executorTs('mprecipeputbyurl', model, decodeStructure(decodeRecipePuByUrlResultBean), arguments);
  },
  mpsettingsget(): Promise<MealSettingsBean> {
    const model = {};
    return executorTs('mpsettingsget', model, decodeStructure(decodeMealSettingsBean), arguments);
  },
  mpsettingsset(settings: MealSettingsBean): Promise<MealSettingsBean> {
    const model = {'settings': encodeMealSettingsBean};
    return executorTs('mpsettingsset', model, decodeStructure(decodeMealSettingsBean), arguments);
  },
  mpsharedlink(FROM: string, to: string): Promise<TokenUrlBean> {
    const model = {'from': encodeString, 'to': encodeString};
    return executorTs('mpsharedlink', model, decodeStructure(decodeTokenUrlBean), arguments);
  },
  /**
   * return the auth uri to send the users to, for authentication.
   */
  outlookAuthUri(): Promise<string> {
    const model = {};
    return executorTs('outlookAuthUri', model, decodeStructure(decodeString), arguments);
  },
  outlookgetcredential(credentialId: string): Promise<OutlookCredentialBean> {
    const model = {'credentialId': encodeMetaId};
    return executorTs('outlookgetcredential', model, decodeStructure(decodeOutlookCredentialBean), arguments);
  },
  /**
   * after the users return from the webview, call this api with the authorization code to finish the authentification
   * @param code the oauth2 authorization code
   */
  outlooklogin(code: string): Promise<OutlookCredentialBean> {
    const model = {'code': encodeString};
    return executorTs('outlooklogin', model, decodeStructure(decodeOutlookCredentialBean), arguments);
  },
  /**
   * If there is a way to get a token and refreshToken you might use this method (it exists for google but certainly not for outlook)
 directly to this api to connect the user's google account
   * @param tokenType type of token, because each device (android/iphone/etc) correspond to a different client id and therefore a different refresh token method.
   * @param accessToken the access token of the user's google account
   * @param refreshToken the refresh token of the user's google account
   * @param expiresDate the expiration date of the access token
   * @param redirectUri for iPhone there is a specific redirectUri we need it to refresh
   * @param useSecret for iPhone we must not use the secret for refreshing the token
   */
  outlooksavetoken(tokenType: GoogleTokenType, accessToken: string, refreshToken: string, expiresDate: Date, redirectUri: string, useSecret: boolean): Promise<OutlookCredentialBean> {
    const model = {'tokenType': encodeEnum, 'accessToken': encodeString, 'refreshToken': encodeString, 'expiresDate': encodeDate, 'redirectUri': encodeString, 'useSecret': encodeBoolean};
    return executorTs('outlooksavetoken', model, decodeStructure(decodeOutlookCredentialBean), arguments);
  },
  /**
   * Select the calender in the OutlookLinkableCalendarBean list found in OutlookCredentialBean
   */
  outlookselectcalendar2(credentialId: string, outlookId?: Array<string>): Promise<CalendarSubscriptionResponseBean> {
    const model = {'credentialId': encodeMetaId, 'outlookId': encodeArray(encodeString)};
    return executorTs('outlookselectcalendar2', model, decodeStructure(decodeCalendarSubscriptionResponseBean), arguments);
  },
  outlooksync(calendarId: string, syncToken?: string): Promise<EventSyncBean> {
    const model = {'calendarId': encodeMetaId, 'syncToken': encodeString};
    return executorTs('outlooksync', model, decodeStructure(decodeEventSyncBean), arguments);
  },
  /**
   * create a POI
   * @param name name of the POI
   * @param geocodedAddress this geocodedAddress bean should have been truely geocoded, it
            will not be verified
   */
  poicreate(name: string, geocodedAddress: GeocodedAddress, placeType: PlaceTypeEnum, isTemporary?: boolean, geofencingActive?: boolean, contactId?: string, text?: string, wifiSSID?: string, wifiMAC?: string, picture?: Array<FizFile>): Promise<IPlace> {
    const model = {'name': encodeString, 'geocodedAddress': encodeGeocodedAddress, 'placeType': encodeEnum, 'isTemporary': encodeBoolean, 'geofencingActive': encodeBoolean, 'contactId': encodeMetaId, 'text': encodeString, 'wifiSSID': encodeString, 'wifiMAC': encodeString, 'picture': encodeArray(encodeFizFile)};
    return executorTs('poicreate', model, decodeStructure(decodeIPlace), arguments);
  },
  poicreatesimple(name: string, address: string, placeType: PlaceTypeEnum, isTemporary?: boolean, geofencingActive?: boolean, contactId?: string, text?: string, wifiSSID?: string, wifiMAC?: string, picture?: Array<FizFile>): Promise<IPlace> {
    const model = {'name': encodeString, 'address': encodeString, 'placeType': encodeEnum, 'isTemporary': encodeBoolean, 'geofencingActive': encodeBoolean, 'contactId': encodeMetaId, 'text': encodeString, 'wifiSSID': encodeString, 'wifiMAC': encodeString, 'picture': encodeArray(encodeFizFile)};
    return executorTs('poicreatesimple', model, decodeStructure(decodeIPlace), arguments);
  },
  /**
   * Add a tip to a POI
   */
  poidelete(placeId: Array<string>): Promise<boolean> {
    const model = {'placeId': encodeArray(encodeMetaId)};
    return executorTs('poidelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * allow to get a POI by its Id
   * @param placeId id of the POI
   */
  poiget(placeId: string): Promise<IPlace> {
    const model = {'placeId': encodeMetaId};
    return executorTs('poiget', model, decodeStructure(decodeIPlace), arguments);
  },
  /**
   * Return all POI of the family
   */
  poigetall(): Promise<Array<IPlace>> {
    const model = {};
    return executorTs('poigetall', model, decodeStructure(decodeArray(decodeIPlace)), arguments);
  },
  poinearby(latitudeE6: number, longitudeE6: number): Promise<PlaceNearbyResult> {
    const model = {'latitudeE6': encodenumber, 'longitudeE6': encodenumber};
    return executorTs('poinearby', model, decodeStructure(decodePlaceNearbyResult), arguments);
  },
  poisync(syncToken?: string, date?: Date): Promise<PlaceSyncBean> {
    const model = {'syncToken': encodeString, 'date': encodeDate};
    return executorTs('poisync', model, decodeStructure(decodePlaceSyncBean), arguments);
  },
  /**
   * Update a POI
   * @param placeId identifier of the place
   * @param name name of the place
   * @param placeType type of the place
   * @param isTemporary (if null not updated)
   * @param geofencingActive flag for kids@home ORANGE (only) activation
   * @param text description of the place
   * @param wifiSSID ssid of the wifi access point for the geofencing
   * @param wifiMAC mac address of the wifi access point for the geofencing
   * @param picture use urls getted by poiget, removing one will remove it, or
            file/multipart to add some more
   */
  poiupdate(placeId: string, name?: string, geocodedAddress?: GeocodedAddress, placeType?: PlaceTypeEnum, isTemporary?: boolean, geofencingActive?: boolean, contactId?: string, text?: string, wifiSSID?: string, wifiMAC?: string, picture?: Array<FizFile>): Promise<IPlace> {
    const model = {'placeId': encodeMetaId, 'name': encodeString, 'geocodedAddress': encodeGeocodedAddress, 'placeType': encodeEnum, 'isTemporary': encodeBoolean, 'geofencingActive': encodeBoolean, 'contactId': encodeMetaId, 'text': encodeString, 'wifiSSID': encodeString, 'wifiMAC': encodeString, 'picture': encodeArray(encodeFizFile)};
    return executorTs('poiupdate', model, decodeStructure(decodeIPlace), arguments);
  },
  /**
   * return a profile of an owner. If the profile does not exist (or you
 cannot access to it), a FizApiModelDoesNotExistException will be thrown.<br>
 Note that, by default, all accounts have a profile.<br>
 This api return live profile and also deleted profiles. Deleted profiles have the boolean isAccountDeleted = true,
 whereas normal profile have the boolean isAccountDeleted = false.
   * @param oid the accountId of the profile to retrieve. if null the logged
            account will be retrieved.
   */
  prfgetProfile(oid?: number): Promise<IProfile> {
    const model = {'oid': encodeNumber};
    return executorTs('prfgetProfile', model, decodeStructure(decodeIProfile), arguments);
  },
  /**
   * return the list of all profiles accessible to the user. This also return the profiles of deleted account, with isAccountDeleted = true
 normal profiles have isAccountDeleted = false
   */
  prfgetProfiles(): Promise<Map<string, IProfile>> {
    const model = {};
    return executorTs('prfgetProfiles', model, decodeStructure(decodeMap(decodeMetaId,decodeIProfile)), arguments);
  },
  /**
   * return the public profiles of any account using their account ids. With this api you don't need the family id !
   * @param oid the list of profiles to retrieve
   */
  prfgetPublicProfiles(oid: Array<number>): Promise<Map<string, IProfile>> {
    const model = {'oid': encodeArray(encodeNumber)};
    return executorTs('prfgetPublicProfiles', model, decodeStructure(decodeMap(decodeMetaId,decodeIProfile)), arguments);
  },
  /**
   * This api allows you to update profile information such as firstname,lastname,image,and addresses and devices<br>
 //FIXME: this api shall block modification of profile attributes that are linked to acccountIdentifier, for now when a profile attribute which is an accountIdentifier (=has same value)
 is modified, the link is broken (because the link is on the value and if the value is different the link does not exist anymore and the accountidentifier does not appear
 in the profile anymore)
  // when this will be done, the accaddidentifier will update the profile, too, and the mobile and email set in accsetprofile during account creation shall not be done anymore (else duplicate!)
   */
  prfupdate(__inline: IProfile, picture?: Array<FizFile>): Promise<IProfile> {
    const model = {'__inline': encodeIProfile, 'picture': encodeArray(encodeFizFile)};
    return executorTs('prfupdate', model, decodeStructure(decodeIProfile), arguments);
  },
  /**
   * new profile api that fit the UI. update the role and customRole in the familyMember, firstname, picture and color in the familyProfile and other elements in the personal profile
   */
  prfupdate2(role: FamilyRoleTypeEnum | undefined, customFamilyRole: string | undefined, __inline: IProfile, picture?: Array<FizFile>): Promise<IProfile> {
    const model = {'role': encodeEnum, 'customFamilyRole': encodeString, '__inline': encodeIProfile, 'picture': encodeArray(encodeFizFile)};
    return executorTs('prfupdate2', model, decodeStructure(decodeIProfile), arguments);
  },
  /**
   * check if an address is available and save it if asked and it is available
 might be used with null email for getting the current settings
   * @param email the email for importing stuff via ia in the family
   */
  settingsaiinboxcheck(email?: string): Promise<AiInboxResponseBean> {
    const model = {'email': encodeString};
    return executorTs('settingsaiinboxcheck', model, decodeStructure(decodeAiInboxResponseBean), arguments);
  },
  /**
   * save the value of ia inbox for this family, if null delete the value
   * @param email the email for importing stuff via ia in the family
   */
  settingsaiinboxsave(email?: string): Promise<AiInboxResponseBean> {
    const model = {'email': encodeString};
    return executorTs('settingsaiinboxsave', model, decodeStructure(decodeAiInboxResponseBean), arguments);
  },
  settingsfeedback(TYPE: FeedbackTypeEnum, score?: number, comment?: string): Promise<boolean> {
    const model = {'type': encodeEnum, 'score': encodeNumber, 'comment': encodeString};
    return executorTs('settingsfeedback', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * get your own settings
   */
  settingsget(): Promise<SettingsBean> {
    const model = {};
    return executorTs('settingsget', model, decodeStructure(decodeSettingsBean), arguments);
  },
  /**
   * retrieve the settings for one family, if the familyId is null, use the current "scoped" one
   */
  settingsgetperfamily(familyId?: string): Promise<ISettingsPerFamily> {
    const model = {'familyId': encodeMetaId};
    return executorTs('settingsgetperfamily', model, decodeStructure(decodeISettingsPerFamily), arguments);
  },
  /**
   * set your own settings
   * @param pushGlobal global push on/off, take precedence over specific settings for push for event/message/etc
   * @param pushForEvent specific push for event, taken into account only if pushGlobal is already true
   * @param pushForMessage specific push for msg, taken into account only if pushGlobal is already true
   * @param pushForCheckin specific push for checkin, taken into account only if pushGlobal is already true correspond to push location, enable Comment_Checkin, New_Checkin, GeoFencingIn, GeoFencingOut, GeolocAutotrackRequest
   * @param pushForPicture specific push for pictures, taken into account only if pushGlobal is already true
   * @param geoTrackingHistory experimental settings used to define if all position of geotracking is recorded in an history, not implemented at this time
   * @param reminderNotificationEnabled enable or disable reminders, however this is not implemented
   * @param pushForTask specific push for tasks, taken into account only if pushGlobal is already true
   * @param pushForStatus specific push for tasks, taken into account only if pushGlobal is already true
   * @param pushForComment specific push for comments, taken into account only if pushGlobal is already true
   * @param pushForBestMoment specific push for best moments, taken into account only if pushGlobal is already true
   * @param pushForTimetable specific push for timetable (lifecycle but not reminder), taken into account only if pushGlobal is already true
   * @param pushForBudget specific push for budget (lifecycle), taken into account only if pushGlobal is already true
   * @param pushForFiler specific push for filer (lifecycle), taken into account only if pushGlobal is already true
   * @param pushForSpecialDays specific push for special days, taken into account only if pushGlobal is already true
   * @param pushByEmail flag to activate push by emails if user does not have a device token
   * @param promoAccept flag to tell if the user has accepted or not promotion in the smartcard or something, related to familyplace...
   */
  settingsset(pushGlobal?: boolean, pushForEvent?: boolean, pushForMessage?: boolean, pushForCheckin?: boolean, pushForPicture?: boolean, geoTrackingHistory?: boolean, reminderNotificationEnabled?: boolean, pushForTask?: boolean, pushForStatus?: boolean, pushForComment?: boolean, pushForBestMoment?: boolean, pushForTimetable?: boolean, pushForBudget?: boolean, pushForFiler?: boolean, pushForSpecialDays?: boolean, pushByEmail?: MailNotificationTypeEnum, promoAccept?: boolean, pushForMealPlanner?: boolean, pushForRecipe?: boolean, pushForContact?: boolean): Promise<SettingsBean> {
    const model = {'pushGlobal': encodeBoolean, 'pushForEvent': encodeBoolean, 'pushForMessage': encodeBoolean, 'pushForCheckin': encodeBoolean, 'pushForPicture': encodeBoolean, 'geoTrackingHistory': encodeBoolean, 'reminderNotificationEnabled': encodeBoolean, 'pushForTask': encodeBoolean, 'pushForStatus': encodeBoolean, 'pushForComment': encodeBoolean, 'pushForBestMoment': encodeBoolean, 'pushForTimetable': encodeBoolean, 'pushForBudget': encodeBoolean, 'pushForFiler': encodeBoolean, 'pushForSpecialDays': encodeBoolean, 'pushByEmail': encodeEnum, 'promoAccept': encodeBoolean, 'pushForMealPlanner': encodeBoolean, 'pushForRecipe': encodeBoolean, 'pushForContact': encodeBoolean};
    return executorTs('settingsset', model, decodeStructure(decodeSettingsBean), arguments);
  },
  /**
   * define settings for one family if familyid not setted use the current "scoped" one
   * @param ComJeronimoFizGeneratedForInline0 settings of the family to write
   */
  settingssetperfamily(__inline: ISettingsPerFamily): Promise<ISettingsPerFamily> {
    const model = {'__inline': encodeISettingsPerFamily};
    return executorTs('settingssetperfamily', model, decodeStructure(decodeISettingsPerFamily), arguments);
  },
  /**
   * put sharing to NEVER to all families
   */
  settingsshutdowngeolocsharing(): Promise<boolean> {
    const model = {};
    return executorTs('settingsshutdowngeolocsharing', model, decodeStructure(decodeboolean), arguments);
  },
  statusget(): Promise<StatusBean> {
    const model = {};
    return executorTs('statusget', model, decodeStructure(decodeStatusBean), arguments);
  },
  stublistsms(number: string): Promise<Array<SmsStubBean>> {
    const model = {'number': encodeString};
    return executorTs('stublistsms', model, decodeStructure(decodeArray(decodeSmsStubBean)), arguments);
  },
  /**
   * delete a task category object (if right to do it)
   */
  taskcategorydelete(id: Array<string>): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId)};
    return executorTs('taskcategorydelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * get a task category by its metaId (if right to read it)
 If not allowed or not exists, it returns null
   */
  taskcategoryget(id: string): Promise<TaskCategoryBean> {
    const model = {'id': encodeMetaId};
    return executorTs('taskcategoryget', model, decodeStructure(decodeTaskCategoryBean), arguments);
  },
  /**
   * list all task categories of this type
   * @param tasklistType type of tasklist
   * @param locale locale
   */
  taskcategorylist(tasklistType?: TaskListTypeEnum, locale?: string, filterTasklistId?: string): Promise<Array<TaskCategoryBean>> {
    const model = {'tasklistType': encodeEnum, 'locale': encodeString, 'filterTasklistId': encodeMetaId};
    return executorTs('taskcategorylist', model, decodeStructure(decodeArray(decodeTaskCategoryBean)), arguments);
  },
  /**
   * create or update a task category. prevId and tasklistId and locale are used to change sorting order of a given category in a given tasklist with a given locale for system categories...<br>
 update or create a task category, can update its properties (from input), or its position (from prevId,tasklistId,locale) or hidden flag (from hidden,tasklistId)
 <br>
 You can do that one by one or the 3 operations at the same time.<br>
   * @param input : the input bean. Note: to reorder, specify the tasklistId the reorder will be affected upon
   * @param prevId to reorder, specify the Id of the previous taskCategory : the modified taskCategory will be positionned just after.
   * @param locale to reorder, specify the locale to integrate the system category into the reordering
   * @param hidden to change the "hidden" flag of the corresponding tasklistId
   */
  taskcategoryput(__inline: TaskCategoryInputBean, prevId?: string, tasklistId?: string, locale?: string, hidden?: boolean): Promise<TaskCategoryBean> {
    const model = {'__inline': encodeTaskCategoryInputBean, 'prevId': encodeMetaId, 'tasklistId': encodeMetaId, 'locale': encodeString, 'hidden': encodeBoolean};
    return executorTs('taskcategoryput', model, decodeStructure(decodeTaskCategoryBean), arguments);
  },
  /**
   * sync task categories
   */
  taskcategorysync(syncToken?: string): Promise<TaskCategorySyncBean> {
    const model = {'syncToken': encodeString};
    return executorTs('taskcategorysync', model, decodeStructure(decodeTaskCategorySyncBean), arguments);
  },
  /**
   * update the info of a list of task, to call when the screen is closed, this will send the push for modified list notification.
   */
  taskcloselist(): Promise<boolean> {
    const model = {};
    return executorTs('taskcloselist', model, decodeStructure(decodeboolean), arguments);
  },
  taskcreate(text: string, dueDate?: Date, assignee?: Array<number>, reminder?: IReminder): Promise<TaskBean> {
    const model = {'text': encodeString, 'dueDate': encodeDate, 'assignee': encodeArray(encodeNumber), 'reminder': encodeIReminder};
    return executorTs('taskcreate', model, decodeStructure(decodeTaskBean), arguments);
  },
  /**
   * new create api allowing for empty assignee
   */
  taskcreate2(__inline: TaskInputBean, picture?: Array<FizFile>): Promise<TaskBean> {
    const model = {'__inline': encodeTaskInputBean, 'picture': encodeArray(encodeFizFile)};
    return executorTs('taskcreate2', model, decodeStructure(decodeTaskBean), arguments);
  },
  /**
   * create
   */
  taskcreatelist(__inline: ITaskList): Promise<ITaskList> {
    const model = {'__inline': encodeITaskList};
    return executorTs('taskcreatelist', model, decodeStructure(decodeITaskList), arguments);
  },
  taskdelete(taskId: string): Promise<boolean> {
    const model = {'taskId': encodeMetaId};
    return executorTs('taskdelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * delete a list of task
   */
  taskdeletelist(id: string): Promise<boolean> {
    const model = {'id': encodeMetaId};
    return executorTs('taskdeletelist', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * Create a new list will all the same settings, and a duplicata of all tasks inside<br/>
 The new name is computed by increasing number in parenthesis WallMart => WallMart (1) => WallMart (2)
   * @param id id of the tasklist to duplicate
   */
  taskduplicatelist(id: string): Promise<ITaskList> {
    const model = {'id': encodeMetaId};
    return executorTs('taskduplicatelist', model, decodeStructure(decodeITaskList), arguments);
  },
  /**
   * get one specific task of the family, by its metaid
   */
  taskget(taskId: string): Promise<TaskBean> {
    const model = {'taskId': encodeMetaId};
    return executorTs('taskget', model, decodeStructure(decodeTaskBean), arguments);
  },
  /**
   * Retrieve the settings for the tasklist section
   */
  taskgetsettings(): Promise<TaskListSettingsBean> {
    const model = {};
    return executorTs('taskgetsettings', model, decodeStructure(decodeTaskListSettingsBean), arguments);
  },
  /**
   * return a suggested list to be created.
   */
  taskgetsuggestedlist(): Promise<ITaskList> {
    const model = {};
    return executorTs('taskgetsuggestedlist', model, decodeStructure(decodeITaskList), arguments);
  },
  /**
   * return all the list of tasks
   */
  taskgettasklists(): Promise<Array<ITaskList>> {
    const model = {};
    return executorTs('taskgettasklists', model, decodeStructure(decodeArray(decodeITaskList)), arguments);
  },
  /**
   * retrieve (with a sync) the suggestion for a given tasklistType and a given locale, return a kind of sync bean that contains isSync=false or the entire list
   * @param tasklistType type of tasklist
   * @param syncToken old synctoken that was previously sent by the server
   * @param locale locale (if locale change remove the syncToken)
   */
  taskgettasksuggestions(tasklistType: TaskListTypeEnum, syncToken?: string, locale?: string): Promise<TaskSuggestionSyncBean> {
    const model = {'tasklistType': encodeEnum, 'syncToken': encodeString, 'locale': encodeString};
    return executorTs('taskgettasksuggestions', model, decodeStructure(decodeTaskSuggestionSyncBean), arguments);
  },
  /**
   * retrieve (with a sync) the suggestion for a given tasklistType and a given locale, return a kind of sync bean that contains isSync=false or the entire list
   * @param tasklistType type of tasklist
   * @param syncToken old synctoken that was previously sent by the server
   * @param locale locale (if locale change remove the syncToken)
   */
  taskgettasksuggestionswcat(tasklistType: TaskListTypeEnum, syncToken?: string, locale?: string): Promise<TaskSuggestionSyncBeanWCategory> {
    const model = {'tasklistType': encodeEnum, 'syncToken': encodeString, 'locale': encodeString};
    return executorTs('taskgettasksuggestionswcat', model, decodeStructure(decodeTaskSuggestionSyncBeanWCategory), arguments);
  },
  /**
   * return all tasks of the family
   */
  tasklist(listId?: string): Promise<Array<TaskBean>> {
    const model = {'listId': encodeMetaId};
    return executorTs('tasklist', model, decodeStructure(decodeArray(decodeTaskBean)), arguments);
  },
  /**
   * mark a task as completed
   * @param taskId the id of the task to mark completed
   * @param complete if true, mark the task completed, if false uncomplete the task
   * @param completedDateForTesting the date to use for completed date, useful for testing
   */
  taskmark(taskId: string, complete: boolean, completedDateForTesting?: Date): Promise<TaskBean> {
    const model = {'taskId': encodeMetaId, 'complete': encodeBoolean, 'completedDateForTesting': encodeDate};
    return executorTs('taskmark', model, decodeStructure(decodeTaskBean), arguments);
  },
  /**
   * Mark task of given taskIds and all task of given taskListId
   * @param id metaIds of task and/or taskList
   */
  taskmetamark(id: Array<string>, complete: boolean): Promise<boolean> {
    const model = {'id': encodeArray(encodeMetaId), 'complete': encodeBoolean};
    return executorTs('taskmetamark', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * Move a task to another list (or the same if null) to it just after the prevTaskId (if null, means first)
 Make sure to securize the code when handling the result, it might return some id of unknown task for the client
   */
  taskmove(taskId: string, taskListId?: string, prevTaskId?: string, taskCategoryId?: string): Promise<Map<string, number>> {
    const model = {'taskId': encodeMetaId, 'taskListId': encodeMetaId, 'prevTaskId': encodeMetaId, 'taskCategoryId': encodeMetaId};
    return executorTs('taskmove', model, decodeStructure(decodeMap(decodeMetaId,decodeNumber)), arguments);
  },
  /**
   * more a tasklist to another position, turn the taskListSorting preference to "custom"<br>
 Warning, potentially many elements have been modified by this api, therefore you must reload all the items.
   * @param id id of the tasklist to move
   * @param prevId id of new position of the tasklist, if null it will be the first position
   */
  taskmovelist(id: string, prevId?: string): Promise<Map<string, number>> {
    const model = {'id': encodeMetaId, 'prevId': encodeMetaId};
    return executorTs('taskmovelist', model, decodeStructure(decodeMap(decodeMetaId,decodeNumber)), arguments);
  },
  /**
   * This api pin or unpin a list by its metaId. The flag parameter 'pin' indicates if we pin or unpin.<br>
 More precisely, if pin is <ul>
     true: set the pinSortingIndex of the currently logged account to 'now': The pinned list is now in the top or bottom position (depending on the rendering)
     false: set the pinSortingIndex of the currently logged account to null: The list is not pinned anymore and return to the normal default list.
 </ul>
 Note: the sorting order in the normal list is not affected.
   * @param id the if of the list to pin
   * @param pin the flag
   */
  taskpinlist(id: string, pin: boolean): Promise<ITaskList> {
    const model = {'id': encodeMetaId, 'pin': encodeboolean};
    return executorTs('taskpinlist', model, decodeStructure(decodeITaskList), arguments);
  },
  /**
   * define on the server the response of a suggestion of a tasklist to create (from getsuggestedlist). true=accept (and it will create the list), 
 false=refuse (and it will not show again)
   */
  taskrespondsuggested(id: number, accept: boolean): Promise<ITaskList> {
    const model = {'id': encodeNumber, 'accept': encodeBoolean};
    return executorTs('taskrespondsuggested', model, decodeStructure(decodeITaskList), arguments);
  },
  /**
   * recreate system list shopping and/or todo if they don't exists
   */
  taskrestoresystemlist(): Promise<number> {
    const model = {};
    return executorTs('taskrestoresystemlist', model, decodeStructure(decodenumber), arguments);
  },
  tasksync(syncToken?: string, date?: Date): Promise<TaskSyncBean> {
    const model = {'syncToken': encodeString, 'date': encodeDate};
    return executorTs('tasksync', model, decodeStructure(decodeTaskSyncBean), arguments);
  },
  taskupdate(taskId: string, text?: string, dueDate?: Date, assignee?: Array<number>, reminder?: IReminder): Promise<TaskBean> {
    const model = {'taskId': encodeMetaId, 'text': encodeString, 'dueDate': encodeDate, 'assignee': encodeArray(encodeNumber), 'reminder': encodeIReminder};
    return executorTs('taskupdate', model, decodeStructure(decodeTaskBean), arguments);
  },
  /**
   * new udpate task api allowing for empty assignee.
   */
  taskupdate2(__inline: TaskInputBean, picture?: Array<FizFile>): Promise<TaskBean> {
    const model = {'__inline': encodeTaskInputBean, 'picture': encodeArray(encodeFizFile)};
    return executorTs('taskupdate2', model, decodeStructure(decodeTaskBean), arguments);
  },
  /**
   * update the info of a list of task
   */
  taskupdatelist(__inline: ITaskList): Promise<ITaskList> {
    const model = {'__inline': encodeITaskList};
    return executorTs('taskupdatelist', model, decodeStructure(decodeITaskList), arguments);
  },
  /**
   * for having activityBean of all accounts
   * @param masterNested if we need to put a nested object, will it be the master or the instance (in case of Event, not really applicable to other objects for the moment)
 			  default to false if absent, used by iOS.
   */
  wallactivityById(masterNested?: boolean): Promise<Map<number, AccountActivityBean>> {
    const model = {'masterNested': encodeBoolean};
    return executorTs('wallactivityById', model, decodeStructure(decodeMap(decodeNumber,decodeAccountActivityBean)), arguments);
  },
  /**
   * Get the last activity of an account. This api has been unmaintainted for a while and is known to be broken: some elements are not computed anymore.
   * @param masterNested if we need to put a nested object, will it be the master or the instance (in case of Event, not really applicable to other objects for the moment)
 			  default to false if absent, used by iOS.
   */
  wallactivityget(accountId: number, masterNested?: boolean): Promise<AccountActivityBean> {
    const model = {'accountId': encodeNumber, 'masterNested': encodeBoolean};
    return executorTs('wallactivityget', model, decodeStructure(decodeAccountActivityBean), arguments);
  },
  /**
   * Comment a IWallMessage
   * @param wall_message_id if of the wallmessage to comment
   * @param comment the text of the comment
   */
  walladdComment(wall_message_id: string, comment: string, mood?: MoodEnum): Promise<CommentResultBean<IWallMessage>> {
    const model = {'wall_message_id': encodeMetaId, 'comment': encodeString, 'mood': encodeEnum};
    return executorTs('walladdComment', model, decodeStructure(decodeCommentResultBean(decodeIWallMessage)), arguments);
  },
  /**
   * return a list of messages corresponding to the asked ids (with their nested reference);
   * @param id list of ids
   * @param masterNested if we need to put a nested object, will it be the master or the instance (in case of Event, not really applicable to other objects for the moment)
 			  default to false if absent, used by iOS.
   */
  wallbyids(id?: Array<string>, masterNested?: boolean): Promise<Array<IWallMessage>> {
    const model = {'id': encodeArray(encodeMetaId), 'masterNested': encodeBoolean};
    return executorTs('wallbyids', model, decodeStructure(decodeArray(decodeIWallMessage)), arguments);
  },
  /**
   * this api lacks documentation.
   */
  walldelete(wallMessageId: Array<string>): Promise<boolean> {
    const model = {'wallMessageId': encodeArray(encodeMetaId)};
    return executorTs('walldelete', model, decodeStructure(decodeboolean), arguments);
  },
  /**
   * return the wall of current Account
   * @param date return only Item sorting date since the given date
   * @param accountId list of id of accounts, only the wall message authored by those accounts will be sent (filter)
   * @param type list of wall message ref object type, will filters only those types
   * @param hasJoin if null no filter, if true only message with a joined picture,
            if false only images without joined picture
   * @param mood if null no filter, else keep only messages the current user as setted with this mood
   * @param bestMoment if null no filter, else filter according to the value
   * @param afterId get only the message that are after the one of this id (for "more" function)
   * @param nb the number of item wanted, if null 25 is used
   * @param nested if true, return nested messages. If null default to false
   * @param masterNested if we need to put a nested object, will it be the master or the instance (in case of Event, not really applicable to other objects for the moment)
 			  default to false if absent, used by iOS.
   * @param sortBy use null or "creation" to sort by creation date and not "natural" sorting date
   */
  wallget(date?: Date, accountId?: Array<number>, TYPE?: Array<RefObjectTypeEnum>, hasJoin?: boolean, mood?: MoodEnum, bestMoment?: boolean, afterId?: string, nb?: number, nested?: boolean, masterNested?: boolean, sortBy?: string): Promise<Array<IWallMessage>> {
    const model = {'date': encodeDate, 'accountId': encodeArray(encodeNumber), 'type': encodeArray(encodeEnum), 'hasJoin': encodeBoolean, 'mood': encodeEnum, 'bestMoment': encodeBoolean, 'afterId': encodeMetaId, 'nb': encodeNumber, 'nested': encodeBoolean, 'masterNested': encodeBoolean, 'sortBy': encodeString};
    return executorTs('wallget', model, decodeStructure(decodeArray(decodeIWallMessage)), arguments);
  },
  /**
   * Return the last item of given type(s) per account
   * @param filter list of wanted type. if null default is
            [PLACE_IN,PLACE_OUT,MESSAGE_THREAD,STATUS]
   */
  walllastbyaccount(filter?: Array<RefObjectTypeEnum>): Promise<Map<number, IWallMessage>> {
    const model = {'filter': encodeArray(encodeEnum)};
    return executorTs('walllastbyaccount', model, decodeStructure(decodeMap(decodeNumber,decodeIWallMessage)), arguments);
  },
  /**
   * allows to set mood (best_moment, like, etc) any wall message
   */
  wallmood(wall_message_id: string, add?: Array<MoodEnum>, remove?: Array<MoodEnum>): Promise<IWallMessage> {
    const model = {'wall_message_id': encodeMetaId, 'add': encodeArray(encodeEnum), 'remove': encodeArray(encodeEnum)};
    return executorTs('wallmood', model, decodeStructure(decodeIWallMessage), arguments);
  },
  /**
   * publish a status on the wall<br>
 Note that if placeId!=null, this API is completely equivalent to loc/publishplacelocation, that means that a wall message will
 be published with the picture of the googlemaps place in pictureUri
   */
  wallpublish(tagline: string): Promise<IWallMessage> {
    const model = {'tagline': encodeString};
    return executorTs('wallpublish', model, decodeStructure(decodeIWallMessage), arguments);
  },
  /**
   * Publish a new set of pictures or update an existing set of pictures:<br>
 this create or update a wall message of type = MULTIPLE_PICTURE 
 
 <p>
 This api can be used to create or update a wall message MULTIPLE_PICTURE:<ul>
 <li>create a new wall message of type MULTIPLE_PICTURE with one picture, which could be completed later with several other ones:<br>
 this can be done when <b>wallMessageId=null</b>
 <li>update an existing wall message of type MULTIPLE_PICTURE enabling to change the description or add a new picture to the wall message:<br>
 this can be done when <b>wallMessageId=wall/xxxxx</b>
 <li>closing the upload of several pictures, enabling the server to send the push notification: <b>New_Multiple_Picture</b></br>
 this is done when <b>finishupload=true</b>
 </ul>
 
 From a client perspective, uploading several (X) pictures at once translates into calling the api "publishmultiplepics" X times:<ul>
 <li>The first time without the wallMessageId and without finishupload=true and nbOfPicturesUpload=X
 <li>The X-2 following times with the wallMessageId (returned from the first call) and without finishupload=false
 <li>The last Xth time with the wallMessageId and with the finishupload=true
 </ul>
 Note that nothing prevents to continue updating a MULTIPLE_PICTURE wall message even after finishupload=true, it will keep adding pictures to the wall.
 </p>
 
 <p>
 IPHONE: in order to ease dev., there is a way to designate the group of pictures by assigning a random ID <b>from the client side</b>.
 This is done through the wallMessageClientId parameters. In this case you don't have to get back the wallMessageId from the first call,
 you can just generate an id on the client-side and use it to group all pictures into a single MULTIPLE_PICTURE wall message.
 </p>
 
 <p>
 When a MULTIPLE_PICTURE wall message is created, the wall message is created and any clients can see it, however the total number of pictures is not
 already uploaded. <b>The counter of remaining pictures shall be displayed</b> on all clients.<br>   
 In order to do so, the foreseen number of total uploads shall be send to <b>nbOfPicturesUpload</b>, so the server can keep track of the remaining number.
 It will return this information to the clients in the "extra" properties of wall messages.
 </p>
 
 <p>
 This api can also be used to create/update an existing album in the album gallery, using the albumId and createalbum parameters when wallMessageId=null.<ul>
 <li>If albumId=mediaAlbum/xxxxx , the pictures of the multiple upload will be added to that album (must exist) and createalbum is disregarded.
 <li>If albumId=null AND createalbum=null or false, the pictures of the multiple upload will be added to the generic family gallery (no specific album)
 <li>If albumId=null and createalbum=true, the  pictures of the multiple upload will be added to a newly created album whose name would be the "description" of the wall message.<br>
 (the albumid will be returned in "refId" of the wall message.)
 </ul>
 </p>
 
 <p>
 <b>Wall Messages characteristics:</b><dl>
 <dt>refType:</dt><dd>MULTIPLE_PICTURE</dd>
 <dt>refId:</dt><dd>Album metaid (mediaAlbum/xxxxx_yyyyyy) , may be null</dd>
 <dt>medias:</dt><dd>associated pictures and videos</dd>
 <dt>extra:</dt><dd>optional extra json indicating the upload status, if an upload is ongoing... <pre>
 Example indicating 2 files uploaded for a total of 5.:
 "upload-nb" : {
 		"current" : "2",
 		"total" : "5"
 } 
 </pre></dd>
 <dt><b>comments:</b></dt><dd>Comments associated TO THIS multiple upload WALL MESSAGE. It is different from SINGLE_PICTURE where the comments are associated to the picture or the video, 
 but because there are several of them here, this is not the case.</dd> 
 </dl>
 </p>
   * @param description Text description of the multiple upload, optional. In case an album is created, this become required and is equal to the album name.
   * @param picture The picture being added to the multiple upload.
   * @param nbOfPicturesUpload During a multiple upload session, the total number of upload to do. Only required when creating a new wall message.
   * @param wallMessageClientId a client-generated random ID to designate the set of pictures (iphone)
   */
  wallpublishmultiplepics(description?: string, picture?: FizFile, nbOfPicturesUpload?: number, wallMessageClientId?: string, clientPicId?: string, finishupload?: boolean, familyIds?: Array<string>, comment?: string): Promise<IWallMessage> {
    const model = {'description': encodeString, 'picture': encodeFizFile, 'nbOfPicturesUpload': encodeNumber, 'wallMessageClientId': encodeString, 'clientPicId': encodeString, 'finishupload': encodeBoolean, 'familyIds': encodeArray(encodeMetaId), 'comment': encodeString};
    return executorTs('wallpublishmultiplepics', model, decodeStructure(decodeIWallMessage), arguments);
  },
  /**
   * Publish an Object on the wall
   * @param tagline text
   * @param refObjectType type of Object
   * @param refObjectId id of the object
   */
  wallpublishref(tagline: string, refObjectType: RefObjectTypeEnum, refObjectId: string): Promise<IWallMessage> {
    const model = {'tagline': encodeString, 'refObjectType': encodeEnum, 'refObjectId': encodeMetaId};
    return executorTs('wallpublishref', model, decodeStructure(decodeIWallMessage), arguments);
  },
  webapiurl(): Promise<string> {
    const model = {};
    return executorTs('webapiurl', model, decodeStructure(decodeString), arguments);
  },
  /**
   * get a value in session (used to detect safari cookies for instance)
   * @param var the variable name
   */
  webget(VAR: string): Promise<string> {
    const model = {'var': encodeString};
    return executorTs('webget', model, decodeStructure(decodeString), arguments);
  },
  webgetExternalWebUrl(partnerType?: PartnerTypeEnum): Promise<string> {
    const model = {'partnerType': encodeEnum};
    return executorTs('webgetExternalWebUrl', model, decodeStructure(decodeString), arguments);
  },
  webgetWebSocketUrl(): Promise<string> {
    const model = {};
    return executorTs('webgetWebSocketUrl', model, decodeStructure(decodeString), arguments);
  },
  /**
   * check if this homehub code is free
   */
  webhomehubvalidatecode(code: string): Promise<boolean> {
    const model = {'code': encodeString};
    return executorTs('webhomehubvalidatecode', model, decodeStructure(decodeBoolean), arguments);
  },
  /**
   * api call to import some ical events via email, used for testing. In real situation, this comes from a kafka message
   */
  webiaimportemail(email: string, FROM: string, ical: string): Promise<IcalImportResultBean> {
    const model = {'email': encodeString, 'from': encodeString, 'ical': encodeString};
    return executorTs('webiaimportemail', model, decodeStructure(decodeIcalImportResultBean), arguments);
  },
  /**
   * Use it to log uncatch js error
   * @param text text to log
   */
  webjslog(text: string): Promise<boolean> {
    const model = {'text': encodeString};
    return executorTs('webjslog', model, decodeStructure(decodeboolean), arguments);
  },
  webog(url: string, refresh?: boolean): Promise<OpenGraphDataBean> {
    const model = {'url': encodeString, 'refresh': encodeBoolean};
    return executorTs('webog', model, decodeStructure(decodeOpenGraphDataBean), arguments);
  },
  /**
   * Store a value in session and return the old value (if previously existing) (used to detect safari cookies for instance)
   * @param var the variable name
   */
  webset(VAR: string, value: string): Promise<string> {
    const model = {'var': encodeString, 'value': encodeString};
    return executorTs('webset', model, decodeStructure(decodeString), arguments);
  },
};

export default { types, methods, methodsTs, setExecutorTs };